var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004, _path4005, _path4006, _path4007, _path4008, _path4009, _path4010, _path4011, _path4012, _path4013, _path4014, _path4015, _path4016, _path4017, _path4018, _path4019, _path4020, _path4021, _path4022, _path4023, _path4024, _path4025, _path4026, _path4027, _path4028, _path4029, _path4030, _path4031, _path4032, _path4033, _path4034, _path4035, _path4036, _path4037, _path4038, _path4039, _path4040, _path4041, _path4042, _path4043, _path4044, _path4045, _path4046, _path4047, _path4048, _path4049, _path4050, _path4051, _path4052, _path4053, _path4054, _path4055, _path4056, _path4057, _path4058, _path4059, _path4060, _path4061, _path4062, _path4063, _path4064, _path4065, _path4066, _path4067, _path4068, _path4069, _path4070, _path4071, _path4072, _path4073, _path4074, _path4075, _path4076, _path4077, _path4078, _path4079, _path4080, _path4081, _path4082, _path4083, _path4084, _path4085, _path4086, _path4087, _path4088, _path4089, _path4090, _path4091, _path4092, _path4093, _path4094, _path4095, _path4096, _path4097, _path4098, _path4099, _path4100, _path4101, _path4102, _path4103, _path4104, _path4105, _path4106, _path4107, _path4108, _path4109, _path4110, _path4111, _path4112, _path4113, _path4114, _path4115, _path4116, _path4117, _path4118, _path4119, _path4120, _path4121, _path4122, _path4123, _path4124, _path4125, _path4126, _path4127, _path4128, _path4129, _path4130, _path4131, _path4132, _path4133, _path4134, _path4135, _path4136, _path4137, _path4138, _path4139, _path4140, _path4141, _path4142, _path4143, _path4144, _path4145, _path4146, _path4147, _path4148, _path4149, _path4150, _path4151, _path4152, _path4153, _path4154, _path4155, _path4156, _path4157, _path4158, _path4159, _path4160, _path4161, _path4162, _path4163, _path4164, _path4165, _path4166, _path4167, _path4168, _path4169, _path4170, _path4171, _path4172, _path4173, _path4174, _path4175, _path4176, _path4177, _path4178, _path4179, _path4180, _path4181, _path4182, _path4183, _path4184, _path4185, _path4186, _path4187, _path4188, _path4189, _path4190, _path4191, _path4192, _path4193, _path4194, _path4195, _path4196, _path4197, _path4198, _path4199, _path4200, _path4201, _path4202, _path4203, _path4204, _path4205, _path4206, _path4207, _path4208, _path4209, _path4210, _path4211, _path4212, _path4213, _path4214, _path4215, _path4216, _path4217, _path4218, _path4219, _path4220, _path4221, _path4222, _path4223, _path4224, _path4225, _path4226, _path4227, _path4228, _path4229, _path4230, _path4231, _path4232, _path4233, _path4234, _path4235, _path4236, _path4237, _path4238, _path4239, _path4240, _path4241, _path4242, _path4243, _path4244, _path4245, _path4246, _path4247, _path4248, _path4249, _path4250, _path4251, _path4252, _path4253, _path4254, _path4255, _path4256, _path4257, _path4258, _path4259, _path4260, _path4261, _path4262, _path4263, _path4264, _path4265, _path4266, _path4267, _path4268, _path4269, _path4270, _path4271, _path4272, _path4273, _path4274, _path4275, _path4276, _path4277, _path4278, _path4279, _path4280, _path4281, _path4282, _path4283, _path4284, _path4285, _path4286, _path4287, _path4288, _path4289, _path4290, _path4291, _path4292, _path4293, _path4294, _path4295, _path4296, _path4297, _path4298, _path4299, _path4300, _path4301, _path4302, _path4303, _path4304, _path4305, _path4306, _path4307, _path4308, _path4309, _path4310, _path4311, _path4312, _path4313, _path4314, _path4315, _path4316, _path4317, _path4318, _path4319, _path4320, _path4321, _path4322, _path4323, _path4324, _path4325, _path4326, _path4327, _path4328, _path4329, _path4330, _path4331, _path4332, _path4333, _path4334, _path4335, _path4336, _path4337, _path4338, _path4339, _path4340, _path4341, _path4342, _path4343, _path4344, _path4345, _path4346, _path4347, _path4348, _path4349, _path4350, _path4351, _path4352, _path4353, _path4354, _path4355, _path4356, _path4357, _path4358, _path4359, _path4360, _path4361, _path4362, _path4363, _path4364, _path4365, _path4366, _path4367, _path4368, _path4369, _path4370, _path4371, _path4372, _path4373, _path4374, _path4375, _path4376, _path4377, _path4378, _path4379, _path4380, _path4381, _path4382, _path4383, _path4384, _path4385, _path4386, _path4387, _path4388, _path4389, _path4390, _path4391, _path4392, _path4393, _path4394, _path4395, _path4396, _path4397, _path4398, _path4399, _path4400, _path4401, _path4402, _path4403, _path4404, _path4405, _path4406, _path4407, _path4408, _path4409, _path4410, _path4411, _path4412, _path4413, _path4414, _path4415, _path4416, _path4417, _path4418, _path4419, _path4420, _path4421, _path4422, _path4423, _path4424, _path4425, _path4426, _path4427, _path4428, _path4429, _path4430, _path4431, _path4432, _path4433, _path4434, _path4435, _path4436, _path4437, _path4438, _path4439, _path4440, _path4441, _path4442, _path4443, _path4444, _path4445, _path4446, _path4447, _path4448, _path4449, _path4450, _path4451, _path4452, _path4453, _path4454, _path4455, _path4456, _path4457, _path4458, _path4459, _path4460, _path4461, _path4462, _path4463, _path4464, _path4465, _path4466, _path4467, _path4468, _path4469, _path4470, _path4471, _path4472, _path4473, _path4474, _path4475, _path4476, _path4477, _path4478, _path4479, _path4480, _path4481, _path4482, _path4483, _path4484, _path4485, _path4486, _path4487, _path4488, _path4489, _path4490, _path4491, _path4492, _path4493, _path4494, _path4495, _path4496, _path4497, _path4498, _path4499, _path4500, _path4501, _path4502, _path4503, _path4504, _path4505, _path4506, _path4507, _path4508, _path4509, _path4510, _path4511, _path4512, _path4513, _path4514, _path4515, _path4516, _path4517, _path4518, _path4519, _path4520, _path4521, _path4522, _path4523, _path4524, _path4525, _path4526, _path4527, _path4528, _path4529, _path4530, _path4531, _path4532, _path4533, _path4534, _path4535, _path4536, _path4537, _path4538, _path4539, _path4540, _path4541, _path4542, _path4543, _path4544, _path4545, _path4546, _path4547, _path4548, _path4549, _path4550, _path4551, _path4552, _path4553, _path4554, _path4555, _path4556, _path4557, _path4558, _path4559, _path4560, _path4561, _path4562, _path4563, _path4564, _path4565, _path4566, _path4567, _path4568, _path4569, _path4570, _path4571, _path4572, _path4573, _path4574, _path4575, _path4576, _path4577, _path4578, _path4579, _path4580, _path4581, _path4582, _path4583, _path4584, _path4585, _path4586, _path4587, _path4588, _path4589, _path4590, _path4591, _path4592, _path4593, _path4594, _path4595, _path4596, _path4597, _path4598, _path4599, _path4600, _path4601, _path4602, _path4603, _path4604, _path4605, _path4606, _path4607, _path4608, _path4609, _path4610, _path4611, _path4612, _path4613, _path4614, _path4615, _path4616, _path4617, _path4618, _path4619, _path4620, _path4621, _path4622, _path4623, _path4624, _path4625, _path4626, _path4627, _path4628, _path4629, _path4630, _path4631, _path4632, _path4633, _path4634, _path4635, _path4636, _path4637, _path4638, _path4639, _path4640, _path4641, _path4642, _path4643, _path4644, _path4645, _path4646, _path4647, _path4648, _path4649, _path4650, _path4651, _path4652, _path4653, _path4654, _path4655, _path4656, _path4657, _path4658, _path4659, _path4660, _path4661, _path4662, _path4663, _path4664, _path4665, _path4666, _path4667, _path4668, _path4669, _path4670, _path4671, _path4672, _path4673, _path4674, _path4675, _path4676, _path4677, _path4678, _path4679, _path4680, _path4681, _path4682, _path4683, _path4684, _path4685, _path4686, _path4687, _path4688, _path4689, _path4690, _path4691, _path4692, _path4693, _path4694, _path4695, _path4696, _path4697, _path4698, _path4699, _path4700, _path4701, _path4702, _path4703, _path4704, _path4705, _path4706, _path4707, _path4708, _path4709, _path4710, _path4711, _path4712, _path4713, _path4714, _path4715, _path4716, _path4717, _path4718, _path4719, _path4720, _path4721, _path4722, _path4723, _path4724, _path4725, _path4726, _path4727, _path4728, _path4729, _path4730, _path4731, _path4732, _path4733, _path4734, _path4735, _path4736, _path4737, _path4738, _path4739, _path4740, _path4741, _path4742, _path4743, _path4744, _path4745, _path4746, _path4747, _path4748, _path4749, _path4750, _path4751, _path4752, _path4753, _path4754, _path4755, _path4756, _path4757, _path4758, _path4759, _path4760, _path4761, _path4762, _path4763, _path4764, _path4765, _path4766, _path4767, _path4768, _path4769, _path4770, _path4771, _path4772, _path4773, _path4774, _path4775, _path4776, _path4777, _path4778, _path4779, _path4780, _path4781, _path4782, _path4783, _path4784, _path4785, _path4786, _path4787, _path4788, _path4789, _path4790, _path4791, _path4792, _path4793, _path4794, _path4795, _path4796, _path4797, _path4798, _path4799, _path4800, _path4801, _path4802, _path4803, _path4804, _path4805, _path4806, _path4807, _path4808, _path4809, _path4810, _path4811, _path4812, _path4813, _path4814, _path4815, _path4816, _path4817, _path4818, _path4819, _path4820, _path4821, _path4822, _path4823, _path4824, _path4825, _path4826, _path4827, _path4828, _path4829, _path4830, _path4831, _path4832, _path4833, _path4834, _path4835, _path4836, _path4837, _path4838, _path4839, _path4840, _path4841, _path4842, _path4843, _path4844, _path4845, _path4846, _path4847, _path4848, _path4849, _path4850, _path4851, _path4852, _path4853, _path4854, _path4855, _path4856, _path4857, _path4858, _path4859, _path4860, _path4861, _path4862, _path4863, _path4864, _path4865, _path4866, _path4867, _path4868, _path4869, _path4870, _path4871, _path4872, _path4873, _path4874, _path4875, _path4876, _path4877, _path4878, _path4879, _path4880, _path4881, _path4882, _path4883, _path4884, _path4885, _path4886, _path4887, _path4888, _path4889, _path4890, _path4891, _path4892, _path4893, _path4894, _path4895, _path4896, _path4897, _path4898, _path4899, _path4900, _path4901, _path4902, _path4903, _path4904, _path4905, _path4906, _path4907, _path4908, _path4909, _path4910, _path4911, _path4912, _path4913, _path4914, _path4915, _path4916, _path4917, _path4918, _path4919, _path4920, _path4921, _path4922, _path4923, _path4924, _path4925, _path4926, _path4927, _path4928, _path4929, _path4930, _path4931, _path4932, _path4933, _path4934, _path4935, _path4936, _path4937, _path4938, _path4939, _path4940, _path4941, _path4942, _path4943, _path4944, _path4945, _path4946, _path4947, _path4948, _path4949, _path4950, _path4951, _path4952, _path4953, _path4954, _path4955, _path4956, _path4957, _path4958, _path4959, _path4960, _path4961, _path4962, _path4963, _path4964, _path4965, _path4966, _path4967, _path4968, _path4969, _path4970, _path4971, _path4972, _path4973, _path4974, _path4975, _path4976, _path4977, _path4978, _path4979, _path4980, _path4981, _path4982, _path4983, _path4984, _path4985, _path4986, _path4987, _path4988, _path4989, _path4990, _path4991, _path4992, _path4993, _path4994, _path4995, _path4996, _path4997, _path4998, _path4999, _path5000, _path5001, _path5002, _path5003, _path5004, _path5005, _path5006, _path5007, _path5008, _path5009, _path5010, _path5011, _path5012, _path5013, _path5014, _path5015, _path5016, _path5017, _path5018, _path5019, _path5020, _path5021, _path5022, _path5023, _path5024, _path5025, _path5026, _path5027, _path5028, _path5029, _path5030, _path5031, _path5032, _path5033, _path5034, _path5035, _path5036, _path5037, _path5038, _path5039, _path5040, _path5041, _path5042, _path5043, _path5044, _path5045, _path5046, _path5047, _path5048, _path5049, _path5050, _path5051, _path5052, _path5053, _path5054, _path5055, _path5056, _path5057, _path5058, _path5059, _path5060, _path5061, _path5062, _path5063, _path5064, _path5065, _path5066, _path5067, _path5068, _path5069, _path5070, _path5071, _path5072, _path5073, _path5074, _path5075, _path5076, _path5077, _path5078, _path5079, _path5080, _path5081, _path5082, _path5083, _path5084, _path5085, _path5086, _path5087, _path5088, _path5089, _path5090, _path5091, _path5092, _path5093, _path5094, _path5095, _path5096, _path5097, _path5098, _path5099, _path5100, _path5101, _path5102, _path5103, _path5104, _path5105, _path5106, _path5107, _path5108, _path5109, _path5110, _path5111, _path5112, _path5113, _path5114, _path5115, _path5116, _path5117, _path5118, _path5119, _path5120, _path5121, _path5122, _path5123, _path5124, _path5125, _path5126, _path5127, _path5128, _path5129, _path5130, _path5131, _path5132, _path5133, _path5134, _path5135, _path5136, _path5137, _path5138, _path5139, _path5140, _path5141, _path5142, _path5143, _path5144, _path5145, _path5146, _path5147, _path5148, _path5149, _path5150, _path5151, _path5152, _path5153, _path5154, _path5155, _path5156, _path5157, _path5158, _path5159, _path5160, _path5161, _path5162, _path5163, _path5164, _path5165, _path5166, _path5167, _path5168, _path5169, _path5170, _path5171, _path5172, _path5173, _path5174, _path5175, _path5176, _path5177, _path5178, _path5179, _path5180, _path5181, _path5182, _path5183, _path5184, _path5185, _path5186, _path5187, _path5188, _path5189, _path5190, _path5191, _path5192, _path5193, _path5194, _path5195, _path5196, _path5197, _path5198, _path5199, _path5200, _path5201, _path5202, _path5203, _path5204, _path5205, _path5206, _path5207, _path5208, _path5209, _path5210, _path5211, _path5212, _path5213, _path5214, _path5215, _path5216, _path5217, _path5218, _path5219, _path5220, _path5221, _path5222, _path5223, _path5224, _path5225, _path5226, _path5227, _path5228, _path5229, _path5230, _path5231, _path5232, _path5233, _path5234, _path5235, _path5236, _path5237, _path5238, _path5239, _path5240, _path5241, _path5242, _path5243, _path5244, _path5245, _path5246, _path5247, _path5248, _path5249, _path5250, _path5251, _path5252, _path5253, _path5254, _path5255, _path5256, _path5257, _path5258, _path5259, _path5260, _path5261, _path5262, _path5263, _path5264, _path5265, _path5266, _path5267, _path5268, _path5269, _path5270, _path5271, _path5272, _path5273, _path5274, _path5275, _path5276, _path5277, _path5278, _path5279, _path5280, _path5281, _path5282, _path5283, _path5284, _path5285, _path5286, _path5287, _path5288, _path5289, _path5290, _path5291, _path5292, _path5293, _path5294, _path5295, _path5296, _path5297, _path5298, _path5299, _path5300, _path5301, _path5302, _path5303, _path5304, _path5305, _path5306, _path5307, _path5308, _path5309, _path5310, _path5311, _path5312, _path5313, _path5314, _path5315, _path5316, _path5317, _path5318, _path5319, _path5320, _path5321, _path5322, _path5323, _path5324, _path5325, _path5326, _path5327, _path5328, _path5329, _path5330, _path5331, _path5332, _path5333, _path5334, _path5335, _path5336, _path5337, _path5338, _path5339, _path5340, _path5341, _path5342, _path5343, _path5344, _path5345, _path5346, _path5347, _path5348, _path5349, _path5350, _path5351, _path5352, _path5353, _path5354, _path5355, _path5356, _path5357, _path5358, _path5359, _path5360, _path5361, _path5362, _path5363, _path5364, _path5365, _path5366, _path5367, _path5368, _path5369, _path5370, _path5371, _path5372, _path5373, _path5374, _path5375, _path5376, _path5377, _path5378, _path5379, _path5380, _path5381, _path5382, _path5383, _path5384, _path5385, _path5386, _path5387, _path5388, _path5389, _path5390, _path5391, _path5392, _path5393, _path5394, _path5395, _path5396, _path5397, _path5398, _path5399, _path5400, _path5401, _path5402, _path5403, _path5404, _path5405, _path5406, _path5407, _path5408, _path5409, _path5410, _path5411, _path5412, _path5413, _path5414, _path5415, _path5416, _path5417, _path5418, _path5419, _path5420, _path5421, _path5422, _path5423, _path5424, _path5425, _path5426, _path5427, _path5428, _path5429, _path5430, _path5431, _path5432, _path5433, _path5434, _path5435, _path5436, _path5437, _path5438, _path5439, _path5440, _path5441, _path5442, _path5443, _path5444, _path5445, _path5446, _path5447, _path5448, _path5449, _path5450, _path5451, _path5452, _path5453, _path5454, _path5455, _path5456, _path5457, _path5458, _path5459, _path5460, _path5461, _path5462, _path5463, _path5464, _path5465, _path5466, _path5467, _path5468, _path5469, _path5470, _path5471, _path5472, _path5473, _path5474, _path5475, _path5476, _path5477, _path5478, _path5479, _path5480, _path5481, _path5482, _path5483, _path5484, _path5485, _path5486, _path5487, _path5488, _path5489, _path5490, _path5491, _path5492, _path5493, _path5494, _path5495, _path5496, _path5497, _path5498, _path5499, _path5500, _path5501, _path5502, _path5503, _path5504, _path5505, _path5506, _path5507, _path5508, _path5509, _path5510, _path5511, _path5512, _path5513, _path5514, _path5515, _path5516, _path5517, _path5518, _path5519, _path5520, _path5521, _path5522, _path5523, _path5524, _path5525, _path5526, _path5527, _path5528, _path5529, _path5530, _path5531, _path5532, _path5533, _path5534, _path5535, _path5536, _path5537, _path5538, _path5539, _path5540, _path5541, _path5542, _path5543, _path5544, _path5545, _path5546, _path5547, _path5548, _path5549, _path5550, _path5551, _path5552, _path5553, _path5554, _path5555, _path5556, _path5557, _path5558, _path5559, _path5560, _path5561, _path5562, _path5563, _path5564, _path5565, _path5566, _path5567, _path5568, _path5569, _path5570, _path5571, _path5572, _path5573, _path5574, _path5575, _path5576, _path5577, _path5578, _path5579, _path5580, _path5581, _path5582, _path5583, _path5584, _path5585, _path5586, _path5587, _path5588, _path5589, _path5590, _path5591, _path5592, _path5593, _path5594, _path5595, _path5596, _path5597, _path5598, _path5599, _path5600, _path5601, _path5602, _path5603, _path5604, _path5605, _path5606, _path5607, _path5608, _path5609, _path5610, _path5611, _path5612, _path5613, _path5614, _path5615, _path5616, _path5617, _path5618, _path5619, _path5620, _path5621, _path5622, _path5623, _path5624, _path5625, _path5626, _path5627, _path5628, _path5629, _path5630, _path5631, _path5632, _path5633, _path5634, _path5635, _path5636, _path5637, _path5638, _path5639, _path5640, _path5641, _path5642, _path5643, _path5644, _path5645, _path5646, _path5647, _path5648, _path5649, _path5650, _path5651, _path5652, _path5653, _path5654, _path5655, _path5656, _path5657, _path5658, _path5659, _path5660, _path5661, _path5662, _path5663, _path5664, _path5665, _path5666, _path5667, _path5668, _path5669, _path5670, _path5671, _path5672, _path5673, _path5674, _path5675, _path5676, _path5677, _path5678, _path5679, _path5680, _path5681, _path5682, _path5683, _path5684, _path5685, _path5686, _path5687, _path5688, _path5689, _path5690, _path5691, _path5692, _path5693, _path5694, _path5695, _path5696, _path5697, _path5698, _path5699, _path5700, _path5701, _path5702, _path5703, _path5704, _path5705, _path5706, _path5707, _path5708, _path5709, _path5710, _path5711, _path5712, _path5713, _path5714, _path5715, _path5716, _path5717, _path5718, _path5719, _path5720, _path5721, _path5722, _path5723, _path5724, _path5725, _path5726, _path5727, _path5728, _path5729, _path5730, _path5731, _path5732, _path5733, _path5734, _path5735, _path5736, _path5737, _path5738, _path5739, _path5740, _path5741, _path5742, _path5743, _path5744, _path5745, _path5746, _path5747, _path5748, _path5749, _path5750, _path5751, _path5752, _path5753, _path5754, _path5755, _path5756, _path5757, _path5758, _path5759, _path5760, _path5761, _path5762, _path5763, _path5764, _path5765, _path5766, _path5767, _path5768, _path5769, _path5770, _path5771, _path5772, _path5773, _path5774, _path5775, _path5776, _path5777, _path5778, _path5779, _path5780, _path5781, _path5782, _path5783, _path5784, _path5785, _path5786, _path5787, _path5788, _path5789, _path5790, _path5791, _path5792, _path5793, _path5794, _path5795, _path5796, _path5797, _path5798, _path5799, _path5800, _path5801, _path5802, _path5803, _path5804, _path5805, _path5806, _path5807, _path5808, _path5809, _path5810, _path5811, _path5812, _path5813, _path5814, _path5815, _path5816, _path5817, _path5818, _path5819, _path5820, _path5821, _path5822, _path5823, _path5824, _path5825, _path5826, _path5827, _path5828, _path5829, _path5830, _path5831, _path5832, _path5833, _path5834, _path5835, _path5836, _path5837, _path5838, _path5839, _path5840, _path5841, _path5842, _path5843, _path5844, _path5845, _path5846, _path5847, _path5848, _path5849, _path5850, _path5851, _path5852, _path5853, _path5854, _path5855, _path5856, _path5857, _path5858, _path5859, _path5860, _path5861, _path5862, _path5863, _path5864, _path5865, _path5866, _path5867, _path5868, _path5869, _path5870, _path5871, _path5872, _path5873, _path5874, _path5875, _path5876, _path5877, _path5878, _path5879, _path5880, _path5881, _path5882, _path5883, _path5884, _path5885, _path5886, _path5887, _path5888, _path5889, _path5890, _path5891, _path5892, _path5893, _path5894, _path5895, _path5896, _path5897, _path5898, _path5899, _path5900, _path5901, _path5902, _path5903, _path5904, _path5905, _path5906, _path5907, _path5908, _path5909, _path5910, _path5911, _path5912, _path5913, _path5914, _path5915, _path5916, _path5917, _path5918, _path5919, _path5920, _path5921, _path5922, _path5923, _path5924, _path5925, _path5926, _path5927, _path5928, _path5929, _path5930, _path5931, _path5932, _path5933, _path5934, _path5935, _path5936, _path5937, _path5938, _path5939, _path5940, _path5941, _path5942, _path5943, _path5944, _path5945, _path5946, _path5947, _path5948, _path5949, _path5950, _path5951, _path5952, _path5953, _path5954, _path5955, _path5956, _path5957, _path5958, _path5959, _path5960, _path5961, _path5962, _path5963, _path5964, _path5965, _path5966, _path5967, _path5968, _path5969, _path5970, _path5971, _path5972, _path5973, _path5974, _path5975, _path5976, _path5977, _path5978, _path5979, _path5980, _path5981, _path5982, _path5983, _path5984, _path5985, _path5986, _path5987, _path5988, _path5989, _path5990, _path5991, _path5992, _path5993, _path5994, _path5995, _path5996, _path5997, _path5998, _path5999, _path6000, _path6001, _path6002, _path6003, _path6004, _path6005, _path6006, _path6007, _path6008, _path6009, _path6010, _path6011, _path6012, _path6013, _path6014, _path6015, _path6016, _path6017, _path6018, _path6019, _path6020, _path6021, _path6022, _path6023, _path6024, _path6025, _path6026, _path6027, _path6028, _path6029, _path6030, _path6031, _path6032, _path6033, _path6034, _path6035, _path6036, _path6037, _path6038, _path6039, _path6040, _path6041, _path6042, _path6043, _path6044, _path6045, _path6046, _path6047, _path6048, _path6049, _path6050, _path6051, _path6052, _path6053, _path6054, _path6055, _path6056, _path6057, _path6058, _path6059, _path6060, _path6061, _path6062, _path6063, _path6064, _path6065, _path6066, _path6067, _path6068, _path6069, _path6070, _path6071, _path6072, _path6073, _path6074, _path6075, _path6076, _path6077, _path6078, _path6079, _path6080, _path6081, _path6082, _path6083, _path6084, _path6085, _path6086, _path6087, _path6088, _path6089, _path6090, _path6091, _path6092, _path6093, _path6094, _path6095, _path6096, _path6097, _path6098, _path6099, _path6100, _path6101, _path6102, _path6103, _path6104, _path6105, _path6106, _path6107, _path6108, _path6109, _path6110, _path6111, _path6112, _path6113, _path6114, _path6115, _path6116, _path6117, _path6118, _path6119, _path6120, _path6121, _path6122, _path6123, _path6124, _path6125, _path6126, _path6127, _path6128, _path6129, _path6130, _path6131, _path6132, _path6133, _path6134, _path6135, _path6136, _path6137, _path6138, _path6139, _path6140, _path6141, _path6142, _path6143, _path6144, _path6145, _path6146, _path6147, _path6148, _path6149, _path6150, _path6151, _path6152, _path6153, _path6154, _path6155, _path6156, _path6157, _path6158, _path6159, _path6160, _path6161, _path6162, _path6163, _path6164, _path6165, _path6166, _path6167, _path6168, _path6169, _path6170, _path6171, _path6172, _path6173, _path6174, _path6175, _path6176, _path6177, _path6178, _path6179, _path6180, _path6181, _path6182, _path6183, _path6184, _path6185, _path6186, _path6187, _path6188, _path6189, _path6190, _path6191, _path6192, _path6193, _path6194, _path6195, _path6196, _path6197, _path6198, _path6199, _path6200, _path6201, _path6202, _path6203, _path6204, _path6205, _path6206, _path6207, _path6208, _path6209, _path6210, _path6211, _path6212, _path6213, _path6214, _path6215, _path6216, _path6217, _path6218, _path6219, _path6220, _path6221, _path6222, _path6223, _path6224, _path6225, _path6226, _path6227, _path6228, _path6229, _path6230, _path6231, _path6232, _path6233, _path6234, _path6235, _path6236, _path6237, _path6238, _path6239, _path6240, _path6241, _path6242, _path6243, _path6244, _path6245, _path6246, _path6247, _path6248, _path6249, _path6250, _path6251, _path6252, _path6253, _path6254, _path6255, _path6256, _path6257, _path6258, _path6259, _path6260, _path6261, _path6262, _path6263, _path6264, _path6265, _path6266, _path6267, _path6268, _path6269, _path6270, _path6271, _path6272, _path6273, _path6274, _path6275, _path6276, _path6277, _path6278, _path6279, _path6280, _path6281, _path6282, _path6283, _path6284, _path6285, _path6286, _path6287, _path6288, _path6289, _path6290, _path6291, _path6292, _path6293, _path6294, _path6295, _path6296, _path6297, _path6298, _path6299, _path6300, _path6301, _path6302, _path6303, _path6304, _path6305, _path6306, _path6307, _path6308, _path6309, _path6310, _path6311, _path6312, _path6313, _path6314, _path6315, _path6316, _path6317, _path6318, _path6319, _path6320, _path6321, _path6322, _path6323, _path6324, _path6325, _path6326, _path6327, _path6328, _path6329, _path6330, _path6331, _path6332, _path6333, _path6334, _path6335, _path6336, _path6337, _path6338, _path6339, _path6340, _path6341, _path6342, _path6343, _path6344, _path6345, _path6346, _path6347, _path6348, _path6349, _path6350, _path6351, _path6352, _path6353, _path6354, _path6355, _path6356, _path6357, _path6358, _path6359, _path6360, _path6361, _path6362, _path6363, _path6364, _path6365, _path6366, _path6367, _path6368, _path6369, _path6370, _path6371, _path6372, _path6373;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMilkCarton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 120v1h-2v3h-1v-7h3v1h3v-2h1v3h-2v2h-1v-1zm6-3v-1h1v1h3v1h-2v1h-1v-1h-1zm7-1v1h-1v1h-1v-2zm7-37v-1h1v1zm0 8h1v1h-1zm-6 29v-1h1v1zm1 0h1v1h-1zm-11 3h1v1h-1zm9 1v-1h1v1z",
    fill: "#d2d4d3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 83v1h-1v2h-3v-1h1v-1h-1v-1zm1 8v-3h1v3zm-3 2h2v2h-1v-1h-1zm3 4h-2v-1h1v-1h1zm1-18v1h-1v-1zm-3 1h1v1h-1zm1 2h1v1h-1zm1 4v1h-1v-1zm1 2v-1h1v1zm1 29h-1v-1h1z",
    fill: "#dadcdb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 82v-2h2v1h2v1zm4 35v1h-5v-1h1zm2-3h1v2h-1v1h-1v-2h1zm-2-23v-1h1v2h-1zm-7 28h-1v-1h2v1zm-6 1v-1h2v1h-1zm13-40h1v1h-1zm-8 40h-1v-1h1z",
    fill: "#d4d6d5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 116h-1v-1h4v2h-3zm-2-37h2v1h-2zm4 1v1h-2v-1h1zm-8 38v1h-2v-1h1zm-8 2v-1h2v1h-1zm18-32h1v1h-1zm-1 1h1v1h-1zm-9 29v-1h1v1zm2-1h1v1h-1zm12 1h1v1h-1zm-17 1h1v1h-1zm-7 2v-1h1v1z",
    fill: "#d3d5d4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 112v1h-2v-2h5v1zm-1-6h-2v-1h1v-1h1zm5 6v-1h3v1h-1zm6 1v-1h3v1zm-12-6v1h-1v-1zm3 2v1h-1v-1zm5 0v1h-1v-1zm1 1h1v1h-1zm4 0v1h-1v-1zm5 1h1v1h-1z",
    fill: "#c9cacc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84v-1h1v1h1v1h-1v1h-2v-1h1zm3-1v-1h3v1h-1zm4 3v-1h2v1h-1zm0 32v-1h1v2h-1zm0-39v1h-1v-1zm-3 1h1v1h-1zm1 6v1h-1v-1zm3 1v1h-1v-1zm-2 4v-1h1v1zm0 0v1h-1v-1zm2 23h1v1h-1zm-8 4h1v1h-1zm3 1h-1v-1h1z",
    fill: "#d8dad9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94v4h-2v-1h1v-2h-1v-1zm-2-10v-1h1v2h-2v-1zm0-2v-2h1v2zm-1 10h2v1h-2zm4-14v1h-1v-1zm0 7h1v1h-1zm0 2h-1v-1h1zm-2 4h1v1h-1zm2 14v1h-1v-1zm0 13h-1v-1h1zm-3 1v-1h1v1z",
    fill: "#dbdddc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48 116v-1h2v-1h3v3h-1v-1zm-11-5h-2v-1h1v-1h2v1h-1zm-3 1h-1v-1h-1v-1h2zm0-10h1v1h-1zm5 2h-1v-1h1zm3 1v-1h1v1zm5 10v-1h1v1z",
    fill: "#d0d1d3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57 116v2h1v1h-3v-3zm5 0v1h-4v-1h1zm3-2h1v1h-1zm6 1h-1v-1h1zm-6 1h1v1h-1zm-18 2v-1h1v1zm6-1h1v1h-1zm22 1v1h-1v-1zm-27 2v1h-1v-1zm8 1h-1v-1h1z",
    fill: "#d1d3d2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M73 85v1h-1v1h-1v-2zm-12-7h-1v-1h1zm11 3v1h-1v-1zm-4 2v1h-1v-1zm-2 2h-1v-1h1zm2-1h1v1h-1zm-1 1h1v1h-1zm7 2h-1v-1h1zm-2 3v-1h1v1zm0 2v-1h1v1zm-6 0h1v1h-1zm9 24h-1v-1h1zm-1 0v1h-1v-1zm-2 2v1h-1v-1z",
    fill: "#d9dbda"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115v1h-6v-1zm-29-5v2h-1v-2zm37 4v1h-2v-1h1zm1-25v-1h1v1zm-35 23v1h-1v-1zm20 3h-1v-1h1zm8 0v-1h1v1zm-1 4v1h-1v-1zm3 0h1v1h-1z",
    fill: "#ced0cf"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65 83v-1h2v1h-1zm7 5v-1h1v2h-1zm-1 31h-2v-1h2zm1-40v1h-1v-1zm-2 3v-1h1v1zm-5 5v-1h1v1zm3-1v1h-1v-1zm3 3h1v1h-1zm0 28h1v1h-1zm-8 2v-1h1v1zm2 0v-1h1v1zm3-1v1h-1v-1z",
    fill: "#d6d8d7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74 89h1v3h-1zm0 5h1v3h-1zm0-14v-1h1v1zm0 2h-1v-1h1zm-1 2h1v1h-1zm1 10h-1v-1h1zm0 5h-1v-1h1zm-1 1v1h-1v-1zm2 7v-1h1v1zm0 8v-1h1v1z",
    fill: "#dddfde"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107h1v7h-1v-1zm-1-27v1h-1v-1zm-1 2h1v1h-1zm2 2v1h-1v-1zm-1 4h1v1h-1zm-1 4h1v1h-1zm-1 1h1v1h-1z",
    fill: "#dcdedd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65 117h-1v-1h-1v-1h2zm2-30v1h-2v-1h1zm-19 34v2h-1v-2zm21-34v1h-1v-1zm0 3v-1h1v1zm1 24v1h-1v-1zm-16 2v-1h1v1zm-7 2h1v1h-1z",
    fill: "#d0d2d1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34 112v-2h1v1h1v1zm15 2h1v1h-2v-1zm-14-10h-1v-1h1zm9-1v1h-1v-1zm0 3v-1h1v1zm-9 2v-1h1v1zm2 0v1h-1v-1zm-1 2h-1v-1h1zm11 3h1v1h-1z",
    fill: "#cfd0d2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h1v5h-2v-1h1zm5 0h1v1h-1zm3 1h-1v-1h1zm2 0v1h-1v-1zm-5 4h1v1h-1zm7 3h1v1h-1zm3 0v1h-1v-1z",
    fill: "#cccdcf"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h2v1h-2zm1 5v-1h2v1h-1zm5 27h1v2h-1v-1zm0 2v2h-1v-2zm-7-33v1h-1v-1zm1 4h-1v-1h1zm4 4v-1h1v1z",
    fill: "#d7d9d8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50 114v-1h3v1zm-17-4v-1h2v1h-1zm4 1v2h-1v-2zm-2-5h1v1h-1zm0 2h1v1h-1zm3 1h-1v-1h1zm11 4v1h-1v-1z",
    fill: "#cecfd1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76 96h-1v-3h1zm-1 8v-2h1v2zm-1-21h1v1h-1zm1 5v-1h1v1zm1 1v1h-1v-1zm0 3h-1v-1h1zm-1 7h-1v-1h1z",
    fill: "#e1e3e2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110v1h-4v-1h2zm-2-6v1h-1v-1zm-4 2h-1v-1h1zm1 2v-1h1v1zm6 3v1h-1v-1zm1 1v1h-1v-1zm5 0v1h-1v-1z",
    fill: "#cacbcd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80h1v1h-1zm-1 4v-1h1v1zm2 1v-1h1v1zm0 9h-1v-1h1zm-1 3h1v1h-1zm0 5h1v1h-1zm2 4h-1v-1h1zm0 11v1h-1v-1zm1 3v1h-1v-1z",
    fill: "#dee0df"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72 116v-2h1v2zm-3 2v-1h2v1h-1zm1-36h-1v-1h1zm1 8v1h-1v-1zm0 26h1v1h-1zm-6 2v1h-1v-1zm-6 1h1v1h-1z",
    fill: "#d5d7d6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71 88h-2v-1h2zm-9 28h-1v-1h2v1zm5-29h1v1h-1zm-2 28h-1v-1h1zm2-1v1h-1v-1zm-20 9h-1v-1h1zm1 1h-1v-1h1z",
    fill: "#cfd1d0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38 112v1h-1v-2h1zm-2-7v-1h1v1zm1 1v1h-1v-1zm-3 2h-1v-1h1zm-2 0h1v1h-1zm7 1v-1h1v1zm0 1v1h-1v-1zm8 1h-1v-1h1z",
    fill: "#cbccce"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52 111h3v1h-3zm-13-5v-1h1v1zm3 0h-1v-1h1zm-5 0h1v1h-1zm4 2v1h-1v-1zm1 1v1h-1v-1zm8 3h-1v-1h1z",
    fill: "#c7c8ca"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100h1v2h-1v-1zm0 6v-1h1v2h-1zm0-26v-1h1v1zm1 1v1h-1v-1zm-1 3v-1h1v1zm0 25v-1h1v1z",
    fill: "#e3e3e3",
    fillOpacity: 0.184
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35 103h2v1h-2zm4 7h-1v-2h1v1zm-5-6h-1v-1h1zm3 6h1v1h-1zm11 3h-1v-1h1zm1 1v-1h1v1z",
    fill: "#cdced0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89h1v1h-1zm-25 17h-1v-1h1zm5 0v1h-1v-1zm-9 2h-1v-1h1zm2 0v-1h1v1zm5 1v1h-1v-1zm10 4v-1h1v1z",
    fill: "#c6c7c9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49 112h-2v-1h2zm-11-7h-1v-1h1zm4 1v-1h1v1zm1 4h-1v-1h1zm12 1h1v1h-1zm-1 1v1h-1v-1z",
    fill: "#c8c9cb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M41 107h-2v-1h4v1h-1v2h-1zm29 6v1h-1v-1z",
    fill: "#c3c4c6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112v-1h1v-1h1v2zm5 1v-1h3v1zm-15-5v-1h1v1z",
    fill: "#c5c6c8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57 114v1h-2v-1h1zm4 0h2v1h-2zm-30-3h-1v-1h1zm31 8h1v1h-1zm9 1v-1h1v1z",
    fill: "#cdcfce"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69h-1v-1h2v1zm6-2v-1h1v1zm1 2h-1v-1h1zm-18 0h1v1h-1zm5 2h1v1h-1z",
    fill: "#d2d9eb"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99v-2h1v2zm0-17v-1h1v1zm1 1v1h-1v-1zm0 5v1h-1v-1zm-1 5v-1h1v1z",
    fill: "#e3e5e4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62h1v-1h1v2h-2zm-1-1v1h-1v-1z",
    fill: "#cdd5e8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h1v1h-2v-1zm-2 1v1h-1v-1zm2 1h1v1h-1z",
    fill: "#d0d9ea"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v-2h1v2zm0 16v-1h1v1zm0 5v-1h1v1z",
    fill: "#e2e4e3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76 79h1v1h-1zm1 2v1h-1v-1zm0 15v1h-1v-1zm0 4v1h-1v-1z",
    fill: "#e2e4e3",
    fillOpacity: 0.973
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v2h-1v-2zm0 6v-1h1v1zm0 3h1v1h-1z",
    fill: "#e0e2e1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M77 92v-1h1v2h-1zm0-6h1v1h-1zm0 9v-1h1v1z",
    fill: "#e2e8e2",
    fillOpacity: 0.176
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60 114v-1h2v1h-1zm7-24v-1h1v1zm-9 24v-1h1v1z",
    fill: "#c7c9c9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92h-1v-1h1zm-20 11h-1v-1h1zm6 5v1h-1v-1zm0 9v1h-1v-1z",
    fill: "#d1d2d2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M32 102v1h-1v-1zm17 5v1h-1v-1zm-15 6h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#ced0d0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M50 116h2v1h-2zm-4-13v1h-1v-1zm2 13h-1v-1h1z",
    fill: "#d1d2d4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M60 111v3h-1v-3zm-12-8v1h-1v-1z",
    fill: "#c7c9c8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M43 105v-1h2v1h-1zm6 11h1v1h-2v-1z",
    fill: "#d2d3d5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M59 3V2h1v1zm-2 3h-1V5h1zm-3 2V7h1v1z",
    fill: "#dadde3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M39 12h-3v-1h3z",
    fill: "#0469bf"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M77 31v-3h1v3z",
    fill: "#2b4890",
    fillOpacity: 0.208
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30h-1v-1h1zm-5 2h-1v-1h1zm3 3v-1h1v1z",
    fill: "#0023a4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53h1v1h-1zm0 2h1v1h-1zm0 7v-1h1v1z",
    fill: "#cfccad"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63h-1v-1h1zm43-1v1h-1v-1zm-20 7h-1v-1h1z",
    fill: "#d0d9ec"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65v1h-1v-1zm-12 4h1v1h-1zm-14 1h1v1h-1z",
    fill: "#cddbe8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65v1h-1v-1zm-3 2h1v1h-1zm-9 2h-1v-1h1z",
    fill: "#cfdaea"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66v-1h1v1zm2 1v-1h1v1zm-10 0v1h-1v-1z",
    fill: "#d1d9ec"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v-1h1v1zm16 46h1v1h-1zm7 1v-1h1v1z",
    fill: "#c9caca"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78v-1h1v1zm5 5v-1h1v1zm10 31h-1v-1h1z",
    fill: "#d7d9d9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79h-1v-1h1zm3 1h-1v-1h1zm-31 33h1v1h-1z",
    fill: "#d2d5d4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78h1v1h-1zm0 9v-1h1v1zm0 6v-1h1v1z",
    fill: "#e1e3e2",
    fillOpacity: 0.969
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86h-1v-1h1zm5 6h1v1h-1zm4 15h1v1h-1z",
    fill: "#dadcdc"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87h1v2h-1v-1zm0 8v-1h1v1z",
    fill: "#e2e4e3",
    fillOpacity: 0.969
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M78 88h-1v-1h1zm0 2v1h-1v-1zm-1 14v-1h1v1z",
    fill: "#e2e2e2",
    fillOpacity: 0.176
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v1h-1v-1zm2 32v-1h1v1zm-18 5h-1v-1h1z",
    fill: "#cbcdcc"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M69 88v2h-1v-2zm-19 34h-1v-1h1z",
    fill: "#c9cbca"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M76 89h1v3h-1z",
    fill: "#e0e2e1",
    fillOpacity: 0.969
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M66 91v1h-1v-1zm-31 12v-1h1v1zm12 13h1v1h-1z",
    fill: "#d0d2d3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M76 117h-1v-2h1v1zm-2-25h1v1h-1z",
    fill: "#dfe1e0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h-1v-1h1zm10 2h1v1h-1zm12 4v-1h1v1z",
    fill: "#cbcccd"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v-2h1v2zm12 15v-1h1v1z",
    fill: "#c2c3c5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h-2v-1h2zm8 2h1v1h-1z",
    fill: "#cccdce"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M77 114h-1v-2h1v1zm-1-4h1v1h-1z",
    fill: "#dee0df",
    fillOpacity: 0.98
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M30 113v-2h1v2zm0 7v1h-1v-1z",
    fill: "#ced0ce"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M61 114v1h-3v-1z",
    fill: "#cccecd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M56 121v-1h1v1zm15-1v1h-1v-1zm-21 2v1h-1v-1z",
    fill: "#b6b8b7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M62 121v-1h1v1zm-9 0v1h-1v-1zm16 1h-1v-1h1z",
    fill: "#a5a7a6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M59 3h-1V2h1zm-3 2v1h-1V5z",
    fill: "#dbdee4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M62 4h-1V3h1zm-7 0h1v1h-1z",
    fill: "#e3e6ea"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M55 7h-1V5h1v1z",
    fill: "#dadde4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M61 5h2v1h-2z",
    fill: "#e5e9ea"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M57 6v1h-1V6zm17 98v1h-1v-1z",
    fill: "#dbdfe0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M59 6v1h-2V6h1z",
    fill: "#d9dddc"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M56 8h1v1h-1zm4 4h-1v-1h1z",
    fill: "#dee3df"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M29 11v-1h1v1zm7 0v-1h1v1z",
    fill: "#026bbb"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M50 11h-1v-1h1zm24 46h-1v-1h1z",
    fill: "#b7c9e4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12v-1h1v1zm1 39v1h-1v-1z",
    fill: "#a1bae1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M65 15v-1h1v1zm5 0h-1v-1h1z",
    fill: "#0131ba"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15h-1v-1h1zm0 1v-1h1v1z",
    fill: "#0231bc"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h1v1h-1zm2 1v-1h1v1z",
    fill: "#002bb4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M47 15v1h-2v-1h1z",
    fill: "#0029b2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M63 15h1v1h-1zm7 1v-1h1v1z",
    fill: "#012eb8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v-1h1v1zm9 16h-1v-1h1z",
    fill: "#0130b5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h-1v-1h1zm6 15v-1h1v1z",
    fill: "#0130b6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15h1v1h-1zm-10 2v-1h1v1z",
    fill: "#022db8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17v-1h2v1h-1z",
    fill: "#0223b0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17v-1h1v1zm5-1h1v1h-1z",
    fill: "#002db7"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M43 19h-1v-1h1zm22 24v-1h1v1z",
    fill: "#001ea8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h-1v-1h1zm3 1h-1v-1h1z",
    fill: "#ff007a"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20v1h-1v-1zm51 91h-1v-1h1z",
    fill: "#d2d2cf"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21h-1v-1h2v1z",
    fill: "#db0d78"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21h2v1h-2z",
    fill: "#ff0076"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24v1h-1v-1zm0 1h1v1h-1z",
    fill: "#91c0e7"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M73 24v1h-2v-1h1z",
    fill: "#0034b1"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M48 25h1v1h-1zm0 2h-1v-1h1z",
    fill: "#5d95d4"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25v1h-1v-1zm3 1h-1v-1h1z",
    fill: "#78a3d9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h1v1h-1zm0 2h1v1h-1z",
    fill: "#022eb3"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v1h-1v-1zm0 7h-1v-1h1z",
    fill: "#25428d",
    fillOpacity: 0.212
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27h1v1h-1zm4 6v-1h1v1z",
    fill: "#8ec0e6"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27v2h-1v-2z",
    fill: "#0429a2",
    fillOpacity: 0.988
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29h-1v-1h1zm3 2h1v1h-1z",
    fill: "#8fbfe7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h1v1h-1zm0 3h1v1h-1z",
    fill: "#0021a8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1zm18 23h1v1h-1z",
    fill: "#a3bbe0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v2h-1z",
    fill: "#c3d6e9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M31 31v-1h1v2h-1z",
    fill: "#024dc9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32h-1v-1h1zm3 56v1h-1v-1z",
    fill: "#002eb2"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v-1h1v1zm-13 5h-1v-1h1z",
    fill: "#9dbedd"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32v1h-1v-1zm2 8h1v1h-1z",
    fill: "#0029ae"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33v1h-1v-1zm-1 2h1v1h-1z",
    fill: "#002fb2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h-1v-1h1zm-12 3h-1v-1h1z",
    fill: "#001fa5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v-1h1v1zm-8 13v1h-1v-1z",
    fill: "#9fc3dc"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v1h-1v-1zm-2 2v-1h1v1z",
    fill: "#0027ad"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1zm-9 15h1v1h-1z",
    fill: "#bfd0e8"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40h-1v-1h1zm-1 13v-1h1v1z",
    fill: "#cbdff0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v2h-1z",
    fill: "#cce2f1"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1zm4 1h-1v-1h1z",
    fill: "#001da5"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43h-1v-1h1zm38 12v1h-1v-1z",
    fill: "#b5c8ea"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42v1h-1v-1zM33 91h1v1h-1z",
    fill: "#0025a9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-1v-1zm0 3h-1v-1h1z",
    fill: "#0026ae"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1zm1 2v1h-1v-1z",
    fill: "#001fa6"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45v2h-1v-2z",
    fill: "#9ac9d8"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47h-1v-1h1zm-1 3h1v1h-1z",
    fill: "#b1b4a1",
    fillOpacity: 0.58
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47v-1h1v1zM32 61v-1h1v1z",
    fill: "#c7d5e9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1zm-8 4v-1h1v1z",
    fill: "#a6bce0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M68 46v1h-1v-1zm4 4h1v1h-1z",
    fill: "#8cacde"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48v1h-1v-1zm-1 13h-1v-1h1z",
    fill: "#c2c6a4"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1zm-13 2h1v1h-1z",
    fill: "#a4bce3"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h-1v-1h1zm-1 14v1h-1v-1z",
    fill: "#c3c3a3"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1zm7 0v1h-1v-1z",
    fill: "#a3bbe2"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1zM28 67v1h-1v-1z",
    fill: "#bfcdde"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52v-1h1v1zm1 2h-1v-1h1z",
    fill: "#a1cde5"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53v-1h1v1zm4 22v1h-1v-1z",
    fill: "#bbbf9f"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54h-1v-1h1zm-3 1v-1h1v1z",
    fill: "#b0ad8e"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1zm8 44h-1v-1h1z",
    fill: "#dfd8cb"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53h1v1h-1zm1 16h-1v-1h1z",
    fill: "#d7cbbb"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53v1h-1v-1zM35 64h1v1h-1z",
    fill: "#d5be9e"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v-1h1v2h-1z",
    fill: "#c9c7a8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55h-1v-1h1zm-4 15h1v1h-1z",
    fill: "#b7b99a"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v-1h1v1zm-4 2v-1h1v1z",
    fill: "#b5cae8"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M20 57h1v1h-1zm1 11h-1v-1h1z",
    fill: "#c2c3a3"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57h1v1h-1zm-2 2v-1h1v1z",
    fill: "#d9d6b7"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M39 59h1v1h-1zm0 5h1v1h-1z",
    fill: "#c49145"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M55 59h1v1h-1zm20 46h-1v-1h1z",
    fill: "#dde0df"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M67 61v-1h1v1zM37 71v1h-1v-1z",
    fill: "#d0dae7"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61h1v1h-1zm-17 7v-1h1v1z",
    fill: "#dcd9da"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M68 62h-1v-1h1zm3-1v1h-1v-1z",
    fill: "#ccd6e7"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M74 61h1v1h-1zM42 72v-1h1v1z",
    fill: "#cddaeb"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62v1h-1v-1zm33 7v-1h1v1z",
    fill: "#d1dbed"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63h-2v-1h2z",
    fill: "#d1dced"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M69 63h-1v-1h1zm-21 8h1v1h-1z",
    fill: "#cfd8e9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62h1v1h-1zM53 73h-1v-1h1z",
    fill: "#ced8eb"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64v-1h1v1zm17 47h1v1h-1z",
    fill: "#d8d6d2"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M68 63v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#ced9e9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M68 64v-1h1v1zm-4 3h-1v-1h1z",
    fill: "#cedae9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M73 63v1h-1v-1zm-24 8h-1v-1h1z",
    fill: "#d0d7eb"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M31 65v-1h1v1zm-1 4v-1h1v1z",
    fill: "#d5e0ec"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64h1v1h-1zm28 47v1h-1v-1z",
    fill: "#e1c9aa"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65h-1v-1h1zm-16 1v1h-1v-1z",
    fill: "#cccfd1"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65h-1v-1h1zm-13 0h1v1h-1z",
    fill: "#d2d4de"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1zm-11 7h-1v-1h1z",
    fill: "#d3d9e9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h1v1zm1 6h-1v-1h1z",
    fill: "#d1d9e8"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65h-1v-1h1zm-12 4h-1v-1h1z",
    fill: "#d1d9ea"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66v-1h1v2h-1z",
    fill: "#d6e0eb"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66v-1h1v1zm23 13v1h-1v-1z",
    fill: "#d3d6d5"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1zm-8 3h-1v-1h1z",
    fill: "#d1d8eb"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h-1v-1zm-5 1h1v1h-1z",
    fill: "#d2daeb"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67h1v1h-1zm-1 1v1h-1v-1z",
    fill: "#d2daea"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69h-1v-1h1zm15 10h-1v-1h1z",
    fill: "#cdcfd0"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68h1v1h-1zm-7 2v1h-1v-1z",
    fill: "#d2d9ea"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68h1v1h-1zm-16 2h1v1h-1z",
    fill: "#cfd7eb"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h1v1h-1zm-11 3v1h-1v-1z",
    fill: "#d3d8ec"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70h-1v-1h1zm0 1v-1h1v1z",
    fill: "#ced9eb"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M57 69h2v1h-2z",
    fill: "#cfd9ea"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70h-1v-1h2v1z",
    fill: "#cfdaeb"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71h-1v-1h1zm-19 0v1h-1v-1z",
    fill: "#ced7e8"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71h1v1h-1zm0 1v1h-1v-1z",
    fill: "#cfd8ec"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1zm-1 2h1v1h-1z",
    fill: "#dee3de",
    fillOpacity: 0.184
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M57 77v1h-1v-1zm-4 32v-1h1v1z",
    fill: "#d1d1d5"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77v1h-1v-1zm-6 17h1v1h-1z",
    fill: "#d6d9d8"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1zm-5 14v1h-1v-1z",
    fill: "#dadbd9"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-1h1v1zm-2 37v1h-1v-1z",
    fill: "#d1d3d3"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v-1h1v1zm2 1h-1v-1h1z",
    fill: "#d1d5d4"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79h-1v-1h1zm-1 30v-1h1v1z",
    fill: "#d7dad8"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1zm-1 26h1v1h-1z",
    fill: "#e3e3e3",
    fillOpacity: 0.18
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M64 80v-1h1v1zm3 11h1v1h-1z",
    fill: "#d2d4d4"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82h1v1h-1zm0 16v-1h1v1z",
    fill: "#e4e6e5",
    fillOpacity: 0.973
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v-1h1v1zm7 12h1v1h-1z",
    fill: "#dadddc"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v1h-1v-2h1z",
    fill: "#dcdedd",
    fillOpacity: 0.973
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h1v2h-1v-1z",
    fill: "#bddfff"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87h-1v-1h1zm-2 2v1h-1v-1z",
    fill: "#f2b84f"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v1h-1v-1zm9 25v-1h1v1z",
    fill: "#d9dbdb"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M67 89h-1v-1h1zm6 23v1h-1v-1z",
    fill: "#c8caca"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h-1v-1h1zm-16 32h-1v-1h1z",
    fill: "#cacccb"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M22 90h-1v-1h1zm-2 3v-1h1v1z",
    fill: "#937457"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M66 90h1v1h-1zm-10 21v-1h1v1z",
    fill: "#c8c9cc"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90h1v1h-1zm-35 19v1h-1v-1z",
    fill: "#cccece"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M59 92h1v1h-1zm6 9v1h-1v-1z",
    fill: "#f6b542"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M67 93v-1h1v1zm4 2v1h-1v-1z",
    fill: "#d8dad8"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h-1v-1h1zm2 4h1v1h-1z",
    fill: "#eea927"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96v-1h1v1zm0 7h1v1h-1z",
    fill: "#eacbb1"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h-1v-1h1zm2 1v1h-1v-1z",
    fill: "#f6bb56"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M78 97h-1v-2h1v1z",
    fill: "#e8e8e8",
    fillOpacity: 0.176
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98h-1v-2h1v1z",
    fill: "#e0bfa0"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97h1v1h-1zm0 2h-1v-1h1z",
    fill: "#feaf02"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M20 99v-1h1v1zm0 1h1v1h-1z",
    fill: "#af8351"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M76 98h1v2h-1v-1z",
    fill: "#e3e5e4",
    fillOpacity: 0.973
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99v1h-1v-1zm33 13v1h-1v-1z",
    fill: "#c9cccb"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99v2h-1v-2z",
    fill: "#dee0e1"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101v-1h1v1zm17 5h1v1h-1z",
    fill: "#d0d1d1"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M22 101h1v1h-1zm2 1v1h-1v-1z",
    fill: "#bf9256"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M34 101v1h-1v-1zm2 1v-1h1v1z",
    fill: "#cdd3d3"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101v1h-1v-1zm13 5h-1v-1h1z",
    fill: "#cdd1d1"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102v-1h1v1zm28 10v1h-1v-1z",
    fill: "#d6d7d8"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M39 103v-1h1v1zm8 3v-1h1v1z",
    fill: "#d1d5d6"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102h1v1h-1zm-11 7v-1h1v1z",
    fill: "#cacccc"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M49 102v1h-1v-1zm10 9v-1h1v1z",
    fill: "#cbcdcb"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#dfe1e0",
    fillOpacity: 0.973
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M30 103h1v1h-1zm1 5v1h-1v-1z",
    fill: "#cacece"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M32 103v1h-1v-1zm-1 1v1h-1v-1z",
    fill: "#cacfce"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M37 104v-1h1v1zm7-1h1v1h-1z",
    fill: "#d0d0d2"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M40 104h-1v-1h1zm3 0h-1v-1h1z",
    fill: "#d1d2d3"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h1v1h-1zm-14 10h-1v-1h1z",
    fill: "#cecfcf"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105v-1h1v1zm20 3v-1h1v1z",
    fill: "#cacecd"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M32 106v-2h1v2z",
    fill: "#cacecf"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M45 104h1v1h-1zm10 20v-1h1v1z",
    fill: "#d3d4d6"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M21 106v-1h1v1zm1 2h-1v-1h1z",
    fill: "#a27e4e"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106h-1v-1h1zm-1 1h-1v-1h1z",
    fill: "#cbcdcf"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106h-1v-1h1zm0 2v1h-1v-1z",
    fill: "#dee0df",
    fillOpacity: 0.973
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M39 107h-1v-1h1zm8 3v-1h1v1z",
    fill: "#c4c5c7"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M43 106h2v1h-2z",
    fill: "#c0c1c3"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108h-1v-1h1zm-2 1v-1h1v1z",
    fill: "#b8b9bb"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M50 108v-1h1v1zm1 0h1v1h-1z",
    fill: "#cdd0cf"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M77 108h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#dddfde",
    fillOpacity: 0.976
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108v1h-1v-1zm6 15h1v1h-1z",
    fill: "#b2b3b5"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h-1v-1h1zm2 1v-1h1v1z",
    fill: "#c6c7ca"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110v-1h1v1zm18 2h1v1h-1z",
    fill: "#c7cac9"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M56 109h1v1h-1zm3 4h-1v-1h1z",
    fill: "#c5c7c8"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M60 110h1v1h-1zm-31 2v-1h1v1z",
    fill: "#d1cfca"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M58 112h-1v-1h1zm-2 2v-1h1v1z",
    fill: "#cacbcc"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M63 111v1h-1v-1zm8 11h-1v-1h1z",
    fill: "#c3c5c4"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M32 113v-1h1v1zm21 1h1v1h-1z",
    fill: "#ced1d0"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113v-1h1v1zm3-1h1v1h-1z",
    fill: "#c9c9cb"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M71 113v-1h1v1zm-3 0v1h-1v-1z",
    fill: "#c2c5c4"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M32 114v-1h1v1zm32 8h1v1h-1z",
    fill: "#d0d0d0"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M36 114v-1h2v1h-1z",
    fill: "#d2d1d5"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M67 114h-1v-1h1zm-13 7v-1h1v1z",
    fill: "#c5c7c6"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M54 115v1h-1v-1zm-9 10v-1h1v1z",
    fill: "#d0d2d2"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M76 118v-2h1v2z",
    fill: "#dee0df",
    fillOpacity: 0.988
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M47 120v-1h1v1zm0 5v-1h1v1z",
    fill: "#d0d3d1"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M66 119h1v1h-1zm-9 1h1v1h-1z",
    fill: "#bcbebd"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M68 119h1v1h-1zm-9 2v-1h1v1z",
    fill: "#b5b7b6"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M70 120v-1h1v1zm-15 1h1v1h-1z",
    fill: "#bec0bf"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119v1h-1v-1zm-16 3v-1h1v1z",
    fill: "#adafae"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119h1v1h-1zm-15 1v1h-1v-1z",
    fill: "#bdbfbe"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M62 121h-1v-1h1zm4 0v-1h1v1z",
    fill: "#9ea09f"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M64 121h-1v-1h1zm-12 1h-1v-1h1z",
    fill: "#9d9f9e"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M68 121v-1h1v1zm-8 1h-1v-1h1z",
    fill: "#949695"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M70 121h-1v-1h1zm-17 0h1v1h-1z",
    fill: "#969897"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M75 122h-1v-1h1zm-12 1h-1v-1h1z",
    fill: "#c2c2c2"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M76 122h1v1h-1zm-8 2v-1h1v1z",
    fill: "#c6c6c6",
    fillOpacity: 0.071
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M66 124h-1v-1h1zm-18 1h1v1h-1z",
    fill: "#ccc",
    fillOpacity: 0.259
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M44 124v1h-2v-1h1z",
    fill: "#cfdbd6"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M61 125h-1v-1h1zm-9 0v1h-1v-1z",
    fill: "#d4d4d4",
    fillOpacity: 0.024
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M50 125h1v1h-1zm-9 1h1v1h-1z",
    fill: "#cecece",
    fillOpacity: 0.082
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M55 1V0h1v1z",
    fill: "#fff",
    fillOpacity: 0.071
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M57 1h-1V0h1z",
    fill: "#f0f0f0",
    fillOpacity: 0.2
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M58 0v1h-1V0z",
    fill: "#ebebee",
    fillOpacity: 0.302
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M58 1V0h1v1z",
    fill: "#ececef",
    fillOpacity: 0.38
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M59 1V0h1v1z",
    fill: "#ebebed",
    fillOpacity: 0.408
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M60 1V0h1v1z",
    fill: "#ededf2",
    fillOpacity: 0.392
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M61 0h1v1h-1z",
    fill: "#efeff2",
    fillOpacity: 0.322
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M63 0v1h-1V0z",
    fill: "#f5f5f5",
    fillOpacity: 0.22
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M63 1V0h1v1z",
    fill: "#f3e7f3",
    fillOpacity: 0.086
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M52 2V1h1v1z",
    fill: "#daffff",
    fillOpacity: 0.027
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M54 2h-1V1h1z",
    fill: "#e8ebee",
    fillOpacity: 0.361
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M55 2h-1V1h1z",
    fill: "#eaedf2",
    fillOpacity: 0.694
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M55 1h1v1h-1z",
    fill: "#e6eaed",
    fillOpacity: 0.859
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M57 1v1h-1V1z",
    fill: "#e4e5ea",
    fillOpacity: 0.957
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M57 2V1h1v1z",
    fill: "#e3e4ea",
    fillOpacity: 0.992
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M58 1h1v1h-1z",
    fill: "#e5e6eb"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M60 2h-1V1h1z",
    fill: "#e4e6eb"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M61 1v1h-1V1z",
    fill: "#e5e6ec"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M61 1h1v1h-1z",
    fill: "#e4e5ea",
    fillOpacity: 0.996
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M63 1v1h-1V1z",
    fill: "#e7e8ec",
    fillOpacity: 0.965
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M63 2V1h1v1z",
    fill: "#e9eaec",
    fillOpacity: 0.867
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M64 2V1h1v1z",
    fill: "#e6e8e6",
    fillOpacity: 0.541
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2V1h1v1z",
    fill: "#fff",
    fillOpacity: 0.047
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M51 2h1v1h-1z",
    fill: "#dfdfdf",
    fillOpacity: 0.031
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M52 2h1v1h-1z",
    fill: "#e3e7e6",
    fillOpacity: 0.643
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M53 2h1v1h-1z",
    fill: "#ebeef2"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M54 3V2h1v1z",
    fill: "#e4ebee"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M55 3V2h1v1z",
    fill: "#dee4e8"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M56 3V2h1v1z",
    fill: "#dfe1e6"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M58 3h-1V2h1z",
    fill: "#dde0e6"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M60 3V2h1v1z",
    fill: "#dadee3"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M62 3h-1V2h1z",
    fill: "#dbdfe3"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M62 2h1v1h-1z",
    fill: "#dce0e4"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M64 2v1h-1V2z",
    fill: "#e4e8ea"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2v1h-1V2z",
    fill: "#f8faf9"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2h1v1h-1z",
    fill: "#f4f7f7",
    fillOpacity: 0.38
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M52 4h-1V3h1z",
    fill: "#dcdce1",
    fillOpacity: 0.2
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M52 4V3h1v1z",
    fill: "#dfe2e4",
    fillOpacity: 0.992
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M53 3h1v1h-1z",
    fill: "#e4e7eb"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M55 4h-1V3h1z",
    fill: "#dce2e5"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M56 3v1h-1V3z",
    fill: "#dce3e5"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M56 3h1v1h-1z",
    fill: "#dde0e5"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M57 4V3h1v1z",
    fill: "#dde1e5"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M58 3h1v1h-1z",
    fill: "#dee1e6"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M60 3v1h-1V3z",
    fill: "#dee1e7"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M60 4V3h1v1z",
    fill: "#e0e4e9"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M63 3v1h-1V3z",
    fill: "#e7ebee"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M63 3h1v1h-1z",
    fill: "#eef2f3"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M65 4h-1V3h1z",
    fill: "#fcfffe"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M65 4V3h1v1z",
    fill: "#f8f9f9",
    fillOpacity: 0.576
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M51 4h1v1h-1z",
    fill: "#dedee2",
    fillOpacity: 0.243
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M53 5h-1V4h1z",
    fill: "#d7d9e1",
    fillOpacity: 0.996
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M53 4h1v1h-1z",
    fill: "#dee2e7"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M55 5h-1V4h1z",
    fill: "#e2e5e9"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M57 4v1h-1V4z",
    fill: "#e1e5e9"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M58 5h-1V4h1z",
    fill: "#e1e4eb"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M59 4v1h-1V4z",
    fill: "#e3e6ed"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M59 5V4h1v1z",
    fill: "#e5e8ef"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M61 4v1h-1V4z",
    fill: "#e3e6ec"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M61 5V4h1v1z",
    fill: "#e8ecf0"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M62 4h1v1h-1z",
    fill: "#e8ecee"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M63 4h1v1h-1z",
    fill: "#f1f5f5"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M65 5h-1V4h1z",
    fill: "#f9fdfc"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M66 5h-1V4h1z",
    fill: "#f5f7f7",
    fillOpacity: 0.663
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M52 6h-1V5h1z",
    fill: "#d9dde1",
    fillOpacity: 0.239
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M52 5h1v1h-1z",
    fill: "#d4d8df",
    fillOpacity: 0.996
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M54 5v1h-1V5z",
    fill: "#d9dde5"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M58 5v1h-1V5z",
    fill: "#d9dce2"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M59 5v1h-1V5z",
    fill: "#dbdee2"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M59 6V5h1v1z",
    fill: "#dfe2e5"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M60 6V5h1v1z",
    fill: "#dce0e1"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6h-1V5h1z",
    fill: "#eff3f2"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6V5h1v1z",
    fill: "#f7fbfa"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M65 5h1v1h-1z",
    fill: "#f3f6f5",
    fillOpacity: 0.725
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M52 6v1h-1V6z",
    fill: "#dbdbe0",
    fillOpacity: 0.227
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M52 7V6h1v1z",
    fill: "#d3d9e0",
    fillOpacity: 0.992
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M53 6h1v1h-1z",
    fill: "#d9dee7"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M55 7V6h1v1z",
    fill: "#dbdee3"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M59 6h1v1h-1z",
    fill: "#dee2e2"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M61 6v1h-1V6z",
    fill: "#dadedd"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M62 6v1h-1V6z",
    fill: "#e2e7e6"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M63 6v1h-1V6z",
    fill: "#e3e7e6"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6v1h-1V6z",
    fill: "#ecf0ef"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M65 7h-1V6h1z",
    fill: "#f5f9f8"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M66 7h-1V6h1z",
    fill: "#f0f3f3",
    fillOpacity: 0.769
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M51 7h1v1h-1z",
    fill: "#e5e5ee",
    fillOpacity: 0.118
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M52 7h1v1h-1z",
    fill: "#d8dde5",
    fillOpacity: 0.925
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8V7h1v1z",
    fill: "#dbdfe9"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M55 8V7h1v1z",
    fill: "#dbdee1"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M56 8V7h1v1z",
    fill: "#dbdfde"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M57 7h1v1h-1z",
    fill: "#dadedc"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M59 7v1h-1V7z",
    fill: "#d9dedc"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M59 8V7h1v1z",
    fill: "#dce0e0"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M61 7v1h-1V7z",
    fill: "#d9dedd"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M61 8V7h1v1z",
    fill: "#e1e6e5"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M62 7h1v1h-1z",
    fill: "#e2e5e2"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M63 7h1v1h-1z",
    fill: "#ebeeea"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M64 7h1v1h-1z",
    fill: "#f0f4f1"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M65 8V7h1v1z",
    fill: "#edf0ed",
    fillOpacity: 0.933
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M67 8h-1V7h1z",
    fill: "#dedede",
    fillOpacity: 0.404
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8h-1V7h1z",
    fill: "#ddd",
    fillOpacity: 0.059
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M31 8v1h-1V8z",
    fill: "#ffa",
    fillOpacity: 0.012
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M32 9h-1V8h1z",
    fill: "#bfbf9f",
    fillOpacity: 0.031
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M33 9h-1V8h1z",
    fill: "#638daa",
    fillOpacity: 0.071
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M33 9V8h1v1z",
    fill: "#4d79a6",
    fillOpacity: 0.09
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M35 9h-1V8h1z",
    fill: "#417394",
    fillOpacity: 0.122
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8v1h-1V8z",
    fill: "#396e96",
    fillOpacity: 0.173
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8h1v1h-1z",
    fill: "#346e95",
    fillOpacity: 0.208
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M38 8v1h-1V8z",
    fill: "#337097",
    fillOpacity: 0.231
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M39 9h-1V8h1z",
    fill: "#306b93",
    fillOpacity: 0.271
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8v1h-1V8z",
    fill: "#2c6a9d",
    fillOpacity: 0.337
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8v1h-1V8z",
    fill: "#1e518c",
    fillOpacity: 0.392
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8h1v1h-1z",
    fill: "#102374",
    fillOpacity: 0.427
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M43 8v1h-1V8z",
    fill: "#141975",
    fillOpacity: 0.478
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M43 8h1v1h-1z",
    fill: "#111572",
    fillOpacity: 0.514
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M45 9h-1V8h1z",
    fill: "#131873",
    fillOpacity: 0.522
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8h1v1h-1z",
    fill: "#1e2477",
    fillOpacity: 0.525
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M46 8h1v1h-1z",
    fill: "#262975",
    fillOpacity: 0.525
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M48 8v1h-1V8z",
    fill: "#424a81",
    fillOpacity: 0.525
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M49 8v1h-1V8z",
    fill: "#c9d1dc",
    fillOpacity: 0.576
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M50 8v1h-1V8z",
    fill: "#d0d3db",
    fillOpacity: 0.643
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M50 9V8h1v1z",
    fill: "#ccd5d8",
    fillOpacity: 0.667
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M51 8h1v1h-1z",
    fill: "#ccd3d6",
    fillOpacity: 0.694
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8v1h-1V8z",
    fill: "#d6dbe2",
    fillOpacity: 0.961
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8h1v1h-1z",
    fill: "#dce0e7"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M55 9h-1V8h1z",
    fill: "#dbdfe2"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M56 9h-1V8h1z",
    fill: "#dee2e1"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9V8h1v1z",
    fill: "#dde3de"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M58 9V8h1v1z",
    fill: "#dee3dd"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M60 9h-1V8h1z",
    fill: "#dde2db"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M60 8h1v1h-1z",
    fill: "#dde1db"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M62 8v1h-1V8z",
    fill: "#e0e3de"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M62 9V8h1v1z",
    fill: "#e4e6e0"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M64 8v1h-1V8z",
    fill: "#e9ebe5"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M64 9V8h1v1z",
    fill: "#edefeb"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M65 8h1v1h-1z",
    fill: "#e9eceb"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M67 9h-1V8h1z",
    fill: "#d9dee0"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M68 9h-1V8h1z",
    fill: "#d8dde0",
    fillOpacity: 0.831
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8h1v1h-1z",
    fill: "#78819b",
    fillOpacity: 0.424
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M70 9h-1V8h1z",
    fill: "#343d8c",
    fillOpacity: 0.114
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10V9h1v1z",
    fill: "#30306d",
    fillOpacity: 0.082
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9h1v1h-1z",
    fill: "#1f2a74",
    fillOpacity: 0.282
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9v1h-1V9z",
    fill: "#223176",
    fillOpacity: 0.345
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10V9h1v1z",
    fill: "#1f3274",
    fillOpacity: 0.376
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9v1h-1V9z",
    fill: "#163175",
    fillOpacity: 0.408
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10V9h1v1z",
    fill: "#15367b",
    fillOpacity: 0.463
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9h1v1h-1z",
    fill: "#19377d",
    fillOpacity: 0.541
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10h-1V9h1z",
    fill: "#224585",
    fillOpacity: 0.576
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9v1h-1V9z",
    fill: "#3466a4",
    fillOpacity: 0.608
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10V9h1v1z",
    fill: "#246aa6",
    fillOpacity: 0.659
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9h1v1h-1z",
    fill: "#1c67a2",
    fillOpacity: 0.714
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10h-1V9h1z",
    fill: "#1a68a1",
    fillOpacity: 0.749
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10V9h1v1z",
    fill: "#1365a0",
    fillOpacity: 0.776
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M31 9h1v1h-1z",
    fill: "#1168a3",
    fillOpacity: 0.816
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10V9h1v1z",
    fill: "#1166a8",
    fillOpacity: 0.875
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M34 10h-1V9h1z",
    fill: "#0e64a8",
    fillOpacity: 0.902
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M35 9v1h-1V9z",
    fill: "#0c65a8",
    fillOpacity: 0.925
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M35 10V9h1v1z",
    fill: "#0a64a7",
    fillOpacity: 0.965
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M37 9v1h-1V9z",
    fill: "#0863a9",
    fillOpacity: 0.98
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M38 10h-1V9h1z",
    fill: "#0764aa",
    fillOpacity: 0.992
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M39 9v1h-1V9z",
    fill: "#0767ad"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M40 10h-1V9h1z",
    fill: "#0869b1"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10h-1V9h1z",
    fill: "#1066b3"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9h1v1h-1z",
    fill: "#0d309b"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10h-1V9h1z",
    fill: "#010287"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M43 9h1v1h-1z",
    fill: "#01028c"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M44 10V9h1v1z",
    fill: "#01028b"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M45 9h1v1h-1z",
    fill: "#010187"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M47 9v1h-1V9z",
    fill: "#010181"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10V9h1v1z",
    fill: "#0f1479"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M48 10V9h1v1z",
    fill: "#aec0e2"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M50 10h-1V9h1z",
    fill: "#dae2e7"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M51 9v1h-1V9z",
    fill: "#ced8dc"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M52 9v1h-1V9z",
    fill: "#ced8db"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10V9h1v1z",
    fill: "#d4d9e0"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M54 10h-1V9h1z",
    fill: "#dde1e7"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M55 10h-1V9h1z",
    fill: "#dde2e4"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M56 10h-1V9h1z",
    fill: "#dde3e1"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9v1h-1V9z",
    fill: "#dde4df"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9h1v1h-1z",
    fill: "#dde4dd"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10h-1V9h1z",
    fill: "#dde3dc"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10V9h1v1z",
    fill: "#dee2da"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M61 9v1h-1V9z",
    fill: "#dee1d8"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M61 10V9h1v1z",
    fill: "#dee3db"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M62 10V9h1v1z",
    fill: "#e2e8e0"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M63 9h1v1h-1z",
    fill: "#e5eae4"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M64 9h1v1h-1z",
    fill: "#e6e9ea"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M66 9v1h-1V9z",
    fill: "#dde2e5"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M66 10V9h1v1z",
    fill: "#d7dee5"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M67 9h1v1h-1z",
    fill: "#dce7f0"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M69 10h-1V9h1z",
    fill: "#457"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M69 10V9h1v1z",
    fill: "#434f40",
    fillOpacity: 0.91
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M71 9v1h-1V9z",
    fill: "#b7b659",
    fillOpacity: 0.604
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M72 10h-1V9h1z",
    fill: "#dcd784",
    fillOpacity: 0.204
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10h-1V9h1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10h1v1h-1z",
    fill: "#1b2471",
    fillOpacity: 0.518
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11v-1h1v1z",
    fill: "#060f89"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10h1v1h-1z",
    fill: "#040f8b"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10v1h-1v-1z",
    fill: "#061989"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10h1v1h-1z",
    fill: "#032189"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10h1v1h-1z",
    fill: "#01218c"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11v-1h1v1z",
    fill: "#001e8b"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11v-1h1v1z",
    fill: "#001f8b"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11v-1h1v1z",
    fill: "#073498"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10h1v1h-1z",
    fill: "#115db9"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10h1v1h-1z",
    fill: "#076abe"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M31 10v1h-1v-1z",
    fill: "#006cbb"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M32 11h-1v-1h1z",
    fill: "#006dbd"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10h1v1h-1z",
    fill: "#006dbe"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M34 10v1h-1v-1z",
    fill: "#016cbe"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M34 11v-1h1v1z",
    fill: "#026bbe"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M36 10v1h-1v-1z",
    fill: "#036bbc"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M37 11v-1h1v1z",
    fill: "#016aba"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M38 11v-1h1v1z",
    fill: "#0168ba"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M39 10h1v1h-1z",
    fill: "#016abb"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10v1h-1v-1z",
    fill: "#026cb8"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10h1v1h-1z",
    fill: "#1264bb"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10v1h-1v-1z",
    fill: "#09299d"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10h1v1h-1z",
    fill: "#030087"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M45 11h-1v-1h1z",
    fill: "#04018b"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10v1h-1v-1z",
    fill: "#020088"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M46 11v-1h1v1z",
    fill: "#020187"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10h1v1h-1z",
    fill: "#00007f"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M48 11v-1h1v1z",
    fill: "#2a3d94"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h-1v-1h1z",
    fill: "#d4e1e3"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11v-1h1v1z",
    fill: "#d1d8dc"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10h1v1h-1z",
    fill: "#d3d9df"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11v-1h1v1z",
    fill: "#d8dee2"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M54 11v-1h1v1z",
    fill: "#dce1e4"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M55 11v-1h1v1z",
    fill: "#dce2e2"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M57 11h-1v-1h1z",
    fill: "#dae1df"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M57 10h1v1h-1z",
    fill: "#d9e1dd"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10v1h-1v-1z",
    fill: "#dbe0db"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10v1h-1v-1z",
    fill: "#dde1d9"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10h1v1h-1z",
    fill: "#dbe0d6"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M62 11h-1v-1h1z",
    fill: "#dae2da"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M63 11h-1v-1h1z",
    fill: "#d9e3dc"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M63 10h1v1h-1z",
    fill: "#dde7df"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v-1h1v1z",
    fill: "#dce5df"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M65 10h1v1h-1z",
    fill: "#dce1da"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M66 10h1v1h-1z",
    fill: "#d6dbca"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M67 11v-1h1v1z",
    fill: "#b2bcad"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M68 11v-1h1v1z",
    fill: "#8b946d"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v-1h1v1z",
    fill: "#beba53"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M71 10v1h-1v-1z",
    fill: "#b3af54"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M72 11h-1v-1h1z",
    fill: "#575d5e",
    fillOpacity: 0.969
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10v1h-1v-1z",
    fill: "#25336c",
    fillOpacity: 0.722
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M74 10v1h-1v-1z",
    fill: "#37477f",
    fillOpacity: 0.251
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M75 10v1h-1v-1z",
    fill: "#ffff7f",
    fillOpacity: 0.008
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11h1v1h-1z",
    fill: "#2b3885",
    fillOpacity: 0.553
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11h1v1h-1z",
    fill: "#020991"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11v1h-1v-1z",
    fill: "#010593"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12v-1h1v1z",
    fill: "#020b96"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11v1h-1v-1z",
    fill: "#001294"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12v-1h1v1z",
    fill: "#051d7c"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12v-1h1v1z",
    fill: "#253b66"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11h1v1h-1z",
    fill: "#284265"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11h1v1h-1z",
    fill: "#1e3267"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M28 11v1h-1v-1z",
    fill: "#112f74"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12v-1h1v1z",
    fill: "#0f4d96"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12h-1v-1h1z",
    fill: "#0a5a9f"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12v-1h1v1z",
    fill: "#045ca4"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M31 11h1v1h-1z",
    fill: "#065fae"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M33 11v1h-1v-1z",
    fill: "#0761b4"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M34 12h-1v-1h1z",
    fill: "#0464b7"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12h-1v-1h1z",
    fill: "#0265b8"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12v-1h1v1z",
    fill: "#0468bc"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h-1v-1h1z",
    fill: "#036bbf"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12v-1h1v1z",
    fill: "#016bbe"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M41 11h1v1h-1z",
    fill: "#036bc1"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M42 11h1v1h-1z",
    fill: "#0f67c5"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12h-1v-1h1z",
    fill: "#0a279b"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M44 11h1v1h-1z",
    fill: "#030086"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12h-1v-1h1z",
    fill: "#008"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M47 11v1h-1v-1z",
    fill: "#00008a"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M47 12v-1h1v1z",
    fill: "#00008b"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12h-1v-1h1z",
    fill: "#00037f"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12h-1v-1h1z",
    fill: "#263f92"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h1v1h-1z",
    fill: "#d8e5ef"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M52 12v-1h1v1z",
    fill: "#dbe0e6"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11h1v1h-1z",
    fill: "#dce1e6"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12h-1v-1h1z",
    fill: "#dee3e7"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v-1h1v1z",
    fill: "#e0e5e7"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M56 12v-1h1v1z",
    fill: "#e0e6e5"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M58 12h-1v-1h1z",
    fill: "#dee6e2"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M58 11h1v1h-1z",
    fill: "#dfe5e3"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M60 11h1v1h-1z",
    fill: "#d7ded7"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M62 11v1h-1v-1z",
    fill: "#d1d8c7"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M62 12v-1h1v1z",
    fill: "#d0d7b9"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v1h-1v-1z",
    fill: "#cdd4ad"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M64 12v-1h1v1z",
    fill: "#d3d3a5"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12h-1v-1h1z",
    fill: "#c3c789"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M66 11h1v1h-1z",
    fill: "#acac76"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12h-1v-1h1z",
    fill: "#78765a"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v1h-1v-1z",
    fill: "#444a4c"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11h1v1h-1z",
    fill: "#2c3150"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M71 12h-1v-1h1z",
    fill: "#1d306f"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M71 11h1v1h-1z",
    fill: "#042082"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M73 12h-1v-1h1z",
    fill: "#052095"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M74 11v1h-1v-1z",
    fill: "#0a1c83",
    fillOpacity: 0.98
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M74 11h1v1h-1z",
    fill: "#111b81",
    fillOpacity: 0.733
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M75 11h1v1h-1z",
    fill: "#1a1d77",
    fillOpacity: 0.376
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M77 12h-1v-1h1z",
    fill: "#3f3366",
    fillOpacity: 0.078
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13v-1h1v1z",
    fill: "#6b78b6",
    fillOpacity: 0.522
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12v1h-1v-1z",
    fill: "#09108f"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12v1h-1v-1z",
    fill: "#010190"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12v1h-1v-1z",
    fill: "#020981"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12h1v1h-1z",
    fill: "#0d1561"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13v-1h1v1z",
    fill: "#899951"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12v1h-1v-1z",
    fill: "#d9d64a"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13v-1h1v1z",
    fill: "#aaa756"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12v1h-1v-1z",
    fill: "#9d9d73"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12h1v1h-1z",
    fill: "#868a78"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12h1v1h-1z",
    fill: "#747f82"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12v1h-1v-1z",
    fill: "#707d89"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12h1v1h-1z",
    fill: "#62748c"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13v-1h1v1z",
    fill: "#4b6487"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12h1v1h-1z",
    fill: "#3c6288"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h-1v-1h1z",
    fill: "#37608c"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12v1h-1v-1z",
    fill: "#2f588c"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h-1v-1h1z",
    fill: "#2c5890"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M37 12v1h-1v-1z",
    fill: "#245491"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13v-1h1v1z",
    fill: "#204f93"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M38 13v-1h1v1z",
    fill: "#1d4d93"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M39 13v-1h1v1z",
    fill: "#194993"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h1v1h-1z",
    fill: "#174a97"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v-1h1v1z",
    fill: "#154999"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M42 12h1v1h-1z",
    fill: "#144b9c"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h-1v-1h1z",
    fill: "#1f439d"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13v-1h1v1z",
    fill: "#0a0e7d"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12v1h-1v-1z",
    fill: "#06057b"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v-1h1v1z",
    fill: "#0a0a7a"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M48 13h-1v-1h1z",
    fill: "#0e0e74"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M49 13h-1v-1h1z",
    fill: "#101275"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12h1v1h-1z",
    fill: "#0c166d"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h-1v-1h1z",
    fill: "#284076"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M51 12h1v1h-1z",
    fill: "#91a6b8"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M53 12v1h-1v-1z",
    fill: "#d2d8d2"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v-1h1v1z",
    fill: "#dbdbce"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v1h-1v-1z",
    fill: "#dddcd2"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v-1h1v1z",
    fill: "#d4d6cc"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13h-1v-1h1z",
    fill: "#c2cabc"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M57 12h1v1h-1z",
    fill: "#bbc7b4"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13v-1h1v1z",
    fill: "#b2bea9"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13v-1h1v1z",
    fill: "#9ca993"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M60 13v-1h1v1z",
    fill: "#a7b49c"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h-1v-1h1z",
    fill: "#aaaf89"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13h-1v-1h1z",
    fill: "#acac7d"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M63 12h1v1h-1z",
    fill: "#96976f"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13h-1v-1h1z",
    fill: "#747e69"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12v1h-1v-1z",
    fill: "#415864"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13h-1v-1h1z",
    fill: "#233865"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12v1h-1v-1z",
    fill: "#08175d"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13h-1v-1h1z",
    fill: "#021b78"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12v1h-1v-1z",
    fill: "#001d8d"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12h1v1h-1z",
    fill: "#001f94"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13v-1h1v1z",
    fill: "#021c9a"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M72 13v-1h1v1z",
    fill: "#021c9b"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13v-1h1v1z",
    fill: "#0317a1"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M75 12v1h-1v-1z",
    fill: "#0211a6"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M76 13h-1v-1h1z",
    fill: "#05139d"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M77 12v1h-1v-1z",
    fill: "#0d228d",
    fillOpacity: 0.839
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M77 12h1v1h-1z",
    fill: "#2d487f",
    fillOpacity: 0.11
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13h1v1h-1z",
    fill: "#9fb2de",
    fillOpacity: 0.494
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13h1v1h-1z",
    fill: "#1f2a9a"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13v1h-1v-1z",
    fill: "#01027f"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14h-1v-1h1z",
    fill: "#3d457e"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13v1h-1v-1z",
    fill: "#6e7355"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13v1h-1v-1z",
    fill: "#efe92f"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13h1v1h-1z",
    fill: "#99933c"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13v1h-1v-1z",
    fill: "#15296c"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14v-1h1v1z",
    fill: "#142b80"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13h1v1h-1z",
    fill: "#1b2c76"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M29 13v1h-1v-1z",
    fill: "#2b3982"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14h-1v-1h1z",
    fill: "#324082"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13h1v1h-1z",
    fill: "#364381"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13h1v1h-1z",
    fill: "#2e3e7a"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14h-1v-1h1z",
    fill: "#364782"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14v-1h1v1z",
    fill: "#425387"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h1v1h-1z",
    fill: "#4f5b87"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13v1h-1v-1z",
    fill: "#586085"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h1v1h-1z",
    fill: "#616589"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13h1v1h-1z",
    fill: "#65678b"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14v-1h1v1z",
    fill: "#676883"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M40 13v1h-1v-1z",
    fill: "#6c6c7f"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v1h-1v-1z",
    fill: "#69677f"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13h1v1h-1z",
    fill: "#6b6885"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h-1v-1h1z",
    fill: "#706c86"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14v-1h1v1z",
    fill: "#6d6f83"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h1v1h-1z",
    fill: "#717187"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v1h-1v-1z",
    fill: "#736e82"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13h1v1h-1z",
    fill: "#76737e"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M47 14v-1h1v1z",
    fill: "#76787b"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M48 14v-1h1v1z",
    fill: "#787a83"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14h-1v-1h1z",
    fill: "#7e8085"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M51 14h-1v-1h1z",
    fill: "#858d86"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h1v1h-1z",
    fill: "#78817c"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v1h-1v-1z",
    fill: "#777e7a"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h-1v-1h1z",
    fill: "#7b8084"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v1h-1v-1z",
    fill: "#76798e"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14v-1h1v1z",
    fill: "#58617e"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13v1h-1v-1z",
    fill: "#526781"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v-1h1v1z",
    fill: "#657d93"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13h1v1h-1z",
    fill: "#586e90"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13h1v1h-1z",
    fill: "#4a5f91"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14v-1h1v1z",
    fill: "#48609f"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13v1h-1v-1z",
    fill: "#2e508e"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13v1h-1v-1z",
    fill: "#1e468d"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M64 13v1h-1v-1z",
    fill: "#163b97"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13v1h-1v-1z",
    fill: "#0f369f"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M65 14v-1h1v1z",
    fill: "#0937a8"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13v1h-1v-1z",
    fill: "#0533ab"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M67 14v-1h1v1z",
    fill: "#032eae"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13v1h-1v-1z",
    fill: "#032ead"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v-1h1v1z",
    fill: "#0230b1"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14h-1v-1h1z",
    fill: "#0431b5"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13h1v1h-1z",
    fill: "#0332b6"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M72 14v-1h1v1z",
    fill: "#0533ba"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M74 13v1h-1v-1z",
    fill: "#0736be"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M75 13v1h-1v-1z",
    fill: "#0336c2"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M75 14v-1h1v1z",
    fill: "#0338c4"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M76 14v-1h1v1z",
    fill: "#073cb2"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M78 13v1h-1v-1z",
    fill: "#214c90",
    fillOpacity: 0.208
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15v-1h1v1z",
    fill: "#b1cdeb",
    fillOpacity: 0.502
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14h1v1h-1z",
    fill: "#455db2"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15h-1v-1h1z",
    fill: "#01036a"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15v-1h1v1z",
    fill: "#686d7c"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15h-1v-1h1z",
    fill: "#8d8b66"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15v-1h1v1z",
    fill: "#d9c92b"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15v-1h1v1z",
    fill: "#6c6f56"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15v-1h1v1z",
    fill: "#011296"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15h-1v-1h1z",
    fill: "#0018a4"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15v-1h1v1z",
    fill: "#021ea2"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15v-1h1v1z",
    fill: "#000f9b"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14h1v1h-1z",
    fill: "#000996"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15v-1h1v1z",
    fill: "#000795"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14v1h-1v-1z",
    fill: "#000597"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15v-1h1v1z",
    fill: "#000391"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14h1v1h-1z",
    fill: "#00038e"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15h-1v-1h1z",
    fill: "#000691"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15v-1h1v1z",
    fill: "#010a92"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M37 15h-1v-1h1z",
    fill: "#041294"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M37 15v-1h1v1z",
    fill: "#071390"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M39 14v1h-1v-1z",
    fill: "#09178e"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14v1h-1v-1z",
    fill: "#0e1e92"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h-1v-1h1z",
    fill: "#0e2490"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14v1h-1v-1z",
    fill: "#122a8c"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15v-1h1v1z",
    fill: "#1b3590"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h1v1h-1z",
    fill: "#1c3b92"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15h-1v-1h1z",
    fill: "#203e91"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15h-1v-1h1z",
    fill: "#243d8d"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M47 15h-1v-1h1z",
    fill: "#1d3c8a"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M48 15h-1v-1h1z",
    fill: "#1e3e95"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15h-1v-1h1z",
    fill: "#214198"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14v1h-1v-1z",
    fill: "#1f409c"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15v-1h1v1z",
    fill: "#1d4197"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15v-1h1v1z",
    fill: "#163c9a"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15v-1h1v1z",
    fill: "#1339a2"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14v1h-1v-1z",
    fill: "#0b33a5"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h1v1h-1z",
    fill: "#052da8"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14h1v1h-1z",
    fill: "#0130a9"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v1h-1v-1z",
    fill: "#002dae"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h-1v-1h1z",
    fill: "#022fb4"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14v1h-1v-1z",
    fill: "#002bae"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M59 15v-1h1v1z",
    fill: "#002bb2"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14h1v1h-1z",
    fill: "#002fb7"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M62 15h-1v-1h1z",
    fill: "#0030ba"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M62 14h1v1h-1z",
    fill: "#0031b9"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M63 14h1v1h-1z",
    fill: "#0130bb"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M64 14h1v1h-1z",
    fill: "#012fbb"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M66 15v-1h1v1z",
    fill: "#0132b8"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M68 15h-1v-1h1z",
    fill: "#0332ba"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v1h-1v-1z",
    fill: "#0231ba"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14v1h-1v-1z",
    fill: "#0133ba"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15v-1h1v1z",
    fill: "#0233bb"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h-1v-1h1z",
    fill: "#0534c1"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v-1h1v1z",
    fill: "#0334be"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M75 14h1v1h-1z",
    fill: "#0234c1"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M77 14v1h-1v-1z",
    fill: "#063cb4",
    fillOpacity: 0.98
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M78 14v1h-1v-1z",
    fill: "#28509b",
    fillOpacity: 0.2
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15v1h-1v-1z",
    fill: "#accadf",
    fillOpacity: 0.533
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16v-1h1v1z",
    fill: "#799ad7"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15v1h-1v-1z",
    fill: "#010756"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16h-1v-1h1z",
    fill: "#8c919b"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16v-1h1v1z",
    fill: "#b8b6aa"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15h1v1h-1z",
    fill: "#bfb146"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16v-1h1v1z",
    fill: "#676a5f"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16h-1v-1h1z",
    fill: "#000c91"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16v-1h1v1z",
    fill: "#000c9b"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15h1v1h-1z",
    fill: "#0921ab"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15h1v1h-1z",
    fill: "#1331a9"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16v-1h1v1z",
    fill: "#082aab"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15h1v1h-1z",
    fill: "#0525ae"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15v1h-1v-1z",
    fill: "#031ba9"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15h1v1h-1z",
    fill: "#051fb1"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15v1h-1v-1z",
    fill: "#0721b2"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16v-1h1v1z",
    fill: "#0425b4"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15v1h-1v-1z",
    fill: "#0426b5"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15h1v1h-1z",
    fill: "#0229b7"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16v-1h1v1z",
    fill: "#0429b6"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M39 16h-1v-1h1z",
    fill: "#0429b7"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15v1h-1v-1z",
    fill: "#012aba"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15v1h-1v-1z",
    fill: "#012cb9"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h-1v-1h1z",
    fill: "#002ab4"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16h-1v-1h1z",
    fill: "#002bb3"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M48 16h-1v-1h1z",
    fill: "#0028b0"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15v1h-1v-1z",
    fill: "#002ab0"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16h-1v-1h1z",
    fill: "#0028a9"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15h1v1h-1z",
    fill: "#0229b4"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15h1v1h-1z",
    fill: "#042eb1"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15h1v1h-1z",
    fill: "#042fad"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M53 16v-1h1v1z",
    fill: "#0832ac"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M55 15v1h-1v-1z",
    fill: "#0b36b0"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15v1h-1v-1z",
    fill: "#0333b3"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15h1v1h-1z",
    fill: "#1442b3"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15v1h-1v-1z",
    fill: "#012ab0"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h1v1h-1z",
    fill: "#214db4"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15v1h-1v-1z",
    fill: "#1a45ac"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16v-1h1v1z",
    fill: "#012bb5"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M62 16h-1v-1h1z",
    fill: "#022eb8"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M63 16h-1v-1h1z",
    fill: "#022fb9"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16h-1v-1h1z",
    fill: "#022db7"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16v-1h1v1z",
    fill: "#022fb8"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M66 16v-1h1v1z",
    fill: "#022fb7"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16h-1v-1h1z",
    fill: "#0130b8"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v1h-1v-1z",
    fill: "#022ebb"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h1v1h-1z",
    fill: "#022fbb"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16h-1v-1h1z",
    fill: "#012fb9"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v-1h1v1z",
    fill: "#063db3",
    fillOpacity: 0.98
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M77 15h1v1h-1z",
    fill: "#28559b",
    fillOpacity: 0.2
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17h-1v-1h1z",
    fill: "#a4bfd7",
    fillOpacity: 0.553
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16v1h-1v-1z",
    fill: "#99c1ef"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16v1h-1v-1z",
    fill: "#213271"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17h-1v-1h1z",
    fill: "#989ca2"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16v1h-1v-1z",
    fill: "#9e9d99"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17v-1h1v1z",
    fill: "#a79f55"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17h-1v-1h1z",
    fill: "#626756"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16h1v1h-1z",
    fill: "#01128e"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16h1v1h-1z",
    fill: "#020ea0"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h-1v-1h1z",
    fill: "#041698"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17v-1h1v1z",
    fill: "#5a7eb7"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16h1v1h-1z",
    fill: "#235eb3"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16v1h-1v-1z",
    fill: "#084fc8"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17h-1v-1h1z",
    fill: "#082bb3"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h-1v-1h1z",
    fill: "#010c9f"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17v-1h1v1z",
    fill: "#030da5"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16h1v1h-1z",
    fill: "#0219ad"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17v-1h1v1z",
    fill: "#0220b0"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16h1v1h-1z",
    fill: "#0022af"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16v1h-1v-1z",
    fill: "#0121af"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16h1v1h-1z",
    fill: "#0122af"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17v-1h1v1z",
    fill: "#0123b0"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M42 16h1v1h-1z",
    fill: "#0325af"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h1v1h-1z",
    fill: "#0327af"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16v1h-1v-1z",
    fill: "#0227af"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17v-1h1v1z",
    fill: "#0328af"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h-1v-1h1z",
    fill: "#2b53b7"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M48 17h-1v-1h1z",
    fill: "#2a53a4"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M49 17h-1v-1h1z",
    fill: "#264da4"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16v1h-1v-1z",
    fill: "#5a81c5"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M50 17v-1h1v1z",
    fill: "#2e52a7"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M52 16v1h-1v-1z",
    fill: "#6691c3"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M52 17v-1h1v1z",
    fill: "#4e7aaf"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17h-1v-1h1z",
    fill: "#4d79af"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17v-1h1v1z",
    fill: "#4f7cbb"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M55 16h1v1h-1z",
    fill: "#1b4aa4"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M57 16v1h-1v-1z",
    fill: "#5887c5"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M57 17v-1h1v1z",
    fill: "#1541a0"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v-1h1v1z",
    fill: "#70a0ca"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17h-1v-1h1z",
    fill: "#608dc4"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17h-1v-1h1z",
    fill: "#012aae"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M62 17v-1h1v1z",
    fill: "#032db8"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M64 16v1h-1v-1z",
    fill: "#012cb7"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M66 17h-1v-1h1z",
    fill: "#002eb8"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v1h-1v-1z",
    fill: "#002eb6"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16h1v1h-1z",
    fill: "#012db7"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M68 16h1v1h-1z",
    fill: "#012eb9"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M71 17h-1v-1h1z",
    fill: "#002cb7"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M72 17h-1v-1h1z",
    fill: "#002db8"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M72 16h1v1h-1z",
    fill: "#002bba"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16v1h-1v-1z",
    fill: "#002bb7"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v1h-1v-1z",
    fill: "#002ab8"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v1h-1v-1z",
    fill: "#002fb9"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17h-1v-1h1z",
    fill: "#023aac",
    fillOpacity: 0.98
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M77 16h1v1h-1z",
    fill: "#285199",
    fillOpacity: 0.196
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18h-1v-1h1z",
    fill: "#9bb6ce",
    fillOpacity: 0.58
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17v1h-1v-1z",
    fill: "#a5d2f4"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17v1h-1v-1z",
    fill: "#405788"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17v1h-1v-1z",
    fill: "#838792"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17h1v1h-1z",
    fill: "#9f9c9c"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18h-1v-1h1z",
    fill: "#a8a261"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18v-1h1v1z",
    fill: "#66694f"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18h-1v-1h1z",
    fill: "#041987"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18v-1h1v1z",
    fill: "#010fa0"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17v1h-1v-1z",
    fill: "#031182"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h1v1h-1z",
    fill: "#89a9cb"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18v-1h1v1z",
    fill: "#2b5cb4"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18v-1h1v1z",
    fill: "#014ecc"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17v1h-1v-1z",
    fill: "#0b57d2"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17h1v1h-1z",
    fill: "#0222ae"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h1v1h-1z",
    fill: "#0104a2"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18v-1h1v1z",
    fill: "#0303a8"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17h1v1h-1z",
    fill: "#010aa9"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M36 18v-1h1v1z",
    fill: "#0218ae"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18h-1v-1h1z",
    fill: "#021baf"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M39 18h-1v-1h1z",
    fill: "#011faf"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17h1v1h-1z",
    fill: "#0120ae"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M41 17v1h-1v-1z",
    fill: "#011dab"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17v1h-1v-1z",
    fill: "#0020ab"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M43 18h-1v-1h1z",
    fill: "#0122ad"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17v1h-1v-1z",
    fill: "#0225b1"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17h1v1h-1z",
    fill: "#0426b2"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17h1v1h-1z",
    fill: "#0022ab"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M46 18v-1h1v1z",
    fill: "#3c66b4"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h1v1h-1z",
    fill: "#557fb8"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h-1v-1h1z",
    fill: "#3f66a9"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M50 18h-1v-1h1z",
    fill: "#6591c2"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17v1h-1v-1z",
    fill: "#4671b1"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17h1v1h-1z",
    fill: "#416fb0"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17v1h-1v-1z",
    fill: "#497ab8"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17h1v1h-1z",
    fill: "#2a5aab"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h-1v-1h1z",
    fill: "#3e70bb"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18v-1h1v1z",
    fill: "#2c5eb8"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18v-1h1v1z",
    fill: "#3360b9"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v1h-1v-1z",
    fill: "#2556b6"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v-1h1v1z",
    fill: "#1945a8"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M59 17h1v1h-1z",
    fill: "#143eab"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v-1h1v1z",
    fill: "#0029af"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M62 18h-1v-1h1z",
    fill: "#0225b0"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M63 17v1h-1v-1z",
    fill: "#0523ac"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v-1h1v1z",
    fill: "#051fa9"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17h1v1h-1z",
    fill: "#0d1fa9"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M65 18v-1h1v1z",
    fill: "#131faa"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h-1v-1h1z",
    fill: "#131ca5"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M68 17v1h-1v-1z",
    fill: "#191ba3"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h-1v-1h1z",
    fill: "#2119a2"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M70 17v1h-1v-1z",
    fill: "#28159e"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18v-1h1v1z",
    fill: "#2e149b"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M71 18v-1h1v1z",
    fill: "#371396"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M72 18v-1h1v1z",
    fill: "#3e1297"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18h-1v-1h1z",
    fill: "#441196"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18h-1v-1h1z",
    fill: "#4c1295"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18v-1h1v1z",
    fill: "#591597"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17v1h-1v-1z",
    fill: "#681b94",
    fillOpacity: 0.98
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M78 17v1h-1v-1z",
    fill: "#73378c",
    fillOpacity: 0.2
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19v-1h1v1z",
    fill: "#94b7cd",
    fillOpacity: 0.584
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19v-1h1v1z",
    fill: "#a4d1f1"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19v-1h1v1z",
    fill: "#6a89af"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18h1v1h-1z",
    fill: "#6e7681"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18h1v1h-1z",
    fill: "#c3bdbc"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19v-1h1v1z",
    fill: "#b4af70"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19h-1v-1h1z",
    fill: "#6c6846"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18v1h-1v-1z",
    fill: "#04157a"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18h1v1h-1z",
    fill: "#010b99"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19h-1v-1h1z",
    fill: "#0f1e7d"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19h-1v-1h1z",
    fill: "#9cc0de"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18h1v1h-1z",
    fill: "#2958b0"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19h-1v-1h1z",
    fill: "#0045c1"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M31 18h1v1h-1z",
    fill: "#0262d6"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18v1h-1v-1z",
    fill: "#0652ce"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19v-1h1v1z",
    fill: "#031aab"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19h-1v-1h1z",
    fill: "#0000a0"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19h-1v-1h1z",
    fill: "#0003a5"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19v-1h1v1z",
    fill: "#000da9"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18v1h-1v-1z",
    fill: "#0016ad"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v-1h1v1z",
    fill: "#001db0"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18v1h-1v-1z",
    fill: "#011bae"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v-1h1v1z",
    fill: "#001cac"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M41 19v-1h1v1z",
    fill: "#001eaa"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M44 18v1h-1v-1z",
    fill: "#001ea9"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19h-1v-1h1z",
    fill: "#0020aa"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19v-1h1v1z",
    fill: "#001fa7"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M47 18v1h-1v-1z",
    fill: "#0524a3"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v-1h1v1z",
    fill: "#0c26a0"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M48 19v-1h1v1z",
    fill: "#0a23a2"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h1v1h-1z",
    fill: "#041c9c"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M51 19h-1v-1h1z",
    fill: "#101f9c"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M52 19h-1v-1h1z",
    fill: "#14189a"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M52 19v-1h1v1z",
    fill: "#1a189b"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M53 18h1v1h-1z",
    fill: "#201897"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M54 18h1v1h-1z",
    fill: "#271596"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h1v1h-1z",
    fill: "#321294"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18h1v1h-1z",
    fill: "#3f0e91"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v1h-1v-1z",
    fill: "#4b0e94"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M59 19h-1v-1h1z",
    fill: "#5d0a93"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v1h-1v-1z",
    fill: "#630789"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M60 19v-1h1v1z",
    fill: "#73098d"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18h1v1h-1z",
    fill: "#7f0c8a"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19h-1v-1h1z",
    fill: "#8f0b88"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1z",
    fill: "#990989"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v-1h1v1z",
    fill: "#a70988"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M66 18v1h-1v-1z",
    fill: "#b20585"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18v1h-1v-1z",
    fill: "#bd0787"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h1v1h-1z",
    fill: "#ca0989"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18v1h-1v-1z",
    fill: "#cc0b87"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h1v1h-1z",
    fill: "#d50d88"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18h1v1h-1z",
    fill: "#db0a84"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M72 19h-1v-1h1z",
    fill: "#e30b81"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M73 19h-1v-1h1z",
    fill: "#eb0a82"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18v1h-1v-1z",
    fill: "#ef0780"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M74 19v-1h1v1z",
    fill: "#f20782"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M75 19v-1h1v1z",
    fill: "#fa0684"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M76 19v-1h1v1z",
    fill: "#ef0b82",
    fillOpacity: 0.992
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M78 19h-1v-1h1z",
    fill: "#d12d84",
    fillOpacity: 0.22
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20v-1h1v1z",
    fill: "#93b5ca",
    fillOpacity: 0.588
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19h1v1h-1z",
    fill: "#9ccae9"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20h-1v-1h1z",
    fill: "#8db3d5"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19v1h-1v-1z",
    fill: "#7c8492"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19h1v1h-1z",
    fill: "#a5a3a0"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20h-1v-1h1z",
    fill: "#98925c"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20v-1h1v1z",
    fill: "#71643d"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20v-1h1v1z",
    fill: "#060d6f"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19h1v1h-1z",
    fill: "#000493"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19h1v1h-1z",
    fill: "#20378a"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19v1h-1v-1z",
    fill: "#a5d1ea"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19v1h-1v-1z",
    fill: "#2553a9"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20v-1h1v1z",
    fill: "#0038b8"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19v1h-1v-1z",
    fill: "#0c52c4"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20h-1v-1h1z",
    fill: "#2058c6"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20v-1h1v1z",
    fill: "#4249bf"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19v1h-1v-1z",
    fill: "#341091"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20v-1h1v1z",
    fill: "#34048a"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20v-1h1v1z",
    fill: "#34068c"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v1h-1v-1z",
    fill: "#390a8f"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M39 19v1h-1v-1z",
    fill: "#400b8f"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v1h-1v-1z",
    fill: "#460b8d"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19h1v1h-1z",
    fill: "#4c0c8b"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M41 20v-1h1v1z",
    fill: "#5c0989"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20h-1v-1h1z",
    fill: "#610986"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19v1h-1v-1z",
    fill: "#6a0785"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19h1v1h-1z",
    fill: "#740b8a"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20v-1h1v1z",
    fill: "#7d0a8b"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v1h-1v-1z",
    fill: "#870a86"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M48 20h-1v-1h1z",
    fill: "#930c81"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M49 19v1h-1v-1z",
    fill: "#9d0b84"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v-1h1v1z",
    fill: "#9f0a81"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20v-1h1v1z",
    fill: "#a9077d"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M51 20v-1h1v1z",
    fill: "#b60981"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M52 20v-1h1v1z",
    fill: "#c1097f"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19v1h-1v-1z",
    fill: "#cb0a7f"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19h1v1h-1z",
    fill: "#d20c83"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M56 19v1h-1v-1z",
    fill: "#db1186"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20h-1v-1h1z",
    fill: "#d71a85"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M58 20h-1v-1h1z",
    fill: "#e01686"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M59 20h-1v-1h1z",
    fill: "#e71786"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h-1v-1h1z",
    fill: "#e4268d"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1z",
    fill: "#f01a8a"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19h1v1h-1z",
    fill: "#f0208b"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1z",
    fill: "#ee1683"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v1h-1v-1z",
    fill: "#f51a88"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1z",
    fill: "#f01d85"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20h-1v-1h1z",
    fill: "#e94ca3"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20h-1v-1h1z",
    fill: "#ed48a4"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19h1v1h-1z",
    fill: "#e72588"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20v-1h1v1z",
    fill: "#ea5aad"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M70 19v1h-1v-1z",
    fill: "#e759ad"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M71 19v1h-1v-1z",
    fill: "#ed2a8e"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h-1v-1h1z",
    fill: "#fe0076"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20v-1h1v1z",
    fill: "#ff007b"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M75 20h-1v-1h1z",
    fill: "#fc0079"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M76 20h-1v-1h1z",
    fill: "#ff0079"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M77 20h-1v-1h1z",
    fill: "#ef077a",
    fillOpacity: 0.996
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20h-1v-1h1z",
    fill: "#cd2c81",
    fillOpacity: 0.224
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20h1v1h-1z",
    fill: "#93b5cb",
    fillOpacity: 0.584
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21v-1h1v1z",
    fill: "#98c6e7"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20h1v1h-1z",
    fill: "#9bc4e6"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20h1v1h-1z",
    fill: "#8493a2"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20h1v1h-1z",
    fill: "#aba65d"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21v-1h1v1z",
    fill: "#7b7041"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20v1h-1v-1z",
    fill: "#0e116e"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21h-1v-1h1z",
    fill: "#000589"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20h1v1h-1z",
    fill: "#3355a0"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20h1v1h-1z",
    fill: "#afd6f1"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21h-1v-1h1z",
    fill: "#774ea1"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20v1h-1v-1z",
    fill: "#831095"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21v-1h1v1z",
    fill: "#ae38a9"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20h1v1h-1z",
    fill: "#cc4bab"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M34 20v1h-1v-1z",
    fill: "#e555ad"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21h-1v-1h1z",
    fill: "#ec44a2"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20h1v1h-1z",
    fill: "#d6177d"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20h1v1h-1z",
    fill: "#de0774"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20v1h-1v-1z",
    fill: "#e10d7b"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M41 20v1h-1v-1z",
    fill: "#ea0779"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M42 20v1h-1v-1z",
    fill: "#e70d7c"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20v1h-1v-1z",
    fill: "#df1680"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M44 20v1h-1v-1z",
    fill: "#e42c90"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M45 21h-1v-1h1z",
    fill: "#e91780"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20v1h-1v-1z",
    fill: "#ee1884"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20h1v1h-1z",
    fill: "#ed1f87"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M47 20h1v1h-1z",
    fill: "#e81f7d"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v1h-1v-1z",
    fill: "#ec2185"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20h1v1h-1z",
    fill: "#e73791"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20h1v1h-1z",
    fill: "#df4e9e"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h-1v-1h1z",
    fill: "#ed2a8d"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M53 20v1h-1v-1z",
    fill: "#e73e96"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M53 21v-1h1v1z",
    fill: "#df64ab"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20v1h-1v-1z",
    fill: "#e83b95"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20h1v1h-1z",
    fill: "#e33f99"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21h-1v-1h1z",
    fill: "#e785c5"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21v-1h1v1z",
    fill: "#df3f92"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21h-1v-1h1z",
    fill: "#e46bb1"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20v1h-1v-1z",
    fill: "#dd80c0"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1z",
    fill: "#de298a"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21h-1v-1h1z",
    fill: "#df5fad"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v1h-1v-1z",
    fill: "#d769b3"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21v-1h1v1z",
    fill: "#da54a6"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h-1v-1h1z",
    fill: "#db499b"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1z",
    fill: "#db84c3"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1z",
    fill: "#d33a90"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1z",
    fill: "#dd2d8b"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20h1v1h-1z",
    fill: "#da53a4"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h-1v-1h1z",
    fill: "#d23990"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21v-1h1v1z",
    fill: "#eb55ac"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M71 20h1v1h-1z",
    fill: "#f90072"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h1v1h-1z",
    fill: "#f07"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h1v1h-1z",
    fill: "#fe0078"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M75 21h-1v-1h1z",
    fill: "#fd007a"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M77 21h-1v-1h1z",
    fill: "#f0087a",
    fillOpacity: 0.996
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h-1v-1h1z",
    fill: "#cf2f81",
    fillOpacity: 0.231
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22v-1h1v1z",
    fill: "#92b4ca",
    fillOpacity: 0.588
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21v1h-1v-1z",
    fill: "#92c2e5"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22h-1v-1h1z",
    fill: "#9ec6eb"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22v-1h1v1z",
    fill: "#7f95ab"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21h1v1h-1z",
    fill: "#8d9089"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21v1h-1v-1z",
    fill: "#aca645"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21h1v1h-1z",
    fill: "#827840"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21h1v1h-1z",
    fill: "#0d0e63"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21h1v1h-1z",
    fill: "#000881"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22v-1h1v1z",
    fill: "#4070b3"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22h-1v-1h1z",
    fill: "#bad7f7"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22h-1v-1h1z",
    fill: "#db5eac"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21h1v1h-1z",
    fill: "#f80081"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21h1v1h-1z",
    fill: "#ff1893"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21v1h-1v-1z",
    fill: "#ff3d99"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22v-1h1v1z",
    fill: "#ff4b9d"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21v1h-1v-1z",
    fill: "#fd4ca1"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22h-1v-1h1z",
    fill: "#f055a7"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21h1v1h-1z",
    fill: "#e60d72"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21v1h-1v-1z",
    fill: "#ea3995"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22v-1h1v1z",
    fill: "#de368e"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22v-1h1v1z",
    fill: "#ea6eb8"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22v-1h1v1z",
    fill: "#da378c"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M41 21h1v1h-1z",
    fill: "#df3c92"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M42 21h1v1h-1z",
    fill: "#dd61ac"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M43 22v-1h1v1z",
    fill: "#d46fb2"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M44 21h1v1h-1z",
    fill: "#d4368c"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22v-1h1v1z",
    fill: "#dc4fa3"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M47 21v1h-1v-1z",
    fill: "#d86eb2"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M47 22v-1h1v1z",
    fill: "#d772b2"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M49 21v1h-1v-1z",
    fill: "#d44294"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M50 21v1h-1v-1z",
    fill: "#dd7bbd"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M51 21v1h-1v-1z",
    fill: "#cd74b3"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21v1h-1v-1z",
    fill: "#d71d7b"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h1v1h-1z",
    fill: "#e375b7"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M54 22h-1v-1h1z",
    fill: "#ce80b8"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21v1h-1v-1z",
    fill: "#e22485"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21h1v1h-1z",
    fill: "#e21079"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22h-1v-1h1z",
    fill: "#e75eac"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1z",
    fill: "#e6046c"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M58 21h1v1h-1z",
    fill: "#e673b8"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22v-1h1v1z",
    fill: "#d16dac"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22h-1v-1h1z",
    fill: "#de2b87"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22h-1v-1h1z",
    fill: "#df47a0"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22v-1h1v1z",
    fill: "#d23e90"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21h1v1h-1z",
    fill: "#e871bb"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22h-1v-1h1z",
    fill: "#e13490"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h1v1h-1z",
    fill: "#e373bb"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-1v-1z",
    fill: "#e354a6"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1z",
    fill: "#e3298a"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M69 21v1h-1v-1z",
    fill: "#e863b3"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M69 22v-1h1v1z",
    fill: "#e853a9"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h1v1h-1z",
    fill: "#ed167f"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M71 21h1v1h-1z",
    fill: "#fd0073"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21v1h-1v-1z",
    fill: "#fe0075"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21v1h-1v-1z",
    fill: "#ff0075"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22h-1v-1h1z",
    fill: "#f10474",
    fillOpacity: 0.996
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M78 22h-1v-1h1z",
    fill: "#cf2f7d",
    fillOpacity: 0.231
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22h1v1h-1z",
    fill: "#91b3c8",
    fillOpacity: 0.592
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22v1h-1v-1z",
    fill: "#91c1e4"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22h1v1h-1z",
    fill: "#98c4e8"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23h-1v-1h1z",
    fill: "#88abc9"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23v-1h1v1z",
    fill: "#434e51"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23h-1v-1h1z",
    fill: "#bab535"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23h-1v-1h1z",
    fill: "#7f7633"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23v-1h1v1z",
    fill: "#040558"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22v1h-1v-1z",
    fill: "#02128a"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22h1v1h-1z",
    fill: "#4c86c5"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22v1h-1v-1z",
    fill: "#b6d7f5"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23v-1h1v1z",
    fill: "#da5fad"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22h1v1h-1z",
    fill: "#f60080"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v-1h1v1z",
    fill: "#fd1895"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22v1h-1v-1z",
    fill: "#fd3a9a"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22h1v1h-1z",
    fill: "#fe499c"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M34 23v-1h1v1z",
    fill: "#f54a9a"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22h1v1h-1z",
    fill: "#f17fc0"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v-1h1v1z",
    fill: "#db4497"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M38 23h-1v-1h1z",
    fill: "#e353aa"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22h1v1h-1z",
    fill: "#da4198"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22h1v1h-1z",
    fill: "#cf4d9a"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h-1v-1h1z",
    fill: "#e07fbf"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M42 22v1h-1v-1z",
    fill: "#da4091"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23v-1h1v1z",
    fill: "#d84998"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M43 23v-1h1v1z",
    fill: "#d36fb1"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23h-1v-1h1z",
    fill: "#de499d"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22h1v1h-1z",
    fill: "#e1469d"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M46 22h1v1h-1z",
    fill: "#d857a4"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23h-1v-1h1z",
    fill: "#e366b1"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v-1h1v1z",
    fill: "#e01b7c"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23h-1v-1h1z",
    fill: "#e85dad"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22h1v1h-1z",
    fill: "#df62ae"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22v1h-1v-1z",
    fill: "#ea2d8f"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22h1v1h-1z",
    fill: "#e6469d"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M53 23v-1h1v1z",
    fill: "#dc55a2"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h-1v-1h1z",
    fill: "#ee2b8e"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M56 22v1h-1v-1z",
    fill: "#f10473"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M57 23h-1v-1h1z",
    fill: "#ee1c83"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#f40072"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v-1h1v1z",
    fill: "#eb2087"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#e5298d"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1z",
    fill: "#e7187e"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1z",
    fill: "#e80c74"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23h-1v-1h1z",
    fill: "#ed0275"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1z",
    fill: "#e50f76"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1z",
    fill: "#e70c79"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23v-1h1v1z",
    fill: "#dd147e"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23h-1v-1h1z",
    fill: "#dd1880"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M68 22v1h-1v-1z",
    fill: "#e41283"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M69 23h-1v-1h1z",
    fill: "#d71682"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1z",
    fill: "#d51582"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M71 22v1h-1v-1z",
    fill: "#d41985"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h-1v-1h1z",
    fill: "#ce1e88"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23v-1h1v1z",
    fill: "#cc1e89"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v1h-1v-1z",
    fill: "#c91f8d"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23h-1v-1h1z",
    fill: "#c9218f"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23v-1h1v1z",
    fill: "#cb2696"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22v1h-1v-1z",
    fill: "#b83097",
    fillOpacity: 0.984
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M77 23v-1h1v1z",
    fill: "#a0508d",
    fillOpacity: 0.212
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23v1h-1v-1z",
    fill: "#92b3c8",
    fillOpacity: 0.592
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24h-1v-1h1z",
    fill: "#91c1e5"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24h-1v-1h1z",
    fill: "#92c2e4"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24v-1h1v1z",
    fill: "#97c5ec"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23v1h-1v-1z",
    fill: "#354d63"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M23 24v-1h1v1z",
    fill: "#bdbc2f"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23h1v1h-1z",
    fill: "#837837"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23v1h-1v-1z",
    fill: "#030258"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24h-1v-1h1z",
    fill: "#0a2898"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23v1h-1v-1z",
    fill: "#5699d3"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23h1v1h-1z",
    fill: "#b6d6f5"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23h1v1h-1z",
    fill: "#dc62af"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v1h-1v-1z",
    fill: "#f6007f"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24v-1h1v1z",
    fill: "#fd1b91"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24h-1v-1h1z",
    fill: "#fd3b9a"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24h-1v-1h1z",
    fill: "#ff429a"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24h-1v-1h1z",
    fill: "#fd4296"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v1h-1v-1z",
    fill: "#f75fa7"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24v-1h1v1z",
    fill: "#f079be"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24h-1v-1h1z",
    fill: "#e82c8f"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v-1h1v1z",
    fill: "#ef1181"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24h-1v-1h1z",
    fill: "#e90872"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23v1h-1v-1z",
    fill: "#e92182"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h1v1h-1z",
    fill: "#eb0d75"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23h1v1h-1z",
    fill: "#e9197d"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24h-1v-1h1z",
    fill: "#e32586"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23v1h-1v-1z",
    fill: "#e50672"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24v-1h1v1z",
    fill: "#e30875"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M46 23h1v1h-1z",
    fill: "#e00c77"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v1h-1v-1z",
    fill: "#e00a76"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24v-1h1v1z",
    fill: "#e50977"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M49 23h1v1h-1z",
    fill: "#e00f79"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v-1h1v1z",
    fill: "#da157c"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h-1v-1h1z",
    fill: "#e0167f"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24v-1h1v1z",
    fill: "#e21883"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24v-1h1v1z",
    fill: "#da1c85"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23h1v1h-1z",
    fill: "#d82589"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1z",
    fill: "#db2d8f"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h1v1h-1z",
    fill: "#d73495"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1z",
    fill: "#d23f9d"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24h-1v-1h1z",
    fill: "#d344a1"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23h1v1h-1z",
    fill: "#c74ca8"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1z",
    fill: "#c056ae"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#bd61ba"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#a65aba"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h1v1z",
    fill: "#af70c5"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M64 23h1v1h-1z",
    fill: "#8e67c3"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23h1v1h-1z",
    fill: "#7967c1"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1z",
    fill: "#817ad2"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v-1h1v1z",
    fill: "#6b6bcd"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h-1v-1h1z",
    fill: "#4d5fc0"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M70 23v1h-1v-1z",
    fill: "#4765c4"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24h-1v-1h1z",
    fill: "#476acb"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v-1h1v1z",
    fill: "#405fc3"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h1v1h-1z",
    fill: "#3456bc"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h-1v-1h1z",
    fill: "#3056be"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24v-1h1v1z",
    fill: "#3059c3"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M76 23v1h-1v-1z",
    fill: "#2c5eca"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24h-1v-1h1z",
    fill: "#285ebb",
    fillOpacity: 0.98
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v-1h1v1z",
    fill: "#3c649b",
    fillOpacity: 0.2
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25h-1v-1h1z",
    fill: "#91b3cc",
    fillOpacity: 0.596
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25h-1v-1h1z",
    fill: "#93c1e5"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24v1h-1v-1z",
    fill: "#9ac8f1"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24h1v1h-1z",
    fill: "#5b8197"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M23 25v-1h1v1z",
    fill: "#b4ba31"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25h-1v-1h1z",
    fill: "#8a7d40"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24h1v1h-1z",
    fill: "#070754"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25v-1h1v1z",
    fill: "#1b489f"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24h1v1h-1z",
    fill: "#5ca6d3"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24h1v1h-1z",
    fill: "#b6d4f4"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25h-1v-1h1z",
    fill: "#e364b3"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25h-1v-1h1z",
    fill: "#f8007a"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24h1v1h-1z",
    fill: "#fb1a8c"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24v1h-1v-1z",
    fill: "#fd3d9a"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25h-1v-1h1z",
    fill: "#f9439c"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25v-1h1v1z",
    fill: "#f3499b"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h-1v-1h1z",
    fill: "#ec4a9a"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25h-1v-1h1z",
    fill: "#e6419e"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v1h-1v-1z",
    fill: "#da329f"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v-1h1v1z",
    fill: "#ce329f"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24v1h-1v-1z",
    fill: "#bf379c"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M41 25h-1v-1h1z",
    fill: "#ad399b"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24h1v1h-1z",
    fill: "#ba49ac"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h-1v-1h1z",
    fill: "#b34dac"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24v1h-1v-1z",
    fill: "#a34faa"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25v-1h1v1z",
    fill: "#b366bc"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24h1v1h-1z",
    fill: "#a964b7"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24v1h-1v-1z",
    fill: "#a873c1"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24h1v1h-1z",
    fill: "#ad7ac4"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h-1v-1h1z",
    fill: "#a97cc6"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25h-1v-1h1z",
    fill: "#b088cf"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M51 25h-1v-1h1z",
    fill: "#af8ed2"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M51 24h1v1h-1z",
    fill: "#b097d7"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h1v1h-1z",
    fill: "#af9edd"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M54 24v1h-1v-1z",
    fill: "#aca3df"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25v-1h1v1z",
    fill: "#a6a7de"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h1v1z",
    fill: "#9da6dd"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1z",
    fill: "#97a9e3"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1z",
    fill: "#899fda"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1z",
    fill: "#85a6df"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#6491d1"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1z",
    fill: "#649ade"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v1h-1v-1z",
    fill: "#307fd1"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v1h-1v-1z",
    fill: "#2c7fd2"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h1z",
    fill: "#3084d8"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24h1v1h-1z",
    fill: "#0461bd"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1z",
    fill: "#0874cf"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#0964ca"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1z",
    fill: "#0049b7"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24v1h-1v-1z",
    fill: "#0054bf"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h1v1h-1z",
    fill: "#0054c4"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v1h-1v-1z",
    fill: "#003fbc"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M74 25h-1v-1h1z",
    fill: "#0037b6"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h1v1h-1z",
    fill: "#0033b4"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M76 25h-1v-1h1z",
    fill: "#0032b8"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v1h-1v-1z",
    fill: "#0032aa",
    fillOpacity: 0.988
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v-1h1v1z",
    fill: "#214890",
    fillOpacity: 0.208
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25v1h-1v-1z",
    fill: "#8eb1cc",
    fillOpacity: 0.596
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25v1h-1v-1z",
    fill: "#8fc2eb"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25h1v1h-1z",
    fill: "#96c4ee"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26v-1h1v1z",
    fill: "#80a9b3"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25v1h-1v-1z",
    fill: "#b7bf30"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25v1h-1v-1z",
    fill: "#94864a"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M25 26v-1h1v1z",
    fill: "#0e124f"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25h1v1h-1z",
    fill: "#225ba1"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25v1h-1v-1z",
    fill: "#65abd7"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25v1h-1v-1z",
    fill: "#aed0ee"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25h1v1h-1z",
    fill: "#be7cbe"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25v1h-1v-1z",
    fill: "#c12a98"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26v-1h1v1z",
    fill: "#d256b7"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25h1v1h-1z",
    fill: "#c777c7"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26v-1h1v1z",
    fill: "#b883d0"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25v1h-1v-1z",
    fill: "#a48ed7"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25v1h-1v-1z",
    fill: "#9695de"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h1v1h-1z",
    fill: "#788fdd"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v1h-1v-1z",
    fill: "#587dd7"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26h-1v-1h1z",
    fill: "#497cd8"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25h1v1h-1z",
    fill: "#3781d8"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25h1v1h-1z",
    fill: "#1b6cc7"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26v-1h1v1z",
    fill: "#2971d1"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25v1h-1v-1z",
    fill: "#3989e1"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h1v1h-1z",
    fill: "#1373c8"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25h1v1h-1z",
    fill: "#3389d4"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25h1v1h-1z",
    fill: "#418dd7"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M47 26h-1v-1h1z",
    fill: "#3885cb"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M48 26h-1v-1h1z",
    fill: "#5899d3"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h1v1h-1z",
    fill: "#6ea0d8"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M51 26h-1v-1h1z",
    fill: "#71a2d8"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26h-1v-1h1z",
    fill: "#75a3d9"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25h1v1h-1z",
    fill: "#79a5da"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h1v1h-1z",
    fill: "#79a3d9"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M57 25v1h-1v-1z",
    fill: "#73a3da"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1z",
    fill: "#6e9dda"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#6698d6"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#5791d2"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M60 26v-1h1v1z",
    fill: "#5190d3"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#3e84c9"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#569de0"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25v1h-1v-1z",
    fill: "#1b6fc3"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-1z",
    fill: "#0972ca"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26v-1h1v1z",
    fill: "#0568c9"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#0043b5"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1z",
    fill: "#0354c2"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h1v1h-1z",
    fill: "#0357c8"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-1v-1h1z",
    fill: "#013db9"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1z",
    fill: "#012cb1"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M72 26h-1v-1h1z",
    fill: "#0232b3"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h1v1h-1z",
    fill: "#0233b4"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25v1h-1v-1z",
    fill: "#012aaf"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M75 26v-1h1v1z",
    fill: "#0129b2"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v1h-1v-1z",
    fill: "#042ba4",
    fillOpacity: 0.988
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27v-1h1v1z",
    fill: "#89aec9",
    fillOpacity: 0.596
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26h1v1h-1z",
    fill: "#8dc1ea"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26h1v1h-1z",
    fill: "#90c0e7"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M21 27v-1h1v1z",
    fill: "#90c3eb"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26v1h-1v-1z",
    fill: "#97c0c9"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27v-1h1v1z",
    fill: "#c9cd41"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26h1v1h-1z",
    fill: "#9b8c47"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26v1h-1v-1z",
    fill: "#111d4b"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26h1v1h-1z",
    fill: "#2269a1"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27v-1h1v1z",
    fill: "#6baad8"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27h-1v-1h1z",
    fill: "#a3d2ed"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27h-1v-1h1z",
    fill: "#548ac7"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26v1h-1v-1z",
    fill: "#2e66c9"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27h-1v-1h1z",
    fill: "#387ed9"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h-1v-1h1z",
    fill: "#2a7ed6"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v-1h1v1z",
    fill: "#1e77d3"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h-1v-1h1z",
    fill: "#1570d1"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27v-1h1v1z",
    fill: "#116dd4"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M36 27v-1h1v1z",
    fill: "#076fd2"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M38 26v1h-1v-1z",
    fill: "#0063c7"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26v1h-1v-1z",
    fill: "#0052c4"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M39 27v-1h1v1z",
    fill: "#0064c9"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M41 27h-1v-1h1z",
    fill: "#006ece"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26h1v1h-1z",
    fill: "#05b"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M42 26h1v1h-1z",
    fill: "#0871ce"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27h-1v-1h1z",
    fill: "#0f7cd0"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26v1h-1v-1z",
    fill: "#0a71c8"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27v-1h1v1z",
    fill: "#3789d7"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26h1v1h-1z",
    fill: "#448cd1"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27h-1v-1h1z",
    fill: "#6898d5"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26h1v1h-1z",
    fill: "#6f9ed4"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M50 27v-1h1v1z",
    fill: "#73a3d8"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26v1h-1v-1z",
    fill: "#79a3da"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27h-1v-1h1z",
    fill: "#7da5da"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M54 27h-1v-1h1z",
    fill: "#81a6da"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26h1v1h-1z",
    fill: "#83a8db"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1z",
    fill: "#83a8da"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v1h-1v-1z",
    fill: "#82a8d6"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1z",
    fill: "#80a6d7"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1z",
    fill: "#7aa3da"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27h-1v-1h1z",
    fill: "#7aa3d7"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27h-1v-1h1z",
    fill: "#98b7e1"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h-1v-1h1z",
    fill: "#acc8e5"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1z",
    fill: "#a0bddf"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1z",
    fill: "#9bc4ea"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1z",
    fill: "#4490d5"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#0058b8"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#0767c7"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1z",
    fill: "#0661ce"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M69 26v1h-1v-1z",
    fill: "#0240b9"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M70 27h-1v-1h1z",
    fill: "#003bb5"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h1v1h-1z",
    fill: "#0641bc"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h1v1h-1z",
    fill: "#063ebc"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h-1v-1h1z",
    fill: "#0132b3"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27v-1h1v1z",
    fill: "#0028ad"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M74 27v-1h1v1z",
    fill: "#0128ae"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M76 26v1h-1v-1z",
    fill: "#0229b2"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27h-1v-1h1z",
    fill: "#052ba4",
    fillOpacity: 0.988
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M78 26v1h-1v-1z",
    fill: "#2a4692",
    fillOpacity: 0.212
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27h1v1h-1z",
    fill: "#83a8c3",
    fillOpacity: 0.6
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28v-1h1v1z",
    fill: "#89bfe7"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27v1h-1v-1z",
    fill: "#8fc2ea"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M23 28h-1v-1h1z",
    fill: "#96c4d7"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27h1v1h-1z",
    fill: "#ccd55e"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28v-1h1v1z",
    fill: "#938a40"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28v-1h1v1z",
    fill: "#0f3350"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27v1h-1v-1z",
    fill: "#2d7fab"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27h1v1h-1z",
    fill: "#78b1da"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27h1v1h-1z",
    fill: "#aad3ef"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28v-1h1v1z",
    fill: "#3e74c3"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h-1v-1h1z",
    fill: "#0038b5"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27h1v1h-1z",
    fill: "#0050c9"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v1h-1v-1z",
    fill: "#0053cc"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h1v1h-1z",
    fill: "#005bcf"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v-1h1v1z",
    fill: "#005ccd"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h1v1h-1z",
    fill: "#0059cb"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v-1h1v1z",
    fill: "#005dcd"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M37 28v-1h1v1z",
    fill: "#046ed6"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M38 27h1v1h-1z",
    fill: "#0263d1"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27v1h-1v-1z",
    fill: "#0053c3"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27h1v1h-1z",
    fill: "#0a70d1"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27v1h-1v-1z",
    fill: "#117ad5"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27h1v1h-1z",
    fill: "#066ac5"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27v1h-1v-1z",
    fill: "#2c85d5"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28h-1v-1h1z",
    fill: "#4c91d5"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27h1v1h-1z",
    fill: "#7baddf"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28h-1v-1h1z",
    fill: "#9dc2e8"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27v1h-1v-1z",
    fill: "#a3c3e8"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28v-1h1v1z",
    fill: "#a2c2e3"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M49 28v-1h1v1z",
    fill: "#98b6da"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27v1h-1v-1z",
    fill: "#8aaed7"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28v-1h1v1z",
    fill: "#89aadb"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-1v-1z",
    fill: "#8babdb"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h1v1z",
    fill: "#8caedc"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1z",
    fill: "#8eb0dc"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h1v1h-1z",
    fill: "#a0bce0"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M57 28h-1v-1h1z",
    fill: "#b6d0ea"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1z",
    fill: "#b7d2ee"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28v-1h1v1z",
    fill: "#a8c1e4"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1z",
    fill: "#92aed5"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1z",
    fill: "#b1cae6"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#6e90bd"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h1v1h-1z",
    fill: "#0a2c90"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h1v1h-1z",
    fill: "#6487be"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#95bfe9"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#2b84d0"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#0c71cf"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v-1h1v1z",
    fill: "#004ab9"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27v1h-1v-1z",
    fill: "#024fc1"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27h1v1h-1z",
    fill: "#0756c9"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27v1h-1v-1z",
    fill: "#0447bf"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M72 27v1h-1v-1z",
    fill: "#0230b2"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v-1h1v1z",
    fill: "#012bae"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M75 27v1h-1v-1z",
    fill: "#022db2"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v-1h1v1z",
    fill: "#0228b1"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M77 28v-1h1v1z",
    fill: "#2a428d",
    fillOpacity: 0.212
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28v1h-1v-1z",
    fill: "#85acc5",
    fillOpacity: 0.608
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28h1v1h-1z",
    fill: "#8cbee7"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29v-1h1v1z",
    fill: "#91c1e7"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28h1v1h-1z",
    fill: "#92c3e3"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M23 28h1v1h-1z",
    fill: "#c1d380"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29v-1h1v1z",
    fill: "#949351"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M26 29h-1v-1h1z",
    fill: "#376c7e"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29h-1v-1h1z",
    fill: "#4a95b9"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28v1h-1v-1z",
    fill: "#88bae2"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29v-1h1v1z",
    fill: "#a7d0ed"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28v1h-1v-1z",
    fill: "#4170bf"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29h-1v-1h1z",
    fill: "#0031b0"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h1v1h-1z",
    fill: "#024ac7"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28v1h-1v-1z",
    fill: "#0154cb"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v1h-1v-1z",
    fill: "#025ace"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28h1v1h-1z",
    fill: "#025fd0"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v1h-1v-1z",
    fill: "#0160cd"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v-1h1v1z",
    fill: "#0157c9"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28v1h-1v-1z",
    fill: "#0060d0"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M38 29v-1h1v1z",
    fill: "#0a79e0"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M39 28h1v1h-1z",
    fill: "#0e72d4"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28v1h-1v-1z",
    fill: "#0363c2"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28h1v1h-1z",
    fill: "#1b84d9"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M43 28v1h-1v-1z",
    fill: "#3a87d3"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28v1h-1v-1z",
    fill: "#70a7da"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29h-1v-1h1z",
    fill: "#afcee8"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M46 28v1h-1v-1z",
    fill: "#9bb5dd"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1z",
    fill: "#7591ca"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29v-1h1v1z",
    fill: "#6784c4"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M49 29h-1v-1h1z",
    fill: "#7b9bcd"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28v1h-1v-1z",
    fill: "#a4c3e1"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v-1h1v1z",
    fill: "#bbd1ec"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29v-1h1v1z",
    fill: "#a2b7dd"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v-1h1v1z",
    fill: "#97b2dc"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29v-1h1v1z",
    fill: "#95b2df"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1z",
    fill: "#9ab7dc"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M55 28h1v1h-1z",
    fill: "#bed3eb"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1z",
    fill: "#7893bd"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29v-1h1v1z",
    fill: "#506eae"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1z",
    fill: "#9db6db"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1z",
    fill: "#b4cbe7"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#adc5de"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1z",
    fill: "#7f9dcd"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#2a51af"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#b2d3ee"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1z",
    fill: "#4e93d7"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1z",
    fill: "#035ebf"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1z",
    fill: "#0867c9"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M68 28h1v1h-1z",
    fill: "#066dcf"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28v1h-1v-1z",
    fill: "#014bbf"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29v-1h1v1z",
    fill: "#0138b3"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v1h-1v-1z",
    fill: "#0136b3"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29h-1v-1h1z",
    fill: "#043aba"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M74 28v1h-1v-1z",
    fill: "#053abc"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v1h-1v-1z",
    fill: "#0231b5"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M76 28v1h-1v-1z",
    fill: "#0229b3"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30h-1v-1h1z",
    fill: "#84adc4",
    fillOpacity: 0.612
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M19 29h1v1h-1z",
    fill: "#89bde5"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30h-1v-1h1z",
    fill: "#8bbfe6"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30h-1v-1h1z",
    fill: "#91c0e8"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30v-1h1v1z",
    fill: "#8dc0e8"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30v-1h1v1z",
    fill: "#aacac0"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30v-1h1v1z",
    fill: "#9db2a7"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30h-1v-1h1z",
    fill: "#6a9db7"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29v1h-1v-1z",
    fill: "#6da7c9"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29h1v1h-1z",
    fill: "#83b1d9"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29h1v1h-1z",
    fill: "#9ecbea"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29v1h-1v-1z",
    fill: "#4372bf"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30h-1v-1h1z",
    fill: "#0032b3"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29h1v1h-1z",
    fill: "#024cc8"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29h1v1h-1z",
    fill: "#0153cc"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h-1v-1h1z",
    fill: "#0259cd"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30h-1v-1h1z",
    fill: "#0362d0"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v1h-1v-1z",
    fill: "#026dd6"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29v1h-1v-1z",
    fill: "#026fd6"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30h-1v-1h1z",
    fill: "#035fca"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30h-1v-1h1z",
    fill: "#015fc9"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30v-1h1v1z",
    fill: "#1f85dc"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30v-1h1v1z",
    fill: "#2b88d9"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30h-1v-1h1z",
    fill: "#307fcb"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30v-1h1v1z",
    fill: "#8fb8e3"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h-1v-1h1z",
    fill: "#a7c6e2"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v-1z",
    fill: "#3f62af"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30v-1h1v1z",
    fill: "#03299c"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#00289b"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#103aa5"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1z",
    fill: "#032f99"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#083094"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30h-1v-1h1z",
    fill: "#839fca"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1z",
    fill: "#c6d8ea"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1z",
    fill: "#a3b8dd"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1z",
    fill: "#9eb8e0"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#5476b3"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#001a9c"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#395ca6"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1z",
    fill: "#c1ddee"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1z",
    fill: "#bcd2e8"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h-1v-1h1z",
    fill: "#7898c7"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30v-1h1v1z",
    fill: "#2d56b3"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-1h1z",
    fill: "#adcee7"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29v1h-1v-1z",
    fill: "#619bd3"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#2d87d8"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29h1v1h-1z",
    fill: "#0c73ce"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v-1h1v1z",
    fill: "#0051b7"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M69 29h1v1h-1z",
    fill: "#004bbc"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29h1v1h-1z",
    fill: "#0552c3"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-1h1v1z",
    fill: "#044ec4"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h-1v-1h1z",
    fill: "#033ebe"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30v-1h1v1z",
    fill: "#0232b7"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29v1h-1v-1z",
    fill: "#002db1"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29h1v1h-1z",
    fill: "#002ab3"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29h1v1h-1z",
    fill: "#052aa3",
    fillOpacity: 0.984
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30v1h-1v-1z",
    fill: "#81a9c2",
    fillOpacity: 0.608
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M19 31v-1h1v1z",
    fill: "#8abbe6"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M21 31h-1v-1h1z",
    fill: "#8abee6"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M22 31h-1v-1h1z",
    fill: "#8ebee5"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30h1v1h-1z",
    fill: "#8ebfe9"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30v1h-1v-1z",
    fill: "#91c0e9"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31v-1h1v1z",
    fill: "#91bfe5"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31v-1h1v1z",
    fill: "#7db2d8"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31h-1v-1h1z",
    fill: "#77accf"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30h1v1h-1z",
    fill: "#78add3"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30h1v1h-1z",
    fill: "#94c7e3"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30h1v1h-1z",
    fill: "#4473be"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30v1h-1v-1z",
    fill: "#0031b3"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30v1h-1v-1z",
    fill: "#0255cd"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M33 31v-1h1v1z",
    fill: "#015bce"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h1v1h-1z",
    fill: "#005dcb"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31h-1v-1h1z",
    fill: "#0163cf"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31v-1h1v1z",
    fill: "#0978d9"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30v1h-1v-1z",
    fill: "#2787e3"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31h-1v-1h1z",
    fill: "#1975d1"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31h-1v-1h1z",
    fill: "#0c6ec8"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30h1v1h-1z",
    fill: "#448cd7"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M41 31v-1h1v1z",
    fill: "#88b1e4"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30v1h-1v-1z",
    fill: "#a3c2e1"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M43 31v-1h1v1z",
    fill: "#2147a3"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h1v1h-1z",
    fill: "#0024a8"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31h-1v-1h1z",
    fill: "#2a53ac"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31v-1h1v1z",
    fill: "#88aed4"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#a7cfe7"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h1v1h-1z",
    fill: "#9dc3e6"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31h-1v-1h1z",
    fill: "#385dae"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31h-1v-1h1z",
    fill: "#1a419a"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1z",
    fill: "#bcd6e8"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#b0c6e2"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#a4bde3"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-1z",
    fill: "#aabde3"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#5175ba"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1z",
    fill: "#001fa8"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v1h-1v-1z",
    fill: "#3e61b4"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1z",
    fill: "#bdd5e7"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31h-1v-1h1z",
    fill: "#c8dbec"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30v1h-1v-1z",
    fill: "#6186bf"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h1v1h-1z",
    fill: "#0021a2"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v1h-1v-1z",
    fill: "#3f6bb7"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31v-1h1v1z",
    fill: "#b5d2ec"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h1v1h-1z",
    fill: "#91b1e2"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M67 31h-1v-1h1z",
    fill: "#6b9fd4"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1z",
    fill: "#5a9bd3"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v1h-1v-1z",
    fill: "#5f9edd"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30h1v1h-1z",
    fill: "#2a81cc"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31h-1v-1h1z",
    fill: "#0153bd"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1z",
    fill: "#013cb6"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M72 31v-1h1v1z",
    fill: "#0033b3"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h1v1h-1z",
    fill: "#0335b7"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31h-1v-1h1z",
    fill: "#0235b6"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M77 30v1h-1v-1z",
    fill: "#052da5",
    fillOpacity: 0.984
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32v-1h1v1z",
    fill: "#7aaac3",
    fillOpacity: 0.604
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M19 31h1v1h-1z",
    fill: "#86c0eb"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M20 32v-1h1v1z",
    fill: "#8cc4eb"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M21 32v-1h1v1z",
    fill: "#8cbfe8"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32v-1h1v1z",
    fill: "#91bdea"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32v-1h1v1z",
    fill: "#91bfe9"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31h1v1h-1z",
    fill: "#85b7e0"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M26 31h1v1h-1z",
    fill: "#7baeda"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M28 31v1h-1v-1z",
    fill: "#77add5"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M29 32h-1v-1h1z",
    fill: "#8abeda"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31v1h-1v-1z",
    fill: "#3f6ebc"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h1v1h-1z",
    fill: "#0258cd"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v-1h1v1z",
    fill: "#0462d4"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31h1v1h-1z",
    fill: "#0465d5"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32v-1h1v1z",
    fill: "#0162d1"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32h-1v-1h1z",
    fill: "#015ccb"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31v1h-1v-1z",
    fill: "#1373d3"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31v1h-1v-1z",
    fill: "#3c91e3"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31v1h-1v-1z",
    fill: "#4792e0"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32h-1v-1h1z",
    fill: "#5f96d8"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32h-1v-1h1z",
    fill: "#adcfea"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31h1v1h-1z",
    fill: "#3861ae"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M44 31v1h-1v-1z",
    fill: "#0025ae"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31v1h-1v-1z",
    fill: "#224cad"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-1v-1h1z",
    fill: "#a3cade"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31v1h-1v-1z",
    fill: "#b9d4eb"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32h-1v-1h1z",
    fill: "#b4cae8"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M49 31v1h-1v-1z",
    fill: "#c0d4ea"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31v1h-1v-1z",
    fill: "#bad3e9"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32h-1v-1h1z",
    fill: "#3b609b"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#afcae3"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#b7cae5"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#a9c1e4"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1z",
    fill: "#aec3e2"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32h-1v-1h1z",
    fill: "#c3d9eb"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#3258b3"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M59 32h-1v-1h1z",
    fill: "#5c85bf"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31h1v1h-1z",
    fill: "#bfd6e7"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M60 31h1v1h-1z",
    fill: "#cadceb"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31v1h-1v-1z",
    fill: "#3b64b2"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v-1h1v1z",
    fill: "#6089c1"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31h1v1h-1z",
    fill: "#c2d8eb"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h1v1z",
    fill: "#bbd3ea"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32h-1v-1h1z",
    fill: "#7597cb"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31v1h-1v-1z",
    fill: "#789ac8"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31h1v1h-1z",
    fill: "#8ab7df"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31v1h-1v-1z",
    fill: "#1a64bb"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32v-1h1v1z",
    fill: "#014abb"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M73 31v1h-1v-1z",
    fill: "#034dc2"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v-1h1v1z",
    fill: "#0344be"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M74 31h1v1h-1z",
    fill: "#033ab8"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32h-1v-1h1z",
    fill: "#052da6",
    fillOpacity: 0.988
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33h-1v-1h1z",
    fill: "#497b92",
    fillOpacity: 0.6
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33v-1h1v1z",
    fill: "#4688b3"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M21 33h-1v-1h1z",
    fill: "#5ca0cf"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33h-1v-1h1z",
    fill: "#7ab7e7"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32h1v1h-1z",
    fill: "#8cc3f0"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32h1v1h-1z",
    fill: "#8fc3ec"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32v1h-1v-1z",
    fill: "#85b9df"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33v-1h1v1z",
    fill: "#7bb0dc"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M27 32h1v1h-1z",
    fill: "#77acd6"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32h1v1h-1z",
    fill: "#88c0df"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33h-1v-1h1z",
    fill: "#4675c2"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32v1h-1v-1z",
    fill: "#002db0"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32v1h-1v-1z",
    fill: "#044ac8"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v1h-1v-1z",
    fill: "#0354cd"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32h1v1h-1z",
    fill: "#0260d5"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-1h1v1z",
    fill: "#056cd8"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32h1v1h-1z",
    fill: "#0779db"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h-1v-1h1z",
    fill: "#197fdc"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33v-1h1v1z",
    fill: "#1374ce"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32h1v1h-1z",
    fill: "#1976cc"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33h-1v-1h1z",
    fill: "#5492da"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32v1h-1v-1z",
    fill: "#93b3e5"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32v1h-1v-1z",
    fill: "#95b4d7"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-1v-1z",
    fill: "#0331a0"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33v-1h1v1z",
    fill: "#6890c9"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#bdd8e9"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1z",
    fill: "#aec5e4"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1z",
    fill: "#a5bdde"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1z",
    fill: "#a9c0dd"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1z",
    fill: "#bfd1e8"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#a7c1d7"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#bfd7e6"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1z",
    fill: "#bdcde7"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#adc2e3"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#b2cae5"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#b6d0e8"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1z",
    fill: "#1640ab"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#0028a6"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33v-1h1v1z",
    fill: "#7ca8cf"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#c2d6eb"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1z",
    fill: "#bed2e7"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1z",
    fill: "#1a41ab"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v1h-1v-1z",
    fill: "#0026a5"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32h1v1h-1z",
    fill: "#89acd0"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#c3e0eb"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M65 33v-1h1v1z",
    fill: "#6686b7"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v-1h1v1z",
    fill: "#1e4495"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v1h-1v-1z",
    fill: "#01299f"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h-1v-1h1z",
    fill: "#002099"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1z",
    fill: "#7594c6"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33v-1h1v1z",
    fill: "#7bbaed"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32h1v1h-1z",
    fill: "#065fc5"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v1h-1v-1z",
    fill: "#0247be"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M74 32v1h-1v-1z",
    fill: "#0235b3"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M75 32v1h-1v-1z",
    fill: "#002eb0"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M75 33v-1h1v1z",
    fill: "#002cb2"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33h-1v-1h1z",
    fill: "#052da4",
    fillOpacity: 0.988
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33v-1h1v1z",
    fill: "#29458b",
    fillOpacity: 0.216
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33v1h-1v-1z",
    fill: "#8da5a3",
    fillOpacity: 0.6
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33h1v1h-1z",
    fill: "#b3cecb"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33h1v1h-1z",
    fill: "#7facb8"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33v1h-1v-1z",
    fill: "#4e89ab"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34h-1v-1h1z",
    fill: "#4889b7"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34h-1v-1h1z",
    fill: "#68a8dc"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33h1v1h-1z",
    fill: "#86c2f0"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33h1v1h-1z",
    fill: "#82bce5"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33h1v1h-1z",
    fill: "#7ab3d8"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h-1v-1h1z",
    fill: "#77aed7"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34v-1h1v1z",
    fill: "#88c0e0"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33h1v1h-1z",
    fill: "#4474c2"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h-1v-1h1z",
    fill: "#0146c4"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33v1h-1v-1z",
    fill: "#0154ca"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34v-1h1v1z",
    fill: "#015ed1"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1z",
    fill: "#0060cd"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-1h1v1z",
    fill: "#0167cd"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#177bd5"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#4694e8"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#5299e4"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33h1v1h-1z",
    fill: "#629adb"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34v-1h1v1z",
    fill: "#a1c1e8"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34h-1v-1h1z",
    fill: "#7498cb"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34h-1v-1h1z",
    fill: "#002cad"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M43 33h1v1h-1z",
    fill: "#002aac"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1z",
    fill: "#7ca6d0"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33h1v1h-1z",
    fill: "#bbd5eb"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1z",
    fill: "#abc3e2"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#a8bfe0"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1z",
    fill: "#aac1de"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#c0cde2"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#c6ddec"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1z",
    fill: "#98b6d1"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1z",
    fill: "#b8d1e7"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1z",
    fill: "#b7cde6"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1z",
    fill: "#bbcfe6"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1z",
    fill: "#9fbcde"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1z",
    fill: "#042da4"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1z",
    fill: "#0933a3"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-1v-1h1z",
    fill: "#97bdd9"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1z",
    fill: "#c8daeb"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33h1v1h-1z",
    fill: "#a6c1df"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33v1h-1v-1z",
    fill: "#062da9"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v-1h1v1z",
    fill: "#0f379f"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#9dc4e1"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M64 34v-1h1v1z",
    fill: "#426ba5"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v1h-1v-1z",
    fill: "#4c73a7"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33v1h-1v-1z",
    fill: "#95c5e1"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33h1v1h-1z",
    fill: "#244db7"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h1v1h-1z",
    fill: "#7096cc"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M71 34h-1v-1h1z",
    fill: "#7db9ea"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h-1v-1h1z",
    fill: "#044cb4"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M73 34h-1v-1h1z",
    fill: "#0037b0"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33v1h-1v-1z",
    fill: "#0238b4"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33h1v1h-1z",
    fill: "#013cb8"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34v-1h1v1z",
    fill: "#033aba"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34h-1v-1h1z",
    fill: "#0432a5",
    fillOpacity: 0.992
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M78 33v1h-1v-1z",
    fill: "#244488",
    fillOpacity: 0.22
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M19 34v1h-1v-1z",
    fill: "#9dafa2",
    fillOpacity: 0.592
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M19 34h1v1h-1z",
    fill: "#b1bda9"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M21 34v1h-1v-1z",
    fill: "#bdc6b8"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h-1v-1h1z",
    fill: "#dce6de"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34v1h-1v-1z",
    fill: "#bcd4ce"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35h-1v-1h1z",
    fill: "#6c9dae"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35h-1v-1h1z",
    fill: "#4084af"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M25 34h1v1h-1z",
    fill: "#6aaad9"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M26 34h1v1h-1z",
    fill: "#7bb7e3"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M27 34h1v1h-1z",
    fill: "#78b0da"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h1v1h-1z",
    fill: "#8bc2e2"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M29 35v-1h1v1z",
    fill: "#3f6fbe"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M31 35h-1v-1h1z",
    fill: "#002fb1"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1z",
    fill: "#0145c3"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h1v1h-1z",
    fill: "#0256cd"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34h1v1h-1z",
    fill: "#0367d8"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35v-1h1v1z",
    fill: "#056bd4"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M36 35h-1v-1h1z",
    fill: "#0b72d1"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34v1h-1v-1z",
    fill: "#0a71cc"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-1v-1h1z",
    fill: "#1b78d0"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1z",
    fill: "#5091d6"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35v-1h1v1z",
    fill: "#7aa5e2"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M41 35h-1v-1h1z",
    fill: "#aec9eb"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34v1h-1v-1z",
    fill: "#6d93ca"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35v-1h1v1z",
    fill: "#002eae"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-1z",
    fill: "#002aae"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35h-1v-1h1z",
    fill: "#648fc4"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1z",
    fill: "#bcdaec"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v-1h1v1z",
    fill: "#b2cae6"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35h-1v-1h1z",
    fill: "#acc2e1"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h-1v-1h1z",
    fill: "#b0c4df"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1z",
    fill: "#c7d5ee"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34h1v1h-1z",
    fill: "#4565b2"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1z",
    fill: "#00239b"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#3d5fa6"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#c1dced"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1z",
    fill: "#c7dbec"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1z",
    fill: "#809fcc"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1z",
    fill: "#0021a4"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M57 34h1v1h-1z",
    fill: "#1f46a5"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35v-1h1v1z",
    fill: "#adcddf"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34v1h-1v-1z",
    fill: "#ceddea"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34h1v1h-1z",
    fill: "#85a5d0"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M63 35h-1v-1h1z",
    fill: "#264fb2"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1z",
    fill: "#4c74ab"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1z",
    fill: "#5b82b1"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h1v1h-1z",
    fill: "#bbdfec"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35h-1v-1h1z",
    fill: "#91b9dd"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34h1v1h-1z",
    fill: "#062aa0"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35h-1v-1h1z",
    fill: "#2950a5"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h1v1h-1z",
    fill: "#a1cce6"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35h-1v-1h1z",
    fill: "#63a6e5"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35v-1h1v1z",
    fill: "#0463c1"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h1v1h-1z",
    fill: "#055dc9"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35v-1h1v1z",
    fill: "#0452c3"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1z",
    fill: "#0146be"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h1v1h-1z",
    fill: "#0340bc"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34v1h-1v-1z",
    fill: "#073baa",
    fillOpacity: 0.992
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34v1h-1v-1z",
    fill: "#23478a",
    fillOpacity: 0.224
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M19 35v1h-1v-1z",
    fill: "#a7b4b1",
    fillOpacity: 0.592
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M19 36v-1h1v1z",
    fill: "#4a5973"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36v-1h1v1z",
    fill: "#060745"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M22 36h-1v-1h1z",
    fill: "#323568"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h1v1h-1z",
    fill: "#7a8193"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35v1h-1v-1z",
    fill: "#c8d1cf"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h-1v-1h1z",
    fill: "#bed6d3"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M26 35v1h-1v-1z",
    fill: "#5589a9"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M26 36v-1h1v1z",
    fill: "#5b97ca"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36h-1v-1h1z",
    fill: "#7ab3de"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36h-1v-1h1z",
    fill: "#8ac3e3"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36v-1h1v1z",
    fill: "#3b6bbb"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v-1h1v1z",
    fill: "#0345c5"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35h1v1h-1z",
    fill: "#0252cd"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M33 35h1v1h-1z",
    fill: "#0160d4"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35h1v1h-1z",
    fill: "#056dd5"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35h1v1h-1z",
    fill: "#1b83de"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M37 36h-1v-1h1z",
    fill: "#3e96e7"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35v1h-1v-1z",
    fill: "#569ae3"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v-1h1v1z",
    fill: "#6d9edf"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#88abe2"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36h-1v-1h1z",
    fill: "#b1c8ea"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36h-1v-1h1z",
    fill: "#86a6d1"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35v1h-1v-1z",
    fill: "#0030ae"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h-1v-1h1z",
    fill: "#032eb6"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35h1v1h-1z",
    fill: "#2650aa"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v1h-1v-1z",
    fill: "#abd2e4"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36h-1v-1h1z",
    fill: "#bad4eb"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1z",
    fill: "#b1c9e2"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36v-1h1v1z",
    fill: "#b8c9e5"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1z",
    fill: "#bccce7"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1z",
    fill: "#13379c"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1z",
    fill: "#0020a4"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#385ea7"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#b9d6e7"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1z",
    fill: "#cfe4f2"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1z",
    fill: "#5b7eb7"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-1h1z",
    fill: "#001da2"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1z",
    fill: "#4066af"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35h1v1h-1z",
    fill: "#b8d6e5"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1z",
    fill: "#d2e0eb"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1z",
    fill: "#6283c2"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#0024aa"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1z",
    fill: "#082da8"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1z",
    fill: "#567eb3"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35v1h-1v-1z",
    fill: "#b6dce7"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36v-1h1v1z",
    fill: "#a4c7e3"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35v1h-1v-1z",
    fill: "#1b3e99"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v-1h1v1z",
    fill: "#2146a3"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35v1h-1v-1z",
    fill: "#95bcdb"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M70 35v1h-1v-1z",
    fill: "#98c6ea"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v-1h1v1z",
    fill: "#3c88d2"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36h-1v-1h1z",
    fill: "#0460c6"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M72 35h1v1h-1z",
    fill: "#0153bf"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1z",
    fill: "#0146b7"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h-1v-1h1z",
    fill: "#013fb7"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36v-1h1v1z",
    fill: "#0141b9"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M77 36h-1v-1h1z",
    fill: "#093fad",
    fillOpacity: 0.992
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M77 35h1v1h-1z",
    fill: "#284d91",
    fillOpacity: 0.22
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M18 37v-1h1v1z",
    fill: "#a7b4ad",
    fillOpacity: 0.592
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M19 36h1v1h-1z",
    fill: "#4e5b7d"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M20 37v-1h1v1z",
    fill: "#000058"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37h-1v-1h1z",
    fill: "#000268"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37v-1h1v1z",
    fill: "#000065"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37h-1v-1h1z",
    fill: "#111064"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36h1v1h-1z",
    fill: "#747999"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h1v1h-1z",
    fill: "#cadfd8"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M27 37h-1v-1h1z",
    fill: "#6394b0"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36v1h-1v-1z",
    fill: "#63a4d1"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37h-1v-1h1z",
    fill: "#92c8e9"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M30 37h-1v-1h1z",
    fill: "#396cbc"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v1h-1v-1z",
    fill: "#0031b1"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36h1v1h-1z",
    fill: "#024bc4"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36h1v1h-1z",
    fill: "#0358cf"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37v-1h1v1z",
    fill: "#035cd3"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36v1h-1v-1z",
    fill: "#0163cd"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1z",
    fill: "#036bc8"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37h-1v-1h1z",
    fill: "#1c79cf"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v1h-1v-1z",
    fill: "#5795dd"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1z",
    fill: "#85ade5"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37h-1v-1h1z",
    fill: "#97b7e6"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1z",
    fill: "#aac3e6"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#afcbe6"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-1v-1h1z",
    fill: "#1145ac"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M43 36h1v1h-1z",
    fill: "#0332be"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v1h-1z",
    fill: "#012bad"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#668fc1"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v1h-1v-1z",
    fill: "#bcd9ec"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37h-1v-1h1z",
    fill: "#b9d1ed"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36h1v1h-1z",
    fill: "#bacae5"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1z",
    fill: "#cedceb"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1z",
    fill: "#88aacf"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#547eba"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#bdd4e8"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1z",
    fill: "#c9e0ef"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1z",
    fill: "#335aa9"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h-1v-1h1z",
    fill: "#6c91c5"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M59 37h-1v-1h1z",
    fill: "#bedbe8"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h1v1h-1z",
    fill: "#d0e1ec"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37h-1v-1h1z",
    fill: "#3f60b5"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v1h-1v-1z",
    fill: "#0020ac"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36h1v1h-1z",
    fill: "#3158ac"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h-1v-1h1z",
    fill: "#abd4e5"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1z",
    fill: "#80a6cf"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36v1h-1v-1z",
    fill: "#183c91"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M67 37h-1v-1h1z",
    fill: "#385eaa"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36h1v1h-1z",
    fill: "#9ec0da"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M68 37v-1h1v1z",
    fill: "#a9cae7"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v1h-1v-1z",
    fill: "#649ed4"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36h1v1h-1z",
    fill: "#0e68bf"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36v1h-1v-1z",
    fill: "#0360c5"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1z",
    fill: "#045ac2"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#0555c1"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37h-1v-1h1z",
    fill: "#0453c3"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h1v1h-1z",
    fill: "#0350c3"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h-1v-1h1z",
    fill: "#0645b0",
    fillOpacity: 0.992
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M78 36v1h-1v-1z",
    fill: "#285196",
    fillOpacity: 0.22
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M19 37v1h-1v-1z",
    fill: "#aab7b0",
    fillOpacity: 0.588
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v-1h1v1z",
    fill: "#505b7d"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37v1h-1v-1z",
    fill: "#005"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M22 38h-1v-1h1z",
    fill: "#232a82"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M23 37v1h-1v-1z",
    fill: "#4357a7"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37v1h-1v-1z",
    fill: "#141f7d"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M25 37v1h-1v-1z",
    fill: "#00005b"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38v-1h1v1z",
    fill: "#41467a"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38h-1v-1h1z",
    fill: "#bbd0cf"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38v-1h1v1z",
    fill: "#5d8fab"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37v1h-1v-1z",
    fill: "#89c3e6"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38v-1h1v1z",
    fill: "#3a72be"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37v1h-1v-1z",
    fill: "#003ab4"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38v-1h1v1z",
    fill: "#0254c7"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37h1v1h-1z",
    fill: "#0265d6"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37v1h-1v-1z",
    fill: "#0372da"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37h1v1h-1z",
    fill: "#2182dc"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37h1v1h-1z",
    fill: "#4592e2"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37v1h-1v-1z",
    fill: "#5c9ae6"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v-1h1v1z",
    fill: "#75a6e6"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37v1h-1v-1z",
    fill: "#95b3e6"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38v-1h1v1z",
    fill: "#a3bee8"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38h-1v-1h1z",
    fill: "#a8c2e4"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38h-1v-1h1z",
    fill: "#c3dbf0"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-1h1v1z",
    fill: "#567dbb"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h-1v-1h1z",
    fill: "#002eaf"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38v-1h1v1z",
    fill: "#0030b7"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1z",
    fill: "#163da7"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37v1h-1v-1z",
    fill: "#bcd7ec"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v-1h1v1z",
    fill: "#c3d2e9"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h1v1z",
    fill: "#c1cee6"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h-1v-1h1z",
    fill: "#6d8fbe"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1z",
    fill: "#5a84bf"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1z",
    fill: "#abc8e1"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1z",
    fill: "#cbdfeb"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1z",
    fill: "#bad2e8"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h-1v-1h1z",
    fill: "#183faa"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h1v1h-1z",
    fill: "#0129a8"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-1v-1z",
    fill: "#87aad2"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h1v1h-1z",
    fill: "#c5dcea"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1z",
    fill: "#c4d9eb"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1z",
    fill: "#2047ac"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#0124ab"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M62 37h1v1h-1z",
    fill: "#537ec5"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1z",
    fill: "#436bb2"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v1h-1z",
    fill: "#234898"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v-1h1v1z",
    fill: "#6c94c5"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h1v1h-1z",
    fill: "#abcfe6"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M68 38h-1v-1h1z",
    fill: "#b1cdeb"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M69 38h-1v-1h1z",
    fill: "#99b9e8"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37v1h-1v-1z",
    fill: "#679fe0"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38v-1h1v1z",
    fill: "#3690dc"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M72 37v1h-1v-1z",
    fill: "#107fd4"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v1h-1v-1z",
    fill: "#0670cf"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#0469cd"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37h1v1h-1z",
    fill: "#0162cc"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M75 38v-1h1v1z",
    fill: "#045dcc"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37v1h-1v-1z",
    fill: "#0553b9",
    fillOpacity: 0.992
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h1v1h-1z",
    fill: "#295c9d",
    fillOpacity: 0.216
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v1h-1v-1z",
    fill: "#afb9b4",
    fillOpacity: 0.588
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39v-1h1v1z",
    fill: "#4f5a7b"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39h-1v-1h1z",
    fill: "#000258"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h-1v-1h1z",
    fill: "#202e81"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v-1h1v1z",
    fill: "#5f7db7"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M24 38v1h-1v-1z",
    fill: "#607eb9"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M25 39h-1v-1h1z",
    fill: "#4056a2"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M26 38v1h-1v-1z",
    fill: "#07146c"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M26 39v-1h1v1z",
    fill: "#495778"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38v1h-1v-1z",
    fill: "#b1cacc"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v-1h1v1z",
    fill: "#7eadc5"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38h1v1h-1z",
    fill: "#3d78c1"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38h1v1h-1z",
    fill: "#003fb8"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38h1v1h-1z",
    fill: "#0256c7"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38v1h-1v-1z",
    fill: "#0263cd"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v-1h1v1z",
    fill: "#016bd1"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38h1v1h-1z",
    fill: "#0c73cf"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38v1h-1v-1z",
    fill: "#3086d7"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v1h-1v-1z",
    fill: "#6499df"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38v1h-1v-1z",
    fill: "#87ade1"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38h1v1h-1z",
    fill: "#a2bae7"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39h-1v-1h1z",
    fill: "#b0c1ea"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v-1h1v1z",
    fill: "#b0c6e8"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39h-1v-1h1z",
    fill: "#becfeb"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39h-1v-1h1z",
    fill: "#adc4e0"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M43 38h1v1h-1z",
    fill: "#0f3ba4"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h1v1h-1z",
    fill: "#0030b6"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M47 38v1h-1v-1z",
    fill: "#4b75b8"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v1h-1v-1z",
    fill: "#b5d6e8"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v1h-1v-1z",
    fill: "#c6d4ef"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1z",
    fill: "#183da3"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#00189d"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v1z",
    fill: "#6583bf"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#cde5ed"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1z",
    fill: "#a6c2de"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-1v-1z",
    fill: "#082ea8"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M57 38v1h-1v-1z",
    fill: "#0e38a9"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M58 39h-1v-1h1z",
    fill: "#9cc1dc"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38v1h-1v-1z",
    fill: "#c9dfee"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1z",
    fill: "#adc7e6"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1z",
    fill: "#0c35a3"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38v1h-1v-1z",
    fill: "#0229a9"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h1v1h-1z",
    fill: "#0529a8"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#002899"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1z",
    fill: "#8cb8d8"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M66 39h-1v-1h1z",
    fill: "#bedaea"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38v1h-1v-1z",
    fill: "#b9cfeb"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38h1v1h-1z",
    fill: "#a6bce2"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39v-1h1v1z",
    fill: "#85a9d9"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M69 39v-1h1v1z",
    fill: "#4d92d5"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39h-1v-1h1z",
    fill: "#1277c9"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M71 38h1v1h-1z",
    fill: "#036ac1"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1z",
    fill: "#0060c2"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M73 38h1v1h-1z",
    fill: "#015bc2"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39v-1h1v1z",
    fill: "#0057c2"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38v1h-1v-1z",
    fill: "#0157c7"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M77 39h-1v-1h1z",
    fill: "#045dc0",
    fillOpacity: 0.988
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h-1v-1h1z",
    fill: "#296aa6",
    fillOpacity: 0.216
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M18 40v-1h1v1z",
    fill: "#b0bbb5",
    fillOpacity: 0.596
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39h1v1h-1z",
    fill: "#495276"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40v-1h1v1z",
    fill: "#000960"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v1h-1v-1z",
    fill: "#2b3f88"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h1v1h-1z",
    fill: "#2e4984"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M23 39h1v1h-1z",
    fill: "#4c6ba8"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h-1v-1h1z",
    fill: "#5a7bb6"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40v-1h1v1z",
    fill: "#325497"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M27 39v1h-1v-1z",
    fill: "#001352"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v1h-1v-1z",
    fill: "#8895a3"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h-1v-1h1z",
    fill: "#a6d2d6"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M30 39v1h-1v-1z",
    fill: "#3573be"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40h-1v-1h1z",
    fill: "#0047bc"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v-1h1v1z",
    fill: "#005ccb"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v1h-1v-1z",
    fill: "#0368ce"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39h1v1h-1z",
    fill: "#0c72d3"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v-1h1v1z",
    fill: "#1d7bd3"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39v1h-1v-1z",
    fill: "#408fdc"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39h1v1h-1z",
    fill: "#6ea0e0"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M37 40v-1h1v1z",
    fill: "#92b1e6"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40h-1v-1h1z",
    fill: "#a8bfea"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v1h-1v-1z",
    fill: "#b4c5ea"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39v1h-1v-1z",
    fill: "#b2c9e9"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39h1v1h-1z",
    fill: "#b6cce7"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M44 39v1h-1v-1z",
    fill: "#5f81c0"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h-1v-1h1z",
    fill: "#012cb4"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M47 40h-1v-1h1z",
    fill: "#0b32a0"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39h1v1h-1z",
    fill: "#91b7d5"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h-1v-1h1z",
    fill: "#c2d6ed"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1z",
    fill: "#c2dbed"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39v1h-1v-1z",
    fill: "#2249ae"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1z",
    fill: "#0020a3"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#6e8ec4"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1z",
    fill: "#85a3cf"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40h-1v-1h1z",
    fill: "#0022a3"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40v-1h1v1z",
    fill: "#204ba9"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#abd0e3"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M59 39v1h-1v-1z",
    fill: "#cee0ef"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1z",
    fill: "#91acd6"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1z",
    fill: "#01219f"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#1d46aa"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1z",
    fill: "#345cb6"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M63 39h1v1h-1z",
    fill: "#001ea2"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v1h-1v-1z",
    fill: "#5e86bb"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#cee2ef"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#b3c3df"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#9eb9e2"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1z",
    fill: "#8cb0de"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M70 40h-1v-1h1z",
    fill: "#70a5e0"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-1v-1z",
    fill: "#5094dd"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40v-1h1v1z",
    fill: "#3387da"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M72 40v-1h1v1z",
    fill: "#137ad1"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#0473cf"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39h1v1h-1z",
    fill: "#036ed0"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M75 40v-1h1v1z",
    fill: "#0168cb"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M76 39h1v1h-1z",
    fill: "#0561bd",
    fillOpacity: 0.988
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40v-1h1v1z",
    fill: "#296fa6",
    fillOpacity: 0.216
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M19 41h-1v-1h1z",
    fill: "#b0b9b5",
    fillOpacity: 0.6
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41h-1v-1h1z",
    fill: "#434972"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40h1v1h-1z",
    fill: "#010759"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h-1v-1h1z",
    fill: "#4f65a2"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41h-1v-1h1z",
    fill: "#5671a5"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41v-1h1v1z",
    fill: "#355190"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M24 41v-1h1v1z",
    fill: "#395999"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h1v1h-1z",
    fill: "#294e95"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M27 41h-1v-1h1z",
    fill: "#0a246a"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M27 40h1v1h-1z",
    fill: "#636c85"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40v1h-1v-1z",
    fill: "#a4d0da"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h1v1h-1z",
    fill: "#2c6fbc"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v1h-1v-1z",
    fill: "#0053c1"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41v-1h1v1z",
    fill: "#026ad0"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40h1v1h-1z",
    fill: "#0779d8"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v1h-1v-1z",
    fill: "#288ae4"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v-1h1v1z",
    fill: "#4f95e4"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1z",
    fill: "#6ea1e4"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h-1v-1h1z",
    fill: "#8cace4"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41h-1v-1h1z",
    fill: "#9fb7e7"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h-1v-1h1z",
    fill: "#abc2ea"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M40 41h-1v-1h1z",
    fill: "#b5c8e9"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40v1h-1v-1z",
    fill: "#b6cce9"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h-1v-1h1z",
    fill: "#b7cee7"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40v1h-1v-1z",
    fill: "#c0d1e9"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M43 41v-1h1v1z",
    fill: "#b8d0e7"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M45 40v1h-1v-1z",
    fill: "#173da7"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v-1h1v1z",
    fill: "#012bb4"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40v1h-1v-1z",
    fill: "#426db4"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1z",
    fill: "#bbd7e4"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h1v1h-1z",
    fill: "#b6d2e8"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41v-1h1v1z",
    fill: "#123ca6"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1z",
    fill: "#032aa6"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v-1h1v1z",
    fill: "#8aacd3"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1z",
    fill: "#607fbe"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1z",
    fill: "#001da4"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h-1v-1h1z",
    fill: "#3d65b3"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M58 40v1h-1v-1z",
    fill: "#bbd7e9"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M59 41h-1v-1h1z",
    fill: "#d3e2f0"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#6c88c5"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1z",
    fill: "#001c9c"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#3f6ab6"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v-1h1v1z",
    fill: "#709cc9"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41v-1h1v1z",
    fill: "#0020a2"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1z",
    fill: "#0f35a5"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#a9c7e1"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#c1d3e7"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#9fb7dc"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#8eacdc"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41v-1h1v1z",
    fill: "#6f9dda"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41v-1h1v1z",
    fill: "#4188d0"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40h1v1h-1z",
    fill: "#1f7cd0"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M73 40v1h-1v-1z",
    fill: "#0d79d2"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#0474ce"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v-1h1v1z",
    fill: "#0370d1"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40v1h-1v-1z",
    fill: "#0270cd"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v-1h1v1z",
    fill: "#096cc0",
    fillOpacity: 0.988
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1z",
    fill: "#2e7db0",
    fillOpacity: 0.216
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42v-1h1v1z",
    fill: "#b3bab6",
    fillOpacity: 0.596
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41v1h-1v-1z",
    fill: "#41456d"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M21 41v1h-1v-1z",
    fill: "#000052"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42v-1h1v1z",
    fill: "#2e3d84"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h1v1h-1z",
    fill: "#576ea9"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42h-1v-1h1z",
    fill: "#5776b0"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42h-1v-1h1z",
    fill: "#44679d"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42v-1h1v1z",
    fill: "#214284"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M26 41h1v1h-1z",
    fill: "#091f67"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42v-1h1v1z",
    fill: "#757a97"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42h-1v-1h1z",
    fill: "#a2ccdb"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41v1h-1v-1z",
    fill: "#286fbb"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M31 42h-1v-1h1z",
    fill: "#0058c2"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41v1h-1v-1z",
    fill: "#0269cd"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41v1h-1v-1z",
    fill: "#0174cf"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v1h-1v-1z",
    fill: "#0f78d1"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41v1h-1v-1z",
    fill: "#3784d7"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42h-1v-1h1z",
    fill: "#6197e0"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#83a8e1"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1z",
    fill: "#a1bce9"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41v1h-1v-1z",
    fill: "#b3c9e9"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h1v1h-1z",
    fill: "#c2d3ed"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42h-1v-1h1z",
    fill: "#c9daf0"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42h-1v-1h1z",
    fill: "#c4d2eb"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h1v1h-1z",
    fill: "#becee9"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M44 42h-1v-1h1z",
    fill: "#cfdff3"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v1h-1v-1z",
    fill: "#6e8fc7"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42h-1v-1h1z",
    fill: "#0027a9"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-1v-1z",
    fill: "#012cb6"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1z",
    fill: "#0d34a5"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#a5c3da"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1z",
    fill: "#97b4d6"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41v1h-1v-1z",
    fill: "#022ba1"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#1742aa"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1z",
    fill: "#a8cbe1"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-1v-1h1z",
    fill: "#cce2f2"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1z",
    fill: "#3d5cb2"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42v-1h1v1z",
    fill: "#001da3"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1z",
    fill: "#6086bf"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h1v1h-1z",
    fill: "#c1d7eb"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1z",
    fill: "#d2e2f0"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42v-1h1v1z",
    fill: "#4867b9"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1z",
    fill: "#5a83be"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h1v1h-1z",
    fill: "#b5d7e8"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#27479e"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#2e51a7"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#b9d1e6"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#c0d6eb"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#76a7d3"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1z",
    fill: "#3e81c0"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41h1v1h-1z",
    fill: "#6ca5e2"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-1v-1h1z",
    fill: "#3f89cf"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1z",
    fill: "#1677c7"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#0773ca"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41h1v1h-1z",
    fill: "#036fcb"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1z",
    fill: "#0170cc"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1z",
    fill: "#086dc4",
    fillOpacity: 0.992
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42h-1v-1h1z",
    fill: "#3178ae",
    fillOpacity: 0.224
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42h1v1h-1z",
    fill: "#adb4b2",
    fillOpacity: 0.6
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M20 42v1h-1v-1z",
    fill: "#4c5178"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M21 43h-1v-1h1z",
    fill: "#111a6f"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42h1v1h-1z",
    fill: "#0a1873"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43h-1v-1h1z",
    fill: "#0d186e"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42v1h-1v-1z",
    fill: "#3a529d"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43v-1h1v1z",
    fill: "#6288be"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43v-1h1v1z",
    fill: "#4f70a7"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M26 43v-1h1v1z",
    fill: "#0a1d5f"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42h1v1h-1z",
    fill: "#818ba4"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42v1h-1v-1z",
    fill: "#9fcedc"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43v-1h1v1z",
    fill: "#2573be"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42h1v1h-1z",
    fill: "#0163cc"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43v-1h1v1z",
    fill: "#0b72d6"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-1z",
    fill: "#2081d7"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42v1h-1v-1z",
    fill: "#4290e0"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v1h-1z",
    fill: "#659de7"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42v1h-1v-1z",
    fill: "#82abea"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1z",
    fill: "#98b8e5"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42h1v1h-1z",
    fill: "#cde4f4"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1z",
    fill: "#a8cce0"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1z",
    fill: "#9cbacc"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h-1v-1h1z",
    fill: "#ccdded"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42v1h-1v-1z",
    fill: "#c3d4eb"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43v-1h1v1z",
    fill: "#c4d3ec"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43h-1v-1h1z",
    fill: "#bfd5eb"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42v1h-1v-1z",
    fill: "#1e41a7"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M46 43v-1h1v1z",
    fill: "#0129b5"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1z",
    fill: "#7c9fd3"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h1v1h-1z",
    fill: "#6b8eca"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#001fa3"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#305baf"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h-1v-1h1z",
    fill: "#b9dae7"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43v-1h1v1z",
    fill: "#c4d9ed"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1z",
    fill: "#2240a5"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1z",
    fill: "#0022a4"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h1v1z",
    fill: "#79a1cb"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1z",
    fill: "#c3d8ea"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43v-1h1v1z",
    fill: "#cdddee"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1z",
    fill: "#2b4cab"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42h1v1h-1z",
    fill: "#0023a6"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1z",
    fill: "#7ba1cd"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M63 42v1h-1v-1z",
    fill: "#cee4eb"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-1h1v1z",
    fill: "#98b2d3"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1z",
    fill: "#082e9d"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#2545a8"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v1h-1v-1z",
    fill: "#86a4d1"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1z",
    fill: "#97c0dd"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1z",
    fill: "#82abcd"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1z",
    fill: "#b2d0df"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43v-1h1v1z",
    fill: "#abc7ec"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M72 43v-1h1v1z",
    fill: "#6197d7"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#398bd2"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1z",
    fill: "#2888d6"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#137fd0"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#0670c2",
    fillOpacity: 0.992
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M77 43v-1h1v1z",
    fill: "#317db2",
    fillOpacity: 0.224
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M19 44h-1v-1h1z",
    fill: "#afb4b0",
    fillOpacity: 0.6
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h-1v-1h1z",
    fill: "#3f4665"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44h-1v-1h1z",
    fill: "#132472"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44v-1h1v1z",
    fill: "#244aa1"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43v1h-1v-1z",
    fill: "#0d2784"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44h-1v-1h1z",
    fill: "#00056c"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M25 44h-1v-1h1z",
    fill: "#203187"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44h-1v-1h1z",
    fill: "#4c70ad"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44h-1v-1h1z",
    fill: "#0c2160"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44v-1h1v1z",
    fill: "#8a97aa"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M28 44v-1h1v1z",
    fill: "#a2cedc"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h-1v-1h1z",
    fill: "#2679c2"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44v-1h1v1z",
    fill: "#006fd1"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43h1v1h-1z",
    fill: "#1f84e1"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v-1h1v1z",
    fill: "#428edf"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44v-1h1v1z",
    fill: "#5895dc"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43v1h-1v-1z",
    fill: "#699ade"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44h-1v-1h1z",
    fill: "#729cda"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-1v-1h1z",
    fill: "#9bb6e0"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43v1h-1v-1z",
    fill: "#bddaee"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44v-1h1v1z",
    fill: "#5f8dc5"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43v1h-1v-1z",
    fill: "#3166a1"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M41 43v1h-1v-1z",
    fill: "#98c0d2"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43v1h-1v-1z",
    fill: "#c7dbed"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h1v1h-1z",
    fill: "#c3d5e9"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43h1v1h-1z",
    fill: "#bdd2e9"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43v1h-1v-1z",
    fill: "#d1e0f0"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M45 44v-1h1v1z",
    fill: "#6685c3"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1z",
    fill: "#0027ac"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1z",
    fill: "#587fc1"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-1z",
    fill: "#426aba"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#001ea5"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1z",
    fill: "#4d79be"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M53 44h-1v-1h1z",
    fill: "#c2dff0"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#b4c6e5"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#0d2ea1"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1z",
    fill: "#0129a7"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v1h-1v-1z",
    fill: "#8eb4d8"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44h-1v-1h1z",
    fill: "#d3e2ee"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43h1v1h-1z",
    fill: "#b5cedb"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1z",
    fill: "#11379d"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#0023a2"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#83aad5"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1z",
    fill: "#c7dcee"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1z",
    fill: "#cddef0"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1z",
    fill: "#8facd3"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1z",
    fill: "#2542a5"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43v1h-1v-1z",
    fill: "#00219a"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1z",
    fill: "#001e98"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43v1h-1v-1z",
    fill: "#1a4094"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1z",
    fill: "#5070a0"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43h1v1h-1z",
    fill: "#a1bfcd"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43h1v1h-1z",
    fill: "#b4d2eb"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43v1h-1v-1z",
    fill: "#7da7db"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1z",
    fill: "#3c87cd"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#2a84d3"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#2a87d3"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44h-1v-1h1z",
    fill: "#1078c4",
    fillOpacity: 0.992
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44h-1v-1h1z",
    fill: "#2c78ae",
    fillOpacity: 0.224
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44h1v1h-1z",
    fill: "#b8b9af",
    fillOpacity: 0.592
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v-1h1v1z",
    fill: "#a7adb1"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h1v1h-1z",
    fill: "#1c2558"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44v1h-1v-1z",
    fill: "#001366"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M23 45h-1v-1h1z",
    fill: "#18439c"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M23 44h1v1h-1z",
    fill: "#153c9a"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h-1v-1h1z",
    fill: "#021474"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44v1h-1v-1z",
    fill: "#172b7a"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45h-1v-1h1z",
    fill: "#081556"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45v-1h1v1z",
    fill: "#91a0ac"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h-1v-1h1z",
    fill: "#a2cbda"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-1v-1h1z",
    fill: "#267fc1"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h1v1h-1z",
    fill: "#0375cb"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v1h-1v-1z",
    fill: "#2884d7"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1z",
    fill: "#4087d6"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44v1h-1v-1z",
    fill: "#558fd5"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v-1h1v1z",
    fill: "#6f9de1"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1z",
    fill: "#88afe4"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45h-1v-1h1z",
    fill: "#bdd9f1"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1z",
    fill: "#4e89bf"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44h1v1h-1z",
    fill: "#0347a7"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45h-1v-1h1z",
    fill: "#99c1df"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M41 44v1h-1v-1z",
    fill: "#cadff2"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45h-1v-1h1z",
    fill: "#c2d7f0"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v-1h1v1z",
    fill: "#bfd3e9"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-1h1v1z",
    fill: "#bdd0e9"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45h-1v-1h1z",
    fill: "#c9d8e9"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44v1h-1v-1z",
    fill: "#a1bfdb"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1z",
    fill: "#0631a7"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1z",
    fill: "#0026b2"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1z",
    fill: "#4c74b6"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#2c54ad"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1z",
    fill: "#638cc7"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1z",
    fill: "#c8e2ea"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1z",
    fill: "#afc4de"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1z",
    fill: "#0629a1"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1z",
    fill: "#0026a8"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1z",
    fill: "#5a7fc4"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#8eafcf"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45v-1h1v1z",
    fill: "#6d94b2"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1z",
    fill: "#446ab0"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#0d2b96"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1z",
    fill: "#557daf"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1z",
    fill: "#c2ddf2"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#c0cee8"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44v1h-1v-1z",
    fill: "#c6d5eb"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1z",
    fill: "#c4d5e8"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1z",
    fill: "#92add7"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1z",
    fill: "#7699d4"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M69 45h-1v-1h1z",
    fill: "#87adda"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M69 44h1v1h-1z",
    fill: "#accde7"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M71 44v1h-1v-1z",
    fill: "#c7d2d8"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M72 44v1h-1v-1z",
    fill: "#c8c9bf"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v-1h1v1z",
    fill: "#b7cce2"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#5b99d9"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45h-1v-1h1z",
    fill: "#3684ce"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M76 45h-1v-1h1z",
    fill: "#3b87d1"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1z",
    fill: "#3184c9",
    fillOpacity: 0.992
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1z",
    fill: "#3b7aa8",
    fillOpacity: 0.22
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v1h-1v-1z",
    fill: "#b0b1a4",
    fillOpacity: 0.584
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46v-1h1v1z",
    fill: "#e5ecd3"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M20 45h1v1h-1z",
    fill: "#c5cfc7"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M21 46v-1h1v1z",
    fill: "#474b75"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v-1h1v1z",
    fill: "#00085f"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45v1h-1v-1z",
    fill: "#123798"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46h-1v-1h1z",
    fill: "#1a419e"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h1v1h-1z",
    fill: "#07287a"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46h-1v-1h1z",
    fill: "#041856"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46h-1v-1h1z",
    fill: "#9eb1ba"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h1v1h-1z",
    fill: "#2482c2"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45v1h-1v-1z",
    fill: "#177ad0"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46v-1h1v1z",
    fill: "#418ddc"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M33 45v1h-1v-1z",
    fill: "#5a95df"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v1h-1v-1z",
    fill: "#6d9ee1"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1z",
    fill: "#80a5e4"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45v1h-1v-1z",
    fill: "#aac5ef"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h1v1z",
    fill: "#84b2d5"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1z",
    fill: "#0042ac"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M39 46h-1v-1h1z",
    fill: "#437ec3"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46h-1v-1h1z",
    fill: "#c3dfee"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M41 46h-1v-1h1z",
    fill: "#c5d4f0"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M42 46h-1v-1h1z",
    fill: "#bbd1e8"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v1h-1v-1z",
    fill: "#c2cfe5"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-1v-1z",
    fill: "#bdcfea"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45h1v1h-1z",
    fill: "#c5d3e8"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1z",
    fill: "#b0c9df"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#0c36a9"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#5c84bc"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#2046a9"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#0021a9"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1z",
    fill: "#547bc0"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1z",
    fill: "#c2deeb"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1z",
    fill: "#819bbe"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1z",
    fill: "#14389f"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45v1h-1v-1z",
    fill: "#0020a1"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1z",
    fill: "#012899"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46h-1v-1h1z",
    fill: "#416da1"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45h1v1h-1z",
    fill: "#a5c8dd"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1z",
    fill: "#bcd7ed"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1z",
    fill: "#aec9ea"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h1v1h-1z",
    fill: "#afc9e7"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1z",
    fill: "#bed1ea"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1z",
    fill: "#b6cae2"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46v-1h1v1z",
    fill: "#aec0db"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46h-1v-1h1z",
    fill: "#b4c6e2"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45v1h-1v-1z",
    fill: "#bbcdec"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1z",
    fill: "#b9d2ec"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h1v1h-1z",
    fill: "#a7c8e6"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v-1h1v1z",
    fill: "#b0c7e2"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46v-1h1v1z",
    fill: "#c5a978"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v1h-1v-1z",
    fill: "#bb8b43"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45h1v1h-1z",
    fill: "#b8bdce"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#70a0dd"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1z",
    fill: "#5993d8"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1z",
    fill: "#5792d8"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46v-1h1v1z",
    fill: "#578fcf",
    fillOpacity: 0.988
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v1h-1v-1z",
    fill: "#668fb9",
    fillOpacity: 0.216
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46h1v1h-1z",
    fill: "#dadebe"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M20 46h1v1h-1z",
    fill: "#e4e9c7"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v1h-1v-1z",
    fill: "#e0e9d2"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h-1v-1h1z",
    fill: "#757b9a"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47v-1h1v1z",
    fill: "#070d5d"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47h-1v-1h1z",
    fill: "#05247d"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M26 47h-1v-1h1z",
    fill: "#1a4a9a"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46v1h-1v-1z",
    fill: "#0e2c61"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47h-1v-1h1z",
    fill: "#aabdc3"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M29 46h1v1h-1z",
    fill: "#2482c3"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M31 47h-1v-1h1z",
    fill: "#3282d7"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46h1v1h-1z",
    fill: "#5995e1"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46v1h-1v-1z",
    fill: "#6a99e1"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47h-1v-1h1z",
    fill: "#6c9ae0"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47h-1v-1h1z",
    fill: "#779dd8"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47h-1v-1h1z",
    fill: "#afcde9"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46v1h-1v-1z",
    fill: "#3770bb"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#0043b9"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#6d9fcf"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M39 47v-1h1v1z",
    fill: "#c8e0f0"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#bed0e9"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47h-1v-1h1z",
    fill: "#bccfec"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1z",
    fill: "#bdcde6"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1z",
    fill: "#b8cbe8"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1z",
    fill: "#9ab5d9"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1z",
    fill: "#022ba5"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M47 46h1v1h-1z",
    fill: "#072da5"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h1v1h-1z",
    fill: "#8cb7d8"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1z",
    fill: "#2247a5"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1z",
    fill: "#022a9c"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#305497"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1z",
    fill: "#80a4be"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47v-1h1v1z",
    fill: "#a2c6de"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-1v-1z",
    fill: "#7698ce"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1z",
    fill: "#84aad3"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1z",
    fill: "#b3d4e7"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1z",
    fill: "#bed4ed"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47v-1h1v1z",
    fill: "#c1d1ea"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#c1d2eb"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#bdceea"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47h-1v-1h1z",
    fill: "#b3c6e5"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-1z",
    fill: "#aabfdf"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1z",
    fill: "#9fbcdf"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1z",
    fill: "#94b0dc"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47v-1h1v1z",
    fill: "#88addd"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M69 47v-1h1v1z",
    fill: "#b4c0d7"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#c09346"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M71 47v-1h1v1z",
    fill: "#c5964a"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#a3b5d0"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#6298d5"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#6194d8"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47h-1v-1h1z",
    fill: "#6497d7"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1z",
    fill: "#6999d0",
    fillOpacity: 0.984
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1z",
    fill: "#84a1c4",
    fillOpacity: 0.204
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47v1h-1v-1z",
    fill: "#b4b8a5",
    fillOpacity: 0.58
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M19 48v-1h1v1z",
    fill: "#c6cbab"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48h-1v-1h1z",
    fill: "#c5c9a7"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M21 47h1v1h-1z",
    fill: "#dee4c4"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48h-1v-1h1z",
    fill: "#e5edd2"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h1v1h-1z",
    fill: "#9ba6af"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47v1h-1v-1z",
    fill: "#1a2865"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48v-1h1v1z",
    fill: "#05206d"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48h-1v-1h1z",
    fill: "#1f3e74"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48v-1h1v1z",
    fill: "#b3c8cc"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M29 48h-1v-1h1z",
    fill: "#9eced9"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h1v1h-1z",
    fill: "#2b87c6"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h-1v-1h1z",
    fill: "#3f88d7"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48h-1v-1h1z",
    fill: "#5d95db"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#6a99db"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47v1h-1v-1z",
    fill: "#719edd"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#8db0e4"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-1v-1z",
    fill: "#a5cbe7"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v1h-1v-1z",
    fill: "#1154b9"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47h1v1h-1z",
    fill: "#0045bf"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#6ca1d1"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1z",
    fill: "#cbe0ec"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#b8cde9"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1z",
    fill: "#b6cfe8"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-1z",
    fill: "#b9cbe7"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#b9c8e8"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h1v1h-1z",
    fill: "#cadff1"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1z",
    fill: "#5177ba"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1z",
    fill: "#001f9f"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h1v1h-1z",
    fill: "#486caf"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h1v1h-1z",
    fill: "#badcea"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1z",
    fill: "#95b6d8"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48h-1v-1h1z",
    fill: "#4a6fb3"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1z",
    fill: "#587dc1"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1z",
    fill: "#93b8d9"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1z",
    fill: "#b7d6ed"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48v-1h1v1z",
    fill: "#c1d9e9"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48v-1h1v1z",
    fill: "#c9dcf1"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-1z",
    fill: "#c6d9f0"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47v1h-1v-1z",
    fill: "#bbd0e9"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-1v-1h1z",
    fill: "#b3c8e4"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1z",
    fill: "#acc6e3"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#acc3e3"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1z",
    fill: "#aabfe3"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-1h1v1z",
    fill: "#a7bee4"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h1z",
    fill: "#a5bce4"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1z",
    fill: "#a1b9e0"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#99b7de"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47h1v1h-1z",
    fill: "#92b1e0"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#88a8df"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47h1v1h-1z",
    fill: "#7fa4d5"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48h-1v-1h1z",
    fill: "#bdc2c5"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48v-1h1v1z",
    fill: "#b78329"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47v1h-1v-1z",
    fill: "#c9a975"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47h1v1h-1z",
    fill: "#9cb6d9"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#6a9bd3"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M75 47v1h-1v-1z",
    fill: "#6999d6"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#6e9dd9"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48v-1h1v1z",
    fill: "#739fd4",
    fillOpacity: 0.98
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47v1h-1v-1z",
    fill: "#8caac8",
    fillOpacity: 0.2
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M18 48h1v1h-1z",
    fill: "#b2b4a3",
    fillOpacity: 0.576
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M19 49v-1h1v1z",
    fill: "#d8debd"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M22 49h-1v-1h1z",
    fill: "#b3b595"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48v1h-1v-1z",
    fill: "#cacfaf"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M24 49h-1v-1h1z",
    fill: "#e3ebcd"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M25 49h-1v-1h1z",
    fill: "#c0c8c3"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48h1v1h-1z",
    fill: "#3a456a"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h-1v-1h1z",
    fill: "#0f2348"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48v1h-1v-1z",
    fill: "#bbcdd2"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M29 49h-1v-1h1z",
    fill: "#9ecddd"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h-1v-1h1z",
    fill: "#3289c5"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49h-1v-1h1z",
    fill: "#5090d6"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h1v1h-1z",
    fill: "#6c9cda"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1z",
    fill: "#79a5de"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#83ace4"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#96b4e5"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1z",
    fill: "#9fc4e3"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#0c52b8"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v1h-1v-1z",
    fill: "#0045c4"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1z",
    fill: "#336fbc"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h-1v-1h1z",
    fill: "#cbe4f0"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49h-1v-1h1z",
    fill: "#c3d2e5"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1z",
    fill: "#bbcbe8"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#bfcce7"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48h1v1h-1z",
    fill: "#cddded"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48v1h-1v-1z",
    fill: "#91b2d4"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1z",
    fill: "#04289a"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1z",
    fill: "#214ba3"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1z",
    fill: "#a3c9de"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1z",
    fill: "#bfd1ee"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49v-1h1v1z",
    fill: "#c5d7ea"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49v-1h1v1z",
    fill: "#c7deee"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#c6dbee"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1z",
    fill: "#c0d3ee"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#b6c9ea"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48h1v1h-1z",
    fill: "#b0c3e1"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48h1v1h-1z",
    fill: "#aec1e1"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1z",
    fill: "#abc2e4"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49v-1h1v1z",
    fill: "#a9c2e1"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M59 49h-1v-1h1z",
    fill: "#a9bee1"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49h-1v-1h1z",
    fill: "#a7bde2"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-1z",
    fill: "#a5bce3"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1z",
    fill: "#a2b9e3"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1z",
    fill: "#9eb6e0"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#9cb6de"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h1v1z",
    fill: "#94b2dc"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48v1h-1v-1z",
    fill: "#8cabdb"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49h-1v-1h1z",
    fill: "#94aedd"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h1v1h-1z",
    fill: "#b2c2dd"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M69 48h1v1h-1z",
    fill: "#d0ba98"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49v-1h1v1z",
    fill: "#b67f1e"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49v-1h1v1z",
    fill: "#cab89f"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#90b0dd"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#7aa3d9"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1z",
    fill: "#7aa6db"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M76 49h-1v-1h1z",
    fill: "#7ba4dc"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1z",
    fill: "#7da2d7",
    fillOpacity: 0.98
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h-1v-1h1z",
    fill: "#93a6cd",
    fillOpacity: 0.204
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M19 50h-1v-1h1z",
    fill: "#a3a693",
    fillOpacity: 0.576
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M20 50h-1v-1h1z",
    fill: "#c0c5a5"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M20 50v-1h1v1z",
    fill: "#dbdfbd"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M21 49h1v1h-1z",
    fill: "#d2d3b3"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M23 50h-1v-1h1z",
    fill: "#b4b696"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h-1v-1h1z",
    fill: "#bec19e"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50v-1h1v1z",
    fill: "#dadfbe"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M26 49v1h-1v-1z",
    fill: "#d2dac6"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49v1h-1v-1z",
    fill: "#a6aea9"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h1v1h-1z",
    fill: "#ced9d7"
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M28 49h1v1h-1z",
    fill: "#a2cde3"
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49v1h-1v-1z",
    fill: "#3a8bc6"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h1v1h-1z",
    fill: "#6399da"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v1h-1v-1z",
    fill: "#7ba3de"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v-1h1v1z",
    fill: "#80a8df"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M34 49v1h-1v-1z",
    fill: "#83abdf"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v-1h1v1z",
    fill: "#92afdf"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h1v1h-1z",
    fill: "#b2d2ed"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1z",
    fill: "#2663b2"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v-1h1v1z",
    fill: "#0042c4"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M39 49v1h-1v-1z",
    fill: "#0240b6"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1z",
    fill: "#628fc5"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h1v1h-1z",
    fill: "#c2ddeb"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M42 49v1h-1v-1z",
    fill: "#cae1f0"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50v-1h1v1z",
    fill: "#bfdaea"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h1v1h-1z",
    fill: "#7c9bcc"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49h1v1h-1z",
    fill: "#093593"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1z",
    fill: "#2b51a8"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1z",
    fill: "#9cc0db"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fill: "#b6d4ec"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#afc7e7"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#a8bfe3"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49h1v1h-1z",
    fill: "#abc1e1"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1z",
    fill: "#adc1e3"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1z",
    fill: "#a9c0e1"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#a7c0e3"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1z",
    fill: "#a9bfe9"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1z",
    fill: "#a9bde3"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49h1v1h-1z",
    fill: "#a4bbe5"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h1v1h-1z",
    fill: "#a5bae5"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1z",
    fill: "#a3bae3"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1z",
    fill: "#a0bbe0"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1z",
    fill: "#a4bce2"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1z",
    fill: "#b1c5e3"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h1v1h-1z",
    fill: "#b7c7e1"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#a9bee3"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#99b3de"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1z",
    fill: "#96afdd"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49v1h-1v-1z",
    fill: "#bdc5dc"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50v-1h1v1z",
    fill: "#c9b284"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1z",
    fill: "#bd8626"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49h1v1h-1z",
    fill: "#bf8728"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49h1v1h-1z",
    fill: "#c3bdb7"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M73 49v1h-1v-1z",
    fill: "#87a9db"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#7ea6da"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1z",
    fill: "#83aade"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M76 50h-1v-1h1z",
    fill: "#86aae1"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M77 49v1h-1v-1z",
    fill: "#86a7db",
    fillOpacity: 0.98
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1z",
    fill: "#93abc9",
    fillOpacity: 0.204
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M19 51v-1h1v1z",
    fill: "#c0c4a4"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51h-1v-1h1z",
    fill: "#aeaf8f"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M22 51h-1v-1h1z",
    fill: "#d4d4b4"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M22 50h1v1h-1z",
    fill: "#d9daba"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h1v1h-1z",
    fill: "#bcbc9d"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M26 50v1h-1v-1z",
    fill: "#dde0be"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51h-1v-1h1z",
    fill: "#edefd7"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v-1h1v1z",
    fill: "#dee6e1"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M29 50v1h-1v-1z",
    fill: "#a3cce3"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51h-1v-1h1z",
    fill: "#4193cb"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51v-1h1v1z",
    fill: "#70a2dc"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v1h-1v-1z",
    fill: "#85a7e1"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51h-1v-1h1z",
    fill: "#85abe4"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51h-1v-1h1z",
    fill: "#8bb0e3"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#97b5e1"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51h-1v-1h1z",
    fill: "#b6cde9"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v1h-1v-1z",
    fill: "#87aed4"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50h1v1h-1z",
    fill: "#0845ab"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v1h-1z",
    fill: "#003cbf"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1z",
    fill: "#0038ae"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1z",
    fill: "#174da9"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#2859af"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-1z",
    fill: "#1544a1"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50h1v1h-1z",
    fill: "#0e3996"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50h1v1h-1z",
    fill: "#5884b9"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1z",
    fill: "#a9cde2"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1z",
    fill: "#b9d4ed"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1z",
    fill: "#adc6e7"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M50 51v-1h1v1z",
    fill: "#a3bce2"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1z",
    fill: "#a2bce0"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1z",
    fill: "#a3bce0"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#a4bde1"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1z",
    fill: "#a4bdde"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1z",
    fill: "#a4bcdf"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#a6bde1"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1z",
    fill: "#a1bbdb"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1z",
    fill: "#a6bbe2"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#d3d1cc"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1z",
    fill: "#cab98c"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1z",
    fill: "#c6a264"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1z",
    fill: "#cbc1b3"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M65 50h1v1h-1z",
    fill: "#acbfdf"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h1v1h-1z",
    fill: "#bcc8df"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51v-1h1v1z",
    fill: "#c4aa7f"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50h1v1h-1z",
    fill: "#c49d4e"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v-1h1v1z",
    fill: "#cc9435"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51h-1v-1h1z",
    fill: "#c09440"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1z",
    fill: "#bbc2cc"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#8aaede"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#8faee1"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51v-1h1v1z",
    fill: "#8fafe3"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1z",
    fill: "#8fafdc",
    fillOpacity: 0.98
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50h1v1h-1z",
    fill: "#98b0c9",
    fillOpacity: 0.204
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52h-1v-1h1z",
    fill: "#b4b6a3",
    fillOpacity: 0.58
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M20 51v1h-1v-1z",
    fill: "#d4d8b8"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51v1h-1v-1z",
    fill: "#d4d5b5"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52v-1h1v1z",
    fill: "#bcbb9c"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M23 51v1h-1v-1z",
    fill: "#bebd9e"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h-1v-1h1z",
    fill: "#d7d6b7"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h1v1h-1z",
    fill: "#b9b89a"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52h-1v-1h1z",
    fill: "#bcbf9e"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v1h-1v-1z",
    fill: "#e7e8cf"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52h-1v-1h1z",
    fill: "#dee7df"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v-1h1v1z",
    fill: "#4898ce"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52v-1h1v1z",
    fill: "#7aa8dd"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h-1v-1h1z",
    fill: "#8aade3"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51v1h-1v-1z",
    fill: "#90aee7"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1z",
    fill: "#95b4e7"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1z",
    fill: "#9cb7e6"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M35 51h1v1h-1z",
    fill: "#a3b8df"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M37 52h-1v-1h1z",
    fill: "#c1d9ec"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M39 51v1h-1v-1z",
    fill: "#5583c2"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M39 52v-1h1v1z",
    fill: "#3061b5"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1z",
    fill: "#2658ae"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#3a67b5"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1z",
    fill: "#638ec4"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M44 51v1h-1v-1z",
    fill: "#a1c2dd"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52v-1h1v1z",
    fill: "#c5dde5"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52h-1v-1h1z",
    fill: "#c6daec"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#afc4e4"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1z",
    fill: "#a2bae0"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1z",
    fill: "#a0b9e2"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#a1bbe3"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1z",
    fill: "#a2b9df"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M52 51h1v1h-1z",
    fill: "#a1bae2"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M54 52h-1v-1h1z",
    fill: "#a1bbe1"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h1v1h-1z",
    fill: "#a1bbe2"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52h-1v-1h1z",
    fill: "#b1c2e9"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h-1v-1h1z",
    fill: "#c6cfd6"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1z",
    fill: "#cecdd5"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52v-1h1v1z",
    fill: "#b9c6e1"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v-1z",
    fill: "#bac7e9"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1z",
    fill: "#ceb189"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#ba8b34"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1z",
    fill: "#caa25a"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fill: "#be831a"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1z",
    fill: "#c0994f"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#d1d6e5"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M67 52h-1v-1h1z",
    fill: "#cdb997"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M68 51v1h-1v-1z",
    fill: "#b88a37"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M68 52v-1h1v1z",
    fill: "#dbc699"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51h1v1h-1z",
    fill: "#bc8d34"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M70 51h1v1h-1z",
    fill: "#c9a265"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M71 52v-1h1v1z",
    fill: "#b1bfdb"
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h-1v-1h1z",
    fill: "#92b0e1"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#96b4e2"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1z",
    fill: "#98b5e0"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M76 52h-1v-1h1z",
    fill: "#9ab6e1"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M76 51h1v1h-1z",
    fill: "#9ab6dc",
    fillOpacity: 0.98
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1z",
    fill: "#a5b9d2",
    fillOpacity: 0.2
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52v1h-1v-1z",
    fill: "#b5b8a6",
    fillOpacity: 0.584
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M20 52h1v1h-1z",
    fill: "#c0c1a1"
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52h1v1h-1z",
    fill: "#dcdbbc"
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M22 52h1v1h-1z",
    fill: "#c4c2a3"
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52v1h-1v-1z",
    fill: "#b6b495"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h1v1h-1z",
    fill: "#d1cfb1"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52v1h-1v-1z",
    fill: "#bdbe9f"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53h-1v-1h1z",
    fill: "#d5d6bb"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M27 52h1v1h-1z",
    fill: "#dee9df"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v1h-1v-1z",
    fill: "#9fcce5"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52h1v1h-1z",
    fill: "#529bd1"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M31 52v1h-1v-1z",
    fill: "#86acdd"
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53h-1v-1h1z",
    fill: "#94b2e6"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h1v1h-1z",
    fill: "#9bb3e8"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52v1h-1v-1z",
    fill: "#9fb7e6"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1z",
    fill: "#9fbae5"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1z",
    fill: "#a0bde2"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1z",
    fill: "#abc1e4"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M38 52v1h-1v-1z",
    fill: "#bfceee"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v1z",
    fill: "#cddfee"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53h-1v-1h1z",
    fill: "#cce2f0"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h-1v-1h1z",
    fill: "#c7ddf1"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1z",
    fill: "#c4daf3"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1z",
    fill: "#d1c8b1"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v1h-1z",
    fill: "#c4ae85"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#c6ccd8"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h1v1z",
    fill: "#a4bde0"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52v1h-1v-1z",
    fill: "#a0b8e0"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h1v1h-1z",
    fill: "#a0b8e1"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h1v1h-1z",
    fill: "#a1bae3"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52h1v1h-1z",
    fill: "#a8bee6"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1z",
    fill: "#b0c3e6"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52v1h-1v-1z",
    fill: "#a9c0e3"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52h1v1h-1z",
    fill: "#a0bcde"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52v1h-1v-1z",
    fill: "#b3c4e5"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53v-1h1v1z",
    fill: "#d0c8b6"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53h-1v-1h1z",
    fill: "#c09f5e"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1z",
    fill: "#b78a33"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52h1v1h-1z",
    fill: "#ceb997"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v1h-1v-1z",
    fill: "#dad9df"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M61 53h-1v-1h1z",
    fill: "#c19645"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1z",
    fill: "#c59543"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M63 53h-1v-1h1z",
    fill: "#ded5bd"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M63 52h1v1h-1z",
    fill: "#c29a49"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M65 52v1h-1v-1z",
    fill: "#c69d56"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53h-1v-1h1z",
    fill: "#ded4c2"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v1h-1z",
    fill: "#ba8736"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v-1h1v1z",
    fill: "#caae7a"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v1h-1v-1z",
    fill: "#dcccb2"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M70 52v1h-1v-1z",
    fill: "#b48224"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v-1h1v1z",
    fill: "#cab18a"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1z",
    fill: "#acc0e1"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52h1v1h-1z",
    fill: "#98b4dd"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#9cb5e1"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53v-1h1v1z",
    fill: "#9db9e4"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53v-1h1v1z",
    fill: "#a2bbe4"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#a3bcdf",
    fillOpacity: 0.976
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M77 52h1v1h-1z",
    fill: "#adc1d6",
    fillOpacity: 0.196
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54h-1v-1h1z",
    fill: "#b5b7a2",
    fillOpacity: 0.584
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53h1v1h-1z",
    fill: "#d8dcbb"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M21 53v1h-1v-1z",
    fill: "#c1c2a2"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53v1h-1v-1z",
    fill: "#b8b596"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M23 54v-1h1v1z",
    fill: "#cbc7a8"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54v-1h1v1z",
    fill: "#d7d8b9"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54h-1v-1h1z",
    fill: "#e9ebd0"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M28 53v1h-1v-1z",
    fill: "#dae6df"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M30 53v1h-1v-1z",
    fill: "#5da1d8"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54v-1h1v1z",
    fill: "#91b1e3"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M31 53h1v1h-1z",
    fill: "#9cb8e6"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#a1b9e6"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54v-1h1v1z",
    fill: "#a4bde6"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1z",
    fill: "#a5bee7"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53v1h-1v-1z",
    fill: "#a6c0e7"
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h1v1h-1z",
    fill: "#a8c0e5"
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v1h-1v-1z",
    fill: "#aabfe4"
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1z",
    fill: "#bacbe6"
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53v1h-1v-1z",
    fill: "#d7d3c9"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1z",
    fill: "#dad2ce"
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#c2cfe2"
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1z",
    fill: "#c79e62"
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53v1h-1v-1z",
    fill: "#c79d5a"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54h-1v-1h1z",
    fill: "#c0cad6"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1z",
    fill: "#a4bbe3"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h-1v-1h1z",
    fill: "#acc0e8"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M49 54h-1v-1h1z",
    fill: "#b3c6e6"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h-1v-1z",
    fill: "#bfcce6"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53v1h-1v-1z",
    fill: "#c7cbc0"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M51 54v-1h1v1z",
    fill: "#cbbb9e"
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h-1v-1h1z",
    fill: "#cbcbc5"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54h-1v-1h1z",
    fill: "#b7cae3"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54v-1h1v1z",
    fill: "#d0ccc6"
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54h-1v-1h1z",
    fill: "#b89349"
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53v1h-1v-1z",
    fill: "#d6b47d"
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h1z",
    fill: "#c59234"
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53h1v1h-1z",
    fill: "#c09b4e"
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v1h-1z",
    fill: "#e4d7c3"
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53h1v1h-1z",
    fill: "#ba8a31"
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53v1h-1v-1z",
    fill: "#d3af81"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v1h-1v-1z",
    fill: "#b8882f"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54h-1v-1h1z",
    fill: "#d4b17b"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v1h-1z",
    fill: "#d2b47c"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v1h-1v-1z",
    fill: "#b78528"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v1h-1v-1z",
    fill: "#b78024"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54h-1v-1h1z",
    fill: "#cbbfa7"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1z",
    fill: "#abc1de"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v1h-1z",
    fill: "#a2bce3"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#a2bee5"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v1h-1v-1z",
    fill: "#a7c0e7"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1z",
    fill: "#aac1e0",
    fillOpacity: 0.976
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M78 53v1h-1v-1z",
    fill: "#bbcada",
    fillOpacity: 0.192
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54v1h-1v-1z",
    fill: "#a7ab96",
    fillOpacity: 0.584
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M20 55h-1v-1h1z",
    fill: "#b9bc9b"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M20 54h1v1h-1z",
    fill: "#dbdcbc"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M21 54h1v1h-1z",
    fill: "#cfcdae"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54v1h-1v-1z",
    fill: "#cdcaab"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54v1h-1v-1z",
    fill: "#daddc2"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M27 55v-1h1v1z",
    fill: "#d9e4e0"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54v1h-1v-1z",
    fill: "#9fcae5"
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55v-1h1v1z",
    fill: "#65a4db"
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54v1h-1v-1z",
    fill: "#9ab9e9"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v1h-1v-1z",
    fill: "#a0bde4"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v-1h1v1z",
    fill: "#a5bee5"
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54h1v1h-1z",
    fill: "#a9c2e7"
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#abc2e8"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1z",
    fill: "#adc5e7"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#aec4e8"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1z",
    fill: "#b0c5e5"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v1h-1v-1z",
    fill: "#d1d3db"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54h1v1h-1z",
    fill: "#c39860"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54h1v1h-1z",
    fill: "#cfb28f"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#bacde2"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M42 55v-1h1v1z",
    fill: "#c9cddc"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54v1h-1v-1z",
    fill: "#c48f3f"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55v-1h1v1z",
    fill: "#ccaf7e"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-1z",
    fill: "#ccd3e4"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55h-1v-1h1z",
    fill: "#cdd2de"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1z",
    fill: "#cdc3b4"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1z",
    fill: "#d2b694"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M49 55v-1h1v1z",
    fill: "#d5b684"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M50 54h1v1h-1z",
    fill: "#bd9445"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55h-1v-1h1z",
    fill: "#b77f20"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-1z",
    fill: "#bd9950"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h1v1h-1z",
    fill: "#d9dadc"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v1h-1v-1z",
    fill: "#c5a66d"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54v1h-1v-1z",
    fill: "#c19c53"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55v-1h1v1z",
    fill: "#e2d8d8"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1z",
    fill: "#c79e53"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55v-1h1v1z",
    fill: "#c2994b"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54v1h-1v-1z",
    fill: "#dec9a1"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h1v1h-1z",
    fill: "#b88521"
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55h-1v-1h1z",
    fill: "#d8bea1"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v1h-1v-1z",
    fill: "#ddcdb7"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54h1v1h-1z",
    fill: "#b78121"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v1h-1v-1z",
    fill: "#dec08f"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1z",
    fill: "#c09441"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55h-1v-1h1z",
    fill: "#c59d53"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M68 54v1h-1v-1z",
    fill: "#dbd8da"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M69 55h-1v-1h1z",
    fill: "#caab74"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55h-1v-1h1z",
    fill: "#bf892f"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v-1h1v1z",
    fill: "#cfc9c3"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1z",
    fill: "#aac3df"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M73 54v1h-1v-1z",
    fill: "#a7bfe0"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55v-1h1v1z",
    fill: "#a7c0e2"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54v1h-1v-1z",
    fill: "#aac2e4"
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#adc5e9"
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1z",
    fill: "#b0c5e3",
    fillOpacity: 0.976
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1z",
    fill: "#bbc5da",
    fillOpacity: 0.192
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56v-1h1v1z",
    fill: "#b4b8a3",
    fillOpacity: 0.58
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M19 55h1v1h-1z",
    fill: "#c0c4a2"
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M20 55h1v1h-1z",
    fill: "#b8b999"
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M21 55h1v1h-1z",
    fill: "#d0ceaf"
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v1h-1v-1z",
    fill: "#b4b192"
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55v1h-1v-1z",
    fill: "#d2d4b6"
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M26 56v-1h1v1z",
    fill: "#c5c8ac"
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v-1h1v1z",
    fill: "#d7e2e0"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55h1v1h-1z",
    fill: "#a0c9e8"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55h1v1h-1z",
    fill: "#74aada"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M31 55v1h-1v-1z",
    fill: "#a1bde7"
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56h-1v-1h1z",
    fill: "#a8c0e3"
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#acc1e4"
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#afc4e6"
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1z",
    fill: "#b1c5e6"
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v-1h1v1z",
    fill: "#b0c7e8"
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M37 56h-1v-1h1z",
    fill: "#b1c7ed"
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55v1h-1v-1z",
    fill: "#b9cdec"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M38 56v-1h1v1z",
    fill: "#d8cbb9"
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h-1v-1h1z",
    fill: "#c28836"
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#d6b890"
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v1h-1z",
    fill: "#c0d1e4"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-1h1z",
    fill: "#d2ccc7"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55h1v1h-1z",
    fill: "#b98735"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55h1v1h-1z",
    fill: "#d7c5a7"
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56v-1h1v1z",
    fill: "#d8bfa8"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1z",
    fill: "#c39b52"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1z",
    fill: "#c19b50"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1z",
    fill: "#bb8016"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56h-1v-1h1z",
    fill: "#bd8823"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55v1h-1v-1z",
    fill: "#dfc8a3"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v-1h1v1z",
    fill: "#cda85c"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55v1h-1v-1z",
    fill: "#bd8f3a"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1z",
    fill: "#e1ceaf"
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M55 56h-1v-1h1z",
    fill: "#bc8731"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55h1v1h-1z",
    fill: "#d2b997"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55h1v1h-1z",
    fill: "#dbdce1"
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1z",
    fill: "#be953f"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55h1v1h-1z",
    fill: "#cda25a"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56h-1v-1h1z",
    fill: "#d9ba85"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M61 55v1h-1v-1z",
    fill: "#ba8628"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55v1h-1v-1z",
    fill: "#d9cdbe"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55v1h-1v-1z",
    fill: "#d4bb90"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M64 55v1h-1v-1z",
    fill: "#b88623"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56h-1v-1h1z",
    fill: "#dec493"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1z",
    fill: "#b9832c"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55v1h-1v-1z",
    fill: "#cfb386"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56v-1h1v1z",
    fill: "#dcdedb"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M68 55h1v1h-1z",
    fill: "#c29445"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56v-1h1v1z",
    fill: "#c4994e"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M71 56h-1v-1h1z",
    fill: "#cbcfd9"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h-1v-1h1z",
    fill: "#aec4e3"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56v-1h1v1z",
    fill: "#aec3e1"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M74 55v1h-1v-1z",
    fill: "#b0c4e3"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v1z",
    fill: "#b2c6e5"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56v-1h1v1z",
    fill: "#b7c9e5",
    fillOpacity: 0.969
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#c2cddd",
    fillOpacity: 0.18
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M18 57v-1h1v1z",
    fill: "#b7baa5",
    fillOpacity: 0.573
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M20 56v1h-1v-1z",
    fill: "#d6dab8"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M20 57v-1h1v1z",
    fill: "#d5d6b6"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M22 56v1h-1v-1z",
    fill: "#bebc9d"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M22 56h1v1h-1z",
    fill: "#bdb99a"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57h-1v-1h1z",
    fill: "#d3d0b1"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M25 57h-1v-1h1z",
    fill: "#b2af90"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M25 56h1v1h-1z",
    fill: "#cfd1b3"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v1h-1v-1z",
    fill: "#ecefd3"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h-1v-1h1z",
    fill: "#d7e2e3"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M28 56h1v1h-1z",
    fill: "#a2cae8"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56v1h-1v-1z",
    fill: "#82b1d9"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57v-1h1v1z",
    fill: "#aac1e5"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M31 56h1v1h-1z",
    fill: "#b1c2e4"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#b6c5e7"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56h1v1h-1z",
    fill: "#b4c7e7"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56v1h-1v-1z",
    fill: "#b7cceb"
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56h1v1h-1z",
    fill: "#bacaeb"
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M38 57h-1v-1h1z",
    fill: "#c9d6e9"
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#d0b287"
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1z",
    fill: "#c5872c"
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h1v1h-1z",
    fill: "#d6ba9e"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1z",
    fill: "#cad7ec"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1z",
    fill: "#d1bfa1"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57h-1v-1h1z",
    fill: "#bd8a3f"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57v-1h1v1z",
    fill: "#e0d2bd"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#c79c58"
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M46 56h1v1h-1z",
    fill: "#c08e38"
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1z",
    fill: "#e2cfb0"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56v1h-1v-1z",
    fill: "#c3953e"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57v-1h1v1z",
    fill: "#ca9d59"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v1h-1v-1z",
    fill: "#dfdcd5"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M52 57h-1v-1h1z",
    fill: "#c49b4e"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h-1v-1h1z",
    fill: "#c9a25d"
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1z",
    fill: "#d6ba86"
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h-1v-1h1z",
    fill: "#bd862d"
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1z",
    fill: "#d3cabf"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M56 57v-1h1v1z",
    fill: "#dad5ca"
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M58 56v1h-1v-1z",
    fill: "#bc892b"
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57v-1h1v1z",
    fill: "#d6b172"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h-1v-1h1z",
    fill: "#cca761"
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57h-1v-1h1z",
    fill: "#c28f3f"
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57v-1h1v1z",
    fill: "#dddad0"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57h-1v-1h1z",
    fill: "#c6a766"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M63 56h1v1h-1z",
    fill: "#bf943d"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56v1h-1v-1z",
    fill: "#ddc294"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56v1h-1v-1z",
    fill: "#b47f1b"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v-1h1v1z",
    fill: "#d5c2a6"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56h1v1h-1z",
    fill: "#dcd9d0"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h1v1h-1z",
    fill: "#b88123"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56h1v1h-1z",
    fill: "#cbac77"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57h-1v-1h1z",
    fill: "#c5cfdf"
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57v-1h1v1z",
    fill: "#b7c6e7"
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h1v1h-1z",
    fill: "#b7c7e3"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1z",
    fill: "#b8cbe6"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#bbccea"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56h1v1h-1z",
    fill: "#bbcce7",
    fillOpacity: 0.969
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#c0d1dd",
    fillOpacity: 0.176
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M19 57v1h-1v-1z",
    fill: "#b9bca5",
    fillOpacity: 0.573
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M20 58h-1v-1h1z",
    fill: "#c1c5a3"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M21 57h1v1h-1z",
    fill: "#dedbbc"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M22 57h1v1h-1z",
    fill: "#bdba9b"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57v1h-1v-1z",
    fill: "#bab798"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M26 58h-1v-1h1z",
    fill: "#c7c9ac"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M27 57v1h-1v-1z",
    fill: "#e3e5cd"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M28 58h-1v-1h1z",
    fill: "#d6e4e5"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h1v1h-1z",
    fill: "#9fc8e6"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M29 57h1v1h-1z",
    fill: "#87b2dc"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v-1h1v1z",
    fill: "#afc7e6"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h1v1z",
    fill: "#b5c6e6"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M33 57v1h-1v-1z",
    fill: "#b9c9ea"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v1h-1v-1z",
    fill: "#bbcbec"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58h-1v-1h1z",
    fill: "#bcceec"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58v-1h1v1z",
    fill: "#bdceeb"
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1z",
    fill: "#bbcfe9"
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58h-1v-1h1z",
    fill: "#d8d5db"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h-1v-1h1z",
    fill: "#caa069"
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1z",
    fill: "#c78f33"
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h1v1h-1z",
    fill: "#d7bf9f"
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1z",
    fill: "#d3ddeb"
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1z",
    fill: "#caad7a"
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58h-1v-1h1z",
    fill: "#c19553"
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v-1h1v1z",
    fill: "#e1d4c1"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1z",
    fill: "#b98d37"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58h-1v-1h1z",
    fill: "#cfae76"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v-1h1v1z",
    fill: "#e0d9cd"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1z",
    fill: "#b9872a"
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57h1v1h-1z",
    fill: "#cdaf7d"
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1z",
    fill: "#ddd9cd"
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h-1v-1h1z",
    fill: "#bb872e"
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58v-1h1v1z",
    fill: "#d4b478"
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h1v1h-1z",
    fill: "#caa358"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h-1v-1h1z",
    fill: "#c69345"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h1v1h-1z",
    fill: "#d5d6d6"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h-1v-1h1z",
    fill: "#d8c9af"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58h-1v-1h1z",
    fill: "#b6821e"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57h1v1h-1z",
    fill: "#dec492"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58v-1h1v1z",
    fill: "#bf953f"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h1v1h-1z",
    fill: "#cca164"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M62 58h-1v-1h1z",
    fill: "#dedad5"
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58h-1v-1h1z",
    fill: "#bd923f"
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-1h1v1z",
    fill: "#cca563"
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57v1h-1v-1z",
    fill: "#ddc19b"
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#b27d19"
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58h-1v-1h1z",
    fill: "#e2c6a4"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v-1h1v1z",
    fill: "#dac398"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58h-1v-1h1z",
    fill: "#b57d15"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58v-1h1v1z",
    fill: "#d1be9b"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58v-1h1v1z",
    fill: "#c3d0e7"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M72 58h-1v-1h1z",
    fill: "#bbc9e9"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57h1v1h-1z",
    fill: "#bccbe6"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57v1h-1v-1z",
    fill: "#bdcce7"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57v1h-1v-1z",
    fill: "#becfe9"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M75 58v-1h1v1z",
    fill: "#c0d1ea"
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v-1h1v1z",
    fill: "#c1d0e7",
    fillOpacity: 0.973
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1z",
    fill: "#cdd8e8",
    fillOpacity: 0.18
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M19 58v1h-1v-1z",
    fill: "#b2b5a0",
    fillOpacity: 0.573
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M20 58v1h-1v-1z",
    fill: "#d2d6b5"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M21 58v1h-1v-1z",
    fill: "#bebe9e"
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M22 58v1h-1v-1z",
    fill: "#bbb899"
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59h-1v-1h1z",
    fill: "#c4c1a2"
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M25 59h-1v-1h1z",
    fill: "#bebb9c"
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M25 58h1v1h-1z",
    fill: "#e2e4c5"
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58v1h-1v-1z",
    fill: "#eef0da"
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58h1v1h-1z",
    fill: "#d5e2e6"
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59h-1v-1h1z",
    fill: "#a1c9ea"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v1h-1v-1z",
    fill: "#8eb7e1"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58h1v1h-1z",
    fill: "#bacbe9"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M33 58v1h-1v-1z",
    fill: "#becdec"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59h-1v-1h1z",
    fill: "#c1d0ee"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59h-1v-1h1z",
    fill: "#c2d2ee"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h-1v-1h1z",
    fill: "#bfd2ea"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#c5d4ef"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58h1v1h-1z",
    fill: "#d8c4b8"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M38 59v-1h1v1z",
    fill: "#d1a164"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h1v1h-1z",
    fill: "#c88f3e"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h-1v-1h1z",
    fill: "#d8c2a9"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1z",
    fill: "#dcdfe5"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1z",
    fill: "#c39a58"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1z",
    fill: "#cca86f"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#ddcfb4"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1z",
    fill: "#b48627"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v1h-1v-1z",
    fill: "#d4c0a0"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59v-1h1v1z",
    fill: "#dccdb5"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58v1h-1v-1z",
    fill: "#b3821c"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58h1v1h-1z",
    fill: "#d5c39f"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1z",
    fill: "#d9ceb5"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59v-1h1v1z",
    fill: "#b47e1f"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h1v1h-1z",
    fill: "#dfc191"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58h1v1h-1z",
    fill: "#bf9039"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58v1h-1v-1z",
    fill: "#caa763"
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h1v1h-1z",
    fill: "#d7e0e3"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59h-1v-1h1z",
    fill: "#d2b588"
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h1v1h-1z",
    fill: "#ba8d30"
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59h-1v-1h1z",
    fill: "#e1caa3"
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59v-1h1v1z",
    fill: "#b58728"
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M61 58v1h-1v-1z",
    fill: "#d3b88b"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v-1h1v1z",
    fill: "#e3d5cb"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v1h-1v-1z",
    fill: "#b7841e"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58v1h-1v-1z",
    fill: "#d2b888"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M65 59h-1v-1h1z",
    fill: "#dccebb"
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1z",
    fill: "#b07b20"
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v1h-1v-1z",
    fill: "#c59440"
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59h-1v-1h1z",
    fill: "#c1944a"
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59v-1h1v1z",
    fill: "#bf9349"
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v-1h1v1z",
    fill: "#ceccbe"
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58h1v1h-1z",
    fill: "#c5d3eb"
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h-1v-1h1z",
    fill: "#c2d0eb"
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h-1v-1h1z",
    fill: "#c2d1e7"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M74 59h-1v-1h1z",
    fill: "#c2d1e6"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58h1v1h-1z",
    fill: "#c4d3e8"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v1h-1v-1z",
    fill: "#c7d3e9"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#c8d2e8",
    fillOpacity: 0.973
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#d3d9e9",
    fillOpacity: 0.184
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M19 60h-1v-1h1z",
    fill: "#a5a992",
    fillOpacity: 0.573
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M20 60h-1v-1h1z",
    fill: "#b4b897"
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M20 60v-1h1v1z",
    fill: "#dadbbb"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M21 59h1v1h-1z",
    fill: "#c7c4a5"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M22 59h1v1h-1z",
    fill: "#b3b091"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59v1h-1v-1z",
    fill: "#d6d3b4"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59h1v1h-1z",
    fill: "#bdbb9b"
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M25 60v-1h1v1z",
    fill: "#bdbfa0"
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M26 59h1v1h-1z",
    fill: "#e6e8d4"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M27 60v-1h1v1z",
    fill: "#d4e0e6"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59v1h-1v-1z",
    fill: "#a0c7e8"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v-1h1v1z",
    fill: "#94bae0"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59h1v1h-1z",
    fill: "#bccfe7"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60h-1v-1h1z",
    fill: "#c0d0e9"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M32 59h1v1h-1z",
    fill: "#c2d2eb"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59v1h-1v-1z",
    fill: "#c4d3eb"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59v1h-1v-1z",
    fill: "#c8d5ed"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59v1h-1v-1z",
    fill: "#c8d5eb"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h1v1h-1z",
    fill: "#d4dbe8"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60h-1v-1h1z",
    fill: "#cbae8a"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M39 60h-1v-1h1z",
    fill: "#deb57d"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59h1v1h-1z",
    fill: "#d9c8b0"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#e0dad5"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#be8b40"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60v-1h1v1z",
    fill: "#d5bb91"
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1z",
    fill: "#d8c095"
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#ba872e"
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#dacebf"
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#d6ba91"
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1z",
    fill: "#b88523"
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1z",
    fill: "#dbd1c2"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59h1v1h-1z",
    fill: "#ceb88c"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h-1v-1h1z",
    fill: "#b8832b"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#e2c89e"
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1z",
    fill: "#b98527"
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v-1h1v1z",
    fill: "#d0b383"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1z",
    fill: "#bf994e"
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59v1h-1v-1z",
    fill: "#c6a566"
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59h1v1h-1z",
    fill: "#dcc59b"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-1v-1h1z",
    fill: "#b48122"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v1h-1v-1z",
    fill: "#d7c9aa"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M62 60h-1v-1h1z",
    fill: "#d7c5a9"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60h-1v-1h1z",
    fill: "#b37f1a"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M64 59v1h-1v-1z",
    fill: "#d5c6a9"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1z",
    fill: "#d6dbe4"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60v-1h1v1z",
    fill: "#d0bca3"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60h-1v-1h1z",
    fill: "#c7aa7c"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h-1v-1h1z",
    fill: "#d8c6b0"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60v-1h1v1z",
    fill: "#d5cfc9"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60h-1v-1h1z",
    fill: "#ced6de"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v-1h1v1z",
    fill: "#c6d3e8"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59v1h-1v-1z",
    fill: "#c6d3ea"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h1v1h-1z",
    fill: "#c6d4e5"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h1v1h-1z",
    fill: "#c6d5e3"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60h-1v-1h1z",
    fill: "#c9d6e6"
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60v-1h1v1z",
    fill: "#ccd7e9"
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M77 59v1h-1v-1z",
    fill: "#ccd5e8",
    fillOpacity: 0.973
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1z",
    fill: "#d8dde8",
    fillOpacity: 0.18
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M19 60v1h-1v-1z",
    fill: "#b6baa3",
    fillOpacity: 0.569
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61h-1v-1h1z",
    fill: "#aeaf8e"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61v-1h1v1z",
    fill: "#cfcdad"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M23 61h-1v-1h1z",
    fill: "#d2cfb0"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M23 61v-1h1v1z",
    fill: "#b1af90"
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M24 60h1v1h-1z",
    fill: "#d8d8b8"
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M26 60v1h-1v-1z",
    fill: "#d5d8ba"
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M26 61v-1h1v1z",
    fill: "#d9dbc8"
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M28 61h-1v-1h1z",
    fill: "#d1dfe6"
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v1h-1v-1z",
    fill: "#9dc7e8"
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h-1v-1h1z",
    fill: "#98bfe2"
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61v-1h1v1z",
    fill: "#c2d3e9"
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61v-1h1v1z",
    fill: "#c6d4eb"
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61v-1h1v1z",
    fill: "#c8d6eb"
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61h-1v-1h1z",
    fill: "#cbd7ee"
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60v1h-1v-1z",
    fill: "#cdd9ef"
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60h1v1h-1z",
    fill: "#dcdbd6"
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1z",
    fill: "#c5a273"
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h-1v-1h1z",
    fill: "#e3c296"
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61h-1v-1h1z",
    fill: "#c18e42"
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61v-1h1v1z",
    fill: "#dccfb3"
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#ddcfb9"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M43 61h-1v-1h1z",
    fill: "#b88731"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60v1h-1v-1z",
    fill: "#decbb3"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60h1v1h-1z",
    fill: "#c9ab6f"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#c28f3e"
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#ded9d2"
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#cca46c"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#bf913e"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#e0dad1"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61v-1h1v1z",
    fill: "#c7a65e"
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61h-1v-1h1z",
    fill: "#c19545"
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M53 61h-1v-1h1z",
    fill: "#e0cba7"
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1z",
    fill: "#b8811d"
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60v1h-1v-1z",
    fill: "#d9bc95"
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1z",
    fill: "#ded0b5"
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h1v1h-1z",
    fill: "#b78935"
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#d7c8ab"
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "M58 60h1v1h-1z",
    fill: "#cab17f"
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60h1v1h-1z",
    fill: "#b88532"
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61h-1v-1h1z",
    fill: "#dcd4c5"
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "M61 60h1v1h-1z",
    fill: "#d0c9b9"
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61v-1h1v1z",
    fill: "#c6ab7c"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v1h-1v-1z",
    fill: "#dad2cf"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61v-1h1v1z",
    fill: "#d0d5e2"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "M66 61h-1v-1h1z",
    fill: "#d3d5e0"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60v1h-1v-1z",
    fill: "#d5dbe6"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h1v1h-1z",
    fill: "#cdd7ec"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v1h-1v-1z",
    fill: "#cbd4e7"
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61h-1v-1h1z",
    fill: "#c9d5e7"
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "M71 60h1v1h-1z",
    fill: "#cad4e8"
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60h1v1h-1z",
    fill: "#cad6e7"
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60v1h-1v-1z",
    fill: "#cad7e7"
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "M75 61h-1v-1h1z",
    fill: "#ccdaea"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v1h-1v-1z",
    fill: "#d0dded"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61v-1h1v1z",
    fill: "#cfdbea",
    fillOpacity: 0.973
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#d3dee9",
    fillOpacity: 0.184
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "M18 62v-1h1v1z",
    fill: "#a4a892",
    fillOpacity: 0.553
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "M20 61v1h-1v-1z",
    fill: "#c8ccab"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62v-1h1v1z",
    fill: "#d0d1b0"
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "M22 61v1h-1v-1z",
    fill: "#b4b494"
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h-1v-1h1z",
    fill: "#c7c6a7"
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62h-1v-1h1z",
    fill: "#b3b495"
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62v-1h1v1z",
    fill: "#e3e5c8"
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "M27 61v1h-1v-1z",
    fill: "#f4f6e3"
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "M27 61h1v1h-1z",
    fill: "#cbdae2"
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h-1v-1h1z",
    fill: "#9ec7e8"
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h-1v-1h1z",
    fill: "#9dc3e5"
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h1v1h-1z",
    fill: "#c8d7eb"
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62h-1v-1h1z",
    fill: "#cbd7ed"
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62v-1h1v1z",
    fill: "#cdd9ec"
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61h1v1h-1z",
    fill: "#cedaed"
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61v1h-1v-1z",
    fill: "#cedaef"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h-1v-1h1z",
    fill: "#d2dff1"
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "M36 61h1v1h-1z",
    fill: "#d5c3a9"
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62v-1h1v1z",
    fill: "#c7a97d"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61h1v1h-1z",
    fill: "#e1c8a8"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h1v1h-1z",
    fill: "#c38a42"
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "M41 61v1h-1v-1z",
    fill: "#ddd1bd"
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v1h-1v-1z",
    fill: "#d3bb94"
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "M42 62v-1h1v1z",
    fill: "#be8f3a"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#e2d3c3"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#bc9948"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61h1v1h-1z",
    fill: "#cb9e5b"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1z",
    fill: "#e1ddd7"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#c18f47"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62h-1v-1h1z",
    fill: "#cba364"
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1z",
    fill: "#e0d9d6"
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61h1v1h-1z",
    fill: "#c19241"
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#cba262"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#e0d1be"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61v1h-1v-1z",
    fill: "#ae801c"
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "M54 62v-1h1v1z",
    fill: "#cfa35b"
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1z",
    fill: "#be9e5c"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1z",
    fill: "#caa879"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1z",
    fill: "#cbc3a6"
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#cdb899"
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1z",
    fill: "#d5d6dc"
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1z",
    fill: "#d8dae2"
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1z",
    fill: "#d5dee6"
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "M63 61h1v1h-1z",
    fill: "#ced2d7"
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61h1v1h-1z",
    fill: "#bdb6ad"
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "M65 61h1v1h-1z",
    fill: "#c3bfbd"
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1z",
    fill: "#ced7e4"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62h-1v-1h1z",
    fill: "#ccd4e9"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "M73 61v1h-1v-1z",
    fill: "#ccd6e9"
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62h-1v-1h1z",
    fill: "#cdd8ea"
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "M76 62h-1v-1h1z",
    fill: "#d1dcec"
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61h1v1h-1z",
    fill: "#d1ddec",
    fillOpacity: 0.973
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v-1h1v1z",
    fill: "#d8e3ee",
    fillOpacity: 0.18
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "M19 62v1h-1v-1z",
    fill: "#adae9a",
    fillOpacity: 0.549
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "M20 63h-1v-1h1z",
    fill: "#b2b595"
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62h1v1h-1z",
    fill: "#c5c6a6"
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "M22 63h-1v-1h1z",
    fill: "#d3d4b4"
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62h1v1h-1z",
    fill: "#b9b798"
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62v1h-1v-1z",
    fill: "#c8c8a9"
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h1v1h-1z",
    fill: "#d1d3b5"
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "M26 62v1h-1v-1z",
    fill: "#dee0c5"
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v-1h1v1z",
    fill: "#f7f8e7"
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63h-1v-1h1z",
    fill: "#cad8e3"
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62v1h-1v-1z",
    fill: "#a1cae9"
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h1v1h-1z",
    fill: "#a7c8e8"
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h1v1h-1z",
    fill: "#ced7ea"
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v-1h1v1z",
    fill: "#dde0ea"
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h1v1h-1z",
    fill: "#cda67e"
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v-1h1v1z",
    fill: "#d7c2a9"
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h-1v-1h1z",
    fill: "#ddc6ab"
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h-1v-1h1z",
    fill: "#c38b41"
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62v1h-1v-1z",
    fill: "#e0d2c2"
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62h1v1h-1z",
    fill: "#cca86d"
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63v-1h1v1z",
    fill: "#c79b57"
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "M43 63v-1h1v1z",
    fill: "#e4d4c0"
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-1v-1h1z",
    fill: "#b8892c"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#d2b288"
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1z",
    fill: "#ded5cc"
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#b98029"
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62h1v1h-1z",
    fill: "#d4b688"
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#ded5c2"
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#b68327"
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "M51 62h1v1h-1z",
    fill: "#d3b68a"
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62v1h-1v-1z",
    fill: "#dddbe3"
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h1v1h-1z",
    fill: "#c9ac7a"
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "M55 62v1h-1v-1z",
    fill: "#b99046"
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "M56 63h-1v-1h1z",
    fill: "#c8b08a"
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h1v1h-1z",
    fill: "#d5d3d2"
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-1h1z",
    fill: "#d7dbe6"
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62h1v1h-1z",
    fill: "#d7dce7"
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62v1h-1v-1z",
    fill: "#d9dde2"
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1z",
    fill: "#c4c4c1"
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#cdc8c3"
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "M63 62v1h-1v-1z",
    fill: "#c3c2c2"
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "M63 63v-1h1v1z",
    fill: "#c6bcab"
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "M64 62h1v1h-1z",
    fill: "#bead9a"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h1v1h-1z",
    fill: "#bbb3ab"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h1v1h-1z",
    fill: "#d3dbe5"
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "M67 63v-1h1v1z",
    fill: "#ccd8e7"
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62v1h-1v-1z",
    fill: "#cdd6e8"
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62v1h-1v-1z",
    fill: "#ced6e9"
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1z",
    fill: "#d3dbec"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#d3deed",
    fillOpacity: 0.973
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#d9dfe9",
    fillOpacity: 0.188
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "M19 64h-1v-1h1z",
    fill: "#b1b5a0",
    fillOpacity: 0.541
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "M20 63v1h-1v-1z",
    fill: "#d0d3b4"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "M20 64v-1h1v1z",
    fill: "#c1c1a2"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "M22 64h-1v-1h1z",
    fill: "#bfc0a0"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64h-1v-1h1z",
    fill: "#d4d3b4"
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64v-1h1v1z",
    fill: "#b5b596"
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "M25 63v1h-1v-1z",
    fill: "#ced1b3"
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v1h-1v-1z",
    fill: "#ebeed3"
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "M27 63v1h-1v-1z",
    fill: "#f8f9e9"
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63v1h-1v-1z",
    fill: "#c6d4e0"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64v-1h1v1z",
    fill: "#a1c9e8"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "M30 63v1h-1v-1z",
    fill: "#accae7"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "M31 64h-1v-1h1z",
    fill: "#d3d9ea"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63v1h-1v-1z",
    fill: "#d3dced"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64v-1h1v1z",
    fill: "#d5deee"
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64h-1v-1h1z",
    fill: "#d5deed"
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v1h-1v-1z",
    fill: "#d5dfef"
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64v-1h1v1z",
    fill: "#dfd3cc"
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v1h-1v-1z",
    fill: "#cc9e6a"
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63h1v1h-1z",
    fill: "#e5d0ba"
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64v-1h1v1z",
    fill: "#d3b581"
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h1v1h-1z",
    fill: "#c28e3f"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h1v1h-1z",
    fill: "#e5d2bd"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "M41 63h1v1h-1z",
    fill: "#c2964c"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63h1v1h-1z",
    fill: "#d0ad7c"
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64h-1v-1h1z",
    fill: "#dbcbab"
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64v-1h1v1z",
    fill: "#b58226"
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#d7c3ac"
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#d7c6a7"
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1z",
    fill: "#b27c18"
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "M48 63h1v1h-1z",
    fill: "#d9c3aa"
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-1z",
    fill: "#d5ccbb"
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1z",
    fill: "#b99054"
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64v-1h1v1z",
    fill: "#d1c7b3"
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-1h1v1z",
    fill: "#d0dfeb"
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64h-1v-1h1z",
    fill: "#d8dae0"
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h-1v-1h1z",
    fill: "#d7dce1"
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h-1v-1h1z",
    fill: "#d3d9e4"
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "M57 63h1v1h-1z",
    fill: "#d2d4d7"
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63v1h-1v-1z",
    fill: "#c4c5c1"
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64v-1h1v1z",
    fill: "#cac2b9"
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "M61 64h-1v-1h1z",
    fill: "#c1b0a1"
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "M62 63v1h-1v-1z",
    fill: "#bdb09e"
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64v-1h1v1z",
    fill: "#c3b1a4"
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "M64 64h-1v-1h1z",
    fill: "#beb3a9"
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1z",
    fill: "#c6bdb8"
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64h-1v-1h1z",
    fill: "#c8c4c6"
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v-1h1v1z",
    fill: "#d0d9e8"
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "M70 64h-1v-1h1z",
    fill: "#cdd7e9"
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63h1v1h-1z",
    fill: "#ced6ea"
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "M71 64v-1h1v1z",
    fill: "#cdd5e9"
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "M73 64v-1h1v1z",
    fill: "#cfdaec"
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1z",
    fill: "#cfdbed"
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "M76 64h-1v-1h1z",
    fill: "#d3dcec"
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63h1v1h-1z",
    fill: "#d5dceb",
    fillOpacity: 0.976
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63v1h-1v-1z",
    fill: "#dadfea",
    fillOpacity: 0.192
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "M18 64h1v1h-1z",
    fill: "#adaf9c",
    fillOpacity: 0.529
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "M20 64v1h-1v-1z",
    fill: "#b6b797"
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "M20 65v-1h1v1z",
    fill: "#d7d6b6"
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "M22 65h-1v-1h1z",
    fill: "#c0c09e"
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "M23 65h-1v-1h1z",
    fill: "#bbbb9a"
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64h1v1h-1z",
    fill: "#d5d6b8"
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "M25 65h-1v-1h1z",
    fill: "#bec2a6"
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "M25 65v-1h1v1z",
    fill: "#c4c9af"
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "M26 65v-1h1v1z",
    fill: "#eff1e0"
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "M28 65h-1v-1h1z",
    fill: "#c5d4e0"
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64h1v1h-1z",
    fill: "#a0c6e9"
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65v-1h1v1z",
    fill: "#b2cbe6"
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "M30 64h1v1h-1z",
    fill: "#d5deeb"
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64h1v1h-1z",
    fill: "#d6dfec"
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64v1h-1v-1z",
    fill: "#d6e1e9"
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65v-1h1v1z",
    fill: "#dce3f1"
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "M36 64h1v1h-1z",
    fill: "#c78f50"
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v-1h1v1z",
    fill: "#c89c68"
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h-1z",
    fill: "#c08e40"
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "M41 65v-1h1v1z",
    fill: "#bb8830"
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64v1h-1v-1z",
    fill: "#d8c19a"
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64h1v1h-1z",
    fill: "#cfb988"
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v-1h1v1z",
    fill: "#b6832c"
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "M45 64h1v1h-1z",
    fill: "#dbd2c7"
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h1v1h-1z",
    fill: "#cebba3"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64v1h-1v-1z",
    fill: "#bb9b5f"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h1v1h-1z",
    fill: "#d7d2cc"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65h-1v-1h1z",
    fill: "#d7dbe1"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h-1v-1h1z",
    fill: "#d3d3d2"
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64h1v1h-1z",
    fill: "#d2dbe1"
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64v1h-1v-1z",
    fill: "#d2e0e6"
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64h1v1h-1z",
    fill: "#c7c4c6"
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v-1h1v1z",
    fill: "#cec8c4"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "M55 65v-1h1v1z",
    fill: "#c6bfb8"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65h-1v-1h1z",
    fill: "#c6bbb4"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64v1h-1v-1z",
    fill: "#c0b4ab"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64h1v1h-1z",
    fill: "#beb2a5"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64h1v1h-1z",
    fill: "#beb1a2"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1z",
    fill: "#c4bbb4"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65v-1h1v1z",
    fill: "#c6c5c6"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v1h-1v-1z",
    fill: "#d4daea"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v-1h1v1z",
    fill: "#d2d3d8"
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h-1v-1h1z",
    fill: "#d1cec9"
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64v1h-1v-1z",
    fill: "#cfc6b1"
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64h1v1h-1z",
    fill: "#cec0a7"
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65h-1v-1h1z",
    fill: "#cdc6bc"
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65h-1v-1h1z",
    fill: "#d1d4dc"
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65v-1h1v1z",
    fill: "#d8deed"
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "M77 65h-1v-1h1z",
    fill: "#d5deeb",
    fillOpacity: 0.976
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "M77 64h1v1h-1z",
    fill: "#d5dfe4",
    fillOpacity: 0.192
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66v-1h1v1z",
    fill: "#b4b6a2",
    fillOpacity: 0.522
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "M20 66h-1v-1h1z",
    fill: "#c1c3a2"
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "M21 65v1h-1v-1z",
    fill: "#b2b192"
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66h-1v-1h1z",
    fill: "#d6d5b5"
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "M24 66h-1v-1h1z",
    fill: "#b8ba9b"
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "M24 65h1v1h-1z",
    fill: "#e1e5c8"
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "M26 66h-1v-1h1z",
    fill: "#d5dac0"
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66h-1v-1h1z",
    fill: "#ebecde"
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "M27 65h1v1h-1z",
    fill: "#c5d4e2"
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "M28 66v-1h1v1z",
    fill: "#a0c8e9"
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65h1v1h-1z",
    fill: "#b2cee6"
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66h-1v-1h1z",
    fill: "#d7e1eb"
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "M32 65h1v1h-1z",
    fill: "#d8e1eb"
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h-1v-1h1z",
    fill: "#d6e2ee"
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65h1v1h-1z",
    fill: "#e2e2e1"
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66v-1h1v1z",
    fill: "#c4a570"
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v1h-1v-1z",
    fill: "#d5b188"
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65h1v1h-1z",
    fill: "#e0cdbe"
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "M38 66v-1h1v1z",
    fill: "#d3ab72"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v-1h1v1z",
    fill: "#c39143"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66v-1h1v1z",
    fill: "#dabd8d"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#b98530"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "M42 65h1v1h-1z",
    fill: "#dcd0b7"
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v1h-1v-1z",
    fill: "#c9b898"
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65h1v1h-1z",
    fill: "#c9a777"
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66h-1v-1h1z",
    fill: "#d2d9db"
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v-1h1v1z",
    fill: "#d5d7d8"
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65h1v1h-1z",
    fill: "#d2dee7"
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1z",
    fill: "#d2d9e1"
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66v-1h1v1z",
    fill: "#d0d8e2"
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "M53 66h-1v-1h1z",
    fill: "#bfb9b1"
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v1h-1v-1z",
    fill: "#c4b5a8"
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66h-1v-1h1z",
    fill: "#c1b3a5"
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "M56 66h-1v-1h1z",
    fill: "#c3b4a8"
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65v1h-1v-1z",
    fill: "#beb1a6"
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66h-1v-1h1z",
    fill: "#c6c0bd"
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "M59 65v1h-1v-1z",
    fill: "#ccc8d0"
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v1h-1v-1z",
    fill: "#ced0d5"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#d1d6e1"
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#d1dbec"
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1z",
    fill: "#d2d8eb"
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1z",
    fill: "#cfdaed"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1z",
    fill: "#d2cec3"
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "M70 65v1h-1v-1z",
    fill: "#d8b886"
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66h-1v-1h1z",
    fill: "#e2b670"
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h1v1h-1z",
    fill: "#e6b161"
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "M72 65h1v1h-1z",
    fill: "#e5ab51"
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65v1h-1v-1z",
    fill: "#dea655"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66h-1v-1h1z",
    fill: "#d5a974"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66v-1h1v1z",
    fill: "#cab4a0"
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h-1v-1h1z",
    fill: "#d1cdca",
    fillOpacity: 0.973
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#d9d9df",
    fillOpacity: 0.188
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66h1v1h-1z",
    fill: "#b0b29f",
    fillOpacity: 0.525
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "M20 66v1h-1v-1z",
    fill: "#d0d3b2"
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "M20 67v-1h1v1z",
    fill: "#cbccac"
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "M21 66h1v1h-1z",
    fill: "#bab99a"
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66h1v1h-1z",
    fill: "#d1d0b1"
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "M24 67h-1v-1h1z",
    fill: "#c4c6a7"
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "M24 66h1v1h-1z",
    fill: "#c6caab"
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "M26 66v1h-1v-1z",
    fill: "#e1e6cb"
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66v1h-1v-1z",
    fill: "#f9fbef"
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66h1v1h-1z",
    fill: "#c1cfe0"
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "M29 67h-1v-1h1z",
    fill: "#a0caea"
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "M29 66h1v1h-1z",
    fill: "#b1cfe5"
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "M31 66h1v1h-1z",
    fill: "#d8e1ec"
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "M32 67v-1h1v1z",
    fill: "#d9e1f0"
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66v1h-1v-1z",
    fill: "#dae3ee"
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h1v1h-1z",
    fill: "#decec0"
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66h1v1h-1z",
    fill: "#c69b67"
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "M37 66v1h-1v-1z",
    fill: "#ded8d0"
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "M37 67v-1h1v1z",
    fill: "#dce6ef"
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v1h-1v-1z",
    fill: "#c3a474"
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67h-1v-1h1z",
    fill: "#be9351"
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66h1v1h-1z",
    fill: "#d8be9e"
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66v1h-1v-1z",
    fill: "#caaa85"
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67v-1h1v1z",
    fill: "#d9d5d5"
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "M44 66v1h-1v-1z",
    fill: "#d6d8db"
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "M45 67h-1v-1h1z",
    fill: "#d5d9db"
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#d2d8dd"
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "M47 67v-1h1v1z",
    fill: "#ced1d5"
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67v-1h1v1z",
    fill: "#bfb6ae"
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66h1v1h-1z",
    fill: "#c9cac8"
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "M51 66h1v1h-1z",
    fill: "#c8c3c0"
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66h1v1h-1z",
    fill: "#c2b1a7"
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67v-1h1v1z",
    fill: "#c2b8b2"
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v1h-1v-1z",
    fill: "#c9c7c4"
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "M55 67v-1h1v1z",
    fill: "#cccfd5"
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "M57 67h-1v-1h1z",
    fill: "#ced3de"
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1z",
    fill: "#d3d8e6"
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67v-1h1v1z",
    fill: "#cfdbeb"
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1z",
    fill: "#d0dbea"
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1z",
    fill: "#d0d9eb"
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "M62 66h1v1h-1z",
    fill: "#cdd9e6"
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-1h1v1z",
    fill: "#d0daeb"
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1z",
    fill: "#d0d8e3"
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v-1h1v1z",
    fill: "#ddc397"
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "M69 66h1v1h-1z",
    fill: "#ecb25c"
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67h-1v-1h1z",
    fill: "#f0af4f"
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67v-1h1v1z",
    fill: "#f1b04c"
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v1h-1v-1z",
    fill: "#efaa43"
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#eda943"
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#e3a641"
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#d9a450"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#c89e66",
    fillOpacity: 0.984
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h1v1h-1z",
    fill: "#c9b093",
    fillOpacity: 0.204
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "M18 67h1v1h-1z",
    fill: "#adb19c",
    fillOpacity: 0.529
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "M19 68v-1h1v1z",
    fill: "#cacfad"
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "M21 67h1v1h-1z",
    fill: "#d3d2b2"
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "M22 67h1v1h-1z",
    fill: "#bbba9a"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "M24 67v1h-1v-1z",
    fill: "#d4d6b7"
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68h-1v-1h1z",
    fill: "#dadebf"
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "M26 67v1h-1v-1z",
    fill: "#c2c8ac"
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "M27 68h-1v-1h1z",
    fill: "#f3f5eb"
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "M29 67v1h-1v-1z",
    fill: "#9dc8e9"
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67v1h-1v-1z",
    fill: "#b0cee5"
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67h1v1h-1z",
    fill: "#d5e1eb"
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68h-1v-1h1z",
    fill: "#d8e0ed"
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "M33 67v1h-1v-1z",
    fill: "#d8e2ef"
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "M33 68v-1h1v1z",
    fill: "#dde5eb"
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "M34 67h1v1h-1z",
    fill: "#d0b08a"
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v-1h1v1z",
    fill: "#cfac85"
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "M36 67h1v1h-1z",
    fill: "#dbdee5"
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "M38 67v1h-1v-1z",
    fill: "#d3e1e9"
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v-1h1v1z",
    fill: "#cdc7b6"
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "M39 67h1v1h-1z",
    fill: "#d0c2af"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "M41 67h1v1h-1z",
    fill: "#d6d2d8"
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67v1h-1v-1z",
    fill: "#d8dbe4"
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67h1v1h-1z",
    fill: "#c2c0c0"
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1z",
    fill: "#cac5c2"
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1z",
    fill: "#c5c1bd"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1z",
    fill: "#c6b6af"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v1h-1v-1z",
    fill: "#bfafa1"
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67h1v1h-1z",
    fill: "#bdb1a5"
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h1v1h-1z",
    fill: "#c0b8b2"
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-1h1v1z",
    fill: "#cacad1"
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1z",
    fill: "#cacfd4"
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68h-1v-1h1z",
    fill: "#ccccd4"
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1z",
    fill: "#d2d7e8"
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-1h1v1z",
    fill: "#d1d7ec"
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67h1v1h-1z",
    fill: "#d1d9e9"
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67v1h-1v-1z",
    fill: "#d2dae9"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1z",
    fill: "#cdd8e8"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68v-1h1v1z",
    fill: "#d1daea"
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1z",
    fill: "#d1dbee"
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1z",
    fill: "#d2d2d0"
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67h1v1h-1z",
    fill: "#e2b87a"
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "M69 68v-1h1v1z",
    fill: "#ecac53"
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68h-1v-1h1z",
    fill: "#f1b15a"
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67v1h-1v-1z",
    fill: "#f0b154"
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1z",
    fill: "#ebab41"
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1z",
    fill: "#eaab43"
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1z",
    fill: "#efb14f"
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "M75 68v-1h1v1z",
    fill: "#e9a846"
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "M77 67v1h-1v-1z",
    fill: "#e0a454",
    fillOpacity: 0.992
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v1h-1v-1z",
    fill: "#d1ad7a",
    fillOpacity: 0.22
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "M19 68v1h-1v-1z",
    fill: "#afb39e",
    fillOpacity: 0.529
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "M20 68v1h-1v-1z",
    fill: "#d0d2ae"
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "M20 69v-1h1v1z",
    fill: "#b5b591"
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "M21 69v-1h1v1z",
    fill: "#bfbf9e"
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "M23 69h-1v-1h1z",
    fill: "#d5d5b5"
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "M24 69h-1v-1h1z",
    fill: "#b5b798"
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68v1h-1v-1z",
    fill: "#d4d8ba"
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "M26 69h-1v-1h1z",
    fill: "#ebefd5"
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69h-1v-1h1z",
    fill: "#f6f8ef"
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69v-1h1v1z",
    fill: "#bbcedc"
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "M28 69v-1h1v1z",
    fill: "#9ac7e6"
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "M30 68v1h-1v-1z",
    fill: "#b2cfe7"
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68v1h-1v-1z",
    fill: "#d8e0ee"
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69v-1h1v1z",
    fill: "#dae1ec"
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v-1h1v1z",
    fill: "#dddee4"
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v1h-1v-1z",
    fill: "#c3a88a"
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68h1v1h-1z",
    fill: "#d6c7b7"
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "M37 69h-1v-1h1z",
    fill: "#d9deeb"
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v1h-1v-1z",
    fill: "#d1dfe7"
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "M38 69v-1h1v1z",
    fill: "#d6dfe6"
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69v-1h1v1z",
    fill: "#dbdef0"
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#c2baae"
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1z",
    fill: "#c5bbb2"
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68v1h-1v-1z",
    fill: "#c3b3ab"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1z",
    fill: "#beb1a5"
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#c7c2b8"
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "M47 68v1h-1v-1z",
    fill: "#bdb7b1"
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h-1v-1h1z",
    fill: "#cac2bd"
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1z",
    fill: "#c9c6c6"
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v1h-1v-1z",
    fill: "#d1d3de"
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1z",
    fill: "#d2d8ea"
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68h1v1h-1z",
    fill: "#d1daec"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1z",
    fill: "#d0d8ec"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1z",
    fill: "#d2daec"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v1h-1v-1z",
    fill: "#d2d8ec"
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69v-1h1v1z",
    fill: "#e5af62"
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69v-1h1v1z",
    fill: "#e9a74d"
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68v1h-1v-1z",
    fill: "#eeae59"
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1z",
    fill: "#edad53"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1z",
    fill: "#f2af51"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1z",
    fill: "#f4b355"
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "M74 69v-1h1v1z",
    fill: "#f7b659"
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1z",
    fill: "#f1b153"
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1z",
    fill: "#e7ad5e",
    fillOpacity: 0.992
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v1h-1v-1z",
    fill: "#dbb786",
    fillOpacity: 0.224
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "M19 69v1h-1v-1z",
    fill: "#939791",
    fillOpacity: 0.522
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "M20 70h-1v-1h1z",
    fill: "#c8cdb7"
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "M20 69h1v1h-1z",
    fill: "#d7d7b4"
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "M21 69h1v1h-1z",
    fill: "#bdbc9c"
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "M22 69h1v1h-1z",
    fill: "#c2c3a4"
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "M24 69v1h-1v-1z",
    fill: "#d3d6b8"
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70v-1h1v1z",
    fill: "#bfc4a7"
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70v-1h1v1z",
    fill: "#e4e6d0"
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70v-1h1v1z",
    fill: "#fbfdf5"
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "M27 70v-1h1v1z",
    fill: "#b7cdda"
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70h-1v-1h1z",
    fill: "#99c6e5"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70v-1h1v1z",
    fill: "#b3cee6"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69h1v1h-1z",
    fill: "#d6e0ec"
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "M31 70v-1h1v1z",
    fill: "#d6e1ef"
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v1h-1v-1z",
    fill: "#d9e1ed"
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69v1h-1v-1z",
    fill: "#dcdfe9"
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70h-1v-1h1z",
    fill: "#d7d6da"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "M36 69v1h-1v-1z",
    fill: "#d5dee7"
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70v-1h1v1z",
    fill: "#d1ddea"
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70v-1h1v1z",
    fill: "#d0dde7"
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "M39 70h-1v-1h1z",
    fill: "#d0ddeb"
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69h1v1h-1z",
    fill: "#d2d4e2"
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69v1h-1v-1z",
    fill: "#c3b7b0"
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#bcac98"
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69v1h-1v-1z",
    fill: "#c2b4ac"
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69h1v1h-1z",
    fill: "#c3bbb7"
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1z",
    fill: "#c4c5c3"
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1z",
    fill: "#c9d1d4"
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70v-1h1v1z",
    fill: "#cfd6e1"
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v1h-1v-1z",
    fill: "#d3d9e7"
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v1h-1z",
    fill: "#ccdae8"
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "M53 69v1h-1v-1z",
    fill: "#d0dae9"
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v-1h1v1z",
    fill: "#d2d9e9"
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h1v1h-1z",
    fill: "#d1d8e8"
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "M55 70v-1h1v1z",
    fill: "#d0d9e9"
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70h-1v-1h1z",
    fill: "#d0daea"
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1z",
    fill: "#cfd9eb"
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#ced9ec"
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h1v1h-1z",
    fill: "#cfdaee"
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v1h-1v-1z",
    fill: "#cedaeb"
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "M67 69v1h-1v-1z",
    fill: "#cfdbe9"
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "M67 70v-1h1v1z",
    fill: "#dac7aa"
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-1v-1h1z",
    fill: "#ebac57"
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69h1v1h-1z",
    fill: "#f0ad52"
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h-1v-1h1z",
    fill: "#e5a750"
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69v1h-1v-1z",
    fill: "#f0b255"
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1z",
    fill: "#eaa849"
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1z",
    fill: "#eba94a"
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70h-1v-1h1z",
    fill: "#f6b457"
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1z",
    fill: "#f8bb60"
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v-1h1v1z",
    fill: "#edb96c",
    fillOpacity: 0.992
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h1v1h-1z",
    fill: "#dfc08f",
    fillOpacity: 0.224
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "M18 70h1v1h-1z",
    fill: "#606879",
    fillOpacity: 0.478
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "M19 70h1v1h-1z",
    fill: "#7b8e93"
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "M20 71v-1h1v1z",
    fill: "#cfd5bf"
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71v-1h1v1z",
    fill: "#dcdabb"
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "M24 71h-1v-1h1z",
    fill: "#cfd4b6"
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70h1v1h-1z",
    fill: "#e4e9ce"
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70h1v1h-1z",
    fill: "#eaeed9"
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70h1v1h-1z",
    fill: "#f9fdf5"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "M28 70v1h-1v-1z",
    fill: "#b6ccda"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v-1h1v1z",
    fill: "#9ac5e6"
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h-1v-1h1z",
    fill: "#b5cfe7"
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71v-1h1v1z",
    fill: "#d7e1f0"
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h-1v-1h1z",
    fill: "#d8e2f3"
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "M33 70v1h-1v-1z",
    fill: "#dae1f0"
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71v-1h1v1z",
    fill: "#d7dfeb"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70v1h-1v-1z",
    fill: "#d4dfee"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71v-1h1v1z",
    fill: "#d2ddea"
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70h1v1h-1z",
    fill: "#d0dbe7"
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71v-1h1v1z",
    fill: "#cfdce8"
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70v1h-1v-1z",
    fill: "#cbcfdb"
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "M41 71h-1v-1h1z",
    fill: "#bdb5ba"
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71h-1v-1h1z",
    fill: "#c9cdca"
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "M42 70h1v1h-1z",
    fill: "#cdd5de"
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70h1v1h-1z",
    fill: "#d0d7e7"
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1z",
    fill: "#cddaea"
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h1v1z",
    fill: "#cedaea"
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h-1v-1h1z",
    fill: "#cfd7ea"
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70v1h-1v-1z",
    fill: "#cfd8ea"
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71v-1h1v1z",
    fill: "#d0d8e9"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71v-1h1v1z",
    fill: "#d1d8ea"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "M56 71h-1v-1h1z",
    fill: "#ced8e9"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70v1h-1v-1z",
    fill: "#cdd9ea"
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h-1v-1h1z",
    fill: "#cdd8eb"
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70h1v1h-1z",
    fill: "#cbd8eb"
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70h1v1h-1z",
    fill: "#cdd7ea"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v-1h1v1z",
    fill: "#d0d3df"
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1h-1v-1z",
    fill: "#d0cfd0"
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1z",
    fill: "#cccbc9"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70v1h-1v-1z",
    fill: "#cbccd0"
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1z",
    fill: "#cccfd7"
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71v-1h1v1z",
    fill: "#dac39f"
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-1v-1z",
    fill: "#edb158"
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "M69 71v-1h1v1z",
    fill: "#e9a94d"
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1z",
    fill: "#ecb15a"
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h1v1h-1z",
    fill: "#e9b055"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1z",
    fill: "#f0b054"
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70v1h-1v-1z",
    fill: "#eca748"
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70h1v1h-1z",
    fill: "#eda645"
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v1h-1v-1z",
    fill: "#eead53"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70h1v1h-1z",
    fill: "#f3c076",
    fillOpacity: 0.988
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "M78 70v1h-1v-1z",
    fill: "#eccca3",
    fillOpacity: 0.22
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "M18 72v-1h1v1z",
    fill: "#636e77",
    fillOpacity: 0.471
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "M19 71h1v1h-1z",
    fill: "#446579"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "M20 71h1v1h-1z",
    fill: "#8ca2a0"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71h1v1h-1z",
    fill: "#dbdabe"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h-1v-1h1z",
    fill: "#d5d8b9"
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v-1h1v1z",
    fill: "#d6dbbd"
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "M25 72h-1v-1h1z",
    fill: "#e8eccf"
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "M26 72h-1v-1h1z",
    fill: "#f0f5dd"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "M27 71v1h-1v-1z",
    fill: "#f7fcf3"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v1h-1v-1z",
    fill: "#b6ccdd"
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71h1v1h-1z",
    fill: "#9ec4de"
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h-1v-1h1z",
    fill: "#bbc2c1"
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h1v1h-1z",
    fill: "#d9cfc6"
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71v1h-1v-1z",
    fill: "#dbcecb"
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h1v1h-1z",
    fill: "#d8d3d4"
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71h1v1h-1z",
    fill: "#dadbe7"
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "M35 72h-1v-1h1z",
    fill: "#d4deed"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71h1v1h-1z",
    fill: "#d1dcea"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v-1h1v1z",
    fill: "#cfd9e8"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71v1h-1v-1z",
    fill: "#cfd9e9"
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71h1v1h-1z",
    fill: "#d3dae9"
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h-1v-1h1z",
    fill: "#d4dced"
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71v1h-1v-1z",
    fill: "#cedeec"
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71v1h-1v-1z",
    fill: "#cdd8e5"
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1z",
    fill: "#cbd7e0"
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h1v1h-1z",
    fill: "#cdd7e5"
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71v1h-1v-1z",
    fill: "#cdd9ed"
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1z",
    fill: "#ced8ec"
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "M52 71v1h-1v-1z",
    fill: "#d1d7eb"
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v-1h1v1z",
    fill: "#d0d8e8"
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h-1v-1h1z",
    fill: "#cfd6e7"
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "M57 72h-1v-1h1z",
    fill: "#cbd8ed"
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1z",
    fill: "#ccd9e9"
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h1v1h-1z",
    fill: "#ced2d5"
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v1h-1v-1z",
    fill: "#d9c5ad"
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72v-1h1v1z",
    fill: "#d6ac7c"
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#b78a50"
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1z",
    fill: "#a97746"
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71h1v1h-1z",
    fill: "#946747"
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#927362"
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#d2cdce"
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v1z",
    fill: "#d1cdcb"
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1z",
    fill: "#dcbd88"
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72h-1v-1h1z",
    fill: "#f3be6e"
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72h-1v-1h1z",
    fill: "#edaf5c"
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72h-1v-1h1z",
    fill: "#efb45e"
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72v-1h1v1z",
    fill: "#ebb35e"
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1z",
    fill: "#f2bb6e"
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72h-1v-1h1z",
    fill: "#f6be72"
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "M74 71h1v1h-1z",
    fill: "#f0b75e"
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "M75 71h1v1h-1z",
    fill: "#e1a64e"
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "M76 71h1v1h-1z",
    fill: "#e8b770",
    fillOpacity: 0.992
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "M77 71h1v1h-1z",
    fill: "#e8cda5",
    fillOpacity: 0.224
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "M19 72v1h-1v-1z",
    fill: "#55727a",
    fillOpacity: 0.49
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "M20 73h-1v-1h1z",
    fill: "#3a6b8b"
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "M21 73h-1v-1h1z",
    fill: "#809ba3"
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h-1v-1h1z",
    fill: "#bdbfa1"
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v1h-1v-1z",
    fill: "#d4d7b8"
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h1v1h-1z",
    fill: "#dfe4c6"
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "M24 73v-1h1v1z",
    fill: "#e8ecd2"
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v-1h1v1z",
    fill: "#f4f5e4"
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73v-1h1v1z",
    fill: "#f7fdf6"
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "M27 72h1v1h-1z",
    fill: "#b0cbda"
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "M29 72v1h-1v-1z",
    fill: "#abc4cf"
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73h-1v-1h1z",
    fill: "#d5b080"
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h1v1h-1z",
    fill: "#eeb470"
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73h-1v-1h1z",
    fill: "#e8b16e"
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73h-1v-1h1z",
    fill: "#d8aa6e"
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "M34 72v1h-1v-1z",
    fill: "#cfae8d"
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73h-1v-1h1z",
    fill: "#d9ceca"
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72v1h-1v-1z",
    fill: "#d3dbe8"
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72h1v1h-1z",
    fill: "#cfdbea"
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72h1v1h-1z",
    fill: "#d0dbef"
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v-1h1v1z",
    fill: "#d0daec"
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "M39 72h1v1h-1z",
    fill: "#cfd8e3"
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73v-1h1v1z",
    fill: "#d1d8d0"
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h1v1h-1z",
    fill: "#d2dbb2"
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73h-1v-1h1z",
    fill: "#d8db93"
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73v-1h1v1z",
    fill: "#dbdd73"
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72h1v1h-1z",
    fill: "#dde15b"
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73v-1h1v1z",
    fill: "#dee05e"
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-1v-1z",
    fill: "#dadd77"
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v-1h1v1z",
    fill: "#d0d7bc"
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72v1h-1v-1z",
    fill: "#cedae6"
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73h-1v-1h1z",
    fill: "#ccd9ea"
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1z",
    fill: "#cbd7eb"
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1z",
    fill: "#ced8ed"
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72v1h-1v-1z",
    fill: "#cdd8e9"
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72h1v1h-1z",
    fill: "#cbd7e8"
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h1v1h-1z",
    fill: "#ccd2db"
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v-1h1v1z",
    fill: "#d5c4a7"
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73h-1v-1h1z",
    fill: "#daad68"
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "M59 72h1v1h-1z",
    fill: "#cd903d"
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1z",
    fill: "#ad6b23"
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1z",
    fill: "#a4651f"
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#a96930"
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "M64 72v1h-1v-1z",
    fill: "#854e28"
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1z",
    fill: "#8b603b"
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1z",
    fill: "#c8a578"
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1z",
    fill: "#ba965d"
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1z",
    fill: "#e0b267"
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72v1h-1v-1z",
    fill: "#f4bf71"
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#f5bc69"
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "M71 73h-1v-1h1z",
    fill: "#eab358"
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#eab35c"
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#f0bd75"
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#f2be82"
  })), _path4005 || (_path4005 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73v-1h1v1z",
    fill: "#f4bd75"
  })), _path4006 || (_path4006 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v1h-1v-1z",
    fill: "#f7be6d"
  })), _path4007 || (_path4007 = /*#__PURE__*/React.createElement("path", {
    d: "M77 72v1h-1v-1z",
    fill: "#eabb75",
    fillOpacity: 0.992
  })), _path4008 || (_path4008 = /*#__PURE__*/React.createElement("path", {
    d: "M77 73v-1h1v1z",
    fill: "#e0c199",
    fillOpacity: 0.227
  })), _path4009 || (_path4009 = /*#__PURE__*/React.createElement("path", {
    d: "M19 74h-1v-1h1z",
    fill: "#4e7673",
    fillOpacity: 0.522
  })), _path4010 || (_path4010 = /*#__PURE__*/React.createElement("path", {
    d: "M19 73h1v1h-1z",
    fill: "#2e6b87"
  })), _path4011 || (_path4011 = /*#__PURE__*/React.createElement("path", {
    d: "M20 74v-1h1v1z",
    fill: "#859fab"
  })), _path4012 || (_path4012 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73v1h-1v-1z",
    fill: "#c1c2a5"
  })), _path4013 || (_path4013 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h1v1h-1z",
    fill: "#bfc2a3"
  })), _path4014 || (_path4014 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74h-1v-1h1z",
    fill: "#dfe4c4"
  })), _path4015 || (_path4015 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v1h-1v-1z",
    fill: "#e8ebd3"
  })), _path4016 || (_path4016 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74h-1v-1h1z",
    fill: "#f4f6e8"
  })), _path4017 || (_path4017 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73h1v1h-1z",
    fill: "#f6fdf7"
  })), _path4018 || (_path4018 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h-1v-1h1z",
    fill: "#acc8d9"
  })), _path4019 || (_path4019 = /*#__PURE__*/React.createElement("path", {
    d: "M28 73h1v1h-1z",
    fill: "#aac4ce"
  })), _path4020 || (_path4020 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73v1h-1v-1z",
    fill: "#dfb174"
  })), _path4021 || (_path4021 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74v-1h1v1z",
    fill: "#f6b364"
  })), _path4022 || (_path4022 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h-1v-1h1z",
    fill: "#f0ad5b"
  })), _path4023 || (_path4023 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73v1h-1v-1z",
    fill: "#eba553"
  })), _path4024 || (_path4024 = /*#__PURE__*/React.createElement("path", {
    d: "M33 74v-1h1v1z",
    fill: "#e9a850"
  })), _path4025 || (_path4025 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73v1h-1v-1z",
    fill: "#d6a468"
  })), _path4026 || (_path4026 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74v-1h1v1z",
    fill: "#d1c4c1"
  })), _path4027 || (_path4027 = /*#__PURE__*/React.createElement("path", {
    d: "M36 73h1v1h-1z",
    fill: "#d6d9e6"
  })), _path4028 || (_path4028 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v1h-1v-1z",
    fill: "#d5d8c5"
  })), _path4029 || (_path4029 = /*#__PURE__*/React.createElement("path", {
    d: "M39 73v1h-1v-1z",
    fill: "#d9db93"
  })), _path4030 || (_path4030 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74v-1h1v1z",
    fill: "#dde067"
  })), _path4031 || (_path4031 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73h1v1h-1z",
    fill: "#e9e937"
  })), _path4032 || (_path4032 = /*#__PURE__*/React.createElement("path", {
    d: "M42 73v1h-1v-1z",
    fill: "#f4ef1e"
  })), _path4033 || (_path4033 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h-1v-1h1z",
    fill: "#fcef0b"
  })), _path4034 || (_path4034 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74h-1v-1h1z",
    fill: "#fef108"
  })), _path4035 || (_path4035 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74v-1h1v1z",
    fill: "#fff402"
  })), _path4036 || (_path4036 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1z",
    fill: "#fff404"
  })), _path4037 || (_path4037 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v1h-1v-1z",
    fill: "#f8f00a"
  })), _path4038 || (_path4038 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1z",
    fill: "#e6e03c"
  })), _path4039 || (_path4039 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73v1h-1v-1z",
    fill: "#cdd3c4"
  })), _path4040 || (_path4040 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h1v1z",
    fill: "#cfd9f1"
  })), _path4041 || (_path4041 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1z",
    fill: "#ccd9ee"
  })), _path4042 || (_path4042 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1z",
    fill: "#cdd3df"
  })), _path4043 || (_path4043 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h-1v-1h1z",
    fill: "#d2cac3"
  })), _path4044 || (_path4044 = /*#__PURE__*/React.createElement("path", {
    d: "M54 73v1h-1v-1z",
    fill: "#c6b49b"
  })), _path4045 || (_path4045 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74h-1v-1h1z",
    fill: "#c1ac98"
  })), _path4046 || (_path4046 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74h-1v-1h1z",
    fill: "#d0c5ab"
  })), _path4047 || (_path4047 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v1h-1v-1z",
    fill: "#d9bd79"
  })), _path4048 || (_path4048 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1z",
    fill: "#e1a442"
  })), _path4049 || (_path4049 = /*#__PURE__*/React.createElement("path", {
    d: "M59 74h-1v-1h1z",
    fill: "#bf7927"
  })), _path4050 || (_path4050 = /*#__PURE__*/React.createElement("path", {
    d: "M60 74h-1v-1h1z",
    fill: "#a06226"
  })), _path4051 || (_path4051 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74h-1v-1h1z",
    fill: "#9b5d23"
  })), _path4052 || (_path4052 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1z",
    fill: "#a26630"
  })), _path4053 || (_path4053 = /*#__PURE__*/React.createElement("path", {
    d: "M63 74h-1v-1h1z",
    fill: "#8a542d"
  })), _path4054 || (_path4054 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v1h-1v-1z",
    fill: "#633c25"
  })), _path4055 || (_path4055 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#674427"
  })), _path4056 || (_path4056 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#af884b"
  })), _path4057 || (_path4057 = /*#__PURE__*/React.createElement("path", {
    d: "M67 74h-1v-1h1z",
    fill: "#efbc6b"
  })), _path4058 || (_path4058 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-1v-1h1z",
    fill: "#f9bc6c"
  })), _path4059 || (_path4059 = /*#__PURE__*/React.createElement("path", {
    d: "M68 73h1v1h-1z",
    fill: "#f2b865"
  })), _path4060 || (_path4060 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1z",
    fill: "#f5bb61"
  })), _path4061 || (_path4061 = /*#__PURE__*/React.createElement("path", {
    d: "M70 73h1v1h-1z",
    fill: "#f4b65a"
  })), _path4062 || (_path4062 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1z",
    fill: "#f4b35d"
  })), _path4063 || (_path4063 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#f8bd73"
  })), _path4064 || (_path4064 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74v-1h1v1z",
    fill: "#f1b671"
  })), _path4065 || (_path4065 = /*#__PURE__*/React.createElement("path", {
    d: "M75 74h-1v-1h1z",
    fill: "#e8aa5c"
  })), _path4066 || (_path4066 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h1v1h-1z",
    fill: "#f6b66c"
  })), _path4067 || (_path4067 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1z",
    fill: "#eab87f",
    fillOpacity: 0.988
  })), _path4068 || (_path4068 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#dec2a2",
    fillOpacity: 0.216
  })), _path4069 || (_path4069 = /*#__PURE__*/React.createElement("path", {
    d: "M18 74h1v1h-1z",
    fill: "#618f76",
    fillOpacity: 0.522
  })), _path4070 || (_path4070 = /*#__PURE__*/React.createElement("path", {
    d: "M19 75v-1h1v1z",
    fill: "#206367"
  })), _path4071 || (_path4071 = /*#__PURE__*/React.createElement("path", {
    d: "M21 75h-1v-1h1z",
    fill: "#739197"
  })), _path4072 || (_path4072 = /*#__PURE__*/React.createElement("path", {
    d: "M21 75v-1h1v1z",
    fill: "#bdc0a2"
  })), _path4073 || (_path4073 = /*#__PURE__*/React.createElement("path", {
    d: "M23 75h-1v-1h1z",
    fill: "#c0c3a4"
  })), _path4074 || (_path4074 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74v1h-1v-1z",
    fill: "#cdd2b2"
  })), _path4075 || (_path4075 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74h1v1h-1z",
    fill: "#ebeed5"
  })), _path4076 || (_path4076 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74v1h-1v-1z",
    fill: "#f4f8e9"
  })), _path4077 || (_path4077 = /*#__PURE__*/React.createElement("path", {
    d: "M27 75h-1v-1h1z",
    fill: "#f5fbf6"
  })), _path4078 || (_path4078 = /*#__PURE__*/React.createElement("path", {
    d: "M27 74h1v1h-1z",
    fill: "#aac6da"
  })), _path4079 || (_path4079 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h1v1h-1z",
    fill: "#a9c0c7"
  })), _path4080 || (_path4080 = /*#__PURE__*/React.createElement("path", {
    d: "M29 75v-1h1v1z",
    fill: "#daad6a"
  })), _path4081 || (_path4081 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74h1v1h-1z",
    fill: "#f1b060"
  })), _path4082 || (_path4082 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74v1h-1v-1z",
    fill: "#f0ad5e"
  })), _path4083 || (_path4083 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h1v1h-1z",
    fill: "#e3a258"
  })), _path4084 || (_path4084 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74v1h-1v-1z",
    fill: "#dc963e"
  })), _path4085 || (_path4085 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74h1v1h-1z",
    fill: "#ca8b22"
  })), _path4086 || (_path4086 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74h1v1h-1z",
    fill: "#cfb254"
  })), _path4087 || (_path4087 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75v-1h1v1z",
    fill: "#ece15f"
  })), _path4088 || (_path4088 = /*#__PURE__*/React.createElement("path", {
    d: "M38 75h-1v-1h1z",
    fill: "#f3e929"
  })), _path4089 || (_path4089 = /*#__PURE__*/React.createElement("path", {
    d: "M39 75h-1v-1h1z",
    fill: "#faf20e"
  })), _path4090 || (_path4090 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74h1v1h-1z",
    fill: "#fef304"
  })), _path4091 || (_path4091 = /*#__PURE__*/React.createElement("path", {
    d: "M41 74v1h-1v-1z",
    fill: "#f6ed0b"
  })), _path4092 || (_path4092 = /*#__PURE__*/React.createElement("path", {
    d: "M42 74v1h-1v-1z",
    fill: "#eee811"
  })), _path4093 || (_path4093 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74v1h-1v-1z",
    fill: "#f7f10f"
  })), _path4094 || (_path4094 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#ece916"
  })), _path4095 || (_path4095 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75h-1v-1h1z",
    fill: "#e5e419"
  })), _path4096 || (_path4096 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1z",
    fill: "#cbcb20"
  })), _path4097 || (_path4097 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v1h-1z",
    fill: "#b5b917"
  })), _path4098 || (_path4098 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74v1h-1v-1z",
    fill: "#e1e41b"
  })), _path4099 || (_path4099 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h1v1h-1z",
    fill: "#cfd390"
  })), _path4100 || (_path4100 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74h1v1h-1z",
    fill: "#ced9ed"
  })), _path4101 || (_path4101 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v-1h1v1z",
    fill: "#d1d0c9"
  })), _path4102 || (_path4102 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h-1v-1h1z",
    fill: "#d9b78a"
  })), _path4103 || (_path4103 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75v-1h1v1z",
    fill: "#e0a455"
  })), _path4104 || (_path4104 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1z",
    fill: "#d58d37"
  })), _path4105 || (_path4105 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1z",
    fill: "#e6a84c"
  })), _path4106 || (_path4106 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74v1h-1v-1z",
    fill: "#f2b452"
  })), _path4107 || (_path4107 = /*#__PURE__*/React.createElement("path", {
    d: "M57 75h-1v-1h1z",
    fill: "#dc9836"
  })), _path4108 || (_path4108 = /*#__PURE__*/React.createElement("path", {
    d: "M57 74h1v1h-1z",
    fill: "#b06d1e"
  })), _path4109 || (_path4109 = /*#__PURE__*/React.createElement("path", {
    d: "M58 75v-1h1v1z",
    fill: "#8d5120"
  })), _path4110 || (_path4110 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h-1v-1h1z",
    fill: "#864e2d"
  })), _path4111 || (_path4111 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75v-1h1v1z",
    fill: "#854f2f"
  })), _path4112 || (_path4112 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#724728"
  })), _path4113 || (_path4113 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h1z",
    fill: "#593520"
  })), _path4114 || (_path4114 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75v-1h1v1z",
    fill: "#573824"
  })), _path4115 || (_path4115 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1z",
    fill: "#734e2c"
  })), _path4116 || (_path4116 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1z",
    fill: "#e3b87e"
  })), _path4117 || (_path4117 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75h-1v-1h1z",
    fill: "#f3ba6a"
  })), _path4118 || (_path4118 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1z",
    fill: "#f6b55f"
  })), _path4119 || (_path4119 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-1v-1h1z",
    fill: "#f0b150"
  })), _path4120 || (_path4120 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74v1h-1v-1z",
    fill: "#eba841"
  })), _path4121 || (_path4121 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v1h-1v-1z",
    fill: "#e69e3e"
  })), _path4122 || (_path4122 = /*#__PURE__*/React.createElement("path", {
    d: "M72 74v1h-1v-1z",
    fill: "#e1953f"
  })), _path4123 || (_path4123 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75h-1v-1h1z",
    fill: "#dd9248"
  })), _path4124 || (_path4124 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75v-1h1v1z",
    fill: "#df9754"
  })), _path4125 || (_path4125 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v-1h1v1z",
    fill: "#de9d58"
  })), _path4126 || (_path4126 = /*#__PURE__*/React.createElement("path", {
    d: "M75 75v-1h1v1z",
    fill: "#dda773"
  })), _path4127 || (_path4127 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v1h-1v-1z",
    fill: "#dbbb9c",
    fillOpacity: 0.976
  })), _path4128 || (_path4128 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h1v1h-1z",
    fill: "#d9cfbf",
    fillOpacity: 0.188
  })), _path4129 || (_path4129 = /*#__PURE__*/React.createElement("path", {
    d: "M18 76v-1h1v1z",
    fill: "#88a582",
    fillOpacity: 0.514
  })), _path4130 || (_path4130 = /*#__PURE__*/React.createElement("path", {
    d: "M19 75h1v1h-1z",
    fill: "#508a63"
  })), _path4131 || (_path4131 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76v-1h1v1z",
    fill: "#779781"
  })), _path4132 || (_path4132 = /*#__PURE__*/React.createElement("path", {
    d: "M22 76h-1v-1h1z",
    fill: "#c2c5a7"
  })), _path4133 || (_path4133 = /*#__PURE__*/React.createElement("path", {
    d: "M23 76v-1h1v1z",
    fill: "#d4d9bb"
  })), _path4134 || (_path4134 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h-1v-1h1z",
    fill: "#eaedd2"
  })), _path4135 || (_path4135 = /*#__PURE__*/React.createElement("path", {
    d: "M25 75h1v1h-1z",
    fill: "#f4f8e2"
  })), _path4136 || (_path4136 = /*#__PURE__*/React.createElement("path", {
    d: "M26 75h1v1h-1z",
    fill: "#f4f9ef"
  })), _path4137 || (_path4137 = /*#__PURE__*/React.createElement("path", {
    d: "M28 75v1h-1v-1z",
    fill: "#a7c8dc"
  })), _path4138 || (_path4138 = /*#__PURE__*/React.createElement("path", {
    d: "M28 76v-1h1v1z",
    fill: "#a7c0c2"
  })), _path4139 || (_path4139 = /*#__PURE__*/React.createElement("path", {
    d: "M30 75v1h-1v-1z",
    fill: "#d2a461"
  })), _path4140 || (_path4140 = /*#__PURE__*/React.createElement("path", {
    d: "M31 76h-1v-1h1z",
    fill: "#e49f53"
  })), _path4141 || (_path4141 = /*#__PURE__*/React.createElement("path", {
    d: "M31 75h1v1h-1z",
    fill: "#d99a4c"
  })), _path4142 || (_path4142 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h-1v-1h1z",
    fill: "#cc962a"
  })), _path4143 || (_path4143 = /*#__PURE__*/React.createElement("path", {
    d: "M34 76h-1v-1h1z",
    fill: "#d8ab15"
  })), _path4144 || (_path4144 = /*#__PURE__*/React.createElement("path", {
    d: "M35 75v1h-1v-1z",
    fill: "#eed312"
  })), _path4145 || (_path4145 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v-1h1v1z",
    fill: "#fced0b"
  })), _path4146 || (_path4146 = /*#__PURE__*/React.createElement("path", {
    d: "M36 76v-1h1v1z",
    fill: "#fdf408"
  })), _path4147 || (_path4147 = /*#__PURE__*/React.createElement("path", {
    d: "M37 75h1v1h-1z",
    fill: "#ede60e"
  })), _path4148 || (_path4148 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h-1v-1h1z",
    fill: "#e8e80f"
  })), _path4149 || (_path4149 = /*#__PURE__*/React.createElement("path", {
    d: "M40 75v1h-1v-1z",
    fill: "#f4ef10"
  })), _path4150 || (_path4150 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76v-1h1v1z",
    fill: "#cdcc17"
  })), _path4151 || (_path4151 = /*#__PURE__*/React.createElement("path", {
    d: "M41 76v-1h1v1z",
    fill: "#adbb2a"
  })), _path4152 || (_path4152 = /*#__PURE__*/React.createElement("path", {
    d: "M43 76h-1v-1h1z",
    fill: "#97a21f"
  })), _path4153 || (_path4153 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75h1v1h-1z",
    fill: "#a7b323"
  })), _path4154 || (_path4154 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75v1h-1v-1z",
    fill: "#a4b11b"
  })), _path4155 || (_path4155 = /*#__PURE__*/React.createElement("path", {
    d: "M46 76h-1v-1h1z",
    fill: "#a2ad26"
  })), _path4156 || (_path4156 = /*#__PURE__*/React.createElement("path", {
    d: "M47 76h-1v-1h1z",
    fill: "#9daa26"
  })), _path4157 || (_path4157 = /*#__PURE__*/React.createElement("path", {
    d: "M48 75v1h-1v-1z",
    fill: "#c3c71c"
  })), _path4158 || (_path4158 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76h-1v-1h1z",
    fill: "#d4d965"
  })), _path4159 || (_path4159 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v1h-1v-1z",
    fill: "#ccd2d2"
  })), _path4160 || (_path4160 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1z",
    fill: "#d4b06e"
  })), _path4161 || (_path4161 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1z",
    fill: "#d99635"
  })), _path4162 || (_path4162 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1z",
    fill: "#cc862b"
  })), _path4163 || (_path4163 = /*#__PURE__*/React.createElement("path", {
    d: "M53 76v-1h1v1z",
    fill: "#eba642"
  })), _path4164 || (_path4164 = /*#__PURE__*/React.createElement("path", {
    d: "M55 76h-1v-1h1z",
    fill: "#f4b249"
  })), _path4165 || (_path4165 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75v1h-1v-1z",
    fill: "#dca047"
  })), _path4166 || (_path4166 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75h1v1h-1z",
    fill: "#c39561"
  })), _path4167 || (_path4167 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h-1v-1h1z",
    fill: "#af8968"
  })), _path4168 || (_path4168 = /*#__PURE__*/React.createElement("path", {
    d: "M59 75v1h-1v-1z",
    fill: "#846546"
  })), _path4169 || (_path4169 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h-1v-1h1z",
    fill: "#6f4b33"
  })), _path4170 || (_path4170 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h1v1h-1z",
    fill: "#603721"
  })), _path4171 || (_path4171 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1z",
    fill: "#63391b"
  })), _path4172 || (_path4172 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1z",
    fill: "#875229"
  })), _path4173 || (_path4173 = /*#__PURE__*/React.createElement("path", {
    d: "M64 75v1h-1v-1z",
    fill: "#ba7639"
  })), _path4174 || (_path4174 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#c57d33"
  })), _path4175 || (_path4175 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76h-1v-1h1z",
    fill: "#d59044"
  })), _path4176 || (_path4176 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75v1h-1v-1z",
    fill: "#e8a650"
  })), _path4177 || (_path4177 = /*#__PURE__*/React.createElement("path", {
    d: "M67 76v-1h1v1z",
    fill: "#df983d"
  })), _path4178 || (_path4178 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1z",
    fill: "#d38e3a"
  })), _path4179 || (_path4179 = /*#__PURE__*/React.createElement("path", {
    d: "M70 76h-1v-1h1z",
    fill: "#ce8d47"
  })), _path4180 || (_path4180 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h-1v-1h1z",
    fill: "#c68549"
  })), _path4181 || (_path4181 = /*#__PURE__*/React.createElement("path", {
    d: "M72 76h-1v-1h1z",
    fill: "#c08047"
  })), _path4182 || (_path4182 = /*#__PURE__*/React.createElement("path", {
    d: "M73 76h-1v-1h1z",
    fill: "#bb7d4f"
  })), _path4183 || (_path4183 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v1h-1v-1z",
    fill: "#c99570"
  })), _path4184 || (_path4184 = /*#__PURE__*/React.createElement("path", {
    d: "M74 76v-1h1v1z",
    fill: "#dbbba0"
  })), _path4185 || (_path4185 = /*#__PURE__*/React.createElement("path", {
    d: "M75 76v-1h1v1z",
    fill: "#e5d9cd"
  })), _path4186 || (_path4186 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1z",
    fill: "#e3e2dd",
    fillOpacity: 0.973
  })), _path4187 || (_path4187 = /*#__PURE__*/React.createElement("path", {
    d: "M19 77h-1v-1h1z",
    fill: "#adbaa3",
    fillOpacity: 0.514
  })), _path4188 || (_path4188 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76v1h-1v-1z",
    fill: "#8aac86"
  })), _path4189 || (_path4189 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76h1v1h-1z",
    fill: "#98af89"
  })), _path4190 || (_path4190 = /*#__PURE__*/React.createElement("path", {
    d: "M21 77v-1h1v1z",
    fill: "#babe9d"
  })), _path4191 || (_path4191 = /*#__PURE__*/React.createElement("path", {
    d: "M22 77v-1h1v1z",
    fill: "#c2c6a6"
  })), _path4192 || (_path4192 = /*#__PURE__*/React.createElement("path", {
    d: "M23 77v-1h1v1z",
    fill: "#cacfb1"
  })), _path4193 || (_path4193 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76v1h-1v-1z",
    fill: "#e7ebcf"
  })), _path4194 || (_path4194 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h1v1h-1z",
    fill: "#eef1d8"
  })), _path4195 || (_path4195 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76v1h-1v-1z",
    fill: "#ecf4ee"
  })), _path4196 || (_path4196 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76h1v1h-1z",
    fill: "#8eb9d6"
  })), _path4197 || (_path4197 = /*#__PURE__*/React.createElement("path", {
    d: "M29 76v1h-1v-1z",
    fill: "#98b2b9"
  })), _path4198 || (_path4198 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v-1h1v1z",
    fill: "#bb8a49"
  })), _path4199 || (_path4199 = /*#__PURE__*/React.createElement("path", {
    d: "M30 76h1v1h-1z",
    fill: "#d2982b"
  })), _path4200 || (_path4200 = /*#__PURE__*/React.createElement("path", {
    d: "M32 76v1h-1v-1z",
    fill: "#dcba19"
  })), _path4201 || (_path4201 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76v1h-1v-1z",
    fill: "#f4e319"
  })), _path4202 || (_path4202 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h1v1h-1z",
    fill: "#f2ee1e"
  })), _path4203 || (_path4203 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#cdcc20"
  })), _path4204 || (_path4204 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76h1v1h-1z",
    fill: "#ddd81b"
  })), _path4205 || (_path4205 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v-1h1v1z",
    fill: "#ccd121"
  })), _path4206 || (_path4206 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v-1h1v1z",
    fill: "#b6bf1e"
  })), _path4207 || (_path4207 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77h-1v-1h1z",
    fill: "#abb220"
  })), _path4208 || (_path4208 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h1v1h-1z",
    fill: "#bfbf17"
  })), _path4209 || (_path4209 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76h1v1h-1z",
    fill: "#d2d523"
  })), _path4210 || (_path4210 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77v-1h1v1z",
    fill: "#9aac24"
  })), _path4211 || (_path4211 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1z",
    fill: "#aabb29"
  })), _path4212 || (_path4212 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#afb722"
  })), _path4213 || (_path4213 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1z",
    fill: "#b7bb21"
  })), _path4214 || (_path4214 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#bec31e"
  })), _path4215 || (_path4215 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#bec418"
  })), _path4216 || (_path4216 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1z",
    fill: "#d5d417"
  })), _path4217 || (_path4217 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76v1h-1v-1z",
    fill: "#e0df41"
  })), _path4218 || (_path4218 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77v-1h1v1z",
    fill: "#ceb894"
  })), _path4219 || (_path4219 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76h1v1h-1z",
    fill: "#c0842c"
  })), _path4220 || (_path4220 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76h1v1h-1z",
    fill: "#cb8e31"
  })), _path4221 || (_path4221 = /*#__PURE__*/React.createElement("path", {
    d: "M52 76h1v1h-1z",
    fill: "#eeb358"
  })), _path4222 || (_path4222 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77v-1h1v1z",
    fill: "#efab43"
  })), _path4223 || (_path4223 = /*#__PURE__*/React.createElement("path", {
    d: "M54 77v-1h1v1z",
    fill: "#dfb06a"
  })), _path4224 || (_path4224 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1z",
    fill: "#decfbd"
  })), _path4225 || (_path4225 = /*#__PURE__*/React.createElement("path", {
    d: "M56 77v-1h1v1z",
    fill: "#e1dad9"
  })), _path4226 || (_path4226 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76v1h-1v-1z",
    fill: "#dddcd8"
  })), _path4227 || (_path4227 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h1v1h-1z",
    fill: "#d9d8cc"
  })), _path4228 || (_path4228 = /*#__PURE__*/React.createElement("path", {
    d: "M59 77v-1h1v1z",
    fill: "#d2c9c2"
  })), _path4229 || (_path4229 = /*#__PURE__*/React.createElement("path", {
    d: "M61 76v1h-1v-1z",
    fill: "#c3b4ae"
  })), _path4230 || (_path4230 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1z",
    fill: "#c0aa98"
  })), _path4231 || (_path4231 = /*#__PURE__*/React.createElement("path", {
    d: "M63 77h-1v-1h1z",
    fill: "#c09a7a"
  })), _path4232 || (_path4232 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1z",
    fill: "#ba8955"
  })), _path4233 || (_path4233 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1z",
    fill: "#b07941"
  })), _path4234 || (_path4234 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v-1h1v1z",
    fill: "#ab743e"
  })), _path4235 || (_path4235 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77h-1v-1h1z",
    fill: "#c28e58"
  })), _path4236 || (_path4236 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1z",
    fill: "#d2a675"
  })), _path4237 || (_path4237 = /*#__PURE__*/React.createElement("path", {
    d: "M69 77h-1v-1h1z",
    fill: "#d9be9d"
  })), _path4238 || (_path4238 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h-1v-1h1z",
    fill: "#dfd1c0"
  })), _path4239 || (_path4239 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77v-1h1v1z",
    fill: "#ddd3c6"
  })), _path4240 || (_path4240 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h1v1h-1z",
    fill: "#ddd4c8"
  })), _path4241 || (_path4241 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77v-1h1v1z",
    fill: "#ded8cf"
  })), _path4242 || (_path4242 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77h-1v-1h1z",
    fill: "#e0ded8"
  })), _path4243 || (_path4243 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77h-1v-1h1z",
    fill: "#e0e0dc"
  })), _path4244 || (_path4244 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77v-1h1v1z",
    fill: "#dfe0e2"
  })), _path4245 || (_path4245 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76v1h-1v-1z",
    fill: "#dde0de",
    fillOpacity: 0.976
  })), _path4246 || (_path4246 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1z",
    fill: "#dfdfda",
    fillOpacity: 0.192
  })), _path4247 || (_path4247 = /*#__PURE__*/React.createElement("path", {
    d: "M19 77v1h-1v-1z",
    fill: "#afb29c",
    fillOpacity: 0.525
  })), _path4248 || (_path4248 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78h-1v-1h1z",
    fill: "#b5c4a7"
  })), _path4249 || (_path4249 = /*#__PURE__*/React.createElement("path", {
    d: "M20 77h1v1h-1z",
    fill: "#aeba9c"
  })), _path4250 || (_path4250 = /*#__PURE__*/React.createElement("path", {
    d: "M21 77h1v1h-1z",
    fill: "#b9bd9b"
  })), _path4251 || (_path4251 = /*#__PURE__*/React.createElement("path", {
    d: "M22 77h1v1h-1z",
    fill: "#bec2a2"
  })), _path4252 || (_path4252 = /*#__PURE__*/React.createElement("path", {
    d: "M24 77v1h-1v-1z",
    fill: "#cbd0b2"
  })), _path4253 || (_path4253 = /*#__PURE__*/React.createElement("path", {
    d: "M24 78v-1h1v1z",
    fill: "#e7ead0"
  })), _path4254 || (_path4254 = /*#__PURE__*/React.createElement("path", {
    d: "M26 77v1h-1v-1z",
    fill: "#eef0d9"
  })), _path4255 || (_path4255 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78v-1h1v1z",
    fill: "#e4eeeb"
  })), _path4256 || (_path4256 = /*#__PURE__*/React.createElement("path", {
    d: "M27 78v-1h1v1z",
    fill: "#7baed1"
  })), _path4257 || (_path4257 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v1h-1v-1z",
    fill: "#92ad9e"
  })), _path4258 || (_path4258 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78h-1v-1h1z",
    fill: "#c5aa1c"
  })), _path4259 || (_path4259 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78v-1h1v1z",
    fill: "#f2e218"
  })), _path4260 || (_path4260 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78h-1v-1h1z",
    fill: "#e7e81c"
  })), _path4261 || (_path4261 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v-1h1v1z",
    fill: "#b3c022"
  })), _path4262 || (_path4262 = /*#__PURE__*/React.createElement("path", {
    d: "M34 77v1h-1v-1z",
    fill: "#889f2f"
  })), _path4263 || (_path4263 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78h-1v-1h1z",
    fill: "#7b8e26"
  })), _path4264 || (_path4264 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v1h-1v-1z",
    fill: "#ccd12b"
  })), _path4265 || (_path4265 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v1h-1v-1z",
    fill: "#afb728"
  })), _path4266 || (_path4266 = /*#__PURE__*/React.createElement("path", {
    d: "M38 77v1h-1v-1z",
    fill: "#aeb727"
  })), _path4267 || (_path4267 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v-1h1v1z",
    fill: "#9ca625"
  })), _path4268 || (_path4268 = /*#__PURE__*/React.createElement("path", {
    d: "M40 77v1h-1v-1z",
    fill: "#bdc021"
  })), _path4269 || (_path4269 = /*#__PURE__*/React.createElement("path", {
    d: "M40 78v-1h1v1z",
    fill: "#ddde21"
  })), _path4270 || (_path4270 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v1h-1v-1z",
    fill: "#ccce1e"
  })), _path4271 || (_path4271 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77h1v1h-1z",
    fill: "#e9e612"
  })), _path4272 || (_path4272 = /*#__PURE__*/React.createElement("path", {
    d: "M43 77h1v1h-1z",
    fill: "#f6f013"
  })), _path4273 || (_path4273 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77v1h-1v-1z",
    fill: "#faf416"
  })), _path4274 || (_path4274 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v-1h1v1z",
    fill: "#faf612"
  })), _path4275 || (_path4275 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#f7f610"
  })), _path4276 || (_path4276 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77v1h-1v-1z",
    fill: "#f9f307"
  })), _path4277 || (_path4277 = /*#__PURE__*/React.createElement("path", {
    d: "M49 78h-1v-1h1z",
    fill: "#f0dd1c"
  })), _path4278 || (_path4278 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1z",
    fill: "#c69b43"
  })), _path4279 || (_path4279 = /*#__PURE__*/React.createElement("path", {
    d: "M50 78v-1h1v1z",
    fill: "#cd974d"
  })), _path4280 || (_path4280 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1z",
    fill: "#f9bc69"
  })), _path4281 || (_path4281 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v-1h1v1z",
    fill: "#e9aa41"
  })), _path4282 || (_path4282 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77h1v1h-1z",
    fill: "#e1ae6f"
  })), _path4283 || (_path4283 = /*#__PURE__*/React.createElement("path", {
    d: "M55 77v1h-1v-1z",
    fill: "#ddd4c3"
  })), _path4284 || (_path4284 = /*#__PURE__*/React.createElement("path", {
    d: "M55 78v-1h1v1z",
    fill: "#d0d3d6"
  })), _path4285 || (_path4285 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h-1v-1h1z",
    fill: "#d1d4d4"
  })), _path4286 || (_path4286 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h-1v-1h1z",
    fill: "#d3d7d7"
  })), _path4287 || (_path4287 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78h-1v-1h1z",
    fill: "#e0e0db"
  })), _path4288 || (_path4288 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78v-1h1v1z",
    fill: "#dfddda"
  })), _path4289 || (_path4289 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77v1h-1v-1z",
    fill: "#dadbd1"
  })), _path4290 || (_path4290 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78v-1h1v1z",
    fill: "#dad9cc"
  })), _path4291 || (_path4291 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78h-1v-1h1z",
    fill: "#ddd5cc"
  })), _path4292 || (_path4292 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77v1h-1v-1z",
    fill: "#ded5ce"
  })), _path4293 || (_path4293 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78v-1h1v1z",
    fill: "#ddd8d4"
  })), _path4294 || (_path4294 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h1v1h-1z",
    fill: "#dbd8d8"
  })), _path4295 || (_path4295 = /*#__PURE__*/React.createElement("path", {
    d: "M69 78v-1h1v1z",
    fill: "#d7d7d9"
  })), _path4296 || (_path4296 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h1v1h-1z",
    fill: "#d5d8d9"
  })), _path4297 || (_path4297 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78h-1v-1h1z",
    fill: "#d5d7da"
  })), _path4298 || (_path4298 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h1v1h-1z",
    fill: "#d6d8d9"
  })), _path4299 || (_path4299 = /*#__PURE__*/React.createElement("path", {
    d: "M76 77v1h-1v-1z",
    fill: "#deddde"
  })), _path4300 || (_path4300 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78v-1h1v1z",
    fill: "#dfdfdd",
    fillOpacity: 0.973
  })), _path4301 || (_path4301 = /*#__PURE__*/React.createElement("path", {
    d: "M18 79v-1h1v1z",
    fill: "#76847a",
    fillOpacity: 0.506
  })), _path4302 || (_path4302 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78v1h-1v-1z",
    fill: "#bcc6b0"
  })), _path4303 || (_path4303 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79v-1h1v1z",
    fill: "#bfbfa2"
  })), _path4304 || (_path4304 = /*#__PURE__*/React.createElement("path", {
    d: "M22 78v1h-1v-1z",
    fill: "#bbbd9e"
  })), _path4305 || (_path4305 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79h-1v-1h1z",
    fill: "#d1d6b6"
  })), _path4306 || (_path4306 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v-1h1v1z",
    fill: "#d1d6b9"
  })), _path4307 || (_path4307 = /*#__PURE__*/React.createElement("path", {
    d: "M25 78v1h-1v-1z",
    fill: "#cbcdb2"
  })), _path4308 || (_path4308 = /*#__PURE__*/React.createElement("path", {
    d: "M25 79v-1h1v1z",
    fill: "#dcdfc5"
  })), _path4309 || (_path4309 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78h1v1h-1z",
    fill: "#e4ece7"
  })), _path4310 || (_path4310 = /*#__PURE__*/React.createElement("path", {
    d: "M28 78v1h-1v-1z",
    fill: "#8db7d8"
  })), _path4311 || (_path4311 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79h-1v-1h1z",
    fill: "#b6d79a"
  })), _path4312 || (_path4312 = /*#__PURE__*/React.createElement("path", {
    d: "M30 79h-1v-1h1z",
    fill: "#ecec1c"
  })), _path4313 || (_path4313 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79h-1v-1h1z",
    fill: "#cdd327"
  })), _path4314 || (_path4314 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v1h-1v-1z",
    fill: "#96a32d"
  })), _path4315 || (_path4315 = /*#__PURE__*/React.createElement("path", {
    d: "M33 78v1h-1v-1z",
    fill: "#95a83e"
  })), _path4316 || (_path4316 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79v-1h1v1z",
    fill: "#547929"
  })), _path4317 || (_path4317 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78v1h-1v-1z",
    fill: "#5f7e1a"
  })), _path4318 || (_path4318 = /*#__PURE__*/React.createElement("path", {
    d: "M35 79v-1h1v1z",
    fill: "#dee324"
  })), _path4319 || (_path4319 = /*#__PURE__*/React.createElement("path", {
    d: "M37 79h-1v-1h1z",
    fill: "#adaf21"
  })), _path4320 || (_path4320 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v1h-1v-1z",
    fill: "#cecb19"
  })), _path4321 || (_path4321 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78v1h-1v-1z",
    fill: "#d8de1a"
  })), _path4322 || (_path4322 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78h1v1h-1z",
    fill: "#d6d71d"
  })), _path4323 || (_path4323 = /*#__PURE__*/React.createElement("path", {
    d: "M40 79v-1h1v1z",
    fill: "#dddd17"
  })), _path4324 || (_path4324 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78h1v1h-1z",
    fill: "#d6d816"
  })), _path4325 || (_path4325 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78v1h-1v-1z",
    fill: "#dedc19"
  })), _path4326 || (_path4326 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78h1v1h-1z",
    fill: "#e0e11d"
  })), _path4327 || (_path4327 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v1h-1v-1z",
    fill: "#bfc316"
  })), _path4328 || (_path4328 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v1h-1z",
    fill: "#bcc416"
  })), _path4329 || (_path4329 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v1h-1v-1z",
    fill: "#bbbe14"
  })), _path4330 || (_path4330 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1z",
    fill: "#fcf60a"
  })), _path4331 || (_path4331 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1z",
    fill: "#f2df0d"
  })), _path4332 || (_path4332 = /*#__PURE__*/React.createElement("path", {
    d: "M50 79h-1v-1h1z",
    fill: "#d4a538"
  })), _path4333 || (_path4333 = /*#__PURE__*/React.createElement("path", {
    d: "M51 79h-1v-1h1z",
    fill: "#f9c26b"
  })), _path4334 || (_path4334 = /*#__PURE__*/React.createElement("path", {
    d: "M52 79h-1v-1h1z",
    fill: "#e5a441"
  })), _path4335 || (_path4335 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79h-1v-1h1z",
    fill: "#daa961"
  })), _path4336 || (_path4336 = /*#__PURE__*/React.createElement("path", {
    d: "M54 78v1h-1v-1z",
    fill: "#dfcebf"
  })), _path4337 || (_path4337 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79v-1h1v1z",
    fill: "#d0d0cf"
  })), _path4338 || (_path4338 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h-1v-1h1z",
    fill: "#d4d4d3"
  })), _path4339 || (_path4339 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h1v1h-1z",
    fill: "#d7d5d3"
  })), _path4340 || (_path4340 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h1v1h-1z",
    fill: "#d8d1c4"
  })), _path4341 || (_path4341 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78v1h-1v-1z",
    fill: "#d7c3a0"
  })), _path4342 || (_path4342 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79v-1h1v1z",
    fill: "#cbac7f"
  })), _path4343 || (_path4343 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1z",
    fill: "#ccbcae"
  })), _path4344 || (_path4344 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v1h-1z",
    fill: "#cfd2cf"
  })), _path4345 || (_path4345 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78h1v1h-1z",
    fill: "#cfd3d2"
  })), _path4346 || (_path4346 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79v-1h1v1z",
    fill: "#d1d4d5"
  })), _path4347 || (_path4347 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78v1h-1v-1z",
    fill: "#d1d5d5"
  })), _path4348 || (_path4348 = /*#__PURE__*/React.createElement("path", {
    d: "M70 79h-1v-1h1z",
    fill: "#d1d4d3"
  })), _path4349 || (_path4349 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79h-1v-1h1z",
    fill: "#cfd2d1"
  })), _path4350 || (_path4350 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79h-1v-1h1z",
    fill: "#d4d7d6"
  })), _path4351 || (_path4351 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78h1v1h-1z",
    fill: "#dfe1e2"
  })), _path4352 || (_path4352 = /*#__PURE__*/React.createElement("path", {
    d: "M19 79v1h-1v-1z",
    fill: "#5b8192",
    fillOpacity: 0.478
  })), _path4353 || (_path4353 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h-1v-1h1z",
    fill: "#89a5a3"
  })), _path4354 || (_path4354 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79h1v1h-1z",
    fill: "#ced0b3"
  })), _path4355 || (_path4355 = /*#__PURE__*/React.createElement("path", {
    d: "M21 79h1v1h-1z",
    fill: "#b1b494"
  })), _path4356 || (_path4356 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v1h-1v-1z",
    fill: "#c9ceae"
  })), _path4357 || (_path4357 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79v1h-1v-1z",
    fill: "#e6ebcc"
  })), _path4358 || (_path4358 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79h1v1h-1z",
    fill: "#e5e6cb"
  })), _path4359 || (_path4359 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80h-1v-1h1z",
    fill: "#d4d5bd"
  })), _path4360 || (_path4360 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80v-1h1v1z",
    fill: "#d9ded9"
  })), _path4361 || (_path4361 = /*#__PURE__*/React.createElement("path", {
    d: "M27 79h1v1h-1z",
    fill: "#95bada"
  })), _path4362 || (_path4362 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79v1h-1v-1z",
    fill: "#bad99a"
  })), _path4363 || (_path4363 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h-1v-1h1z",
    fill: "#cfdb21"
  })), _path4364 || (_path4364 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79v1h-1v-1z",
    fill: "#6c8730"
  })), _path4365 || (_path4365 = /*#__PURE__*/React.createElement("path", {
    d: "M31 80v-1h1v1z",
    fill: "#83a246"
  })), _path4366 || (_path4366 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79h1v1h-1z",
    fill: "#9fb438"
  })), _path4367 || (_path4367 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79h1v1h-1z",
    fill: "#879b31"
  })), _path4368 || (_path4368 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80v-1h1v1z",
    fill: "#a3ab29"
  })), _path4369 || (_path4369 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80h-1v-1h1z",
    fill: "#f0ec10"
  })), _path4370 || (_path4370 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80v-1h1v1z",
    fill: "#e1e116"
  })), _path4371 || (_path4371 = /*#__PURE__*/React.createElement("path", {
    d: "M37 80v-1h1v1z",
    fill: "#eae719"
  })), _path4372 || (_path4372 = /*#__PURE__*/React.createElement("path", {
    d: "M38 79h1v1h-1z",
    fill: "#eceb19"
  })), _path4373 || (_path4373 = /*#__PURE__*/React.createElement("path", {
    d: "M39 79h1v1h-1z",
    fill: "#e1e015"
  })), _path4374 || (_path4374 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79v1h-1v-1z",
    fill: "#c0c111"
  })), _path4375 || (_path4375 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79h1v1h-1z",
    fill: "#bfc41a"
  })), _path4376 || (_path4376 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-1v-1z",
    fill: "#d2d425"
  })), _path4377 || (_path4377 = /*#__PURE__*/React.createElement("path", {
    d: "M43 80v-1h1v1z",
    fill: "#c3c72e"
  })), _path4378 || (_path4378 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79v1h-1v-1z",
    fill: "#a5ae28"
  })), _path4379 || (_path4379 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79h1v1h-1z",
    fill: "#9eab1f"
  })), _path4380 || (_path4380 = /*#__PURE__*/React.createElement("path", {
    d: "M47 80h-1v-1h1z",
    fill: "#a8aa19"
  })), _path4381 || (_path4381 = /*#__PURE__*/React.createElement("path", {
    d: "M47 79h1v1h-1z",
    fill: "#faf30f"
  })), _path4382 || (_path4382 = /*#__PURE__*/React.createElement("path", {
    d: "M49 79v1h-1v-1z",
    fill: "#fbea09"
  })), _path4383 || (_path4383 = /*#__PURE__*/React.createElement("path", {
    d: "M49 80v-1h1v1z",
    fill: "#f2bf3b"
  })), _path4384 || (_path4384 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80v-1h1v1z",
    fill: "#e1a23e"
  })), _path4385 || (_path4385 = /*#__PURE__*/React.createElement("path", {
    d: "M52 80h-1v-1h1z",
    fill: "#d5a15b"
  })), _path4386 || (_path4386 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79v1h-1v-1z",
    fill: "#dbcdbe"
  })), _path4387 || (_path4387 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h-1v-1h1z",
    fill: "#cbd1d1"
  })), _path4388 || (_path4388 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79h1v1h-1z",
    fill: "#d2d0cc"
  })), _path4389 || (_path4389 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v1h-1v-1z",
    fill: "#dbcfbd"
  })), _path4390 || (_path4390 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-1v-1h1z",
    fill: "#ddcaa6"
  })), _path4391 || (_path4391 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1z",
    fill: "#dabd8e"
  })), _path4392 || (_path4392 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1z",
    fill: "#d1ae71"
  })), _path4393 || (_path4393 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79v1h-1v-1z",
    fill: "#d2a651"
  })), _path4394 || (_path4394 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80v-1h1v1z",
    fill: "#d19827"
  })), _path4395 || (_path4395 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80h-1v-1h1z",
    fill: "#c08422"
  })), _path4396 || (_path4396 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1z",
    fill: "#ba997a"
  })), _path4397 || (_path4397 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v-1h1v1z",
    fill: "#d6d6d9"
  })), _path4398 || (_path4398 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h-1v-1h1z",
    fill: "#d2d6d5"
  })), _path4399 || (_path4399 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81v-1h1v1z",
    fill: "#6b97b0",
    fillOpacity: 0.482
  })), _path4400 || (_path4400 = /*#__PURE__*/React.createElement("path", {
    d: "M19 80h1v1h-1z",
    fill: "#4f849b"
  })), _path4401 || (_path4401 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h1v1h-1z",
    fill: "#abc1b7"
  })), _path4402 || (_path4402 = /*#__PURE__*/React.createElement("path", {
    d: "M21 81v-1h1v1z",
    fill: "#d5d7b7"
  })), _path4403 || (_path4403 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81h-1v-1h1z",
    fill: "#bac09d"
  })), _path4404 || (_path4404 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81v-1h1v1z",
    fill: "#cfd5b5"
  })), _path4405 || (_path4405 = /*#__PURE__*/React.createElement("path", {
    d: "M24 80h1v1h-1z",
    fill: "#e8e9cd"
  })), _path4406 || (_path4406 = /*#__PURE__*/React.createElement("path", {
    d: "M25 80h1v1h-1z",
    fill: "#eff0d9"
  })), _path4407 || (_path4407 = /*#__PURE__*/React.createElement("path", {
    d: "M27 80v1h-1v-1z",
    fill: "#e8eee9"
  })), _path4408 || (_path4408 = /*#__PURE__*/React.createElement("path", {
    d: "M27 81v-1h1v1z",
    fill: "#96bcdb"
  })), _path4409 || (_path4409 = /*#__PURE__*/React.createElement("path", {
    d: "M28 80h1v1h-1z",
    fill: "#b9d9a1"
  })), _path4410 || (_path4410 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80v1h-1v-1z",
    fill: "#d3de2c"
  })), _path4411 || (_path4411 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h1v1h-1z",
    fill: "#5e7e32"
  })), _path4412 || (_path4412 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80v1h-1v-1z",
    fill: "#7b9642"
  })), _path4413 || (_path4413 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80h1v1h-1z",
    fill: "#95a121"
  })), _path4414 || (_path4414 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-1h1z",
    fill: "#dbde20"
  })), _path4415 || (_path4415 = /*#__PURE__*/React.createElement("path", {
    d: "M35 80v1h-1v-1z",
    fill: "#f3ed15"
  })), _path4416 || (_path4416 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v-1h1v1z",
    fill: "#f7f40f"
  })), _path4417 || (_path4417 = /*#__PURE__*/React.createElement("path", {
    d: "M37 81h-1v-1h1z",
    fill: "#dddf13"
  })), _path4418 || (_path4418 = /*#__PURE__*/React.createElement("path", {
    d: "M38 80v1h-1v-1z",
    fill: "#a8b129"
  })), _path4419 || (_path4419 = /*#__PURE__*/React.createElement("path", {
    d: "M38 81v-1h1v1z",
    fill: "#a7b12a"
  })), _path4420 || (_path4420 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80v1h-1v-1z",
    fill: "#abb21a"
  })), _path4421 || (_path4421 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81v-1h1v1z",
    fill: "#d5d722"
  })), _path4422 || (_path4422 = /*#__PURE__*/React.createElement("path", {
    d: "M41 81v-1h1v1z",
    fill: "#c3c316"
  })), _path4423 || (_path4423 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81h-1v-1h1z",
    fill: "#cccc1b"
  })), _path4424 || (_path4424 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81v-1h1v1z",
    fill: "#babc1c"
  })), _path4425 || (_path4425 = /*#__PURE__*/React.createElement("path", {
    d: "M45 80v1h-1v-1z",
    fill: "#d5d818"
  })), _path4426 || (_path4426 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81v-1h1v1z",
    fill: "#e8e71b"
  })), _path4427 || (_path4427 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81h-1v-1h1z",
    fill: "#e6e214"
  })), _path4428 || (_path4428 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81v-1h1v1z",
    fill: "#fef504"
  })), _path4429 || (_path4429 = /*#__PURE__*/React.createElement("path", {
    d: "M49 81h-1v-1h1z",
    fill: "#fcef05"
  })), _path4430 || (_path4430 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81h-1v-1h1z",
    fill: "#d7aa1c"
  })), _path4431 || (_path4431 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81v-1h1v1z",
    fill: "#cb9e62"
  })), _path4432 || (_path4432 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81h-1v-1h1z",
    fill: "#d9cdc3"
  })), _path4433 || (_path4433 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81v-1h1v1z",
    fill: "#d5ced4"
  })), _path4434 || (_path4434 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81h-1v-1h1z",
    fill: "#d9ccbd"
  })), _path4435 || (_path4435 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h1v1h-1z",
    fill: "#e4c290"
  })), _path4436 || (_path4436 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-1v-1h1z",
    fill: "#eab459"
  })), _path4437 || (_path4437 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80v1h-1v-1z",
    fill: "#dda030"
  })), _path4438 || (_path4438 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#d18f20"
  })), _path4439 || (_path4439 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#ca881d"
  })), _path4440 || (_path4440 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#c98715"
  })), _path4441 || (_path4441 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#d99921"
  })), _path4442 || (_path4442 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80v1h-1v-1z",
    fill: "#bb8328"
  })), _path4443 || (_path4443 = /*#__PURE__*/React.createElement("path", {
    d: "M63 81h-1v-1h1z",
    fill: "#b39071"
  })), _path4444 || (_path4444 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80h1v1h-1z",
    fill: "#d8dada"
  })), _path4445 || (_path4445 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h-1v-1h1z",
    fill: "#d3d6d6"
  })), _path4446 || (_path4446 = /*#__PURE__*/React.createElement("path", {
    d: "M76 81v-1h1v1z",
    fill: "#e1e3e2",
    fillOpacity: 0.976
  })), _path4447 || (_path4447 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#e4e4e4",
    fillOpacity: 0.188
  })), _path4448 || (_path4448 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81h1v1h-1z",
    fill: "#688fa8",
    fillOpacity: 0.486
  })), _path4449 || (_path4449 = /*#__PURE__*/React.createElement("path", {
    d: "M20 81v1h-1v-1z",
    fill: "#5695c4"
  })), _path4450 || (_path4450 = /*#__PURE__*/React.createElement("path", {
    d: "M20 81h1v1h-1z",
    fill: "#53819b"
  })), _path4451 || (_path4451 = /*#__PURE__*/React.createElement("path", {
    d: "M22 81v1h-1v-1z",
    fill: "#c5d2bd"
  })), _path4452 || (_path4452 = /*#__PURE__*/React.createElement("path", {
    d: "M22 82v-1h1v1z",
    fill: "#dce0bc"
  })), _path4453 || (_path4453 = /*#__PURE__*/React.createElement("path", {
    d: "M24 81v1h-1v-1z",
    fill: "#c4c6a9"
  })), _path4454 || (_path4454 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82h-1v-1h1z",
    fill: "#ced1b4"
  })), _path4455 || (_path4455 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82v-1h1v1z",
    fill: "#eff2d9"
  })), _path4456 || (_path4456 = /*#__PURE__*/React.createElement("path", {
    d: "M26 82v-1h1v1z",
    fill: "#ebf2ec"
  })), _path4457 || (_path4457 = /*#__PURE__*/React.createElement("path", {
    d: "M28 82h-1v-1h1z",
    fill: "#98beda"
  })), _path4458 || (_path4458 = /*#__PURE__*/React.createElement("path", {
    d: "M28 81h1v1h-1z",
    fill: "#b9daa1"
  })), _path4459 || (_path4459 = /*#__PURE__*/React.createElement("path", {
    d: "M29 82v-1h1v1z",
    fill: "#d8da26"
  })), _path4460 || (_path4460 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h-1v-1h1z",
    fill: "#a4b02a"
  })), _path4461 || (_path4461 = /*#__PURE__*/React.createElement("path", {
    d: "M32 82h-1v-1h1z",
    fill: "#c7ce23"
  })), _path4462 || (_path4462 = /*#__PURE__*/React.createElement("path", {
    d: "M33 81v1h-1v-1z",
    fill: "#e6e91c"
  })), _path4463 || (_path4463 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81v1h-1v-1z",
    fill: "#faf716"
  })), _path4464 || (_path4464 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v1h-1v-1z",
    fill: "#c9c51c"
  })), _path4465 || (_path4465 = /*#__PURE__*/React.createElement("path", {
    d: "M36 81v1h-1v-1z",
    fill: "#afb218"
  })), _path4466 || (_path4466 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h-1v-1h1z",
    fill: "#dfe416"
  })), _path4467 || (_path4467 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82h-1v-1h1z",
    fill: "#b5be2c"
  })), _path4468 || (_path4468 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h-1v-1h1z",
    fill: "#adb027"
  })), _path4469 || (_path4469 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82v-1h1v1z",
    fill: "#b4bb1a"
  })), _path4470 || (_path4470 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81h1v1h-1z",
    fill: "#ede714"
  })), _path4471 || (_path4471 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82v-1h1v1z",
    fill: "#f6eb09"
  })), _path4472 || (_path4472 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1z",
    fill: "#fdf50c"
  })), _path4473 || (_path4473 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1z",
    fill: "#fef711"
  })), _path4474 || (_path4474 = /*#__PURE__*/React.createElement("path", {
    d: "M44 82v-1h1v1z",
    fill: "#fdf30b"
  })), _path4475 || (_path4475 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81h1v1h-1z",
    fill: "#f7e80b"
  })), _path4476 || (_path4476 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#f5e20a"
  })), _path4477 || (_path4477 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h-1v-1h1z",
    fill: "#f5e00c"
  })), _path4478 || (_path4478 = /*#__PURE__*/React.createElement("path", {
    d: "M48 81h1v1h-1z",
    fill: "#faea10"
  })), _path4479 || (_path4479 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82h-1v-1h1z",
    fill: "#cdb546"
  })), _path4480 || (_path4480 = /*#__PURE__*/React.createElement("path", {
    d: "M51 81v1h-1v-1z",
    fill: "#ddd1c6"
  })), _path4481 || (_path4481 = /*#__PURE__*/React.createElement("path", {
    d: "M51 82v-1h1v1z",
    fill: "#dad6d3"
  })), _path4482 || (_path4482 = /*#__PURE__*/React.createElement("path", {
    d: "M53 82h-1v-1h1z",
    fill: "#e5cc9f"
  })), _path4483 || (_path4483 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81v1h-1v-1z",
    fill: "#e6b55b"
  })), _path4484 || (_path4484 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82v-1h1v1z",
    fill: "#edae3e"
  })), _path4485 || (_path4485 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-1v-1z",
    fill: "#e09a1f"
  })), _path4486 || (_path4486 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h1z",
    fill: "#cf8d18"
  })), _path4487 || (_path4487 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#c58418"
  })), _path4488 || (_path4488 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82v-1h1v1z",
    fill: "#c48119"
  })), _path4489 || (_path4489 = /*#__PURE__*/React.createElement("path", {
    d: "M59 82v-1h1v1z",
    fill: "#cc8a1e"
  })), _path4490 || (_path4490 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1z",
    fill: "#d89929"
  })), _path4491 || (_path4491 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h-1v-1h1z",
    fill: "#af7724"
  })), _path4492 || (_path4492 = /*#__PURE__*/React.createElement("path", {
    d: "M63 82h-1v-1h1z",
    fill: "#956f4d"
  })), _path4493 || (_path4493 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#d7d6d3"
  })), _path4494 || (_path4494 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81v1h-1v-1z",
    fill: "#d5d8d7"
  })), _path4495 || (_path4495 = /*#__PURE__*/React.createElement("path", {
    d: "M19 82v1h-1v-1z",
    fill: "#5f89a5",
    fillOpacity: 0.494
  })), _path4496 || (_path4496 = /*#__PURE__*/React.createElement("path", {
    d: "M20 83h-1v-1h1z",
    fill: "#5b9bca"
  })), _path4497 || (_path4497 = /*#__PURE__*/React.createElement("path", {
    d: "M21 83h-1v-1h1z",
    fill: "#5a9cc5"
  })), _path4498 || (_path4498 = /*#__PURE__*/React.createElement("path", {
    d: "M21 83v-1h1v1z",
    fill: "#5b8a9e"
  })), _path4499 || (_path4499 = /*#__PURE__*/React.createElement("path", {
    d: "M23 83h-1v-1h1z",
    fill: "#c7d4c4"
  })), _path4500 || (_path4500 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82v1h-1v-1z",
    fill: "#ebecd3"
  })), _path4501 || (_path4501 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82h1v1h-1z",
    fill: "#e4e8cd"
  })), _path4502 || (_path4502 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83h-1v-1h1z",
    fill: "#ecefd9"
  })), _path4503 || (_path4503 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83v-1h1v1z",
    fill: "#edf3ef"
  })), _path4504 || (_path4504 = /*#__PURE__*/React.createElement("path", {
    d: "M27 82h1v1h-1z",
    fill: "#99bfdd"
  })), _path4505 || (_path4505 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v-1h1v1z",
    fill: "#b7d7a6"
  })), _path4506 || (_path4506 = /*#__PURE__*/React.createElement("path", {
    d: "M29 83v-1h1v1z",
    fill: "#edeb1a"
  })), _path4507 || (_path4507 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82v1h-1v-1z",
    fill: "#f3f00d"
  })), _path4508 || (_path4508 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h1v1h-1z",
    fill: "#e1dc15"
  })), _path4509 || (_path4509 = /*#__PURE__*/React.createElement("path", {
    d: "M33 82v1h-1v-1z",
    fill: "#b8bd24"
  })), _path4510 || (_path4510 = /*#__PURE__*/React.createElement("path", {
    d: "M33 83v-1h1v1z",
    fill: "#b7be28"
  })), _path4511 || (_path4511 = /*#__PURE__*/React.createElement("path", {
    d: "M35 83h-1v-1h1z",
    fill: "#b2ba31"
  })), _path4512 || (_path4512 = /*#__PURE__*/React.createElement("path", {
    d: "M36 82v1h-1v-1z",
    fill: "#a7ad23"
  })), _path4513 || (_path4513 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82v1h-1v-1z",
    fill: "#e9e517"
  })), _path4514 || (_path4514 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h1v1h-1z",
    fill: "#e9e40d"
  })), _path4515 || (_path4515 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83v-1h1v1z",
    fill: "#f2ee12"
  })), _path4516 || (_path4516 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h1v1h-1z",
    fill: "#fffe14"
  })), _path4517 || (_path4517 = /*#__PURE__*/React.createElement("path", {
    d: "M41 83h-1v-1h1z",
    fill: "#fff50a"
  })), _path4518 || (_path4518 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v1h-1v-1z",
    fill: "#e9df0d"
  })), _path4519 || (_path4519 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82h1v1h-1z",
    fill: "#e4cd0f"
  })), _path4520 || (_path4520 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1z",
    fill: "#e3b80a"
  })), _path4521 || (_path4521 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82v1h-1v-1z",
    fill: "#dead08"
  })), _path4522 || (_path4522 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82h1v1h-1z",
    fill: "#d8a703"
  })), _path4523 || (_path4523 = /*#__PURE__*/React.createElement("path", {
    d: "M47 83h-1v-1h1z",
    fill: "#e0a405"
  })), _path4524 || (_path4524 = /*#__PURE__*/React.createElement("path", {
    d: "M48 83h-1v-1h1z",
    fill: "#e0a505"
  })), _path4525 || (_path4525 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h1v1h-1z",
    fill: "#e0b30a"
  })), _path4526 || (_path4526 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#e6ce7f"
  })), _path4527 || (_path4527 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83v-1h1v1z",
    fill: "#e0d8c3"
  })), _path4528 || (_path4528 = /*#__PURE__*/React.createElement("path", {
    d: "M52 82v1h-1v-1z",
    fill: "#e5cb8d"
  })), _path4529 || (_path4529 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83v-1h1v1z",
    fill: "#edb34a"
  })), _path4530 || (_path4530 = /*#__PURE__*/React.createElement("path", {
    d: "M53 83v-1h1v1z",
    fill: "#eeab34"
  })), _path4531 || (_path4531 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82h1v1h-1z",
    fill: "#d99724"
  })), _path4532 || (_path4532 = /*#__PURE__*/React.createElement("path", {
    d: "M55 82h1v1h-1z",
    fill: "#c88816"
  })), _path4533 || (_path4533 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h1v1h-1z",
    fill: "#ca8b21"
  })), _path4534 || (_path4534 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#be7f1e"
  })), _path4535 || (_path4535 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#c98522"
  })), _path4536 || (_path4536 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v1h-1v-1z",
    fill: "#c68217"
  })), _path4537 || (_path4537 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82h1v1h-1z",
    fill: "#c58821"
  })), _path4538 || (_path4538 = /*#__PURE__*/React.createElement("path", {
    d: "M61 82h1v1h-1z",
    fill: "#a97326"
  })), _path4539 || (_path4539 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1z",
    fill: "#8d623b"
  })), _path4540 || (_path4540 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83v-1h1v1z",
    fill: "#d3c9c5"
  })), _path4541 || (_path4541 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1z",
    fill: "#e4e6e5"
  })), _path4542 || (_path4542 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1z",
    fill: "#e3e9e3",
    fillOpacity: 0.184
  })), _path4543 || (_path4543 = /*#__PURE__*/React.createElement("path", {
    d: "M18 84v-1h1v1z",
    fill: "#6c7d8c",
    fillOpacity: 0.478
  })), _path4544 || (_path4544 = /*#__PURE__*/React.createElement("path", {
    d: "M20 83v1h-1v-1z",
    fill: "#6190a7"
  })), _path4545 || (_path4545 = /*#__PURE__*/React.createElement("path", {
    d: "M20 84v-1h1v1z",
    fill: "#6caccf"
  })), _path4546 || (_path4546 = /*#__PURE__*/React.createElement("path", {
    d: "M22 83v1h-1v-1z",
    fill: "#6da7d6"
  })), _path4547 || (_path4547 = /*#__PURE__*/React.createElement("path", {
    d: "M23 83v1h-1v-1z",
    fill: "#52809f"
  })), _path4548 || (_path4548 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v-1h1v1z",
    fill: "#a4c2c6"
  })), _path4549 || (_path4549 = /*#__PURE__*/React.createElement("path", {
    d: "M24 83h1v1h-1z",
    fill: "#e6f0de"
  })), _path4550 || (_path4550 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84h-1v-1h1z",
    fill: "#f1f7db"
  })), _path4551 || (_path4551 = /*#__PURE__*/React.createElement("path", {
    d: "M27 83v1h-1v-1z",
    fill: "#f4f6ec"
  })), _path4552 || (_path4552 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v1h-1v-1z",
    fill: "#9cbcd9"
  })), _path4553 || (_path4553 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84h-1v-1h1z",
    fill: "#bad9a6"
  })), _path4554 || (_path4554 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83v1h-1v-1z",
    fill: "#f8f00f"
  })), _path4555 || (_path4555 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83h1v1h-1z",
    fill: "#fff602"
  })), _path4556 || (_path4556 = /*#__PURE__*/React.createElement("path", {
    d: "M32 83v1h-1v-1z",
    fill: "#edea15"
  })), _path4557 || (_path4557 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84v-1h1v1z",
    fill: "#bfc726"
  })), _path4558 || (_path4558 = /*#__PURE__*/React.createElement("path", {
    d: "M33 84v-1h1v1z",
    fill: "#acb325"
  })), _path4559 || (_path4559 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h-1v-1h1z",
    fill: "#c2c724"
  })), _path4560 || (_path4560 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84v-1h1v1z",
    fill: "#e0e319"
  })), _path4561 || (_path4561 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84h-1v-1h1z",
    fill: "#fff811"
  })), _path4562 || (_path4562 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84v-1h1v1z",
    fill: "#fff819"
  })), _path4563 || (_path4563 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v-1h1v1z",
    fill: "#d1d827"
  })), _path4564 || (_path4564 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84v-1h1v1z",
    fill: "#94a127"
  })), _path4565 || (_path4565 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h-1v-1h1z",
    fill: "#a9b330"
  })), _path4566 || (_path4566 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83v1h-1v-1z",
    fill: "#aca928"
  })), _path4567 || (_path4567 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83h1v1h-1z",
    fill: "#b08d18"
  })), _path4568 || (_path4568 = /*#__PURE__*/React.createElement("path", {
    d: "M44 84h-1v-1h1z",
    fill: "#ebac0e"
  })), _path4569 || (_path4569 = /*#__PURE__*/React.createElement("path", {
    d: "M45 84h-1v-1h1z",
    fill: "#faac06"
  })), _path4570 || (_path4570 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83h1v1h-1z",
    fill: "#fab102"
  })), _path4571 || (_path4571 = /*#__PURE__*/React.createElement("path", {
    d: "M46 84v-1h1v1z",
    fill: "#fdb102"
  })), _path4572 || (_path4572 = /*#__PURE__*/React.createElement("path", {
    d: "M47 84v-1h1v1z",
    fill: "#feb201"
  })), _path4573 || (_path4573 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v-1h1v1z",
    fill: "#eead03"
  })), _path4574 || (_path4574 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83h1v1h-1z",
    fill: "#e9b95a"
  })), _path4575 || (_path4575 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83h1v1h-1z",
    fill: "#ecc581"
  })), _path4576 || (_path4576 = /*#__PURE__*/React.createElement("path", {
    d: "M51 83h1v1h-1z",
    fill: "#efb54d"
  })), _path4577 || (_path4577 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83h1v1h-1z",
    fill: "#eaa62a"
  })), _path4578 || (_path4578 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v-1h1v1z",
    fill: "#e5a32a"
  })), _path4579 || (_path4579 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1z",
    fill: "#d39223"
  })), _path4580 || (_path4580 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84v-1h1v1z",
    fill: "#d19123"
  })), _path4581 || (_path4581 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84v-1h1v1z",
    fill: "#c38320"
  })), _path4582 || (_path4582 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83v1h-1v-1z",
    fill: "#b5751e"
  })), _path4583 || (_path4583 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83v1h-1v-1z",
    fill: "#bc7c22"
  })), _path4584 || (_path4584 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83h1v1h-1z",
    fill: "#bf7f1d"
  })), _path4585 || (_path4585 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1z",
    fill: "#bb7e25"
  })), _path4586 || (_path4586 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84h-1v-1h1z",
    fill: "#a06929"
  })), _path4587 || (_path4587 = /*#__PURE__*/React.createElement("path", {
    d: "M62 83h1v1h-1z",
    fill: "#835530"
  })), _path4588 || (_path4588 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83h1v1h-1z",
    fill: "#cfbdb8"
  })), _path4589 || (_path4589 = /*#__PURE__*/React.createElement("path", {
    d: "M65 84h-1v-1h1z",
    fill: "#d8dbda"
  })), _path4590 || (_path4590 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1z",
    fill: "#e0e2e1",
    fillOpacity: 0.976
  })), _path4591 || (_path4591 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85h-1v-1h1z",
    fill: "#80745f",
    fillOpacity: 0.482
  })), _path4592 || (_path4592 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85v-1h1v1z",
    fill: "#7e8b8e"
  })), _path4593 || (_path4593 = /*#__PURE__*/React.createElement("path", {
    d: "M20 84h1v1h-1z",
    fill: "#6da5ca"
  })), _path4594 || (_path4594 = /*#__PURE__*/React.createElement("path", {
    d: "M21 84h1v1h-1z",
    fill: "#81b9e0"
  })), _path4595 || (_path4595 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v1h-1v-1z",
    fill: "#74abdd"
  })), _path4596 || (_path4596 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84h1v1h-1z",
    fill: "#4e8ab5"
  })), _path4597 || (_path4597 = /*#__PURE__*/React.createElement("path", {
    d: "M25 84v1h-1v-1z",
    fill: "#5f91ae"
  })), _path4598 || (_path4598 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84v1h-1v-1z",
    fill: "#9abeca"
  })), _path4599 || (_path4599 = /*#__PURE__*/React.createElement("path", {
    d: "M26 85v-1h1v1z",
    fill: "#d5e5ec"
  })), _path4600 || (_path4600 = /*#__PURE__*/React.createElement("path", {
    d: "M28 84v1h-1v-1z",
    fill: "#97bbd9"
  })), _path4601 || (_path4601 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84v1h-1v-1z",
    fill: "#b9d9a5"
  })), _path4602 || (_path4602 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84v1h-1v-1z",
    fill: "#f6ed13"
  })), _path4603 || (_path4603 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84h1v1h-1z",
    fill: "#fff401"
  })), _path4604 || (_path4604 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85h-1v-1h1z",
    fill: "#f4ea0d"
  })), _path4605 || (_path4605 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84h1v1h-1z",
    fill: "#d0cd16"
  })), _path4606 || (_path4606 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84v1h-1v-1z",
    fill: "#e6e013"
  })), _path4607 || (_path4607 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84h1v1h-1z",
    fill: "#fef912"
  })), _path4608 || (_path4608 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h1v1h-1z",
    fill: "#e9e917"
  })), _path4609 || (_path4609 = /*#__PURE__*/React.createElement("path", {
    d: "M36 85v-1h1v1z",
    fill: "#a3b329"
  })), _path4610 || (_path4610 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v1h-1v-1z",
    fill: "#516d4a"
  })), _path4611 || (_path4611 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84h1v1h-1z",
    fill: "#0c305a"
  })), _path4612 || (_path4612 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84h1v1h-1z",
    fill: "#002076"
  })), _path4613 || (_path4613 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84v1h-1v-1z",
    fill: "#0b2f72"
  })), _path4614 || (_path4614 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h1v1h-1z",
    fill: "#6f8c5a"
  })), _path4615 || (_path4615 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84v1h-1v-1z",
    fill: "#bdc045"
  })), _path4616 || (_path4616 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84h1v1h-1z",
    fill: "#c79e19"
  })), _path4617 || (_path4617 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85h-1v-1h1z",
    fill: "#ffb607"
  })), _path4618 || (_path4618 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85h-1v-1h1z",
    fill: "#ffb304"
  })), _path4619 || (_path4619 = /*#__PURE__*/React.createElement("path", {
    d: "M47 85h-1v-1h1z",
    fill: "#feb401"
  })), _path4620 || (_path4620 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v1h-1v-1z",
    fill: "#ffb501"
  })), _path4621 || (_path4621 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85v-1h1v1z",
    fill: "#f3af0d"
  })), _path4622 || (_path4622 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85h-1v-1h1z",
    fill: "#eeb94d"
  })), _path4623 || (_path4623 = /*#__PURE__*/React.createElement("path", {
    d: "M50 84h1v1h-1z",
    fill: "#f0c05d"
  })), _path4624 || (_path4624 = /*#__PURE__*/React.createElement("path", {
    d: "M51 84h1v1h-1z",
    fill: "#edae3f"
  })), _path4625 || (_path4625 = /*#__PURE__*/React.createElement("path", {
    d: "M53 85h-1v-1h1z",
    fill: "#e5a22c"
  })), _path4626 || (_path4626 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84h1v1h-1z",
    fill: "#dd9f27"
  })), _path4627 || (_path4627 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85v-1h1v1z",
    fill: "#cd8d21"
  })), _path4628 || (_path4628 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84h1v1h-1z",
    fill: "#cc8d25"
  })), _path4629 || (_path4629 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84h1v1h-1z",
    fill: "#b8781a"
  })), _path4630 || (_path4630 = /*#__PURE__*/React.createElement("path", {
    d: "M58 84v1h-1v-1z",
    fill: "#b57723"
  })), _path4631 || (_path4631 = /*#__PURE__*/React.createElement("path", {
    d: "M59 85h-1v-1h1z",
    fill: "#af7523"
  })), _path4632 || (_path4632 = /*#__PURE__*/React.createElement("path", {
    d: "M60 85h-1v-1h1z",
    fill: "#b37828"
  })), _path4633 || (_path4633 = /*#__PURE__*/React.createElement("path", {
    d: "M61 85h-1v-1h1z",
    fill: "#a56e27"
  })), _path4634 || (_path4634 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84v1h-1v-1z",
    fill: "#8f5f2a"
  })), _path4635 || (_path4635 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85v-1h1v1z",
    fill: "#7a502d"
  })), _path4636 || (_path4636 = /*#__PURE__*/React.createElement("path", {
    d: "M63 85v-1h1v1z",
    fill: "#c7b5b0"
  })), _path4637 || (_path4637 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v-1h1v1z",
    fill: "#dde3dd",
    fillOpacity: 0.18
  })), _path4638 || (_path4638 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85v1h-1v-1z",
    fill: "#806b52",
    fillOpacity: 0.475
  })), _path4639 || (_path4639 = /*#__PURE__*/React.createElement("path", {
    d: "M20 86h-1v-1h1z",
    fill: "#918879"
  })), _path4640 || (_path4640 = /*#__PURE__*/React.createElement("path", {
    d: "M20 85h1v1h-1z",
    fill: "#749ab4"
  })), _path4641 || (_path4641 = /*#__PURE__*/React.createElement("path", {
    d: "M21 86v-1h1v1z",
    fill: "#7cb4d8"
  })), _path4642 || (_path4642 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86h-1v-1h1z",
    fill: "#7eb3dd"
  })), _path4643 || (_path4643 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86v-1h1v1z",
    fill: "#85bce9"
  })), _path4644 || (_path4644 = /*#__PURE__*/React.createElement("path", {
    d: "M24 86v-1h1v1z",
    fill: "#82bee6"
  })), _path4645 || (_path4645 = /*#__PURE__*/React.createElement("path", {
    d: "M25 85h1v1h-1z",
    fill: "#72aad0"
  })), _path4646 || (_path4646 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h-1v-1h1z",
    fill: "#82aed2"
  })), _path4647 || (_path4647 = /*#__PURE__*/React.createElement("path", {
    d: "M27 85h1v1h-1z",
    fill: "#8ebadc"
  })), _path4648 || (_path4648 = /*#__PURE__*/React.createElement("path", {
    d: "M28 86v-1h1v1z",
    fill: "#bddda6"
  })), _path4649 || (_path4649 = /*#__PURE__*/React.createElement("path", {
    d: "M30 85v1h-1v-1z",
    fill: "#f3ed14"
  })), _path4650 || (_path4650 = /*#__PURE__*/React.createElement("path", {
    d: "M30 86v-1h1v1z",
    fill: "#fff302"
  })), _path4651 || (_path4651 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85v1h-1v-1z",
    fill: "#fdf105"
  })), _path4652 || (_path4652 = /*#__PURE__*/React.createElement("path", {
    d: "M33 85v1h-1v-1z",
    fill: "#fff708"
  })), _path4653 || (_path4653 = /*#__PURE__*/React.createElement("path", {
    d: "M34 86h-1v-1h1z",
    fill: "#eded1e"
  })), _path4654 || (_path4654 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h-1v-1h1z",
    fill: "#bac239"
  })), _path4655 || (_path4655 = /*#__PURE__*/React.createElement("path", {
    d: "M35 85h1v1h-1z",
    fill: "#94ab74"
  })), _path4656 || (_path4656 = /*#__PURE__*/React.createElement("path", {
    d: "M37 86h-1v-1h1z",
    fill: "#426485"
  })), _path4657 || (_path4657 = /*#__PURE__*/React.createElement("path", {
    d: "M38 85v1h-1v-1z",
    fill: "#00268c"
  })), _path4658 || (_path4658 = /*#__PURE__*/React.createElement("path", {
    d: "M38 86v-1h1v1z",
    fill: "#5f82c0"
  })), _path4659 || (_path4659 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86h-1v-1h1z",
    fill: "#87a6ce"
  })), _path4660 || (_path4660 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v1z",
    fill: "#769dd1"
  })), _path4661 || (_path4661 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#072b8a"
  })), _path4662 || (_path4662 = /*#__PURE__*/React.createElement("path", {
    d: "M43 86h-1v-1h1z",
    fill: "#63825f"
  })), _path4663 || (_path4663 = /*#__PURE__*/React.createElement("path", {
    d: "M44 86h-1v-1h1z",
    fill: "#c1b540"
  })), _path4664 || (_path4664 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85v1h-1v-1z",
    fill: "#e0a611"
  })), _path4665 || (_path4665 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85v1h-1v-1z",
    fill: "#ffb406"
  })), _path4666 || (_path4666 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h-1v-1h1z",
    fill: "#ffb302"
  })), _path4667 || (_path4667 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-1h1z",
    fill: "#f7b105"
  })), _path4668 || (_path4668 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85h1v1h-1z",
    fill: "#e9ab26"
  })), _path4669 || (_path4669 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85v1h-1v-1z",
    fill: "#efbb59"
  })), _path4670 || (_path4670 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h-1v-1h1z",
    fill: "#ecba4f"
  })), _path4671 || (_path4671 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86v-1h1v1z",
    fill: "#e2a72f"
  })), _path4672 || (_path4672 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86v-1h1v1z",
    fill: "#e3a42b"
  })), _path4673 || (_path4673 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86h-1v-1h1z",
    fill: "#c98c1d"
  })), _path4674 || (_path4674 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85h1v1h-1z",
    fill: "#c48622"
  })), _path4675 || (_path4675 = /*#__PURE__*/React.createElement("path", {
    d: "M55 85h1v1h-1z",
    fill: "#bf7e26"
  })), _path4676 || (_path4676 = /*#__PURE__*/React.createElement("path", {
    d: "M57 85v1h-1v-1z",
    fill: "#b2721a"
  })), _path4677 || (_path4677 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#ba7f2c"
  })), _path4678 || (_path4678 = /*#__PURE__*/React.createElement("path", {
    d: "M58 85h1v1h-1z",
    fill: "#9f641d"
  })), _path4679 || (_path4679 = /*#__PURE__*/React.createElement("path", {
    d: "M59 86v-1h1v1z",
    fill: "#a36b27"
  })), _path4680 || (_path4680 = /*#__PURE__*/React.createElement("path", {
    d: "M61 86h-1v-1h1z",
    fill: "#885720"
  })), _path4681 || (_path4681 = /*#__PURE__*/React.createElement("path", {
    d: "M62 86h-1v-1h1z",
    fill: "#7f512d"
  })), _path4682 || (_path4682 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85h1v1h-1z",
    fill: "#784e30"
  })), _path4683 || (_path4683 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v1h-1v-1z",
    fill: "#c5b4af"
  })), _path4684 || (_path4684 = /*#__PURE__*/React.createElement("path", {
    d: "M78 86h-1v-1h1z",
    fill: "#ddd",
    fillOpacity: 0.18
  })), _path4685 || (_path4685 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87h-1v-1h1z",
    fill: "#7f6a54",
    fillOpacity: 0.486
  })), _path4686 || (_path4686 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87v-1h1v1z",
    fill: "#947c61"
  })), _path4687 || (_path4687 = /*#__PURE__*/React.createElement("path", {
    d: "M21 86v1h-1v-1z",
    fill: "#8f9087"
  })), _path4688 || (_path4688 = /*#__PURE__*/React.createElement("path", {
    d: "M22 87h-1v-1h1z",
    fill: "#87acc3"
  })), _path4689 || (_path4689 = /*#__PURE__*/React.createElement("path", {
    d: "M22 86h1v1h-1z",
    fill: "#7cb3e2"
  })), _path4690 || (_path4690 = /*#__PURE__*/React.createElement("path", {
    d: "M24 87h-1v-1h1z",
    fill: "#88bae5"
  })), _path4691 || (_path4691 = /*#__PURE__*/React.createElement("path", {
    d: "M25 86v1h-1v-1z",
    fill: "#a3cdef"
  })), _path4692 || (_path4692 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87h-1v-1h1z",
    fill: "#a5d0f4"
  })), _path4693 || (_path4693 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87v-1h1v1z",
    fill: "#b9dffc"
  })), _path4694 || (_path4694 = /*#__PURE__*/React.createElement("path", {
    d: "M29 87h-1v-1h1z",
    fill: "#c0d9a6"
  })), _path4695 || (_path4695 = /*#__PURE__*/React.createElement("path", {
    d: "M29 86h1v1h-1z",
    fill: "#f6ee12"
  })), _path4696 || (_path4696 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87h-1v-1h1z",
    fill: "#fff60a"
  })), _path4697 || (_path4697 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87v-1h1v1z",
    fill: "#f8f00e"
  })), _path4698 || (_path4698 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86v1h-1v-1z",
    fill: "#c5cd23"
  })), _path4699 || (_path4699 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86h1v1h-1z",
    fill: "#315544"
  })), _path4700 || (_path4700 = /*#__PURE__*/React.createElement("path", {
    d: "M34 87v-1h1v1z",
    fill: "#6c90aa"
  })), _path4701 || (_path4701 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h1v1h-1z",
    fill: "#5d78b3"
  })), _path4702 || (_path4702 = /*#__PURE__*/React.createElement("path", {
    d: "M36 87v-1h1v1z",
    fill: "#a9c6e7"
  })), _path4703 || (_path4703 = /*#__PURE__*/React.createElement("path", {
    d: "M38 87h-1v-1h1z",
    fill: "#4365a6"
  })), _path4704 || (_path4704 = /*#__PURE__*/React.createElement("path", {
    d: "M39 87h-1v-1h1z",
    fill: "#8faac2"
  })), _path4705 || (_path4705 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v1h-1v-1z",
    fill: "#496a9b"
  })), _path4706 || (_path4706 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86v1h-1v-1z",
    fill: "#204a9f"
  })), _path4707 || (_path4707 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1z",
    fill: "#012aac"
  })), _path4708 || (_path4708 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#052888"
  })), _path4709 || (_path4709 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v-1h1v1z",
    fill: "#9bac5a"
  })), _path4710 || (_path4710 = /*#__PURE__*/React.createElement("path", {
    d: "M44 87v-1h1v1z",
    fill: "#c19f23"
  })), _path4711 || (_path4711 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v-1h1v1z",
    fill: "#fdb40c"
  })), _path4712 || (_path4712 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v1z",
    fill: "#f8b203"
  })), _path4713 || (_path4713 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86v1h-1v-1z",
    fill: "#e2ac25"
  })), _path4714 || (_path4714 = /*#__PURE__*/React.createElement("path", {
    d: "M49 86v1h-1v-1z",
    fill: "#ecb955"
  })), _path4715 || (_path4715 = /*#__PURE__*/React.createElement("path", {
    d: "M50 86h1v1h-1z",
    fill: "#ecae3d"
  })), _path4716 || (_path4716 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h1v1h-1z",
    fill: "#edb037"
  })), _path4717 || (_path4717 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86h1v1h-1z",
    fill: "#d49822"
  })), _path4718 || (_path4718 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86v1h-1v-1z",
    fill: "#c0821b"
  })), _path4719 || (_path4719 = /*#__PURE__*/React.createElement("path", {
    d: "M55 86v1h-1v-1z",
    fill: "#bc7a25"
  })), _path4720 || (_path4720 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87v-1h1v1z",
    fill: "#ab691a"
  })), _path4721 || (_path4721 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87h-1v-1h1z",
    fill: "#bb7c27"
  })), _path4722 || (_path4722 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86v1h-1v-1z",
    fill: "#a66c22"
  })), _path4723 || (_path4723 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86h1v1h-1z",
    fill: "#9d6428"
  })), _path4724 || (_path4724 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87v-1h1v1z",
    fill: "#8b5825"
  })), _path4725 || (_path4725 = /*#__PURE__*/React.createElement("path", {
    d: "M60 87v-1h1v1z",
    fill: "#764b25"
  })), _path4726 || (_path4726 = /*#__PURE__*/React.createElement("path", {
    d: "M62 87h-1v-1h1z",
    fill: "#754c31"
  })), _path4727 || (_path4727 = /*#__PURE__*/React.createElement("path", {
    d: "M63 86v1h-1v-1z",
    fill: "#724931"
  })), _path4728 || (_path4728 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#c5b3af"
  })), _path4729 || (_path4729 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87v1h-1v-1z",
    fill: "#7d6f5b",
    fillOpacity: 0.494
  })), _path4730 || (_path4730 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87h1v1h-1z",
    fill: "#81694d"
  })), _path4731 || (_path4731 = /*#__PURE__*/React.createElement("path", {
    d: "M20 87h1v1h-1z",
    fill: "#957b5c"
  })), _path4732 || (_path4732 = /*#__PURE__*/React.createElement("path", {
    d: "M21 88v-1h1v1z",
    fill: "#959692"
  })), _path4733 || (_path4733 = /*#__PURE__*/React.createElement("path", {
    d: "M22 87h1v1h-1z",
    fill: "#81b2d8"
  })), _path4734 || (_path4734 = /*#__PURE__*/React.createElement("path", {
    d: "M24 87v1h-1v-1z",
    fill: "#8abce7"
  })), _path4735 || (_path4735 = /*#__PURE__*/React.createElement("path", {
    d: "M25 88h-1v-1h1z",
    fill: "#a3cbf0"
  })), _path4736 || (_path4736 = /*#__PURE__*/React.createElement("path", {
    d: "M25 87h1v1h-1z",
    fill: "#9dc8ef"
  })), _path4737 || (_path4737 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88h-1v-1h1z",
    fill: "#b8ddf8"
  })), _path4738 || (_path4738 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88v-1h1v1z",
    fill: "#bed9ab"
  })), _path4739 || (_path4739 = /*#__PURE__*/React.createElement("path", {
    d: "M30 88h-1v-1h1z",
    fill: "#ece51f"
  })), _path4740 || (_path4740 = /*#__PURE__*/React.createElement("path", {
    d: "M31 88h-1v-1h1z",
    fill: "#cbbe0e"
  })), _path4741 || (_path4741 = /*#__PURE__*/React.createElement("path", {
    d: "M32 88h-1v-1h1z",
    fill: "#aba325"
  })), _path4742 || (_path4742 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88h-1v-1h1z",
    fill: "#5d7b4f"
  })), _path4743 || (_path4743 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88v-1h1v1z",
    fill: "#002998"
  })), _path4744 || (_path4744 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88h-1v-1h1z",
    fill: "#1748b3"
  })), _path4745 || (_path4745 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v-1h1v1z",
    fill: "#00259a"
  })), _path4746 || (_path4746 = /*#__PURE__*/React.createElement("path", {
    d: "M36 88v-1h1v1z",
    fill: "#8cadda"
  })), _path4747 || (_path4747 = /*#__PURE__*/React.createElement("path", {
    d: "M37 87h1v1h-1z",
    fill: "#587aa6"
  })), _path4748 || (_path4748 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88v-1h1v1z",
    fill: "#8ea8c8"
  })), _path4749 || (_path4749 = /*#__PURE__*/React.createElement("path", {
    d: "M40 88h-1v-1h1z",
    fill: "#9cb5ce"
  })), _path4750 || (_path4750 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v1h-1v-1z",
    fill: "#94b4da"
  })), _path4751 || (_path4751 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v1h-1v-1z",
    fill: "#1339a6"
  })), _path4752 || (_path4752 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v1h-1v-1z",
    fill: "#0022a8"
  })), _path4753 || (_path4753 = /*#__PURE__*/React.createElement("path", {
    d: "M43 88v-1h1v1z",
    fill: "#4a696a"
  })), _path4754 || (_path4754 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v1h-1v-1z",
    fill: "#beb336"
  })), _path4755 || (_path4755 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-1h1v1z",
    fill: "#e1a814"
  })), _path4756 || (_path4756 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h-1v-1h1z",
    fill: "#e4ae26"
  })), _path4757 || (_path4757 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88h-1v-1h1z",
    fill: "#efbe60"
  })), _path4758 || (_path4758 = /*#__PURE__*/React.createElement("path", {
    d: "M49 88h-1v-1h1z",
    fill: "#edb54a"
  })), _path4759 || (_path4759 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87v1h-1v-1z",
    fill: "#efae3d"
  })), _path4760 || (_path4760 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88v-1h1v1z",
    fill: "#eaac3a"
  })), _path4761 || (_path4761 = /*#__PURE__*/React.createElement("path", {
    d: "M51 87h1v1h-1z",
    fill: "#d99f29"
  })), _path4762 || (_path4762 = /*#__PURE__*/React.createElement("path", {
    d: "M53 87v1h-1v-1z",
    fill: "#cf9527"
  })), _path4763 || (_path4763 = /*#__PURE__*/React.createElement("path", {
    d: "M53 88v-1h1v1z",
    fill: "#af7117"
  })), _path4764 || (_path4764 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88h-1v-1h1z",
    fill: "#ab681e"
  })), _path4765 || (_path4765 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87h1v1h-1z",
    fill: "#af6f1f"
  })), _path4766 || (_path4766 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87v1h-1v-1z",
    fill: "#aa6f26"
  })), _path4767 || (_path4767 = /*#__PURE__*/React.createElement("path", {
    d: "M57 88v-1h1v1z",
    fill: "#915d24"
  })), _path4768 || (_path4768 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88h-1v-1h1z",
    fill: "#936130"
  })), _path4769 || (_path4769 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87h1v1h-1z",
    fill: "#7a4d27"
  })), _path4770 || (_path4770 = /*#__PURE__*/React.createElement("path", {
    d: "M60 88v-1h1v1z",
    fill: "#6b462a"
  })), _path4771 || (_path4771 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87h1v1h-1z",
    fill: "#69492d"
  })), _path4772 || (_path4772 = /*#__PURE__*/React.createElement("path", {
    d: "M62 88v-1h1v1z",
    fill: "#6d4935"
  })), _path4773 || (_path4773 = /*#__PURE__*/React.createElement("path", {
    d: "M64 87v1h-1v-1z",
    fill: "#c6b5b1"
  })), _path4774 || (_path4774 = /*#__PURE__*/React.createElement("path", {
    d: "M64 88v-1h1v1z",
    fill: "#d3d5d5"
  })), _path4775 || (_path4775 = /*#__PURE__*/React.createElement("path", {
    d: "M18 89v-1h1v1z",
    fill: "#7f6d61",
    fillOpacity: 0.494
  })), _path4776 || (_path4776 = /*#__PURE__*/React.createElement("path", {
    d: "M20 88v1h-1v-1z",
    fill: "#7d6450"
  })), _path4777 || (_path4777 = /*#__PURE__*/React.createElement("path", {
    d: "M20 88h1v1h-1z",
    fill: "#8a694c"
  })), _path4778 || (_path4778 = /*#__PURE__*/React.createElement("path", {
    d: "M21 89v-1h1v1z",
    fill: "#a0856a"
  })), _path4779 || (_path4779 = /*#__PURE__*/React.createElement("path", {
    d: "M23 88v1h-1v-1z",
    fill: "#8aa3b0"
  })), _path4780 || (_path4780 = /*#__PURE__*/React.createElement("path", {
    d: "M24 89h-1v-1h1z",
    fill: "#93bde1"
  })), _path4781 || (_path4781 = /*#__PURE__*/React.createElement("path", {
    d: "M25 89h-1v-1h1z",
    fill: "#97c4ee"
  })), _path4782 || (_path4782 = /*#__PURE__*/React.createElement("path", {
    d: "M26 89h-1v-1h1z",
    fill: "#95c7ee"
  })), _path4783 || (_path4783 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88v1h-1v-1z",
    fill: "#b6dbf9"
  })), _path4784 || (_path4784 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88v1h-1v-1z",
    fill: "#bedffd"
  })), _path4785 || (_path4785 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88h1v1h-1z",
    fill: "#a5c6ba"
  })), _path4786 || (_path4786 = /*#__PURE__*/React.createElement("path", {
    d: "M30 88v1h-1v-1z",
    fill: "#b2a662"
  })), _path4787 || (_path4787 = /*#__PURE__*/React.createElement("path", {
    d: "M30 89v-1h1v1z",
    fill: "#8d7b43"
  })), _path4788 || (_path4788 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v-1h1v1z",
    fill: "#a7ab49"
  })), _path4789 || (_path4789 = /*#__PURE__*/React.createElement("path", {
    d: "M32 89v-1h1v1z",
    fill: "#2c546c"
  })), _path4790 || (_path4790 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v1h-1v-1z",
    fill: "#0027b7"
  })), _path4791 || (_path4791 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89h-1v-1h1z",
    fill: "#143ba3"
  })), _path4792 || (_path4792 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v-1h1v1z",
    fill: "#9cbad8"
  })), _path4793 || (_path4793 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v-1h1v1z",
    fill: "#1f3d9c"
  })), _path4794 || (_path4794 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88v1h-1v-1z",
    fill: "#1235a7"
  })), _path4795 || (_path4795 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88h1v1h-1z",
    fill: "#0e2e92"
  })), _path4796 || (_path4796 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h-1v-1h1z",
    fill: "#b1cce0"
  })), _path4797 || (_path4797 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89h-1v-1h1z",
    fill: "#3d60ac"
  })), _path4798 || (_path4798 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#0021ae"
  })), _path4799 || (_path4799 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88v1h-1v-1z",
    fill: "#1a407c"
  })), _path4800 || (_path4800 = /*#__PURE__*/React.createElement("path", {
    d: "M45 89h-1v-1h1z",
    fill: "#b1b547"
  })), _path4801 || (_path4801 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88h1v1h-1z",
    fill: "#bf9c2e"
  })), _path4802 || (_path4802 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88v1h-1v-1z",
    fill: "#f2bd5a"
  })), _path4803 || (_path4803 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h1v1h-1z",
    fill: "#f2b754"
  })), _path4804 || (_path4804 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v-1h1v1z",
    fill: "#e6a838"
  })), _path4805 || (_path4805 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89v-1h1v1z",
    fill: "#e9ad3f"
  })), _path4806 || (_path4806 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88v1h-1v-1z",
    fill: "#e2ac40"
  })), _path4807 || (_path4807 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88h1v1h-1z",
    fill: "#d29e2d"
  })), _path4808 || (_path4808 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h-1v-1h1z",
    fill: "#ce952e"
  })), _path4809 || (_path4809 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v-1h1v1z",
    fill: "#c98f30"
  })), _path4810 || (_path4810 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89h-1v-1h1z",
    fill: "#d3973c"
  })), _path4811 || (_path4811 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h-1v-1h1z",
    fill: "#c8902f"
  })), _path4812 || (_path4812 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89v-1h1v1z",
    fill: "#9f6c23"
  })), _path4813 || (_path4813 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89h-1v-1h1z",
    fill: "#7f5021"
  })), _path4814 || (_path4814 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88v1h-1v-1z",
    fill: "#85562d"
  })), _path4815 || (_path4815 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v-1h1v1z",
    fill: "#7a4f2d"
  })), _path4816 || (_path4816 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v-1h1v1z",
    fill: "#6e4b2f"
  })), _path4817 || (_path4817 = /*#__PURE__*/React.createElement("path", {
    d: "M62 89h-1v-1h1z",
    fill: "#604324"
  })), _path4818 || (_path4818 = /*#__PURE__*/React.createElement("path", {
    d: "M63 89h-1v-1h1z",
    fill: "#654835"
  })), _path4819 || (_path4819 = /*#__PURE__*/React.createElement("path", {
    d: "M63 88h1v1h-1z",
    fill: "#c6bbb6"
  })), _path4820 || (_path4820 = /*#__PURE__*/React.createElement("path", {
    d: "M66 88v1h-1v-1z",
    fill: "#c8cac9"
  })), _path4821 || (_path4821 = /*#__PURE__*/React.createElement("path", {
    d: "M68 88v1h-1v-1z",
    fill: "#c9cbcb"
  })), _path4822 || (_path4822 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v-1h1v1z",
    fill: "#e2e7e7",
    fillOpacity: 0.173
  })), _path4823 || (_path4823 = /*#__PURE__*/React.createElement("path", {
    d: "M19 89v1h-1v-1z",
    fill: "#816f5e",
    fillOpacity: 0.486
  })), _path4824 || (_path4824 = /*#__PURE__*/React.createElement("path", {
    d: "M19 90v-1h1v1z",
    fill: "#856b4e"
  })), _path4825 || (_path4825 = /*#__PURE__*/React.createElement("path", {
    d: "M21 89v1h-1v-1z",
    fill: "#927655"
  })), _path4826 || (_path4826 = /*#__PURE__*/React.createElement("path", {
    d: "M22 90v-1h1v1z",
    fill: "#a58e75"
  })), _path4827 || (_path4827 = /*#__PURE__*/React.createElement("path", {
    d: "M24 89v1h-1v-1z",
    fill: "#b0a99b"
  })), _path4828 || (_path4828 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90v-1h1v1z",
    fill: "#9ab3c1"
  })), _path4829 || (_path4829 = /*#__PURE__*/React.createElement("path", {
    d: "M26 89v1h-1v-1z",
    fill: "#92bee1"
  })), _path4830 || (_path4830 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90v-1h1v1z",
    fill: "#b1d8f9"
  })), _path4831 || (_path4831 = /*#__PURE__*/React.createElement("path", {
    d: "M28 90h-1v-1h1z",
    fill: "#b8dcfe"
  })), _path4832 || (_path4832 = /*#__PURE__*/React.createElement("path", {
    d: "M29 89v1h-1v-1z",
    fill: "#9fc2df"
  })), _path4833 || (_path4833 = /*#__PURE__*/React.createElement("path", {
    d: "M29 89h1v1h-1z",
    fill: "#c7ccda"
  })), _path4834 || (_path4834 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v1h-1v-1z",
    fill: "#b3b69d"
  })), _path4835 || (_path4835 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89h1v1h-1z",
    fill: "#a0b552"
  })), _path4836 || (_path4836 = /*#__PURE__*/React.createElement("path", {
    d: "M33 90h-1v-1h1z",
    fill: "#0f3882"
  })), _path4837 || (_path4837 = /*#__PURE__*/React.createElement("path", {
    d: "M34 90h-1v-1h1z",
    fill: "#002ab2"
  })), _path4838 || (_path4838 = /*#__PURE__*/React.createElement("path", {
    d: "M34 89h1v1h-1z",
    fill: "#062aa2"
  })), _path4839 || (_path4839 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v1h-1v-1z",
    fill: "#6c8cba"
  })), _path4840 || (_path4840 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v1h-1v-1z",
    fill: "#4a689c"
  })), _path4841 || (_path4841 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90h-1v-1h1z",
    fill: "#0826a0"
  })), _path4842 || (_path4842 = /*#__PURE__*/React.createElement("path", {
    d: "M38 89h1v1h-1z",
    fill: "#0021a7"
  })), _path4843 || (_path4843 = /*#__PURE__*/React.createElement("path", {
    d: "M40 89v1h-1v-1z",
    fill: "#2647a7"
  })), _path4844 || (_path4844 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90v-1h1v1z",
    fill: "#9cb8d6"
  })), _path4845 || (_path4845 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h1v1h-1z",
    fill: "#193a9f"
  })), _path4846 || (_path4846 = /*#__PURE__*/React.createElement("path", {
    d: "M43 90h-1v-1h1z",
    fill: "#0124b4"
  })), _path4847 || (_path4847 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1z",
    fill: "#0e3584"
  })), _path4848 || (_path4848 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h-1v-1h1z",
    fill: "#aab24c"
  })), _path4849 || (_path4849 = /*#__PURE__*/React.createElement("path", {
    d: "M46 89v1h-1v-1z",
    fill: "#cda543"
  })), _path4850 || (_path4850 = /*#__PURE__*/React.createElement("path", {
    d: "M47 89v1h-1v-1z",
    fill: "#f4ba53"
  })), _path4851 || (_path4851 = /*#__PURE__*/React.createElement("path", {
    d: "M48 90v-1h1v1z",
    fill: "#db9e36"
  })), _path4852 || (_path4852 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89h1v1h-1z",
    fill: "#de9f33"
  })), _path4853 || (_path4853 = /*#__PURE__*/React.createElement("path", {
    d: "M50 89h1v1h-1z",
    fill: "#eaae36"
  })), _path4854 || (_path4854 = /*#__PURE__*/React.createElement("path", {
    d: "M52 90h-1v-1h1z",
    fill: "#ecb132"
  })), _path4855 || (_path4855 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v1h-1v-1z",
    fill: "#ecb131"
  })), _path4856 || (_path4856 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h1v1h-1z",
    fill: "#f8be42"
  })), _path4857 || (_path4857 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89v1h-1v-1z",
    fill: "#f8be49"
  })), _path4858 || (_path4858 = /*#__PURE__*/React.createElement("path", {
    d: "M55 90v-1h1v1z",
    fill: "#f4bc4e"
  })), _path4859 || (_path4859 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h1v1h-1z",
    fill: "#e7b355"
  })), _path4860 || (_path4860 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89v1h-1v-1z",
    fill: "#c59548"
  })), _path4861 || (_path4861 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v1h-1v-1z",
    fill: "#9a6b33"
  })), _path4862 || (_path4862 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v1h-1v-1z",
    fill: "#6f441f"
  })), _path4863 || (_path4863 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90v-1h1v1z",
    fill: "#694526"
  })), _path4864 || (_path4864 = /*#__PURE__*/React.createElement("path", {
    d: "M61 89h1v1h-1z",
    fill: "#63422a"
  })), _path4865 || (_path4865 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h1z",
    fill: "#6d5343"
  })), _path4866 || (_path4866 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v-1h1v1z",
    fill: "#cac3c0"
  })), _path4867 || (_path4867 = /*#__PURE__*/React.createElement("path", {
    d: "M65 89v1h-1v-1z",
    fill: "#c6c8c8"
  })), _path4868 || (_path4868 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89v1h-1v-1z",
    fill: "#c4c6c6"
  })), _path4869 || (_path4869 = /*#__PURE__*/React.createElement("path", {
    d: "M77 90v-1h1v1z",
    fill: "#e2e7e2",
    fillOpacity: 0.173
  })), _path4870 || (_path4870 = /*#__PURE__*/React.createElement("path", {
    d: "M18 91v-1h1v1z",
    fill: "#85755e",
    fillOpacity: 0.478
  })), _path4871 || (_path4871 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91h-1v-1h1z",
    fill: "#927955"
  })), _path4872 || (_path4872 = /*#__PURE__*/React.createElement("path", {
    d: "M21 90v1h-1v-1z",
    fill: "#907454"
  })), _path4873 || (_path4873 = /*#__PURE__*/React.createElement("path", {
    d: "M21 91v-1h1v1z",
    fill: "#846555"
  })), _path4874 || (_path4874 = /*#__PURE__*/React.createElement("path", {
    d: "M22 91v-1h1v1z",
    fill: "#917062"
  })), _path4875 || (_path4875 = /*#__PURE__*/React.createElement("path", {
    d: "M23 91v-1h1v1z",
    fill: "#a38468"
  })), _path4876 || (_path4876 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90h1v1h-1z",
    fill: "#c1aa8f"
  })), _path4877 || (_path4877 = /*#__PURE__*/React.createElement("path", {
    d: "M25 90h1v1h-1z",
    fill: "#b8b3a7"
  })), _path4878 || (_path4878 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90h1v1h-1z",
    fill: "#c5ccd0"
  })), _path4879 || (_path4879 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91v-1h1v1z",
    fill: "#c7d1dc"
  })), _path4880 || (_path4880 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91v-1h1v1z",
    fill: "#bcc3c7"
  })), _path4881 || (_path4881 = /*#__PURE__*/React.createElement("path", {
    d: "M30 90v1h-1v-1z",
    fill: "#d7caa9"
  })), _path4882 || (_path4882 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91v-1h1v1z",
    fill: "#baa64e"
  })), _path4883 || (_path4883 = /*#__PURE__*/React.createElement("path", {
    d: "M31 90h1v1h-1z",
    fill: "#a0b045"
  })), _path4884 || (_path4884 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91v-1h1v1z",
    fill: "#063081"
  })), _path4885 || (_path4885 = /*#__PURE__*/React.createElement("path", {
    d: "M33 91v-1h1v1z",
    fill: "#0021ac"
  })), _path4886 || (_path4886 = /*#__PURE__*/React.createElement("path", {
    d: "M35 90v1h-1v-1z",
    fill: "#567ac1"
  })), _path4887 || (_path4887 = /*#__PURE__*/React.createElement("path", {
    d: "M36 90v1h-1v-1z",
    fill: "#c6dee9"
  })), _path4888 || (_path4888 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90v1h-1v-1z",
    fill: "#a7c2d5"
  })), _path4889 || (_path4889 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90v1h-1v-1z",
    fill: "#4f74ba"
  })), _path4890 || (_path4890 = /*#__PURE__*/React.createElement("path", {
    d: "M38 91v-1h1v1z",
    fill: "#3558a9"
  })), _path4891 || (_path4891 = /*#__PURE__*/React.createElement("path", {
    d: "M39 90h1v1h-1z",
    fill: "#7c9ec3"
  })), _path4892 || (_path4892 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90h1v1h-1z",
    fill: "#28499b"
  })), _path4893 || (_path4893 = /*#__PURE__*/React.createElement("path", {
    d: "M42 91h-1v-1h1z",
    fill: "#001faa"
  })), _path4894 || (_path4894 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#0025b1"
  })), _path4895 || (_path4895 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v-1h1v1z",
    fill: "#143981"
  })), _path4896 || (_path4896 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90h1v1h-1z",
    fill: "#a9b546"
  })), _path4897 || (_path4897 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h1v1h-1z",
    fill: "#cfa343"
  })), _path4898 || (_path4898 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1z",
    fill: "#f5b84a"
  })), _path4899 || (_path4899 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91h-1v-1h1z",
    fill: "#dfa53d"
  })), _path4900 || (_path4900 = /*#__PURE__*/React.createElement("path", {
    d: "M49 90v1h-1v-1z",
    fill: "#c68a2e"
  })), _path4901 || (_path4901 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v-1h1v1z",
    fill: "#c38517"
  })), _path4902 || (_path4902 = /*#__PURE__*/React.createElement("path", {
    d: "M50 91v-1h1v1z",
    fill: "#d5930c"
  })), _path4903 || (_path4903 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v1z",
    fill: "#d59205"
  })), _path4904 || (_path4904 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#d89800"
  })), _path4905 || (_path4905 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90v1h-1v-1z",
    fill: "#e4a314"
  })), _path4906 || (_path4906 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90h1v1h-1z",
    fill: "#eba929"
  })), _path4907 || (_path4907 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91h-1v-1h1z",
    fill: "#ebaa2a"
  })), _path4908 || (_path4908 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#efb133"
  })), _path4909 || (_path4909 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91h-1v-1h1z",
    fill: "#f4bc48"
  })), _path4910 || (_path4910 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v-1h1v1z",
    fill: "#efbb57"
  })), _path4911 || (_path4911 = /*#__PURE__*/React.createElement("path", {
    d: "M59 90h1v1h-1z",
    fill: "#cda155"
  })), _path4912 || (_path4912 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90h1v1h-1z",
    fill: "#8a6731"
  })), _path4913 || (_path4913 = /*#__PURE__*/React.createElement("path", {
    d: "M62 90v1h-1v-1z",
    fill: "#644426"
  })), _path4914 || (_path4914 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v1h-1v-1z",
    fill: "#796054"
  })), _path4915 || (_path4915 = /*#__PURE__*/React.createElement("path", {
    d: "M64 91h-1v-1h1z",
    fill: "#cfccca"
  })), _path4916 || (_path4916 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91h-1v-1h1z",
    fill: "#c7c9cc"
  })), _path4917 || (_path4917 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v-1h1v1z",
    fill: "#c7c8cc"
  })), _path4918 || (_path4918 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v1h-1v-1z",
    fill: "#d1d3d1"
  })), _path4919 || (_path4919 = /*#__PURE__*/React.createElement("path", {
    d: "M19 92h-1v-1h1z",
    fill: "#84735e",
    fillOpacity: 0.475
  })), _path4920 || (_path4920 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91v1h-1v-1z",
    fill: "#8c7254"
  })), _path4921 || (_path4921 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91h1v1h-1z",
    fill: "#9b7f5f"
  })), _path4922 || (_path4922 = /*#__PURE__*/React.createElement("path", {
    d: "M21 91h1v1h-1z",
    fill: "#83684e"
  })), _path4923 || (_path4923 = /*#__PURE__*/React.createElement("path", {
    d: "M23 91v1h-1v-1z",
    fill: "#886c60"
  })), _path4924 || (_path4924 = /*#__PURE__*/React.createElement("path", {
    d: "M24 91v1h-1v-1z",
    fill: "#8f7866"
  })), _path4925 || (_path4925 = /*#__PURE__*/React.createElement("path", {
    d: "M25 91v1h-1v-1z",
    fill: "#a8846b"
  })), _path4926 || (_path4926 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v-1h1v1z",
    fill: "#cea77e"
  })), _path4927 || (_path4927 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h-1v-1h1z",
    fill: "#e6c6a5"
  })), _path4928 || (_path4928 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91h1v1h-1z",
    fill: "#e7cab5"
  })), _path4929 || (_path4929 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91h1v1h-1z",
    fill: "#e1bb82"
  })), _path4930 || (_path4930 = /*#__PURE__*/React.createElement("path", {
    d: "M29 92v-1h1v1z",
    fill: "#f3b025"
  })), _path4931 || (_path4931 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91h1v1h-1z",
    fill: "#d09d14"
  })), _path4932 || (_path4932 = /*#__PURE__*/React.createElement("path", {
    d: "M31 92v-1h1v1z",
    fill: "#b0b642"
  })), _path4933 || (_path4933 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91h1v1h-1z",
    fill: "#11367e"
  })), _path4934 || (_path4934 = /*#__PURE__*/React.createElement("path", {
    d: "M34 92v-1h1v1z",
    fill: "#244bac"
  })), _path4935 || (_path4935 = /*#__PURE__*/React.createElement("path", {
    d: "M36 92h-1v-1h1z",
    fill: "#3859a3"
  })), _path4936 || (_path4936 = /*#__PURE__*/React.createElement("path", {
    d: "M37 91v1h-1v-1z",
    fill: "#2c4da3"
  })), _path4937 || (_path4937 = /*#__PURE__*/React.createElement("path", {
    d: "M38 92h-1v-1h1z",
    fill: "#1f429c"
  })), _path4938 || (_path4938 = /*#__PURE__*/React.createElement("path", {
    d: "M39 92h-1v-1h1z",
    fill: "#2f549f"
  })), _path4939 || (_path4939 = /*#__PURE__*/React.createElement("path", {
    d: "M39 91h1v1h-1z",
    fill: "#254a9d"
  })), _path4940 || (_path4940 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91h1v1h-1z",
    fill: "#1e4cab"
  })), _path4941 || (_path4941 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1z",
    fill: "#2b58ba"
  })), _path4942 || (_path4942 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#0e39b0"
  })), _path4943 || (_path4943 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92h-1v-1h1z",
    fill: "#325371"
  })), _path4944 || (_path4944 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92v-1h1v1z",
    fill: "#b0b343"
  })), _path4945 || (_path4945 = /*#__PURE__*/React.createElement("path", {
    d: "M45 91h1v1h-1z",
    fill: "#d2a74a"
  })), _path4946 || (_path4946 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1z",
    fill: "#efb143"
  })), _path4947 || (_path4947 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91v1h-1v-1z",
    fill: "#c98f2b"
  })), _path4948 || (_path4948 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v1h-1v-1z",
    fill: "#ac7123"
  })), _path4949 || (_path4949 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92h-1v-1h1z",
    fill: "#ba7f1b"
  })), _path4950 || (_path4950 = /*#__PURE__*/React.createElement("path", {
    d: "M51 92h-1v-1h1z",
    fill: "#db9819"
  })), _path4951 || (_path4951 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91h1v1h-1z",
    fill: "#da9507"
  })), _path4952 || (_path4952 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#db9905"
  })), _path4953 || (_path4953 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#e29f17"
  })), _path4954 || (_path4954 = /*#__PURE__*/React.createElement("path", {
    d: "M55 91v1h-1v-1z",
    fill: "#f6b237"
  })), _path4955 || (_path4955 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-1z",
    fill: "#e9a421"
  })), _path4956 || (_path4956 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92v-1h1v1z",
    fill: "#e09d0d"
  })), _path4957 || (_path4957 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1z",
    fill: "#f0af2d"
  })), _path4958 || (_path4958 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92v-1h1v1z",
    fill: "#f6b741"
  })), _path4959 || (_path4959 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91v1h-1v-1z",
    fill: "#f7bf50"
  })), _path4960 || (_path4960 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h1v1h-1z",
    fill: "#f2c367"
  })), _path4961 || (_path4961 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v-1h1v1z",
    fill: "#c39c57"
  })), _path4962 || (_path4962 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92h-1v-1h1z",
    fill: "#b09673"
  })), _path4963 || (_path4963 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92v-1h1v1z",
    fill: "#d5d1cd"
  })), _path4964 || (_path4964 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v1h-1v-1z",
    fill: "#cdd0d4"
  })), _path4965 || (_path4965 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h-1v-1h1z",
    fill: "#d4d6d4"
  })), _path4966 || (_path4966 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v1h-1v-1z",
    fill: "#d6d7d7"
  })), _path4967 || (_path4967 = /*#__PURE__*/React.createElement("path", {
    d: "M19 92v1h-1v-1z",
    fill: "#857463",
    fillOpacity: 0.463
  })), _path4968 || (_path4968 = /*#__PURE__*/React.createElement("path", {
    d: "M19 93v-1h1v1z",
    fill: "#886d57"
  })), _path4969 || (_path4969 = /*#__PURE__*/React.createElement("path", {
    d: "M22 93h-1v-1h1z",
    fill: "#977a5a"
  })), _path4970 || (_path4970 = /*#__PURE__*/React.createElement("path", {
    d: "M22 92h1v1h-1z",
    fill: "#8d6a56"
  })), _path4971 || (_path4971 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h-1v-1h1z",
    fill: "#95776b"
  })), _path4972 || (_path4972 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v1h-1v-1z",
    fill: "#947967"
  })), _path4973 || (_path4973 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92h1v1h-1z",
    fill: "#c8a480"
  })), _path4974 || (_path4974 = /*#__PURE__*/React.createElement("path", {
    d: "M26 92h1v1h-1z",
    fill: "#e7c5a2"
  })), _path4975 || (_path4975 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h1v1h-1z",
    fill: "#edcbb0"
  })), _path4976 || (_path4976 = /*#__PURE__*/React.createElement("path", {
    d: "M28 93v-1h1v1z",
    fill: "#ebb663"
  })), _path4977 || (_path4977 = /*#__PURE__*/React.createElement("path", {
    d: "M30 93h-1v-1h1z",
    fill: "#feae03"
  })), _path4978 || (_path4978 = /*#__PURE__*/React.createElement("path", {
    d: "M30 92h1v1h-1z",
    fill: "#db9f10"
  })), _path4979 || (_path4979 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h-1v-1h1z",
    fill: "#bcb73f"
  })), _path4980 || (_path4980 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h-1v-1h1z",
    fill: "#2d4b60"
  })), _path4981 || (_path4981 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93v-1h1v1z",
    fill: "#1c45b2"
  })), _path4982 || (_path4982 = /*#__PURE__*/React.createElement("path", {
    d: "M35 92v1h-1v-1z",
    fill: "#2a56b3"
  })), _path4983 || (_path4983 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93v-1h1v1z",
    fill: "#3f71bd"
  })), _path4984 || (_path4984 = /*#__PURE__*/React.createElement("path", {
    d: "M36 93v-1h1v1z",
    fill: "#2b5cb2"
  })), _path4985 || (_path4985 = /*#__PURE__*/React.createElement("path", {
    d: "M37 92h1v1h-1z",
    fill: "#4772b6"
  })), _path4986 || (_path4986 = /*#__PURE__*/React.createElement("path", {
    d: "M38 93v-1h1v1z",
    fill: "#608fc7"
  })), _path4987 || (_path4987 = /*#__PURE__*/React.createElement("path", {
    d: "M40 92v1h-1v-1z",
    fill: "#5488cb"
  })), _path4988 || (_path4988 = /*#__PURE__*/React.createElement("path", {
    d: "M40 93v-1h1v1z",
    fill: "#4d88c3"
  })), _path4989 || (_path4989 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#427cb6"
  })), _path4990 || (_path4990 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#2352a6"
  })), _path4991 || (_path4991 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93v-1h1v1z",
    fill: "#728c67"
  })), _path4992 || (_path4992 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92v1h-1v-1z",
    fill: "#b0a337"
  })), _path4993 || (_path4993 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#daa846"
  })), _path4994 || (_path4994 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#d4982f"
  })), _path4995 || (_path4995 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93h-1v-1h1z",
    fill: "#ba7c27"
  })), _path4996 || (_path4996 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93h-1v-1h1z",
    fill: "#a36828"
  })), _path4997 || (_path4997 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92v1h-1v-1z",
    fill: "#b4771e"
  })), _path4998 || (_path4998 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1z",
    fill: "#cf8b15"
  })), _path4999 || (_path4999 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#d6910d"
  })), _path5000 || (_path5000 = /*#__PURE__*/React.createElement("path", {
    d: "M52 92h1v1h-1z",
    fill: "#dd9812"
  })), _path5001 || (_path5001 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#d7910c"
  })), _path5002 || (_path5002 = /*#__PURE__*/React.createElement("path", {
    d: "M55 93h-1v-1h1z",
    fill: "#e49f1b"
  })), _path5003 || (_path5003 = /*#__PURE__*/React.createElement("path", {
    d: "M56 93h-1v-1h1z",
    fill: "#f4b02e"
  })), _path5004 || (_path5004 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92h1v1h-1z",
    fill: "#e8a61d"
  })), _path5005 || (_path5005 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93h-1v-1h1z",
    fill: "#e09d12"
  })), _path5006 || (_path5006 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92h1v1h-1z",
    fill: "#f1ad2b"
  })), _path5007 || (_path5007 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v1h-1v-1z",
    fill: "#f3bb4e"
  })), _path5008 || (_path5008 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h-1v-1h1z",
    fill: "#f8c25e"
  })), _path5009 || (_path5009 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93v-1h1v1z",
    fill: "#f0c477"
  })), _path5010 || (_path5010 = /*#__PURE__*/React.createElement("path", {
    d: "M64 92v1h-1v-1z",
    fill: "#e4cda5"
  })), _path5011 || (_path5011 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93h-1v-1h1z",
    fill: "#ddd8cf"
  })), _path5012 || (_path5012 = /*#__PURE__*/React.createElement("path", {
    d: "M65 92h1v1h-1z",
    fill: "#d8dadb"
  })), _path5013 || (_path5013 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h1v1h-1z",
    fill: "#d9dbd9"
  })), _path5014 || (_path5014 = /*#__PURE__*/React.createElement("path", {
    d: "M19 94h-1v-1h1z",
    fill: "#87755b",
    fillOpacity: 0.459
  })), _path5015 || (_path5015 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93v1h-1v-1z",
    fill: "#907457"
  })), _path5016 || (_path5016 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93h1v1h-1z",
    fill: "#84644e"
  })), _path5017 || (_path5017 = /*#__PURE__*/React.createElement("path", {
    d: "M21 94v-1h1v1z",
    fill: "#9c7d60"
  })), _path5018 || (_path5018 = /*#__PURE__*/React.createElement("path", {
    d: "M22 94v-1h1v1z",
    fill: "#ae8d6f"
  })), _path5019 || (_path5019 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94h-1v-1h1z",
    fill: "#9a7766"
  })), _path5020 || (_path5020 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h1v1h-1z",
    fill: "#a58471"
  })), _path5021 || (_path5021 = /*#__PURE__*/React.createElement("path", {
    d: "M25 93h1v1h-1z",
    fill: "#cfa985"
  })), _path5022 || (_path5022 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93v1h-1v-1z",
    fill: "#e2c1a0"
  })), _path5023 || (_path5023 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93h1v1h-1z",
    fill: "#eeceb3"
  })), _path5024 || (_path5024 = /*#__PURE__*/React.createElement("path", {
    d: "M28 94v-1h1v1z",
    fill: "#ebbc69"
  })), _path5025 || (_path5025 = /*#__PURE__*/React.createElement("path", {
    d: "M30 93v1h-1v-1z",
    fill: "#fbad06"
  })), _path5026 || (_path5026 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94h-1v-1h1z",
    fill: "#f3ac0e"
  })), _path5027 || (_path5027 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93v1h-1v-1z",
    fill: "#b9a12d"
  })), _path5028 || (_path5028 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h1v1h-1z",
    fill: "#7f9251"
  })), _path5029 || (_path5029 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h1v1h-1z",
    fill: "#1d478b"
  })), _path5030 || (_path5030 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94h-1v-1h1z",
    fill: "#4572c0"
  })), _path5031 || (_path5031 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93h1v1h-1z",
    fill: "#477cbc"
  })), _path5032 || (_path5032 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v-1h1v1z",
    fill: "#4476b9"
  })), _path5033 || (_path5033 = /*#__PURE__*/React.createElement("path", {
    d: "M38 94h-1v-1h1z",
    fill: "#4f7fbe"
  })), _path5034 || (_path5034 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93v1h-1v-1z",
    fill: "#497db8"
  })), _path5035 || (_path5035 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93h1v1h-1z",
    fill: "#3b72ba"
  })), _path5036 || (_path5036 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94h-1v-1h1z",
    fill: "#4982c5"
  })), _path5037 || (_path5037 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94v-1h1v1z",
    fill: "#4e84c7"
  })), _path5038 || (_path5038 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94v-1h1v1z",
    fill: "#3d6678"
  })), _path5039 || (_path5039 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h1v1h-1z",
    fill: "#afb852"
  })), _path5040 || (_path5040 = /*#__PURE__*/React.createElement("path", {
    d: "M45 94h-1v-1h1z",
    fill: "#b29337"
  })), _path5041 || (_path5041 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h-1v-1h1z",
    fill: "#dba243"
  })), _path5042 || (_path5042 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-1v-1z",
    fill: "#c1842a"
  })), _path5043 || (_path5043 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94h-1v-1h1z",
    fill: "#af712b"
  })), _path5044 || (_path5044 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93v1h-1v-1z",
    fill: "#915c2a"
  })), _path5045 || (_path5045 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#a46c25"
  })), _path5046 || (_path5046 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93v1h-1v-1z",
    fill: "#ba7b1a"
  })), _path5047 || (_path5047 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93v1h-1v-1z",
    fill: "#c18216"
  })), _path5048 || (_path5048 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h1v1h-1z",
    fill: "#ca8613"
  })), _path5049 || (_path5049 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94h-1v-1h1z",
    fill: "#e39d1a"
  })), _path5050 || (_path5050 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#e39e15"
  })), _path5051 || (_path5051 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h-1v-1h1z",
    fill: "#e59e1e"
  })), _path5052 || (_path5052 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94v-1h1v1z",
    fill: "#f2ac2d"
  })), _path5053 || (_path5053 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93v1h-1v-1z",
    fill: "#eca723"
  })), _path5054 || (_path5054 = /*#__PURE__*/React.createElement("path", {
    d: "M59 93v1h-1v-1z",
    fill: "#df9914"
  })), _path5055 || (_path5055 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94h-1v-1h1z",
    fill: "#eaa325"
  })), _path5056 || (_path5056 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93h1v1h-1z",
    fill: "#f5b13d"
  })), _path5057 || (_path5057 = /*#__PURE__*/React.createElement("path", {
    d: "M61 93h1v1h-1z",
    fill: "#f7b84b"
  })), _path5058 || (_path5058 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h1v1h-1z",
    fill: "#f2bd54"
  })), _path5059 || (_path5059 = /*#__PURE__*/React.createElement("path", {
    d: "M64 93v1h-1v-1z",
    fill: "#efc269"
  })), _path5060 || (_path5060 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v1h-1v-1z",
    fill: "#ebca90"
  })), _path5061 || (_path5061 = /*#__PURE__*/React.createElement("path", {
    d: "M65 94v-1h1v1z",
    fill: "#e2d7c8"
  })), _path5062 || (_path5062 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94h-1v-1h1z",
    fill: "#dbdcdb"
  })), _path5063 || (_path5063 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h-1v-1h1z",
    fill: "#d7dcdb"
  })), _path5064 || (_path5064 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94v-1h1v1z",
    fill: "#d7dbdb"
  })), _path5065 || (_path5065 = /*#__PURE__*/React.createElement("path", {
    d: "M70 93v1h-1v-1z",
    fill: "#d7dbda"
  })), _path5066 || (_path5066 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93h1v1h-1z",
    fill: "#e0e2e1",
    fillOpacity: 0.973
  })), _path5067 || (_path5067 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93v1h-1v-1z",
    fill: "#e2e8e8",
    fillOpacity: 0.176
  })), _path5068 || (_path5068 = /*#__PURE__*/React.createElement("path", {
    d: "M19 94v1h-1v-1z",
    fill: "#836f55",
    fillOpacity: 0.447
  })), _path5069 || (_path5069 = /*#__PURE__*/React.createElement("path", {
    d: "M20 95h-1v-1h1z",
    fill: "#9a7c55"
  })), _path5070 || (_path5070 = /*#__PURE__*/React.createElement("path", {
    d: "M21 94v1h-1v-1z",
    fill: "#906f53"
  })), _path5071 || (_path5071 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95h-1v-1h1z",
    fill: "#876a57"
  })), _path5072 || (_path5072 = /*#__PURE__*/React.createElement("path", {
    d: "M22 94h1v1h-1z",
    fill: "#967b5e"
  })), _path5073 || (_path5073 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94v1h-1v-1z",
    fill: "#b69979"
  })), _path5074 || (_path5074 = /*#__PURE__*/React.createElement("path", {
    d: "M24 95v-1h1v1z",
    fill: "#ab8b6a"
  })), _path5075 || (_path5075 = /*#__PURE__*/React.createElement("path", {
    d: "M26 94v1h-1v-1z",
    fill: "#c9a27c"
  })), _path5076 || (_path5076 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95v-1h1v1z",
    fill: "#e3c2a2"
  })), _path5077 || (_path5077 = /*#__PURE__*/React.createElement("path", {
    d: "M28 95h-1v-1h1z",
    fill: "#eccdb2"
  })), _path5078 || (_path5078 = /*#__PURE__*/React.createElement("path", {
    d: "M29 95h-1v-1h1z",
    fill: "#eabb6a"
  })), _path5079 || (_path5079 = /*#__PURE__*/React.createElement("path", {
    d: "M29 94h1v1h-1z",
    fill: "#faad08"
  })), _path5080 || (_path5080 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94v1h-1v-1z",
    fill: "#ffb106"
  })), _path5081 || (_path5081 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95v-1h1v1z",
    fill: "#cc9c17"
  })), _path5082 || (_path5082 = /*#__PURE__*/React.createElement("path", {
    d: "M33 94v1h-1v-1z",
    fill: "#bcbc45"
  })), _path5083 || (_path5083 = /*#__PURE__*/React.createElement("path", {
    d: "M34 94v1h-1v-1z",
    fill: "#5b785c"
  })), _path5084 || (_path5084 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94v1h-1v-1z",
    fill: "#487abb"
  })), _path5085 || (_path5085 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v1h-1v-1z",
    fill: "#4879c6"
  })), _path5086 || (_path5086 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95v-1h1v1z",
    fill: "#305cb2"
  })), _path5087 || (_path5087 = /*#__PURE__*/React.createElement("path", {
    d: "M37 94h1v1h-1z",
    fill: "#4775cc"
  })), _path5088 || (_path5088 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h-1v-1h1z",
    fill: "#3162b8"
  })), _path5089 || (_path5089 = /*#__PURE__*/React.createElement("path", {
    d: "M39 94h1v1h-1z",
    fill: "#2251b3"
  })), _path5090 || (_path5090 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v1z",
    fill: "#174bab"
  })), _path5091 || (_path5091 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95v-1h1v1z",
    fill: "#32587f"
  })), _path5092 || (_path5092 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94h1v1h-1z",
    fill: "#aac05c"
  })), _path5093 || (_path5093 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95h-1v-1h1z",
    fill: "#ad9436"
  })), _path5094 || (_path5094 = /*#__PURE__*/React.createElement("path", {
    d: "M44 94h1v1h-1z",
    fill: "#c99432"
  })), _path5095 || (_path5095 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v-1h1v1z",
    fill: "#ca8a27"
  })), _path5096 || (_path5096 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1z",
    fill: "#bb7b26"
  })), _path5097 || (_path5097 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95h-1v-1h1z",
    fill: "#a66d28"
  })), _path5098 || (_path5098 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95v-1h1v1z",
    fill: "#7d5023"
  })), _path5099 || (_path5099 = /*#__PURE__*/React.createElement("path", {
    d: "M49 94h1v1h-1z",
    fill: "#916128"
  })), _path5100 || (_path5100 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1z",
    fill: "#a56e24"
  })), _path5101 || (_path5101 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1z",
    fill: "#af7320"
  })), _path5102 || (_path5102 = /*#__PURE__*/React.createElement("path", {
    d: "M53 94v1h-1v-1z",
    fill: "#ba7716"
  })), _path5103 || (_path5103 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#d69218"
  })), _path5104 || (_path5104 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94v1h-1v-1z",
    fill: "#e6a31d"
  })), _path5105 || (_path5105 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h1v1h-1z",
    fill: "#e6a11a"
  })), _path5106 || (_path5106 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h1v1h-1z",
    fill: "#dc960e"
  })), _path5107 || (_path5107 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94v1h-1v-1z",
    fill: "#f1ae2d"
  })), _path5108 || (_path5108 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94v1h-1v-1z",
    fill: "#e59d1a"
  })), _path5109 || (_path5109 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95v-1h1v1z",
    fill: "#e79c1e"
  })), _path5110 || (_path5110 = /*#__PURE__*/React.createElement("path", {
    d: "M61 94h1v1h-1z",
    fill: "#f4ad31"
  })), _path5111 || (_path5111 = /*#__PURE__*/React.createElement("path", {
    d: "M63 94v1h-1v-1z",
    fill: "#f8b94b"
  })), _path5112 || (_path5112 = /*#__PURE__*/React.createElement("path", {
    d: "M63 95v-1h1v1z",
    fill: "#f6ba58"
  })), _path5113 || (_path5113 = /*#__PURE__*/React.createElement("path", {
    d: "M64 94h1v1h-1z",
    fill: "#f1bd63"
  })), _path5114 || (_path5114 = /*#__PURE__*/React.createElement("path", {
    d: "M66 94v1h-1v-1z",
    fill: "#eac785"
  })), _path5115 || (_path5115 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94v1h-1v-1z",
    fill: "#e1d4bd"
  })), _path5116 || (_path5116 = /*#__PURE__*/React.createElement("path", {
    d: "M67 95v-1h1v1z",
    fill: "#d7d8d7"
  })), _path5117 || (_path5117 = /*#__PURE__*/React.createElement("path", {
    d: "M69 94h1v1h-1z",
    fill: "#d4d9da"
  })), _path5118 || (_path5118 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95h-1v-1h1z",
    fill: "#d8d9d8"
  })), _path5119 || (_path5119 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96v-1h1v1z",
    fill: "#836d52",
    fillOpacity: 0.447
  })), _path5120 || (_path5120 = /*#__PURE__*/React.createElement("path", {
    d: "M19 95h1v1h-1z",
    fill: "#99764d"
  })), _path5121 || (_path5121 = /*#__PURE__*/React.createElement("path", {
    d: "M21 95v1h-1v-1z",
    fill: "#ac865d"
  })), _path5122 || (_path5122 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95v1h-1v-1z",
    fill: "#967559"
  })), _path5123 || (_path5123 = /*#__PURE__*/React.createElement("path", {
    d: "M22 96v-1h1v1z",
    fill: "#94755b"
  })), _path5124 || (_path5124 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h-1v-1h1z",
    fill: "#96785d"
  })), _path5125 || (_path5125 = /*#__PURE__*/React.createElement("path", {
    d: "M25 96h-1v-1h1z",
    fill: "#be9d7c"
  })), _path5126 || (_path5126 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96h-1v-1h1z",
    fill: "#d6af88"
  })), _path5127 || (_path5127 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95h1v1h-1z",
    fill: "#e1c0a1"
  })), _path5128 || (_path5128 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96v-1h1v1z",
    fill: "#ebb96c"
  })), _path5129 || (_path5129 = /*#__PURE__*/React.createElement("path", {
    d: "M30 95v1h-1v-1z",
    fill: "#f9ae0b"
  })), _path5130 || (_path5130 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96h-1v-1h1z",
    fill: "#feb000"
  })), _path5131 || (_path5131 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95h1v1h-1z",
    fill: "#f8b20b"
  })), _path5132 || (_path5132 = /*#__PURE__*/React.createElement("path", {
    d: "M32 96v-1h1v1z",
    fill: "#bc9522"
  })), _path5133 || (_path5133 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96h-1v-1h1z",
    fill: "#c0c347"
  })), _path5134 || (_path5134 = /*#__PURE__*/React.createElement("path", {
    d: "M35 95v1h-1v-1z",
    fill: "#5f7651"
  })), _path5135 || (_path5135 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h-1v-1h1z",
    fill: "#092970"
  })), _path5136 || (_path5136 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95h1v1h-1z",
    fill: "#001e96"
  })), _path5137 || (_path5137 = /*#__PURE__*/React.createElement("path", {
    d: "M38 95v1h-1v-1z",
    fill: "#001f9c"
  })), _path5138 || (_path5138 = /*#__PURE__*/React.createElement("path", {
    d: "M38 96v-1h1v1z",
    fill: "#001d94"
  })), _path5139 || (_path5139 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h1v1h-1z",
    fill: "#002389"
  })), _path5140 || (_path5140 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h-1v-1h1z",
    fill: "#3c5467"
  })), _path5141 || (_path5141 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95h1v1h-1z",
    fill: "#a7b259"
  })), _path5142 || (_path5142 = /*#__PURE__*/React.createElement("path", {
    d: "M43 96h-1v-1h1z",
    fill: "#a79c39"
  })), _path5143 || (_path5143 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95v1h-1v-1z",
    fill: "#c4953d"
  })), _path5144 || (_path5144 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v1h-1v-1z",
    fill: "#c78624"
  })), _path5145 || (_path5145 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95h1v1h-1z",
    fill: "#c88321"
  })), _path5146 || (_path5146 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#b67625"
  })), _path5147 || (_path5147 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1z",
    fill: "#9d6528"
  })), _path5148 || (_path5148 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v-1h1v1z",
    fill: "#7c4e29"
  })), _path5149 || (_path5149 = /*#__PURE__*/React.createElement("path", {
    d: "M50 95v1h-1v-1z",
    fill: "#835427"
  })), _path5150 || (_path5150 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v1h-1v-1z",
    fill: "#976426"
  })), _path5151 || (_path5151 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h1v1h-1z",
    fill: "#a56921"
  })), _path5152 || (_path5152 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h-1v-1h1z",
    fill: "#ba751b"
  })), _path5153 || (_path5153 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95v1h-1v-1z",
    fill: "#c98313"
  })), _path5154 || (_path5154 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95h1v1h-1z",
    fill: "#ce8a0e"
  })), _path5155 || (_path5155 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96h-1v-1h1z",
    fill: "#d69315"
  })), _path5156 || (_path5156 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96v-1h1v1z",
    fill: "#e8a523"
  })), _path5157 || (_path5157 = /*#__PURE__*/React.createElement("path", {
    d: "M57 95h1v1h-1z",
    fill: "#e3a01b"
  })), _path5158 || (_path5158 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h1v1h-1z",
    fill: "#eaa929"
  })), _path5159 || (_path5159 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h1v1h-1z",
    fill: "#f5b338"
  })), _path5160 || (_path5160 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h-1v-1h1z",
    fill: "#eba329"
  })), _path5161 || (_path5161 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95v1h-1v-1z",
    fill: "#eda21d"
  })), _path5162 || (_path5162 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95h1v1h-1z",
    fill: "#f4af35"
  })), _path5163 || (_path5163 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96h-1v-1h1z",
    fill: "#f6bd5a"
  })), _path5164 || (_path5164 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h-1v-1h1z",
    fill: "#f7b95a"
  })), _path5165 || (_path5165 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96v-1h1v1z",
    fill: "#ecc27e"
  })), _path5166 || (_path5166 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96h-1v-1h1z",
    fill: "#e2d4ba"
  })), _path5167 || (_path5167 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96v-1h1v1z",
    fill: "#dbd8d7"
  })), _path5168 || (_path5168 = /*#__PURE__*/React.createElement("path", {
    d: "M69 95h1v1h-1z",
    fill: "#d6dadc"
  })), _path5169 || (_path5169 = /*#__PURE__*/React.createElement("path", {
    d: "M71 96v-1h1v1z",
    fill: "#dadbda"
  })), _path5170 || (_path5170 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95h1v1h-1z",
    fill: "#e1e3e2",
    fillOpacity: 0.973
  })), _path5171 || (_path5171 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96h1v1h-1z",
    fill: "#856e54",
    fillOpacity: 0.451
  })), _path5172 || (_path5172 = /*#__PURE__*/React.createElement("path", {
    d: "M19 96h1v1h-1z",
    fill: "#9d774c"
  })), _path5173 || (_path5173 = /*#__PURE__*/React.createElement("path", {
    d: "M20 97v-1h1v1z",
    fill: "#ac804e"
  })), _path5174 || (_path5174 = /*#__PURE__*/React.createElement("path", {
    d: "M21 96h1v1h-1z",
    fill: "#b68d64"
  })), _path5175 || (_path5175 = /*#__PURE__*/React.createElement("path", {
    d: "M23 96v1h-1v-1z",
    fill: "#a07a61"
  })), _path5176 || (_path5176 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96v1h-1v-1z",
    fill: "#8d6f5d"
  })), _path5177 || (_path5177 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h1v1h-1z",
    fill: "#ba9979"
  })), _path5178 || (_path5178 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96v1h-1v-1z",
    fill: "#d7ae88"
  })), _path5179 || (_path5179 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96h1v1h-1z",
    fill: "#ebcdb3"
  })), _path5180 || (_path5180 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96h1v1h-1z",
    fill: "#edbd6f"
  })), _path5181 || (_path5181 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v-1h1v1z",
    fill: "#faad09"
  })), _path5182 || (_path5182 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96v1h-1v-1z",
    fill: "#fdb001"
  })), _path5183 || (_path5183 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97v-1h1v1z",
    fill: "#ffad05"
  })), _path5184 || (_path5184 = /*#__PURE__*/React.createElement("path", {
    d: "M32 97v-1h1v1z",
    fill: "#f6ae0d"
  })), _path5185 || (_path5185 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96v1h-1v-1z",
    fill: "#ba9320"
  })), _path5186 || (_path5186 = /*#__PURE__*/React.createElement("path", {
    d: "M34 97v-1h1v1z",
    fill: "#aaaf47"
  })), _path5187 || (_path5187 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96v1h-1v-1z",
    fill: "#9fb34b"
  })), _path5188 || (_path5188 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h1v1h-1z",
    fill: "#788956"
  })), _path5189 || (_path5189 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97h-1v-1h1z",
    fill: "#657b5b"
  })), _path5190 || (_path5190 = /*#__PURE__*/React.createElement("path", {
    d: "M39 97h-1v-1h1z",
    fill: "#738559"
  })), _path5191 || (_path5191 = /*#__PURE__*/React.createElement("path", {
    d: "M39 96h1v1h-1z",
    fill: "#99ab53"
  })), _path5192 || (_path5192 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96v1h-1v-1z",
    fill: "#b9b948"
  })), _path5193 || (_path5193 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h1v1h-1z",
    fill: "#a89435"
  })), _path5194 || (_path5194 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97v-1h1v1z",
    fill: "#ce9d43"
  })), _path5195 || (_path5195 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97v-1h1v1z",
    fill: "#d7942b"
  })), _path5196 || (_path5196 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97h-1v-1h1z",
    fill: "#ce8723"
  })), _path5197 || (_path5197 = /*#__PURE__*/React.createElement("path", {
    d: "M46 96v1h-1v-1z",
    fill: "#c68526"
  })), _path5198 || (_path5198 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v1h-1v-1z",
    fill: "#a97028"
  })), _path5199 || (_path5199 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v1h-1v-1z",
    fill: "#89572a"
  })), _path5200 || (_path5200 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97v-1h1v1z",
    fill: "#794d32"
  })), _path5201 || (_path5201 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97v-1h1v1z",
    fill: "#7e522e"
  })), _path5202 || (_path5202 = /*#__PURE__*/React.createElement("path", {
    d: "M51 96v1h-1v-1z",
    fill: "#99652a"
  })), _path5203 || (_path5203 = /*#__PURE__*/React.createElement("path", {
    d: "M52 97h-1v-1h1z",
    fill: "#a3681f"
  })), _path5204 || (_path5204 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96v1h-1v-1z",
    fill: "#b6721e"
  })), _path5205 || (_path5205 = /*#__PURE__*/React.createElement("path", {
    d: "M54 96v1h-1v-1z",
    fill: "#c27d1a"
  })), _path5206 || (_path5206 = /*#__PURE__*/React.createElement("path", {
    d: "M55 96v1h-1v-1z",
    fill: "#c47f11"
  })), _path5207 || (_path5207 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97v-1h1v1z",
    fill: "#ca8511"
  })), _path5208 || (_path5208 = /*#__PURE__*/React.createElement("path", {
    d: "M57 96v1h-1v-1z",
    fill: "#e19e27"
  })), _path5209 || (_path5209 = /*#__PURE__*/React.createElement("path", {
    d: "M58 96v1h-1v-1z",
    fill: "#eea92a"
  })), _path5210 || (_path5210 = /*#__PURE__*/React.createElement("path", {
    d: "M58 97v-1h1v1z",
    fill: "#e29e1c"
  })), _path5211 || (_path5211 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96v1h-1v-1z",
    fill: "#eeac33"
  })), _path5212 || (_path5212 = /*#__PURE__*/React.createElement("path", {
    d: "M60 97v-1h1v1z",
    fill: "#fab949"
  })), _path5213 || (_path5213 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h1v1h-1z",
    fill: "#eeab35"
  })), _path5214 || (_path5214 = /*#__PURE__*/React.createElement("path", {
    d: "M63 96v1h-1v-1z",
    fill: "#e6a524"
  })), _path5215 || (_path5215 = /*#__PURE__*/React.createElement("path", {
    d: "M63 97v-1h1v1z",
    fill: "#f3b54b"
  })), _path5216 || (_path5216 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96v1h-1v-1z",
    fill: "#f6bd57"
  })), _path5217 || (_path5217 = /*#__PURE__*/React.createElement("path", {
    d: "M65 97v-1h1v1z",
    fill: "#f6b850"
  })), _path5218 || (_path5218 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#f3b959"
  })), _path5219 || (_path5219 = /*#__PURE__*/React.createElement("path", {
    d: "M67 96h1v1h-1z",
    fill: "#f0c88b"
  })), _path5220 || (_path5220 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97h-1v-1h1z",
    fill: "#e5d5c5"
  })), _path5221 || (_path5221 = /*#__PURE__*/React.createElement("path", {
    d: "M70 96v1h-1v-1z",
    fill: "#d9d9da"
  })), _path5222 || (_path5222 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97v-1h1v1z",
    fill: "#d8dbd9"
  })), _path5223 || (_path5223 = /*#__PURE__*/React.createElement("path", {
    d: "M18 98v-1h1v1z",
    fill: "#857156",
    fillOpacity: 0.451
  })), _path5224 || (_path5224 = /*#__PURE__*/React.createElement("path", {
    d: "M19 97h1v1h-1z",
    fill: "#a07a4d"
  })), _path5225 || (_path5225 = /*#__PURE__*/React.createElement("path", {
    d: "M20 97h1v1h-1z",
    fill: "#b28552"
  })), _path5226 || (_path5226 = /*#__PURE__*/React.createElement("path", {
    d: "M21 97h1v1h-1z",
    fill: "#b58550"
  })), _path5227 || (_path5227 = /*#__PURE__*/React.createElement("path", {
    d: "M22 97h1v1h-1z",
    fill: "#bc9060"
  })), _path5228 || (_path5228 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97v1h-1v-1z",
    fill: "#ad8a65"
  })), _path5229 || (_path5229 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97h1v1h-1z",
    fill: "#bb9773"
  })), _path5230 || (_path5230 = /*#__PURE__*/React.createElement("path", {
    d: "M26 97v1h-1v-1z",
    fill: "#d8af88"
  })), _path5231 || (_path5231 = /*#__PURE__*/React.createElement("path", {
    d: "M28 98h-1v-1h1z",
    fill: "#e9cdb4"
  })), _path5232 || (_path5232 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v1h-1v-1z",
    fill: "#ecc070"
  })), _path5233 || (_path5233 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97h1v1h-1z",
    fill: "#faac0a"
  })), _path5234 || (_path5234 = /*#__PURE__*/React.createElement("path", {
    d: "M31 98h-1v-1h1z",
    fill: "#ffae02"
  })), _path5235 || (_path5235 = /*#__PURE__*/React.createElement("path", {
    d: "M33 97v1h-1v-1z",
    fill: "#f5ac06"
  })), _path5236 || (_path5236 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98h-1v-1h1z",
    fill: "#cfa54d"
  })), _path5237 || (_path5237 = /*#__PURE__*/React.createElement("path", {
    d: "M35 97v1h-1v-1z",
    fill: "#a9aea2"
  })), _path5238 || (_path5238 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v-1h1v1z",
    fill: "#94a484"
  })), _path5239 || (_path5239 = /*#__PURE__*/React.createElement("path", {
    d: "M36 98v-1h1v1z",
    fill: "#98a964"
  })), _path5240 || (_path5240 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97v1h-1v-1z",
    fill: "#9bae54"
  })), _path5241 || (_path5241 = /*#__PURE__*/React.createElement("path", {
    d: "M38 98v-1h1v1z",
    fill: "#9dac5c"
  })), _path5242 || (_path5242 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98v-1h1v1z",
    fill: "#a9a04d"
  })), _path5243 || (_path5243 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v-1h1v1z",
    fill: "#c2993a"
  })), _path5244 || (_path5244 = /*#__PURE__*/React.createElement("path", {
    d: "M41 98v-1h1v1z",
    fill: "#e4ab4d"
  })), _path5245 || (_path5245 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97h1v1h-1z",
    fill: "#e8a439"
  })), _path5246 || (_path5246 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97h1v1h-1z",
    fill: "#d89226"
  })), _path5247 || (_path5247 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97v1h-1v-1z",
    fill: "#d08b24"
  })), _path5248 || (_path5248 = /*#__PURE__*/React.createElement("path", {
    d: "M46 98h-1v-1h1z",
    fill: "#c38225"
  })), _path5249 || (_path5249 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97v1h-1v-1z",
    fill: "#9b6727"
  })), _path5250 || (_path5250 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h-1v-1h1z",
    fill: "#7d532d"
  })), _path5251 || (_path5251 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97h1v1h-1z",
    fill: "#66422d"
  })), _path5252 || (_path5252 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97h1v1h-1z",
    fill: "#714929"
  })), _path5253 || (_path5253 = /*#__PURE__*/React.createElement("path", {
    d: "M50 97h1v1h-1z",
    fill: "#996227"
  })), _path5254 || (_path5254 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v-1h1v1z",
    fill: "#a56b26"
  })), _path5255 || (_path5255 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97v1h-1v-1z",
    fill: "#a76c1e"
  })), _path5256 || (_path5256 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97h1v1h-1z",
    fill: "#bb7a21"
  })), _path5257 || (_path5257 = /*#__PURE__*/React.createElement("path", {
    d: "M54 97h1v1h-1z",
    fill: "#ba7515"
  })), _path5258 || (_path5258 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97h1v1h-1z",
    fill: "#c78218"
  })), _path5259 || (_path5259 = /*#__PURE__*/React.createElement("path", {
    d: "M57 97v1h-1v-1z",
    fill: "#cb8816"
  })), _path5260 || (_path5260 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h-1v-1h1z",
    fill: "#f1ab32"
  })), _path5261 || (_path5261 = /*#__PURE__*/React.createElement("path", {
    d: "M59 97v1h-1v-1z",
    fill: "#f5b02e"
  })), _path5262 || (_path5262 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98h-1v-1h1z",
    fill: "#eaa723"
  })), _path5263 || (_path5263 = /*#__PURE__*/React.createElement("path", {
    d: "M61 98h-1v-1h1z",
    fill: "#f2b138"
  })), _path5264 || (_path5264 = /*#__PURE__*/React.createElement("path", {
    d: "M62 97v1h-1v-1z",
    fill: "#fbbe54"
  })), _path5265 || (_path5265 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98h-1v-1h1z",
    fill: "#f3b84a"
  })), _path5266 || (_path5266 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v-1h1v1z",
    fill: "#e4a534"
  })), _path5267 || (_path5267 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98h-1v-1h1z",
    fill: "#f1b449"
  })), _path5268 || (_path5268 = /*#__PURE__*/React.createElement("path", {
    d: "M67 97v1h-1v-1z",
    fill: "#f8ba57"
  })), _path5269 || (_path5269 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98v-1h1v1z",
    fill: "#f5bc5e"
  })), _path5270 || (_path5270 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97v1h-1v-1z",
    fill: "#edce93"
  })), _path5271 || (_path5271 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97h1v1h-1z",
    fill: "#d8dbdd"
  })), _path5272 || (_path5272 = /*#__PURE__*/React.createElement("path", {
    d: "M78 97v1h-1v-1z",
    fill: "#e3e9e9",
    fillOpacity: 0.184
  })), _path5273 || (_path5273 = /*#__PURE__*/React.createElement("path", {
    d: "M19 99h-1v-1h1z",
    fill: "#836d55",
    fillOpacity: 0.455
  })), _path5274 || (_path5274 = /*#__PURE__*/React.createElement("path", {
    d: "M20 98v1h-1v-1z",
    fill: "#a17c50"
  })), _path5275 || (_path5275 = /*#__PURE__*/React.createElement("path", {
    d: "M22 98v1h-1v-1z",
    fill: "#b78751"
  })), _path5276 || (_path5276 = /*#__PURE__*/React.createElement("path", {
    d: "M22 99v-1h1v1z",
    fill: "#bb8c49"
  })), _path5277 || (_path5277 = /*#__PURE__*/React.createElement("path", {
    d: "M24 99h-1v-1h1z",
    fill: "#c19b5f"
  })), _path5278 || (_path5278 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99h-1v-1h1z",
    fill: "#d4ac81"
  })), _path5279 || (_path5279 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99v-1h1v1z",
    fill: "#d8af87"
  })), _path5280 || (_path5280 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98v1h-1v-1z",
    fill: "#e0c0a1"
  })), _path5281 || (_path5281 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98h1v1h-1z",
    fill: "#e9d0b6"
  })), _path5282 || (_path5282 = /*#__PURE__*/React.createElement("path", {
    d: "M29 99h-1v-1h1z",
    fill: "#ecc273"
  })), _path5283 || (_path5283 = /*#__PURE__*/React.createElement("path", {
    d: "M30 98v1h-1v-1z",
    fill: "#faac08"
  })), _path5284 || (_path5284 = /*#__PURE__*/React.createElement("path", {
    d: "M31 98h1v1h-1z",
    fill: "#f3ab09"
  })), _path5285 || (_path5285 = /*#__PURE__*/React.createElement("path", {
    d: "M32 98h1v1h-1z",
    fill: "#d1a349"
  })), _path5286 || (_path5286 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98v1h-1v-1z",
    fill: "#ccc4b3"
  })), _path5287 || (_path5287 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v1h-1v-1z",
    fill: "#d0cfd7"
  })), _path5288 || (_path5288 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h-1v-1h1z",
    fill: "#cad0d6"
  })), _path5289 || (_path5289 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h-1v-1h1z",
    fill: "#c4cccf"
  })), _path5290 || (_path5290 = /*#__PURE__*/React.createElement("path", {
    d: "M38 99h-1v-1h1z",
    fill: "#c0c7c8"
  })), _path5291 || (_path5291 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h-1v-1h1z",
    fill: "#cdcabe"
  })), _path5292 || (_path5292 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v1h-1v-1z",
    fill: "#e5ba67"
  })), _path5293 || (_path5293 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98h1v1h-1z",
    fill: "#f0ae43"
  })), _path5294 || (_path5294 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v-1h1v1z",
    fill: "#ecb044"
  })), _path5295 || (_path5295 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99v-1h1v1z",
    fill: "#d99f36"
  })), _path5296 || (_path5296 = /*#__PURE__*/React.createElement("path", {
    d: "M43 99v-1h1v1z",
    fill: "#daa14f"
  })), _path5297 || (_path5297 = /*#__PURE__*/React.createElement("path", {
    d: "M44 99v-1h1v1z",
    fill: "#c6923d"
  })), _path5298 || (_path5298 = /*#__PURE__*/React.createElement("path", {
    d: "M45 98h1v1h-1z",
    fill: "#ba8537"
  })), _path5299 || (_path5299 = /*#__PURE__*/React.createElement("path", {
    d: "M46 99v-1h1v1z",
    fill: "#905e29"
  })), _path5300 || (_path5300 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v1h-1v-1z",
    fill: "#724928"
  })), _path5301 || (_path5301 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v1h-1z",
    fill: "#5b3a25"
  })), _path5302 || (_path5302 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99h-1v-1h1z",
    fill: "#6d4625"
  })), _path5303 || (_path5303 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v1h-1v-1z",
    fill: "#9b6227"
  })), _path5304 || (_path5304 = /*#__PURE__*/React.createElement("path", {
    d: "M51 99v-1h1v1z",
    fill: "#a06421"
  })), _path5305 || (_path5305 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99h-1v-1h1z",
    fill: "#a66c21"
  })), _path5306 || (_path5306 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99h-1v-1h1z",
    fill: "#af7318"
  })), _path5307 || (_path5307 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99v-1h1v1z",
    fill: "#be7d21"
  })), _path5308 || (_path5308 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v-1h1v1z",
    fill: "#b77510"
  })), _path5309 || (_path5309 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99v-1h1v1z",
    fill: "#c78616"
  })), _path5310 || (_path5310 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99h-1v-1h1z",
    fill: "#d28d17"
  })), _path5311 || (_path5311 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h1v1h-1z",
    fill: "#f0a92b"
  })), _path5312 || (_path5312 = /*#__PURE__*/React.createElement("path", {
    d: "M59 99v-1h1v1z",
    fill: "#f2ac29"
  })), _path5313 || (_path5313 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v-1h1v1z",
    fill: "#eda622"
  })), _path5314 || (_path5314 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99v-1h1v1z",
    fill: "#f1ae34"
  })), _path5315 || (_path5315 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v1h-1v-1z",
    fill: "#fbbe51"
  })), _path5316 || (_path5316 = /*#__PURE__*/React.createElement("path", {
    d: "M64 99h-1v-1h1z",
    fill: "#f4b94c"
  })), _path5317 || (_path5317 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98v1h-1v-1z",
    fill: "#e2a233"
  })), _path5318 || (_path5318 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v1h-1v-1z",
    fill: "#f2b44c"
  })), _path5319 || (_path5319 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h-1v-1h1z",
    fill: "#f6ba5a"
  })), _path5320 || (_path5320 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98h1v1h-1z",
    fill: "#f3ba56"
  })), _path5321 || (_path5321 = /*#__PURE__*/React.createElement("path", {
    d: "M68 99v-1h1v1z",
    fill: "#f2c26d"
  })), _path5322 || (_path5322 = /*#__PURE__*/React.createElement("path", {
    d: "M69 98h1v1h-1z",
    fill: "#eacfab"
  })), _path5323 || (_path5323 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h1v1h-1z",
    fill: "#dedcd6"
  })), _path5324 || (_path5324 = /*#__PURE__*/React.createElement("path", {
    d: "M72 98v1h-1v-1z",
    fill: "#dcdede"
  })), _path5325 || (_path5325 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v1h-1v-1z",
    fill: "#dcdfde"
  })), _path5326 || (_path5326 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98h1v1h-1z",
    fill: "#e8e8e8",
    fillOpacity: 0.18
  })), _path5327 || (_path5327 = /*#__PURE__*/React.createElement("path", {
    d: "M19 99v1h-1v-1z",
    fill: "#856e56",
    fillOpacity: 0.463
  })), _path5328 || (_path5328 = /*#__PURE__*/React.createElement("path", {
    d: "M19 100v-1h1v1z",
    fill: "#a07a4f"
  })), _path5329 || (_path5329 = /*#__PURE__*/React.createElement("path", {
    d: "M21 99v1h-1v-1z",
    fill: "#ae8250"
  })), _path5330 || (_path5330 = /*#__PURE__*/React.createElement("path", {
    d: "M21 100v-1h1v1z",
    fill: "#b58750"
  })), _path5331 || (_path5331 = /*#__PURE__*/React.createElement("path", {
    d: "M22 99h1v1h-1z",
    fill: "#be8e54"
  })), _path5332 || (_path5332 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100h-1v-1h1z",
    fill: "#c4965f"
  })), _path5333 || (_path5333 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100v-1h1v1z",
    fill: "#cc9f6d"
  })), _path5334 || (_path5334 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99h1v1h-1z",
    fill: "#d5ab7c"
  })), _path5335 || (_path5335 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100h-1v-1h1z",
    fill: "#dfbf9c"
  })), _path5336 || (_path5336 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100v-1h1v1z",
    fill: "#ebd1ba"
  })), _path5337 || (_path5337 = /*#__PURE__*/React.createElement("path", {
    d: "M28 100v-1h1v1z",
    fill: "#efc378"
  })), _path5338 || (_path5338 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100h-1v-1h1z",
    fill: "#f8ae08"
  })), _path5339 || (_path5339 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100v-1h1v1z",
    fill: "#f5aa05"
  })), _path5340 || (_path5340 = /*#__PURE__*/React.createElement("path", {
    d: "M32 100h-1v-1h1z",
    fill: "#d2a343"
  })), _path5341 || (_path5341 = /*#__PURE__*/React.createElement("path", {
    d: "M33 100h-1v-1h1z",
    fill: "#d2c6ba"
  })), _path5342 || (_path5342 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99v1h-1v-1z",
    fill: "#cdd1d4"
  })), _path5343 || (_path5343 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99h1v1h-1z",
    fill: "#c9ced0"
  })), _path5344 || (_path5344 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h1v1h-1z",
    fill: "#c7c8cb"
  })), _path5345 || (_path5345 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h1v1h-1z",
    fill: "#c5cbcc"
  })), _path5346 || (_path5346 = /*#__PURE__*/React.createElement("path", {
    d: "M39 100h-1v-1h1z",
    fill: "#dacaaf"
  })), _path5347 || (_path5347 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h1v1h-1z",
    fill: "#e1a83f"
  })), _path5348 || (_path5348 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v1h-1v-1z",
    fill: "#eca73a"
  })), _path5349 || (_path5349 = /*#__PURE__*/React.createElement("path", {
    d: "M41 100v-1h1v1z",
    fill: "#d99836"
  })), _path5350 || (_path5350 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99h1v1h-1z",
    fill: "#ca8a2a"
  })), _path5351 || (_path5351 = /*#__PURE__*/React.createElement("path", {
    d: "M44 100h-1v-1h1z",
    fill: "#c2873d"
  })), _path5352 || (_path5352 = /*#__PURE__*/React.createElement("path", {
    d: "M45 100h-1v-1h1z",
    fill: "#d4b385"
  })), _path5353 || (_path5353 = /*#__PURE__*/React.createElement("path", {
    d: "M46 100h-1v-1h1z",
    fill: "#c0aa86"
  })), _path5354 || (_path5354 = /*#__PURE__*/React.createElement("path", {
    d: "M47 100h-1v-1h1z",
    fill: "#7c542f"
  })), _path5355 || (_path5355 = /*#__PURE__*/React.createElement("path", {
    d: "M48 99v1h-1v-1z",
    fill: "#684125"
  })), _path5356 || (_path5356 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100v-1h1v1z",
    fill: "#5b392a"
  })), _path5357 || (_path5357 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99v1h-1v-1z",
    fill: "#78553a"
  })), _path5358 || (_path5358 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100v-1h1v1z",
    fill: "#9d6829"
  })), _path5359 || (_path5359 = /*#__PURE__*/React.createElement("path", {
    d: "M52 99v1h-1v-1z",
    fill: "#a96a20"
  })), _path5360 || (_path5360 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99v1h-1v-1z",
    fill: "#a5691e"
  })), _path5361 || (_path5361 = /*#__PURE__*/React.createElement("path", {
    d: "M53 100v-1h1v1z",
    fill: "#b1791d"
  })), _path5362 || (_path5362 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v1h-1v-1z",
    fill: "#b6781c"
  })), _path5363 || (_path5363 = /*#__PURE__*/React.createElement("path", {
    d: "M55 100v-1h1v1z",
    fill: "#b6731a"
  })), _path5364 || (_path5364 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99h1v1h-1z",
    fill: "#c48317"
  })), _path5365 || (_path5365 = /*#__PURE__*/React.createElement("path", {
    d: "M57 99h1v1h-1z",
    fill: "#cd8813"
  })), _path5366 || (_path5366 = /*#__PURE__*/React.createElement("path", {
    d: "M58 100v-1h1v1z",
    fill: "#d48b13"
  })), _path5367 || (_path5367 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v1h-1v-1z",
    fill: "#e99e22"
  })), _path5368 || (_path5368 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100v-1h1v1z",
    fill: "#efa82b"
  })), _path5369 || (_path5369 = /*#__PURE__*/React.createElement("path", {
    d: "M63 99v1h-1v-1z",
    fill: "#f2ad33"
  })), _path5370 || (_path5370 = /*#__PURE__*/React.createElement("path", {
    d: "M63 100v-1h1v1z",
    fill: "#fbb84a"
  })), _path5371 || (_path5371 = /*#__PURE__*/React.createElement("path", {
    d: "M65 99v1h-1v-1z",
    fill: "#f2b547"
  })), _path5372 || (_path5372 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99v1h-1v-1z",
    fill: "#eeb047"
  })), _path5373 || (_path5373 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99h1v1h-1z",
    fill: "#f3b350"
  })), _path5374 || (_path5374 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h1v1h-1z",
    fill: "#fcbd5e"
  })), _path5375 || (_path5375 = /*#__PURE__*/React.createElement("path", {
    d: "M69 99v1h-1v-1z",
    fill: "#fabd66"
  })), _path5376 || (_path5376 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100v-1h1v1z",
    fill: "#f5c781"
  })), _path5377 || (_path5377 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100v-1h1v1z",
    fill: "#e7d7bc"
  })), _path5378 || (_path5378 = /*#__PURE__*/React.createElement("path", {
    d: "M71 99h1v1h-1z",
    fill: "#dfdfdc"
  })), _path5379 || (_path5379 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100h-1v-1h1z",
    fill: "#dee0dd"
  })), _path5380 || (_path5380 = /*#__PURE__*/React.createElement("path", {
    d: "M74 100v-1h1v1z",
    fill: "#e1e2e1"
  })), _path5381 || (_path5381 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100v-1h1v1z",
    fill: "#e3e6e4"
  })), _path5382 || (_path5382 = /*#__PURE__*/React.createElement("path", {
    d: "M77 99h1v1h-1z",
    fill: "#dee3e3",
    fillOpacity: 0.184
  })), _path5383 || (_path5383 = /*#__PURE__*/React.createElement("path", {
    d: "M19 100v1h-1v-1z",
    fill: "#89735a",
    fillOpacity: 0.467
  })), _path5384 || (_path5384 = /*#__PURE__*/React.createElement("path", {
    d: "M20 100v1h-1v-1z",
    fill: "#a0794f"
  })), _path5385 || (_path5385 = /*#__PURE__*/React.createElement("path", {
    d: "M21 101v-1h1v1z",
    fill: "#b78952"
  })), _path5386 || (_path5386 = /*#__PURE__*/React.createElement("path", {
    d: "M23 101h-1v-1h1z",
    fill: "#bd8f54"
  })), _path5387 || (_path5387 = /*#__PURE__*/React.createElement("path", {
    d: "M23 101v-1h1v1z",
    fill: "#c5955c"
  })), _path5388 || (_path5388 = /*#__PURE__*/React.createElement("path", {
    d: "M25 101h-1v-1h1z",
    fill: "#cea06a"
  })), _path5389 || (_path5389 = /*#__PURE__*/React.createElement("path", {
    d: "M25 100h1v1h-1z",
    fill: "#cea269"
  })), _path5390 || (_path5390 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100v1h-1v-1z",
    fill: "#d7b58a"
  })), _path5391 || (_path5391 = /*#__PURE__*/React.createElement("path", {
    d: "M27 101v-1h1v1z",
    fill: "#ebcfb5"
  })), _path5392 || (_path5392 = /*#__PURE__*/React.createElement("path", {
    d: "M29 101h-1v-1h1z",
    fill: "#f0c47a"
  })), _path5393 || (_path5393 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100v1h-1v-1z",
    fill: "#f7aa0c"
  })), _path5394 || (_path5394 = /*#__PURE__*/React.createElement("path", {
    d: "M31 101h-1v-1h1z",
    fill: "#d7a036"
  })), _path5395 || (_path5395 = /*#__PURE__*/React.createElement("path", {
    d: "M31 100h1v1h-1z",
    fill: "#cec7af"
  })), _path5396 || (_path5396 = /*#__PURE__*/React.createElement("path", {
    d: "M33 101v-1h1v1z",
    fill: "#c9cecd"
  })), _path5397 || (_path5397 = /*#__PURE__*/React.createElement("path", {
    d: "M35 100v1h-1v-1z",
    fill: "#c8cecd"
  })), _path5398 || (_path5398 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101h-1v-1h1z",
    fill: "#cacccf"
  })), _path5399 || (_path5399 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h-1v-1h1z",
    fill: "#cdcbcf"
  })), _path5400 || (_path5400 = /*#__PURE__*/React.createElement("path", {
    d: "M38 100v1h-1v-1z",
    fill: "#ced1d1"
  })), _path5401 || (_path5401 = /*#__PURE__*/React.createElement("path", {
    d: "M38 101v-1h1v1z",
    fill: "#cfc1a0"
  })), _path5402 || (_path5402 = /*#__PURE__*/React.createElement("path", {
    d: "M40 100v1h-1v-1z",
    fill: "#c19038"
  })), _path5403 || (_path5403 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101h-1v-1h1z",
    fill: "#bf8522"
  })), _path5404 || (_path5404 = /*#__PURE__*/React.createElement("path", {
    d: "M42 101h-1v-1h1z",
    fill: "#ba7b26"
  })), _path5405 || (_path5405 = /*#__PURE__*/React.createElement("path", {
    d: "M42 100h1v1h-1z",
    fill: "#bf843a"
  })), _path5406 || (_path5406 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101h-1v-1h1z",
    fill: "#bf8f56"
  })), _path5407 || (_path5407 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101v-1h1v1z",
    fill: "#ccbdaa"
  })), _path5408 || (_path5408 = /*#__PURE__*/React.createElement("path", {
    d: "M45 101v-1h1v1z",
    fill: "#d9d7d1"
  })), _path5409 || (_path5409 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101v-1h1v1z",
    fill: "#cabdaf"
  })), _path5410 || (_path5410 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101v-1h1v1z",
    fill: "#b8a99a"
  })), _path5411 || (_path5411 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100h1v1h-1z",
    fill: "#bfb2ac"
  })), _path5412 || (_path5412 = /*#__PURE__*/React.createElement("path", {
    d: "M49 101v-1h1v1z",
    fill: "#d8c7b8"
  })), _path5413 || (_path5413 = /*#__PURE__*/React.createElement("path", {
    d: "M51 100v1h-1v-1z",
    fill: "#9a6e37"
  })), _path5414 || (_path5414 = /*#__PURE__*/React.createElement("path", {
    d: "M52 100v1h-1v-1z",
    fill: "#ae6e1f"
  })), _path5415 || (_path5415 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-1v-1h1z",
    fill: "#a4651d"
  })), _path5416 || (_path5416 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101h-1v-1h1z",
    fill: "#a96e1d"
  })), _path5417 || (_path5417 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101h-1v-1h1z",
    fill: "#b97e20"
  })), _path5418 || (_path5418 = /*#__PURE__*/React.createElement("path", {
    d: "M56 100v1h-1v-1z",
    fill: "#a76616"
  })), _path5419 || (_path5419 = /*#__PURE__*/React.createElement("path", {
    d: "M56 101v-1h1v1z",
    fill: "#b16f1a"
  })), _path5420 || (_path5420 = /*#__PURE__*/React.createElement("path", {
    d: "M58 101h-1v-1h1z",
    fill: "#c58315"
  })), _path5421 || (_path5421 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h-1v-1h1z",
    fill: "#c07a0f"
  })), _path5422 || (_path5422 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v-1h1v1z",
    fill: "#df9823"
  })), _path5423 || (_path5423 = /*#__PURE__*/React.createElement("path", {
    d: "M61 100v1h-1v-1z",
    fill: "#e0991f"
  })), _path5424 || (_path5424 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101v-1h1v1z",
    fill: "#f9b339"
  })), _path5425 || (_path5425 = /*#__PURE__*/React.createElement("path", {
    d: "M62 101v-1h1v1z",
    fill: "#eda72b"
  })), _path5426 || (_path5426 = /*#__PURE__*/React.createElement("path", {
    d: "M64 101h-1v-1h1z",
    fill: "#efa931"
  })), _path5427 || (_path5427 = /*#__PURE__*/React.createElement("path", {
    d: "M64 100h1v1h-1z",
    fill: "#f3b547"
  })), _path5428 || (_path5428 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h-1v-1h1z",
    fill: "#f3b84c"
  })), _path5429 || (_path5429 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101v-1h1v1z",
    fill: "#eaa83a"
  })), _path5430 || (_path5430 = /*#__PURE__*/React.createElement("path", {
    d: "M68 100v1h-1v-1z",
    fill: "#f5b349"
  })), _path5431 || (_path5431 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h-1v-1h1z",
    fill: "#fabc5c"
  })), _path5432 || (_path5432 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100h1v1h-1z",
    fill: "#f7c163"
  })), _path5433 || (_path5433 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100h1v1h-1z",
    fill: "#eccc95"
  })), _path5434 || (_path5434 = /*#__PURE__*/React.createElement("path", {
    d: "M71 100h1v1h-1z",
    fill: "#e1dad2"
  })), _path5435 || (_path5435 = /*#__PURE__*/React.createElement("path", {
    d: "M74 101v-1h1v1z",
    fill: "#e0e1df"
  })), _path5436 || (_path5436 = /*#__PURE__*/React.createElement("path", {
    d: "M76 101h-1v-1h1z",
    fill: "#e3e4e4"
  })), _path5437 || (_path5437 = /*#__PURE__*/React.createElement("path", {
    d: "M18 101h1v1h-1z",
    fill: "#87725b",
    fillOpacity: 0.478
  })), _path5438 || (_path5438 = /*#__PURE__*/React.createElement("path", {
    d: "M20 102h-1v-1h1z",
    fill: "#a17b53"
  })), _path5439 || (_path5439 = /*#__PURE__*/React.createElement("path", {
    d: "M21 102h-1v-1h1z",
    fill: "#ac814e"
  })), _path5440 || (_path5440 = /*#__PURE__*/React.createElement("path", {
    d: "M22 101v1h-1v-1z",
    fill: "#b58950"
  })), _path5441 || (_path5441 = /*#__PURE__*/React.createElement("path", {
    d: "M24 101v1h-1v-1z",
    fill: "#c6985e"
  })), _path5442 || (_path5442 = /*#__PURE__*/React.createElement("path", {
    d: "M25 101v1h-1v-1z",
    fill: "#ca9f67"
  })), _path5443 || (_path5443 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102v-1h1v1z",
    fill: "#d3a66f"
  })), _path5444 || (_path5444 = /*#__PURE__*/React.createElement("path", {
    d: "M27 101v1h-1v-1z",
    fill: "#dab48b"
  })), _path5445 || (_path5445 = /*#__PURE__*/React.createElement("path", {
    d: "M28 102h-1v-1h1z",
    fill: "#ecceb7"
  })), _path5446 || (_path5446 = /*#__PURE__*/React.createElement("path", {
    d: "M28 101h1v1h-1z",
    fill: "#efbf7b"
  })), _path5447 || (_path5447 = /*#__PURE__*/React.createElement("path", {
    d: "M30 101v1h-1v-1z",
    fill: "#d79e2f"
  })), _path5448 || (_path5448 = /*#__PURE__*/React.createElement("path", {
    d: "M31 101v1h-1v-1z",
    fill: "#d0bfa4"
  })), _path5449 || (_path5449 = /*#__PURE__*/React.createElement("path", {
    d: "M31 102v-1h1v1z",
    fill: "#ced4d3"
  })), _path5450 || (_path5450 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101h1v1h-1z",
    fill: "#ced3d2"
  })), _path5451 || (_path5451 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102v-1h1v1z",
    fill: "#ced1d2"
  })), _path5452 || (_path5452 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h1v1h-1z",
    fill: "#ced2d3"
  })), _path5453 || (_path5453 = /*#__PURE__*/React.createElement("path", {
    d: "M39 102h-1v-1h1z",
    fill: "#d2d1ca"
  })), _path5454 || (_path5454 = /*#__PURE__*/React.createElement("path", {
    d: "M39 101h1v1h-1z",
    fill: "#d6cab2"
  })), _path5455 || (_path5455 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101v1h-1v-1z",
    fill: "#cab998"
  })), _path5456 || (_path5456 = /*#__PURE__*/React.createElement("path", {
    d: "M41 102v-1h1v1z",
    fill: "#c5ae95"
  })), _path5457 || (_path5457 = /*#__PURE__*/React.createElement("path", {
    d: "M43 101v1h-1v-1z",
    fill: "#d4c2b0"
  })), _path5458 || (_path5458 = /*#__PURE__*/React.createElement("path", {
    d: "M43 102v-1h1v1z",
    fill: "#d3cbc3"
  })), _path5459 || (_path5459 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102h-1v-1h1z",
    fill: "#d2d2d4"
  })), _path5460 || (_path5460 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102h-1v-1h1z",
    fill: "#d0d3d7"
  })), _path5461 || (_path5461 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101h1v1h-1z",
    fill: "#d9dad6"
  })), _path5462 || (_path5462 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v-1h1v1z",
    fill: "#dadad8"
  })), _path5463 || (_path5463 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102h-1v-1h1z",
    fill: "#d9d7cd"
  })), _path5464 || (_path5464 = /*#__PURE__*/React.createElement("path", {
    d: "M50 101h1v1h-1z",
    fill: "#9d7b50"
  })), _path5465 || (_path5465 = /*#__PURE__*/React.createElement("path", {
    d: "M51 101h1v1h-1z",
    fill: "#ab701c"
  })), _path5466 || (_path5466 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101v1h-1v-1z",
    fill: "#b27420"
  })), _path5467 || (_path5467 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101v1h-1v-1z",
    fill: "#9c6019"
  })), _path5468 || (_path5468 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101v1h-1v-1z",
    fill: "#b37a23"
  })), _path5469 || (_path5469 = /*#__PURE__*/React.createElement("path", {
    d: "M55 102v-1h1v1z",
    fill: "#b97d20"
  })), _path5470 || (_path5470 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102h-1v-1h1z",
    fill: "#a76613"
  })), _path5471 || (_path5471 = /*#__PURE__*/React.createElement("path", {
    d: "M58 102h-1v-1h1z",
    fill: "#b6751b"
  })), _path5472 || (_path5472 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v1h-1v-1z",
    fill: "#bc791d"
  })), _path5473 || (_path5473 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h1v1h-1z",
    fill: "#c17b1a"
  })), _path5474 || (_path5474 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102v-1h1v1z",
    fill: "#da961e"
  })), _path5475 || (_path5475 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101h1v1h-1z",
    fill: "#e29d22"
  })), _path5476 || (_path5476 = /*#__PURE__*/React.createElement("path", {
    d: "M63 101v1h-1v-1z",
    fill: "#f1aa31"
  })), _path5477 || (_path5477 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v-1h1v1z",
    fill: "#eaa32a"
  })), _path5478 || (_path5478 = /*#__PURE__*/React.createElement("path", {
    d: "M65 102v-1h1v1z",
    fill: "#f6bb4d"
  })), _path5479 || (_path5479 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h1v1h-1z",
    fill: "#edad3c"
  })), _path5480 || (_path5480 = /*#__PURE__*/React.createElement("path", {
    d: "M68 102h-1v-1h1z",
    fill: "#edaa3c"
  })), _path5481 || (_path5481 = /*#__PURE__*/React.createElement("path", {
    d: "M68 101h1v1h-1z",
    fill: "#f5b550"
  })), _path5482 || (_path5482 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h1v1h-1z",
    fill: "#fcbc5b"
  })), _path5483 || (_path5483 = /*#__PURE__*/React.createElement("path", {
    d: "M71 102h-1v-1h1z",
    fill: "#f4c073"
  })), _path5484 || (_path5484 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101v1h-1v-1z",
    fill: "#e5d2b8"
  })), _path5485 || (_path5485 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101h1v1h-1z",
    fill: "#dcdee0"
  })), _path5486 || (_path5486 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h-1v-1h1z",
    fill: "#dddfdf"
  })), _path5487 || (_path5487 = /*#__PURE__*/React.createElement("path", {
    d: "M75 101v1h-1v-1z",
    fill: "#dfe0dd"
  })), _path5488 || (_path5488 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102h-1v-1h1z",
    fill: "#e2e3e2",
    fillOpacity: 0.973
  })), _path5489 || (_path5489 = /*#__PURE__*/React.createElement("path", {
    d: "M19 102v1h-1v-1z",
    fill: "#86725b",
    fillOpacity: 0.482
  })), _path5490 || (_path5490 = /*#__PURE__*/React.createElement("path", {
    d: "M20 103h-1v-1h1z",
    fill: "#a07c56"
  })), _path5491 || (_path5491 = /*#__PURE__*/React.createElement("path", {
    d: "M21 102v1h-1v-1z",
    fill: "#ac8250"
  })), _path5492 || (_path5492 = /*#__PURE__*/React.createElement("path", {
    d: "M21 102h1v1h-1z",
    fill: "#b3894e"
  })), _path5493 || (_path5493 = /*#__PURE__*/React.createElement("path", {
    d: "M23 103h-1v-1h1z",
    fill: "#bc8f53"
  })), _path5494 || (_path5494 = /*#__PURE__*/React.createElement("path", {
    d: "M24 103v-1h1v1z",
    fill: "#cba067"
  })), _path5495 || (_path5495 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102h1v1h-1z",
    fill: "#d2a66e"
  })), _path5496 || (_path5496 = /*#__PURE__*/React.createElement("path", {
    d: "M27 103h-1v-1h1z",
    fill: "#d3ad81"
  })), _path5497 || (_path5497 = /*#__PURE__*/React.createElement("path", {
    d: "M28 103h-1v-1h1z",
    fill: "#ebccb4"
  })), _path5498 || (_path5498 = /*#__PURE__*/React.createElement("path", {
    d: "M29 103h-1v-1h1z",
    fill: "#debb9a"
  })), _path5499 || (_path5499 = /*#__PURE__*/React.createElement("path", {
    d: "M30 102v1h-1v-1z",
    fill: "#cfbba0"
  })), _path5500 || (_path5500 = /*#__PURE__*/React.createElement("path", {
    d: "M31 103h-1v-1h1z",
    fill: "#d1d1d2"
  })), _path5501 || (_path5501 = /*#__PURE__*/React.createElement("path", {
    d: "M33 102v1h-1v-1z",
    fill: "#cdd1d3"
  })), _path5502 || (_path5502 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v-1h1v1z",
    fill: "#cfd1d3"
  })), _path5503 || (_path5503 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102h1v1h-1z",
    fill: "#cfd3d4"
  })), _path5504 || (_path5504 = /*#__PURE__*/React.createElement("path", {
    d: "M37 102h1v1h-1z",
    fill: "#d1d1d1"
  })), _path5505 || (_path5505 = /*#__PURE__*/React.createElement("path", {
    d: "M38 103v-1h1v1z",
    fill: "#d0d3d3"
  })), _path5506 || (_path5506 = /*#__PURE__*/React.createElement("path", {
    d: "M40 103v-1h1v1z",
    fill: "#d3d5d8"
  })), _path5507 || (_path5507 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v-1h1v1z",
    fill: "#d1d3d6"
  })), _path5508 || (_path5508 = /*#__PURE__*/React.createElement("path", {
    d: "M44 102v1h-1v-1z",
    fill: "#c6c9ce"
  })), _path5509 || (_path5509 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102v1h-1v-1z",
    fill: "#cccccf"
  })), _path5510 || (_path5510 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h-1v-1h1z",
    fill: "#d1d1d3"
  })), _path5511 || (_path5511 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v1h-1v-1z",
    fill: "#cfd0ce"
  })), _path5512 || (_path5512 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102v1h-1v-1z",
    fill: "#cdcfca"
  })), _path5513 || (_path5513 = /*#__PURE__*/React.createElement("path", {
    d: "M51 103h-1v-1h1z",
    fill: "#b0967d"
  })), _path5514 || (_path5514 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h-1v-1h1z",
    fill: "#9e651a"
  })), _path5515 || (_path5515 = /*#__PURE__*/React.createElement("path", {
    d: "M53 103h-1v-1h1z",
    fill: "#b97b1d"
  })), _path5516 || (_path5516 = /*#__PURE__*/React.createElement("path", {
    d: "M53 102h1v1h-1z",
    fill: "#a3691c"
  })), _path5517 || (_path5517 = /*#__PURE__*/React.createElement("path", {
    d: "M54 102h1v1h-1z",
    fill: "#9b611b"
  })), _path5518 || (_path5518 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-1v-1h1z",
    fill: "#b4741d"
  })), _path5519 || (_path5519 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103v-1h1v1z",
    fill: "#bf7c1e"
  })), _path5520 || (_path5520 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103v-1h1v1z",
    fill: "#ab6b17"
  })), _path5521 || (_path5521 = /*#__PURE__*/React.createElement("path", {
    d: "M59 103h-1v-1h1z",
    fill: "#c07f1e"
  })), _path5522 || (_path5522 = /*#__PURE__*/React.createElement("path", {
    d: "M60 103h-1v-1h1z",
    fill: "#c17c1a"
  })), _path5523 || (_path5523 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102h1v1h-1z",
    fill: "#c27c17"
  })), _path5524 || (_path5524 = /*#__PURE__*/React.createElement("path", {
    d: "M62 102v1h-1v-1z",
    fill: "#de9923"
  })), _path5525 || (_path5525 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v1h-1v-1z",
    fill: "#eea928"
  })), _path5526 || (_path5526 = /*#__PURE__*/React.createElement("path", {
    d: "M64 102v1h-1v-1z",
    fill: "#f1a92a"
  })), _path5527 || (_path5527 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103h-1v-1h1z",
    fill: "#e7a029"
  })), _path5528 || (_path5528 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h-1v-1h1z",
    fill: "#f7ba52"
  })), _path5529 || (_path5529 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103v-1h1v1z",
    fill: "#f7b952"
  })), _path5530 || (_path5530 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h-1v-1h1z",
    fill: "#e3a135"
  })), _path5531 || (_path5531 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102v1h-1v-1z",
    fill: "#f3b34a"
  })), _path5532 || (_path5532 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102h1v1h-1z",
    fill: "#f8b453"
  })), _path5533 || (_path5533 = /*#__PURE__*/React.createElement("path", {
    d: "M70 102h1v1h-1z",
    fill: "#f7b85e"
  })), _path5534 || (_path5534 = /*#__PURE__*/React.createElement("path", {
    d: "M71 103v-1h1v1z",
    fill: "#ebc99b"
  })), _path5535 || (_path5535 = /*#__PURE__*/React.createElement("path", {
    d: "M73 102v1h-1v-1z",
    fill: "#e0dedd"
  })), _path5536 || (_path5536 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102v1h-1v-1z",
    fill: "#dedee2"
  })), _path5537 || (_path5537 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103h-1v-1h1z",
    fill: "#dde3e3",
    fillOpacity: 0.18
  })), _path5538 || (_path5538 = /*#__PURE__*/React.createElement("path", {
    d: "M19 104h-1v-1h1z",
    fill: "#7d6c56",
    fillOpacity: 0.486
  })), _path5539 || (_path5539 = /*#__PURE__*/React.createElement("path", {
    d: "M20 103v1h-1v-1z",
    fill: "#997852"
  })), _path5540 || (_path5540 = /*#__PURE__*/React.createElement("path", {
    d: "M20 103h1v1h-1z",
    fill: "#ad8252"
  })), _path5541 || (_path5541 = /*#__PURE__*/React.createElement("path", {
    d: "M22 103v1h-1v-1z",
    fill: "#b48a52"
  })), _path5542 || (_path5542 = /*#__PURE__*/React.createElement("path", {
    d: "M22 104v-1h1v1z",
    fill: "#bb8e53"
  })), _path5543 || (_path5543 = /*#__PURE__*/React.createElement("path", {
    d: "M24 104h-1v-1h1z",
    fill: "#c29459"
  })), _path5544 || (_path5544 = /*#__PURE__*/React.createElement("path", {
    d: "M25 103v1h-1v-1z",
    fill: "#c99c64"
  })), _path5545 || (_path5545 = /*#__PURE__*/React.createElement("path", {
    d: "M25 104v-1h1v1z",
    fill: "#cfa36a"
  })), _path5546 || (_path5546 = /*#__PURE__*/React.createElement("path", {
    d: "M26 104v-1h1v1z",
    fill: "#d8b184"
  })), _path5547 || (_path5547 = /*#__PURE__*/React.createElement("path", {
    d: "M29 104h-1v-1h1z",
    fill: "#d9bfad"
  })), _path5548 || (_path5548 = /*#__PURE__*/React.createElement("path", {
    d: "M30 104h-1v-1h1z",
    fill: "#d0c8c8"
  })), _path5549 || (_path5549 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v1h-1v-1z",
    fill: "#caced0"
  })), _path5550 || (_path5550 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v1h-1v-1z",
    fill: "#d1d2d5"
  })), _path5551 || (_path5551 = /*#__PURE__*/React.createElement("path", {
    d: "M42 103v1h-1v-1z",
    fill: "#d1d3d5"
  })), _path5552 || (_path5552 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104h-1v-1h1z",
    fill: "#c4c6c4"
  })), _path5553 || (_path5553 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104v-1h1v1z",
    fill: "#c4c8c6"
  })), _path5554 || (_path5554 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h-1v-1h1z",
    fill: "#bdb1a1"
  })), _path5555 || (_path5555 = /*#__PURE__*/React.createElement("path", {
    d: "M52 104h-1v-1h1z",
    fill: "#8b6024"
  })), _path5556 || (_path5556 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h1v1h-1z",
    fill: "#ae721e"
  })), _path5557 || (_path5557 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103v1h-1v-1z",
    fill: "#b27825"
  })), _path5558 || (_path5558 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104v-1h1v1z",
    fill: "#98611b"
  })), _path5559 || (_path5559 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h1v1z",
    fill: "#a7671f"
  })), _path5560 || (_path5560 = /*#__PURE__*/React.createElement("path", {
    d: "M56 104v-1h1v1z",
    fill: "#c98823"
  })), _path5561 || (_path5561 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103v1h-1v-1z",
    fill: "#b8771b"
  })), _path5562 || (_path5562 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103h1v1h-1z",
    fill: "#b97719"
  })), _path5563 || (_path5563 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104v-1h1v1z",
    fill: "#cc8c1a"
  })), _path5564 || (_path5564 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104v-1h1v1z",
    fill: "#bc7717"
  })), _path5565 || (_path5565 = /*#__PURE__*/React.createElement("path", {
    d: "M62 104h-1v-1h1z",
    fill: "#c7831e"
  })), _path5566 || (_path5566 = /*#__PURE__*/React.createElement("path", {
    d: "M62 103h1v1h-1z",
    fill: "#e5a22d"
  })), _path5567 || (_path5567 = /*#__PURE__*/React.createElement("path", {
    d: "M63 103h1v1h-1z",
    fill: "#fdb841"
  })), _path5568 || (_path5568 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103v1h-1v-1z",
    fill: "#eaa932"
  })), _path5569 || (_path5569 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104v-1h1v1z",
    fill: "#da9b30"
  })), _path5570 || (_path5570 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h1v1h-1z",
    fill: "#fabd5e"
  })), _path5571 || (_path5571 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103v1h-1v-1z",
    fill: "#f2b84e"
  })), _path5572 || (_path5572 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h1v1h-1z",
    fill: "#eba93f"
  })), _path5573 || (_path5573 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104h-1v-1h1z",
    fill: "#f6b24c"
  })), _path5574 || (_path5574 = /*#__PURE__*/React.createElement("path", {
    d: "M71 103v1h-1v-1z",
    fill: "#f8b757"
  })), _path5575 || (_path5575 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103v1h-1v-1z",
    fill: "#edbe83"
  })), _path5576 || (_path5576 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103h1v1h-1z",
    fill: "#e3d9d4"
  })), _path5577 || (_path5577 = /*#__PURE__*/React.createElement("path", {
    d: "M73 103h1v1h-1z",
    fill: "#dddfe2"
  })), _path5578 || (_path5578 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104h-1v-1h1z",
    fill: "#dee0de"
  })), _path5579 || (_path5579 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103v1h-1v-1z",
    fill: "#dee1e0",
    fillOpacity: 0.969
  })), _path5580 || (_path5580 = /*#__PURE__*/React.createElement("path", {
    d: "M19 104v1h-1v-1z",
    fill: "#7c6d5b",
    fillOpacity: 0.482
  })), _path5581 || (_path5581 = /*#__PURE__*/React.createElement("path", {
    d: "M19 105v-1h1v1z",
    fill: "#907050"
  })), _path5582 || (_path5582 = /*#__PURE__*/React.createElement("path", {
    d: "M21 105h-1v-1h1z",
    fill: "#a67d52"
  })), _path5583 || (_path5583 = /*#__PURE__*/React.createElement("path", {
    d: "M22 104v1h-1v-1z",
    fill: "#b68d5c"
  })), _path5584 || (_path5584 = /*#__PURE__*/React.createElement("path", {
    d: "M23 104v1h-1v-1z",
    fill: "#c09461"
  })), _path5585 || (_path5585 = /*#__PURE__*/React.createElement("path", {
    d: "M23 104h1v1h-1z",
    fill: "#c1925c"
  })), _path5586 || (_path5586 = /*#__PURE__*/React.createElement("path", {
    d: "M25 105h-1v-1h1z",
    fill: "#cb9e66"
  })), _path5587 || (_path5587 = /*#__PURE__*/React.createElement("path", {
    d: "M25 104h1v1h-1z",
    fill: "#d3a76f"
  })), _path5588 || (_path5588 = /*#__PURE__*/React.createElement("path", {
    d: "M26 105v-1h1v1z",
    fill: "#d2ab7e"
  })), _path5589 || (_path5589 = /*#__PURE__*/React.createElement("path", {
    d: "M28 105h-1v-1h1z",
    fill: "#ebccb0"
  })), _path5590 || (_path5590 = /*#__PURE__*/React.createElement("path", {
    d: "M28 105v-1h1v1z",
    fill: "#dac2ad"
  })), _path5591 || (_path5591 = /*#__PURE__*/React.createElement("path", {
    d: "M29 105v-1h1v1z",
    fill: "#d0cac7"
  })), _path5592 || (_path5592 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104v1h-1v-1z",
    fill: "#caccce"
  })), _path5593 || (_path5593 = /*#__PURE__*/React.createElement("path", {
    d: "M35 105v-1h1v1z",
    fill: "#cdcdcf"
  })), _path5594 || (_path5594 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h1v1h-1z",
    fill: "#d2d4d6"
  })), _path5595 || (_path5595 = /*#__PURE__*/React.createElement("path", {
    d: "M48 104v1h-1v-1z",
    fill: "#c9cccc"
  })), _path5596 || (_path5596 = /*#__PURE__*/React.createElement("path", {
    d: "M49 105h-1v-1h1z",
    fill: "#bec1bf"
  })), _path5597 || (_path5597 = /*#__PURE__*/React.createElement("path", {
    d: "M50 104v1h-1v-1z",
    fill: "#b5bab9"
  })), _path5598 || (_path5598 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105v-1h1v1z",
    fill: "#b5b4ac"
  })), _path5599 || (_path5599 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h1v1h-1z",
    fill: "#91744e"
  })), _path5600 || (_path5600 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104v1h-1v-1z",
    fill: "#8e5a1c"
  })), _path5601 || (_path5601 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104h1v1h-1z",
    fill: "#ab6f24"
  })), _path5602 || (_path5602 = /*#__PURE__*/React.createElement("path", {
    d: "M55 105h-1v-1h1z",
    fill: "#ac711e"
  })), _path5603 || (_path5603 = /*#__PURE__*/React.createElement("path", {
    d: "M56 105h-1v-1h1z",
    fill: "#965b1b"
  })), _path5604 || (_path5604 = /*#__PURE__*/React.createElement("path", {
    d: "M57 104v1h-1v-1z",
    fill: "#b5791e"
  })), _path5605 || (_path5605 = /*#__PURE__*/React.createElement("path", {
    d: "M58 104v1h-1v-1z",
    fill: "#ce8a1c"
  })), _path5606 || (_path5606 = /*#__PURE__*/React.createElement("path", {
    d: "M58 105v-1h1v1z",
    fill: "#b5710d"
  })), _path5607 || (_path5607 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104h1v1h-1z",
    fill: "#c6861c"
  })), _path5608 || (_path5608 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104h1v1h-1z",
    fill: "#c78626"
  })), _path5609 || (_path5609 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104h1v1h-1z",
    fill: "#ad6b17"
  })), _path5610 || (_path5610 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h-1v-1h1z",
    fill: "#b97817"
  })), _path5611 || (_path5611 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h-1v-1h1z",
    fill: "#e7a53a"
  })), _path5612 || (_path5612 = /*#__PURE__*/React.createElement("path", {
    d: "M65 105h-1v-1h1z",
    fill: "#fabc4a"
  })), _path5613 || (_path5613 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104h1v1h-1z",
    fill: "#e1a22f"
  })), _path5614 || (_path5614 = /*#__PURE__*/React.createElement("path", {
    d: "M66 104h1v1h-1z",
    fill: "#eca83f"
  })), _path5615 || (_path5615 = /*#__PURE__*/React.createElement("path", {
    d: "M68 105h-1v-1h1z",
    fill: "#fec25a"
  })), _path5616 || (_path5616 = /*#__PURE__*/React.createElement("path", {
    d: "M68 104h1v1h-1z",
    fill: "#f3b64f"
  })), _path5617 || (_path5617 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104v1h-1v-1z",
    fill: "#f0af49"
  })), _path5618 || (_path5618 = /*#__PURE__*/React.createElement("path", {
    d: "M71 105h-1v-1h1z",
    fill: "#f9b34e"
  })), _path5619 || (_path5619 = /*#__PURE__*/React.createElement("path", {
    d: "M71 104h1v1h-1z",
    fill: "#edb26a"
  })), _path5620 || (_path5620 = /*#__PURE__*/React.createElement("path", {
    d: "M73 104v1h-1v-1z",
    fill: "#e0d1c4"
  })), _path5621 || (_path5621 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v-1h1v1z",
    fill: "#e1e3e1"
  })), _path5622 || (_path5622 = /*#__PURE__*/React.createElement("path", {
    d: "M19 106h-1v-1h1z",
    fill: "#7a6b5c",
    fillOpacity: 0.475
  })), _path5623 || (_path5623 = /*#__PURE__*/React.createElement("path", {
    d: "M19 105h1v1h-1z",
    fill: "#8f7356"
  })), _path5624 || (_path5624 = /*#__PURE__*/React.createElement("path", {
    d: "M20 106v-1h1v1z",
    fill: "#9c7a4f"
  })), _path5625 || (_path5625 = /*#__PURE__*/React.createElement("path", {
    d: "M22 106v-1h1v1z",
    fill: "#c09669"
  })), _path5626 || (_path5626 = /*#__PURE__*/React.createElement("path", {
    d: "M24 106h-1v-1h1z",
    fill: "#ca9d6e"
  })), _path5627 || (_path5627 = /*#__PURE__*/React.createElement("path", {
    d: "M25 106h-1v-1h1z",
    fill: "#cb9f6b"
  })), _path5628 || (_path5628 = /*#__PURE__*/React.createElement("path", {
    d: "M25 106v-1h1v1z",
    fill: "#d3a673"
  })), _path5629 || (_path5629 = /*#__PURE__*/React.createElement("path", {
    d: "M26 105h1v1h-1z",
    fill: "#dbb38a"
  })), _path5630 || (_path5630 = /*#__PURE__*/React.createElement("path", {
    d: "M28 105v1h-1v-1z",
    fill: "#e9caad"
  })), _path5631 || (_path5631 = /*#__PURE__*/React.createElement("path", {
    d: "M29 106h-1v-1h1z",
    fill: "#d9c3ab"
  })), _path5632 || (_path5632 = /*#__PURE__*/React.createElement("path", {
    d: "M29 105h1v1h-1z",
    fill: "#ccc8c5"
  })), _path5633 || (_path5633 = /*#__PURE__*/React.createElement("path", {
    d: "M31 106h-1v-1h1z",
    fill: "#c7cdcb"
  })), _path5634 || (_path5634 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105h1v1h-1z",
    fill: "#c8cccb"
  })), _path5635 || (_path5635 = /*#__PURE__*/React.createElement("path", {
    d: "M36 106h-1v-1h1z",
    fill: "#cbcbcd"
  })), _path5636 || (_path5636 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h-1v-1h1z",
    fill: "#d0d2d4"
  })), _path5637 || (_path5637 = /*#__PURE__*/React.createElement("path", {
    d: "M47 105v1h-1v-1z",
    fill: "#d1d5d7"
  })), _path5638 || (_path5638 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106v-1h1v1z",
    fill: "#c3c6c5"
  })), _path5639 || (_path5639 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105h1v1h-1z",
    fill: "#bbbbbc"
  })), _path5640 || (_path5640 = /*#__PURE__*/React.createElement("path", {
    d: "M52 105v1h-1v-1z",
    fill: "#a89a8a"
  })), _path5641 || (_path5641 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h-1v-1h1z",
    fill: "#7a5529"
  })), _path5642 || (_path5642 = /*#__PURE__*/React.createElement("path", {
    d: "M54 105v1h-1v-1z",
    fill: "#955d1f"
  })), _path5643 || (_path5643 = /*#__PURE__*/React.createElement("path", {
    d: "M54 106v-1h1v1z",
    fill: "#b27223"
  })), _path5644 || (_path5644 = /*#__PURE__*/React.createElement("path", {
    d: "M56 106h-1v-1h1z",
    fill: "#a06a25"
  })), _path5645 || (_path5645 = /*#__PURE__*/React.createElement("path", {
    d: "M57 105v1h-1v-1z",
    fill: "#965a19"
  })), _path5646 || (_path5646 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106h-1v-1h1z",
    fill: "#c4831a"
  })), _path5647 || (_path5647 = /*#__PURE__*/React.createElement("path", {
    d: "M59 105v1h-1v-1z",
    fill: "#ce9015"
  })), _path5648 || (_path5648 = /*#__PURE__*/React.createElement("path", {
    d: "M59 106v-1h1v1z",
    fill: "#c37f19"
  })), _path5649 || (_path5649 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v-1h1v1z",
    fill: "#c07e1c"
  })), _path5650 || (_path5650 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106v-1h1v1z",
    fill: "#b37120"
  })), _path5651 || (_path5651 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105v1h-1v-1z",
    fill: "#be7d24"
  })), _path5652 || (_path5652 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h1v1h-1z",
    fill: "#cd8c1f"
  })), _path5653 || (_path5653 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h1v1h-1z",
    fill: "#f3b546"
  })), _path5654 || (_path5654 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v-1h1v1z",
    fill: "#fab94a"
  })), _path5655 || (_path5655 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105v1h-1v-1z",
    fill: "#e29b2c"
  })), _path5656 || (_path5656 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105h1v1h-1z",
    fill: "#eeaf49"
  })), _path5657 || (_path5657 = /*#__PURE__*/React.createElement("path", {
    d: "M69 105v1h-1v-1z",
    fill: "#fbc260"
  })), _path5658 || (_path5658 = /*#__PURE__*/React.createElement("path", {
    d: "M70 106h-1v-1h1z",
    fill: "#f5b957"
  })), _path5659 || (_path5659 = /*#__PURE__*/React.createElement("path", {
    d: "M70 105h1v1h-1z",
    fill: "#f5ae4b"
  })), _path5660 || (_path5660 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106v-1h1v1z",
    fill: "#e2a25a"
  })), _path5661 || (_path5661 = /*#__PURE__*/React.createElement("path", {
    d: "M72 105h1v1h-1z",
    fill: "#e0d0c2"
  })), _path5662 || (_path5662 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v-1h1v1z",
    fill: "#dee1e2"
  })), _path5663 || (_path5663 = /*#__PURE__*/React.createElement("path", {
    d: "M19 106v1h-1v-1z",
    fill: "#7e7665",
    fillOpacity: 0.475
  })), _path5664 || (_path5664 = /*#__PURE__*/React.createElement("path", {
    d: "M19 107v-1h1v1z",
    fill: "#8d7456"
  })), _path5665 || (_path5665 = /*#__PURE__*/React.createElement("path", {
    d: "M20 107v-1h1v1z",
    fill: "#9e7c51"
  })), _path5666 || (_path5666 = /*#__PURE__*/React.createElement("path", {
    d: "M21 106h1v1h-1z",
    fill: "#a07c4e"
  })), _path5667 || (_path5667 = /*#__PURE__*/React.createElement("path", {
    d: "M23 107h-1v-1h1z",
    fill: "#a88055"
  })), _path5668 || (_path5668 = /*#__PURE__*/React.createElement("path", {
    d: "M23 106h1v1h-1z",
    fill: "#c2986d"
  })), _path5669 || (_path5669 = /*#__PURE__*/React.createElement("path", {
    d: "M24 107v-1h1v1z",
    fill: "#d2a777"
  })), _path5670 || (_path5670 = /*#__PURE__*/React.createElement("path", {
    d: "M25 107v-1h1v1z",
    fill: "#d7ad7d"
  })), _path5671 || (_path5671 = /*#__PURE__*/React.createElement("path", {
    d: "M26 107v-1h1v1z",
    fill: "#dbb48f"
  })), _path5672 || (_path5672 = /*#__PURE__*/React.createElement("path", {
    d: "M27 106h1v1h-1z",
    fill: "#e7c8ab"
  })), _path5673 || (_path5673 = /*#__PURE__*/React.createElement("path", {
    d: "M29 106v1h-1v-1z",
    fill: "#dac5ab"
  })), _path5674 || (_path5674 = /*#__PURE__*/React.createElement("path", {
    d: "M29 107v-1h1v1z",
    fill: "#cdc9c5"
  })), _path5675 || (_path5675 = /*#__PURE__*/React.createElement("path", {
    d: "M30 106h1v1h-1z",
    fill: "#c8cdcc"
  })), _path5676 || (_path5676 = /*#__PURE__*/React.createElement("path", {
    d: "M32 107h-1v-1h1z",
    fill: "#c8cbca"
  })), _path5677 || (_path5677 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106v1h-1v-1z",
    fill: "#ccced0"
  })), _path5678 || (_path5678 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h1v1h-1z",
    fill: "#c9cccf"
  })), _path5679 || (_path5679 = /*#__PURE__*/React.createElement("path", {
    d: "M48 106v1h-1v-1z",
    fill: "#ccd0d2"
  })), _path5680 || (_path5680 = /*#__PURE__*/React.createElement("path", {
    d: "M48 107v-1h1v1z",
    fill: "#cfd2d3"
  })), _path5681 || (_path5681 = /*#__PURE__*/React.createElement("path", {
    d: "M51 106v1h-1v-1z",
    fill: "#d0d2d5"
  })), _path5682 || (_path5682 = /*#__PURE__*/React.createElement("path", {
    d: "M51 107v-1h1v1z",
    fill: "#d5d6d0"
  })), _path5683 || (_path5683 = /*#__PURE__*/React.createElement("path", {
    d: "M52 106h1v1h-1z",
    fill: "#c9bea5"
  })), _path5684 || (_path5684 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h1v1h-1z",
    fill: "#916d44"
  })), _path5685 || (_path5685 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v-1h1v1z",
    fill: "#9b6927"
  })), _path5686 || (_path5686 = /*#__PURE__*/React.createElement("path", {
    d: "M55 107v-1h1v1z",
    fill: "#a36f25"
  })), _path5687 || (_path5687 = /*#__PURE__*/React.createElement("path", {
    d: "M57 107h-1v-1h1z",
    fill: "#92591d"
  })), _path5688 || (_path5688 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106v1h-1v-1z",
    fill: "#9f661b"
  })), _path5689 || (_path5689 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h-1v-1h1z",
    fill: "#cc8f1b"
  })), _path5690 || (_path5690 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v1h-1v-1z",
    fill: "#de9c1a"
  })), _path5691 || (_path5691 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107v-1h1v1z",
    fill: "#d0901d"
  })), _path5692 || (_path5692 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106h1v1h-1z",
    fill: "#ae6d1a"
  })), _path5693 || (_path5693 = /*#__PURE__*/React.createElement("path", {
    d: "M62 106h1v1h-1z",
    fill: "#b97728"
  })), _path5694 || (_path5694 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107h-1v-1h1z",
    fill: "#d39121"
  })), _path5695 || (_path5695 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v1h-1v-1z",
    fill: "#e7a930"
  })), _path5696 || (_path5696 = /*#__PURE__*/React.createElement("path", {
    d: "M65 107v-1h1v1z",
    fill: "#f1b242"
  })), _path5697 || (_path5697 = /*#__PURE__*/React.createElement("path", {
    d: "M66 106h1v1h-1z",
    fill: "#f5b344"
  })), _path5698 || (_path5698 = /*#__PURE__*/React.createElement("path", {
    d: "M68 106v1h-1v-1z",
    fill: "#df9c35"
  })), _path5699 || (_path5699 = /*#__PURE__*/React.createElement("path", {
    d: "M68 107v-1h1v1z",
    fill: "#eeb050"
  })), _path5700 || (_path5700 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v-1h1v1z",
    fill: "#fdc160"
  })), _path5701 || (_path5701 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107v-1h1v1z",
    fill: "#edaa4d"
  })), _path5702 || (_path5702 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106h1v1h-1z",
    fill: "#e0ad73"
  })), _path5703 || (_path5703 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v1h-1v-1z",
    fill: "#e3ddd3"
  })), _path5704 || (_path5704 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h-1v-1h1z",
    fill: "#dcdfdf"
  })), _path5705 || (_path5705 = /*#__PURE__*/React.createElement("path", {
    d: "M75 106v1h-1v-1z",
    fill: "#dbdbdb"
  })), _path5706 || (_path5706 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v1h-1v-1z",
    fill: "#dee0df",
    fillOpacity: 0.976
  })), _path5707 || (_path5707 = /*#__PURE__*/React.createElement("path", {
    d: "M19 108h-1v-1h1z",
    fill: "#778181",
    fillOpacity: 0.486
  })), _path5708 || (_path5708 = /*#__PURE__*/React.createElement("path", {
    d: "M20 107v1h-1v-1z",
    fill: "#8f816c"
  })), _path5709 || (_path5709 = /*#__PURE__*/React.createElement("path", {
    d: "M21 108h-1v-1h1z",
    fill: "#ae875c"
  })), _path5710 || (_path5710 = /*#__PURE__*/React.createElement("path", {
    d: "M23 107v1h-1v-1z",
    fill: "#a98458"
  })), _path5711 || (_path5711 = /*#__PURE__*/React.createElement("path", {
    d: "M23 108v-1h1v1z",
    fill: "#ad865c"
  })), _path5712 || (_path5712 = /*#__PURE__*/React.createElement("path", {
    d: "M25 107v1h-1v-1z",
    fill: "#c7a071"
  })), _path5713 || (_path5713 = /*#__PURE__*/React.createElement("path", {
    d: "M25 107h1v1h-1z",
    fill: "#d5af7f"
  })), _path5714 || (_path5714 = /*#__PURE__*/React.createElement("path", {
    d: "M27 108h-1v-1h1z",
    fill: "#dab690"
  })), _path5715 || (_path5715 = /*#__PURE__*/React.createElement("path", {
    d: "M28 107v1h-1v-1z",
    fill: "#e4c6a8"
  })), _path5716 || (_path5716 = /*#__PURE__*/React.createElement("path", {
    d: "M29 108h-1v-1h1z",
    fill: "#dbc6a9"
  })), _path5717 || (_path5717 = /*#__PURE__*/React.createElement("path", {
    d: "M30 107v1h-1v-1z",
    fill: "#cfcac7"
  })), _path5718 || (_path5718 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107v1h-1v-1z",
    fill: "#c9cdcd"
  })), _path5719 || (_path5719 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107h1v1h-1z",
    fill: "#cacbcb"
  })), _path5720 || (_path5720 = /*#__PURE__*/React.createElement("path", {
    d: "M43 107h1v1h-1z",
    fill: "#bfc0c2"
  })), _path5721 || (_path5721 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107v1h-1v-1z",
    fill: "#bbbcbe"
  })), _path5722 || (_path5722 = /*#__PURE__*/React.createElement("path", {
    d: "M47 107v1h-1v-1z",
    fill: "#babec0"
  })), _path5723 || (_path5723 = /*#__PURE__*/React.createElement("path", {
    d: "M47 108v-1h1v1z",
    fill: "#c8cbcc"
  })), _path5724 || (_path5724 = /*#__PURE__*/React.createElement("path", {
    d: "M50 107v1h-1v-1z",
    fill: "#cdcfcd"
  })), _path5725 || (_path5725 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108h-1v-1h1z",
    fill: "#d4d4ce"
  })), _path5726 || (_path5726 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v1h-1v-1z",
    fill: "#d6d1c5"
  })), _path5727 || (_path5727 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107h1v1h-1z",
    fill: "#d1c3b0"
  })), _path5728 || (_path5728 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108h-1v-1h1z",
    fill: "#cbae87"
  })), _path5729 || (_path5729 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108v-1h1v1z",
    fill: "#976d2e"
  })), _path5730 || (_path5730 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108v-1h1v1z",
    fill: "#814e16"
  })), _path5731 || (_path5731 = /*#__PURE__*/React.createElement("path", {
    d: "M59 108h-1v-1h1z",
    fill: "#ad701c"
  })), _path5732 || (_path5732 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h1v1h-1z",
    fill: "#cc8d12"
  })), _path5733 || (_path5733 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107h1v1h-1z",
    fill: "#df9e20"
  })), _path5734 || (_path5734 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107v1h-1v-1z",
    fill: "#c18021"
  })), _path5735 || (_path5735 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107h1v1h-1z",
    fill: "#a0631a"
  })), _path5736 || (_path5736 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107v1h-1v-1z",
    fill: "#b77b1f"
  })), _path5737 || (_path5737 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108v-1h1v1z",
    fill: "#de9f2d"
  })), _path5738 || (_path5738 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h-1v-1h1z",
    fill: "#e5a22e"
  })), _path5739 || (_path5739 = /*#__PURE__*/React.createElement("path", {
    d: "M66 107h1v1h-1z",
    fill: "#f4b247"
  })), _path5740 || (_path5740 = /*#__PURE__*/React.createElement("path", {
    d: "M67 107h1v1h-1z",
    fill: "#f2ad44"
  })), _path5741 || (_path5741 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v1h-1v-1z",
    fill: "#eba53f"
  })), _path5742 || (_path5742 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108v-1h1v1z",
    fill: "#e4a33f"
  })), _path5743 || (_path5743 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107h1v1h-1z",
    fill: "#dd9b45"
  })), _path5744 || (_path5744 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v-1h1v1z",
    fill: "#ddba99"
  })), _path5745 || (_path5745 = /*#__PURE__*/React.createElement("path", {
    d: "M72 108v-1h1v1z",
    fill: "#e2e0e3"
  })), _path5746 || (_path5746 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107v1h-1v-1z",
    fill: "#d9dcde"
  })), _path5747 || (_path5747 = /*#__PURE__*/React.createElement("path", {
    d: "M78 107v1h-1v-1z",
    fill: "#dfe4df",
    fillOpacity: 0.188
  })), _path5748 || (_path5748 = /*#__PURE__*/React.createElement("path", {
    d: "M18 108h1v1h-1z",
    fill: "#67889e",
    fillOpacity: 0.475
  })), _path5749 || (_path5749 = /*#__PURE__*/React.createElement("path", {
    d: "M20 109h-1v-1h1z",
    fill: "#7e8a8f"
  })), _path5750 || (_path5750 = /*#__PURE__*/React.createElement("path", {
    d: "M20 108h1v1h-1z",
    fill: "#ac8965"
  })), _path5751 || (_path5751 = /*#__PURE__*/React.createElement("path", {
    d: "M21 108h1v1h-1z",
    fill: "#b79060"
  })), _path5752 || (_path5752 = /*#__PURE__*/React.createElement("path", {
    d: "M22 108h1v1h-1z",
    fill: "#ab8659"
  })), _path5753 || (_path5753 = /*#__PURE__*/React.createElement("path", {
    d: "M24 108v1h-1v-1z",
    fill: "#af8b5e"
  })), _path5754 || (_path5754 = /*#__PURE__*/React.createElement("path", {
    d: "M25 108v1h-1v-1z",
    fill: "#b69064"
  })), _path5755 || (_path5755 = /*#__PURE__*/React.createElement("path", {
    d: "M25 109v-1h1v1z",
    fill: "#c59d71"
  })), _path5756 || (_path5756 = /*#__PURE__*/React.createElement("path", {
    d: "M27 109h-1v-1h1z",
    fill: "#d6b28c"
  })), _path5757 || (_path5757 = /*#__PURE__*/React.createElement("path", {
    d: "M27 109v-1h1v1z",
    fill: "#e5c7a9"
  })), _path5758 || (_path5758 = /*#__PURE__*/React.createElement("path", {
    d: "M28 108h1v1h-1z",
    fill: "#d7c2a6"
  })), _path5759 || (_path5759 = /*#__PURE__*/React.createElement("path", {
    d: "M30 109h-1v-1h1z",
    fill: "#cecac7"
  })), _path5760 || (_path5760 = /*#__PURE__*/React.createElement("path", {
    d: "M44 108v1h-1v-1z",
    fill: "#bebfc1"
  })), _path5761 || (_path5761 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v-1h1v1z",
    fill: "#abadaf"
  })), _path5762 || (_path5762 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h-1v-1h1z",
    fill: "#b5b7b7"
  })), _path5763 || (_path5763 = /*#__PURE__*/React.createElement("path", {
    d: "M49 108v1h-1v-1z",
    fill: "#c1c4c3"
  })), _path5764 || (_path5764 = /*#__PURE__*/React.createElement("path", {
    d: "M50 109h-1v-1h1z",
    fill: "#c3c6c3"
  })), _path5765 || (_path5765 = /*#__PURE__*/React.createElement("path", {
    d: "M51 109h-1v-1h1z",
    fill: "#caccc8"
  })), _path5766 || (_path5766 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h-1v-1h1z",
    fill: "#c9cdd0"
  })), _path5767 || (_path5767 = /*#__PURE__*/React.createElement("path", {
    d: "M55 108h1v1h-1z",
    fill: "#d0cec8"
  })), _path5768 || (_path5768 = /*#__PURE__*/React.createElement("path", {
    d: "M57 109h-1v-1h1z",
    fill: "#cbbda0"
  })), _path5769 || (_path5769 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108h1v1h-1z",
    fill: "#a48765"
  })), _path5770 || (_path5770 = /*#__PURE__*/React.createElement("path", {
    d: "M58 109v-1h1v1z",
    fill: "#82542b"
  })), _path5771 || (_path5771 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v-1h1v1z",
    fill: "#a76d1b"
  })), _path5772 || (_path5772 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109v-1h1v1z",
    fill: "#d18d1a"
  })), _path5773 || (_path5773 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h-1v-1h1z",
    fill: "#df9923"
  })), _path5774 || (_path5774 = /*#__PURE__*/React.createElement("path", {
    d: "M63 108v1h-1v-1z",
    fill: "#b87423"
  })), _path5775 || (_path5775 = /*#__PURE__*/React.createElement("path", {
    d: "M63 109v-1h1v1z",
    fill: "#985c19"
  })), _path5776 || (_path5776 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108h1v1h-1z",
    fill: "#ac7121"
  })), _path5777 || (_path5777 = /*#__PURE__*/React.createElement("path", {
    d: "M65 108h1v1h-1z",
    fill: "#e19b36"
  })), _path5778 || (_path5778 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h1v1h-1z",
    fill: "#e5a238"
  })), _path5779 || (_path5779 = /*#__PURE__*/React.createElement("path", {
    d: "M68 108v1h-1v-1z",
    fill: "#e6a43b"
  })), _path5780 || (_path5780 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h-1v-1h1z",
    fill: "#de9934"
  })), _path5781 || (_path5781 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108h1v1h-1z",
    fill: "#e29d3b"
  })), _path5782 || (_path5782 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v1h-1v-1z",
    fill: "#d29041"
  })), _path5783 || (_path5783 = /*#__PURE__*/React.createElement("path", {
    d: "M71 109v-1h1v1z",
    fill: "#d8bda6"
  })), _path5784 || (_path5784 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109v-1h1v1z",
    fill: "#dfdde2"
  })), _path5785 || (_path5785 = /*#__PURE__*/React.createElement("path", {
    d: "M74 108h1v1h-1z",
    fill: "#d8dcd9"
  })), _path5786 || (_path5786 = /*#__PURE__*/React.createElement("path", {
    d: "M18 109h1v1h-1z",
    fill: "#6188a3",
    fillOpacity: 0.482
  })), _path5787 || (_path5787 = /*#__PURE__*/React.createElement("path", {
    d: "M19 110v-1h1v1z",
    fill: "#6a9bc0"
  })), _path5788 || (_path5788 = /*#__PURE__*/React.createElement("path", {
    d: "M21 110h-1v-1h1z",
    fill: "#829094"
  })), _path5789 || (_path5789 = /*#__PURE__*/React.createElement("path", {
    d: "M22 110h-1v-1h1z",
    fill: "#ac8d69"
  })), _path5790 || (_path5790 = /*#__PURE__*/React.createElement("path", {
    d: "M23 109v1h-1v-1z",
    fill: "#bc9366"
  })), _path5791 || (_path5791 = /*#__PURE__*/React.createElement("path", {
    d: "M24 109v1h-1v-1z",
    fill: "#b58f61"
  })), _path5792 || (_path5792 = /*#__PURE__*/React.createElement("path", {
    d: "M25 110h-1v-1h1z",
    fill: "#b58e63"
  })), _path5793 || (_path5793 = /*#__PURE__*/React.createElement("path", {
    d: "M26 109v1h-1v-1z",
    fill: "#bd956b"
  })), _path5794 || (_path5794 = /*#__PURE__*/React.createElement("path", {
    d: "M26 110v-1h1v1z",
    fill: "#be9a73"
  })), _path5795 || (_path5795 = /*#__PURE__*/React.createElement("path", {
    d: "M28 109v1h-1v-1z",
    fill: "#e2c4a6"
  })), _path5796 || (_path5796 = /*#__PURE__*/React.createElement("path", {
    d: "M29 109v1h-1v-1z",
    fill: "#d7c2a7"
  })), _path5797 || (_path5797 = /*#__PURE__*/React.createElement("path", {
    d: "M29 109h1v1h-1z",
    fill: "#d0ccc9"
  })), _path5798 || (_path5798 = /*#__PURE__*/React.createElement("path", {
    d: "M30 109h1v1h-1z",
    fill: "#cbcfce"
  })), _path5799 || (_path5799 = /*#__PURE__*/React.createElement("path", {
    d: "M33 109v1h-1v-1z",
    fill: "#ced0d1"
  })), _path5800 || (_path5800 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h1v1h-1z",
    fill: "#c9cacb"
  })), _path5801 || (_path5801 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h1v1h-1z",
    fill: "#c3c6c7"
  })), _path5802 || (_path5802 = /*#__PURE__*/React.createElement("path", {
    d: "M49 109h1v1h-1z",
    fill: "#c4c7c8"
  })), _path5803 || (_path5803 = /*#__PURE__*/React.createElement("path", {
    d: "M50 110v-1h1v1z",
    fill: "#cacccd"
  })), _path5804 || (_path5804 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110h-1v-1h1z",
    fill: "#c8c9c9"
  })), _path5805 || (_path5805 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110h-1v-1h1z",
    fill: "#cbcecd"
  })), _path5806 || (_path5806 = /*#__PURE__*/React.createElement("path", {
    d: "M54 109h1v1h-1z",
    fill: "#c9cbc9"
  })), _path5807 || (_path5807 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h1v1h-1z",
    fill: "#c4c5c9"
  })), _path5808 || (_path5808 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110v-1h1v1z",
    fill: "#d1d0cb"
  })), _path5809 || (_path5809 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v1h-1v-1z",
    fill: "#ccc5b8"
  })), _path5810 || (_path5810 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109h1v1h-1z",
    fill: "#c0ac8d"
  })), _path5811 || (_path5811 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109h1v1h-1z",
    fill: "#cea969"
  })), _path5812 || (_path5812 = /*#__PURE__*/React.createElement("path", {
    d: "M62 110h-1v-1h1z",
    fill: "#d6a449"
  })), _path5813 || (_path5813 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h1v1h-1z",
    fill: "#bd8338"
  })), _path5814 || (_path5814 = /*#__PURE__*/React.createElement("path", {
    d: "M64 109v1h-1v-1z",
    fill: "#aa7630"
  })), _path5815 || (_path5815 = /*#__PURE__*/React.createElement("path", {
    d: "M65 110h-1v-1h1z",
    fill: "#a16823"
  })), _path5816 || (_path5816 = /*#__PURE__*/React.createElement("path", {
    d: "M65 109h1v1h-1z",
    fill: "#b4721f"
  })), _path5817 || (_path5817 = /*#__PURE__*/React.createElement("path", {
    d: "M66 109h1v1h-1z",
    fill: "#c78029"
  })), _path5818 || (_path5818 = /*#__PURE__*/React.createElement("path", {
    d: "M67 110v-1h1v1z",
    fill: "#cf8a34"
  })), _path5819 || (_path5819 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109v1h-1v-1z",
    fill: "#d6913b"
  })), _path5820 || (_path5820 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h1v1h-1z",
    fill: "#dc973d"
  })), _path5821 || (_path5821 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110h-1v-1h1z",
    fill: "#cb893f"
  })), _path5822 || (_path5822 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h-1v-1h1z",
    fill: "#d8bba8"
  })), _path5823 || (_path5823 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109h1v1h-1z",
    fill: "#dadcde"
  })), _path5824 || (_path5824 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109h1v1h-1z",
    fill: "#d3d6d4"
  })), _path5825 || (_path5825 = /*#__PURE__*/React.createElement("path", {
    d: "M74 110v-1h1v1z",
    fill: "#d9dadb"
  })), _path5826 || (_path5826 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109h1v1h-1z",
    fill: "#e4e4e4",
    fillOpacity: 0.192
  })), _path5827 || (_path5827 = /*#__PURE__*/React.createElement("path", {
    d: "M19 111h-1v-1h1z",
    fill: "#62889e",
    fillOpacity: 0.498
  })), _path5828 || (_path5828 = /*#__PURE__*/React.createElement("path", {
    d: "M20 111h-1v-1h1z",
    fill: "#639fcb"
  })), _path5829 || (_path5829 = /*#__PURE__*/React.createElement("path", {
    d: "M21 110v1h-1v-1z",
    fill: "#79a9cb"
  })), _path5830 || (_path5830 = /*#__PURE__*/React.createElement("path", {
    d: "M22 110v1h-1v-1z",
    fill: "#9a9c91"
  })), _path5831 || (_path5831 = /*#__PURE__*/React.createElement("path", {
    d: "M22 111v-1h1v1z",
    fill: "#b38d60"
  })), _path5832 || (_path5832 = /*#__PURE__*/React.createElement("path", {
    d: "M23 110h1v1h-1z",
    fill: "#c69c69"
  })), _path5833 || (_path5833 = /*#__PURE__*/React.createElement("path", {
    d: "M25 111h-1v-1h1z",
    fill: "#c29b70"
  })), _path5834 || (_path5834 = /*#__PURE__*/React.createElement("path", {
    d: "M25 111v-1h1v1z",
    fill: "#b69166"
  })), _path5835 || (_path5835 = /*#__PURE__*/React.createElement("path", {
    d: "M27 110v1h-1v-1z",
    fill: "#be9b76"
  })), _path5836 || (_path5836 = /*#__PURE__*/React.createElement("path", {
    d: "M27 111v-1h1v1z",
    fill: "#e2c3a5"
  })), _path5837 || (_path5837 = /*#__PURE__*/React.createElement("path", {
    d: "M29 111h-1v-1h1z",
    fill: "#dcc6ae"
  })), _path5838 || (_path5838 = /*#__PURE__*/React.createElement("path", {
    d: "M30 110v1h-1v-1z",
    fill: "#d0cec9"
  })), _path5839 || (_path5839 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111h-1v-1h1z",
    fill: "#c6c8ca"
  })), _path5840 || (_path5840 = /*#__PURE__*/React.createElement("path", {
    d: "M53 111h-1v-1h1z",
    fill: "#c4c6c7"
  })), _path5841 || (_path5841 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110v1h-1v-1z",
    fill: "#c8cacb"
  })), _path5842 || (_path5842 = /*#__PURE__*/React.createElement("path", {
    d: "M54 111v-1h1v1z",
    fill: "#c9cacd"
  })), _path5843 || (_path5843 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111h-1v-1h1z",
    fill: "#cacbce"
  })), _path5844 || (_path5844 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110h1v1h-1z",
    fill: "#c5c7ca"
  })), _path5845 || (_path5845 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111h-1v-1h1z",
    fill: "#c4c7c7"
  })), _path5846 || (_path5846 = /*#__PURE__*/React.createElement("path", {
    d: "M62 111h-1v-1h1z",
    fill: "#d9d0c4"
  })), _path5847 || (_path5847 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110v1h-1v-1z",
    fill: "#dccbb8"
  })), _path5848 || (_path5848 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110h1v1h-1z",
    fill: "#d4bfa6"
  })), _path5849 || (_path5849 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111h-1v-1h1z",
    fill: "#ccb086"
  })), _path5850 || (_path5850 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111v-1h1v1z",
    fill: "#ce9e61"
  })), _path5851 || (_path5851 = /*#__PURE__*/React.createElement("path", {
    d: "M66 111v-1h1v1z",
    fill: "#c98c44"
  })), _path5852 || (_path5852 = /*#__PURE__*/React.createElement("path", {
    d: "M68 110v1h-1v-1z",
    fill: "#c38138"
  })), _path5853 || (_path5853 = /*#__PURE__*/React.createElement("path", {
    d: "M69 111h-1v-1h1z",
    fill: "#c17e35"
  })), _path5854 || (_path5854 = /*#__PURE__*/React.createElement("path", {
    d: "M70 110v1h-1v-1z",
    fill: "#c78633"
  })), _path5855 || (_path5855 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110v1h-1v-1z",
    fill: "#cd965b"
  })), _path5856 || (_path5856 = /*#__PURE__*/React.createElement("path", {
    d: "M71 111v-1h1v1z",
    fill: "#e0cec2"
  })), _path5857 || (_path5857 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h1v1h-1z",
    fill: "#d0d7d8"
  })), _path5858 || (_path5858 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h-1v-1h1z",
    fill: "#e5eae5",
    fillOpacity: 0.196
  })), _path5859 || (_path5859 = /*#__PURE__*/React.createElement("path", {
    d: "M19 111v1h-1v-1z",
    fill: "#688094",
    fillOpacity: 0.498
  })), _path5860 || (_path5860 = /*#__PURE__*/React.createElement("path", {
    d: "M20 111v1h-1v-1z",
    fill: "#669cc4"
  })), _path5861 || (_path5861 = /*#__PURE__*/React.createElement("path", {
    d: "M20 111h1v1h-1z",
    fill: "#6ea9d3"
  })), _path5862 || (_path5862 = /*#__PURE__*/React.createElement("path", {
    d: "M22 112h-1v-1h1z",
    fill: "#8daec5"
  })), _path5863 || (_path5863 = /*#__PURE__*/React.createElement("path", {
    d: "M23 112h-1v-1h1z",
    fill: "#988f84"
  })), _path5864 || (_path5864 = /*#__PURE__*/React.createElement("path", {
    d: "M23 111h1v1h-1z",
    fill: "#b79976"
  })), _path5865 || (_path5865 = /*#__PURE__*/React.createElement("path", {
    d: "M24 112v-1h1v1z",
    fill: "#c9a372"
  })), _path5866 || (_path5866 = /*#__PURE__*/React.createElement("path", {
    d: "M26 111v1h-1v-1z",
    fill: "#d0a77b"
  })), _path5867 || (_path5867 = /*#__PURE__*/React.createElement("path", {
    d: "M26 112v-1h1v1z",
    fill: "#c39d76"
  })), _path5868 || (_path5868 = /*#__PURE__*/React.createElement("path", {
    d: "M28 112h-1v-1h1z",
    fill: "#d1b194"
  })), _path5869 || (_path5869 = /*#__PURE__*/React.createElement("path", {
    d: "M28 111h1v1h-1z",
    fill: "#ddc7b1"
  })), _path5870 || (_path5870 = /*#__PURE__*/React.createElement("path", {
    d: "M33 111v1h-1v-1z",
    fill: "#d0d1d4"
  })), _path5871 || (_path5871 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v1h-1v-1z",
    fill: "#c9cbcc"
  })), _path5872 || (_path5872 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111v1h-1v-1z",
    fill: "#c2c4c5"
  })), _path5873 || (_path5873 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111h1v1h-1z",
    fill: "#c1c2c4"
  })), _path5874 || (_path5874 = /*#__PURE__*/React.createElement("path", {
    d: "M63 112v-1h1v1z",
    fill: "#c7c8c6"
  })), _path5875 || (_path5875 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111v1h-1v-1z",
    fill: "#cecfca"
  })), _path5876 || (_path5876 = /*#__PURE__*/React.createElement("path", {
    d: "M66 112h-1v-1h1z",
    fill: "#d7d4c6"
  })), _path5877 || (_path5877 = /*#__PURE__*/React.createElement("path", {
    d: "M66 111h1v1h-1z",
    fill: "#decfb7"
  })), _path5878 || (_path5878 = /*#__PURE__*/React.createElement("path", {
    d: "M68 111h1v1h-1z",
    fill: "#ddc6a5"
  })), _path5879 || (_path5879 = /*#__PURE__*/React.createElement("path", {
    d: "M70 112h-1v-1h1z",
    fill: "#ddc4a4"
  })), _path5880 || (_path5880 = /*#__PURE__*/React.createElement("path", {
    d: "M71 112h-1v-1h1z",
    fill: "#e0cdbd"
  })), _path5881 || (_path5881 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111v1h-1v-1z",
    fill: "#c9cbce"
  })), _path5882 || (_path5882 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111h1v1h-1z",
    fill: "#d2d2d1"
  })), _path5883 || (_path5883 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v-1h1v1z",
    fill: "#d8dcda"
  })), _path5884 || (_path5884 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112h-1v-1h1z",
    fill: "#dfe1e0",
    fillOpacity: 0.98
  })), _path5885 || (_path5885 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111v1h-1v-1z",
    fill: "#e1e6e6",
    fillOpacity: 0.2
  })), _path5886 || (_path5886 = /*#__PURE__*/React.createElement("path", {
    d: "M18 113v-1h1v1z",
    fill: "#7d7b6b",
    fillOpacity: 0.494
  })), _path5887 || (_path5887 = /*#__PURE__*/React.createElement("path", {
    d: "M19 112h1v1h-1z",
    fill: "#7b98a0"
  })), _path5888 || (_path5888 = /*#__PURE__*/React.createElement("path", {
    d: "M20 112h1v1h-1z",
    fill: "#6fa9cf"
  })), _path5889 || (_path5889 = /*#__PURE__*/React.createElement("path", {
    d: "M21 113v-1h1v1z",
    fill: "#83b3d9"
  })), _path5890 || (_path5890 = /*#__PURE__*/React.createElement("path", {
    d: "M22 113v-1h1v1z",
    fill: "#8fb4d4"
  })), _path5891 || (_path5891 = /*#__PURE__*/React.createElement("path", {
    d: "M24 113h-1v-1h1z",
    fill: "#96a1a7"
  })), _path5892 || (_path5892 = /*#__PURE__*/React.createElement("path", {
    d: "M25 112v1h-1v-1z",
    fill: "#c2a07a"
  })), _path5893 || (_path5893 = /*#__PURE__*/React.createElement("path", {
    d: "M25 112h1v1h-1z",
    fill: "#d2a979"
  })), _path5894 || (_path5894 = /*#__PURE__*/React.createElement("path", {
    d: "M26 112h1v1h-1z",
    fill: "#d4ae81"
  })), _path5895 || (_path5895 = /*#__PURE__*/React.createElement("path", {
    d: "M27 113v-1h1v1z",
    fill: "#dfbd9a"
  })), _path5896 || (_path5896 = /*#__PURE__*/React.createElement("path", {
    d: "M28 113v-1h1v1z",
    fill: "#dcc4ac"
  })), _path5897 || (_path5897 = /*#__PURE__*/React.createElement("path", {
    d: "M30 113h-1v-1h1z",
    fill: "#d0cfc9"
  })), _path5898 || (_path5898 = /*#__PURE__*/React.createElement("path", {
    d: "M42 113h-1v-1h1z",
    fill: "#c8c8ca"
  })), _path5899 || (_path5899 = /*#__PURE__*/React.createElement("path", {
    d: "M43 113h-1v-1h1z",
    fill: "#c7c8c9"
  })), _path5900 || (_path5900 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113h-1v-1h1z",
    fill: "#cacacd"
  })), _path5901 || (_path5901 = /*#__PURE__*/React.createElement("path", {
    d: "M61 113h-1v-1h1z",
    fill: "#c8c8c7"
  })), _path5902 || (_path5902 = /*#__PURE__*/React.createElement("path", {
    d: "M62 112v1h-1v-1z",
    fill: "#c6c6c6"
  })), _path5903 || (_path5903 = /*#__PURE__*/React.createElement("path", {
    d: "M62 112h1v1h-1z",
    fill: "#c2c4c4"
  })), _path5904 || (_path5904 = /*#__PURE__*/React.createElement("path", {
    d: "M64 113h-1v-1h1z",
    fill: "#c1c2c2"
  })), _path5905 || (_path5905 = /*#__PURE__*/React.createElement("path", {
    d: "M65 113h-1v-1h1z",
    fill: "#c3c2c4"
  })), _path5906 || (_path5906 = /*#__PURE__*/React.createElement("path", {
    d: "M65 112h1v1h-1z",
    fill: "#c4c8c8"
  })), _path5907 || (_path5907 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112v1h-1v-1z",
    fill: "#cbcecb"
  })), _path5908 || (_path5908 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112h1v1h-1z",
    fill: "#cccdcd"
  })), _path5909 || (_path5909 = /*#__PURE__*/React.createElement("path", {
    d: "M69 113v-1h1v1z",
    fill: "#cacac9"
  })), _path5910 || (_path5910 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112h1v1h-1z",
    fill: "#d9dada"
  })), _path5911 || (_path5911 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112h1v1h-1z",
    fill: "#e5e5e5",
    fillOpacity: 0.196
  })), _path5912 || (_path5912 = /*#__PURE__*/React.createElement("path", {
    d: "M18 113h1v1h-1z",
    fill: "#8e724a",
    fillOpacity: 0.498
  })), _path5913 || (_path5913 = /*#__PURE__*/React.createElement("path", {
    d: "M20 113v1h-1v-1z",
    fill: "#9e987a"
  })), _path5914 || (_path5914 = /*#__PURE__*/React.createElement("path", {
    d: "M21 114h-1v-1h1z",
    fill: "#8cb0cc"
  })), _path5915 || (_path5915 = /*#__PURE__*/React.createElement("path", {
    d: "M22 113v1h-1v-1z",
    fill: "#88b4d4"
  })), _path5916 || (_path5916 = /*#__PURE__*/React.createElement("path", {
    d: "M23 114h-1v-1h1z",
    fill: "#8cb9da"
  })), _path5917 || (_path5917 = /*#__PURE__*/React.createElement("path", {
    d: "M24 114h-1v-1h1z",
    fill: "#8bb3cd"
  })), _path5918 || (_path5918 = /*#__PURE__*/React.createElement("path", {
    d: "M25 114h-1v-1h1z",
    fill: "#98a1a4"
  })), _path5919 || (_path5919 = /*#__PURE__*/React.createElement("path", {
    d: "M25 114v-1h1v1z",
    fill: "#b9a790"
  })), _path5920 || (_path5920 = /*#__PURE__*/React.createElement("path", {
    d: "M27 113v1h-1v-1z",
    fill: "#cfaf8b"
  })), _path5921 || (_path5921 = /*#__PURE__*/React.createElement("path", {
    d: "M27 113h1v1h-1z",
    fill: "#e0bd9c"
  })), _path5922 || (_path5922 = /*#__PURE__*/React.createElement("path", {
    d: "M29 113v1h-1v-1z",
    fill: "#dac3ad"
  })), _path5923 || (_path5923 = /*#__PURE__*/React.createElement("path", {
    d: "M29 114v-1h1v1z",
    fill: "#d0cdca"
  })), _path5924 || (_path5924 = /*#__PURE__*/React.createElement("path", {
    d: "M31 113v1h-1v-1z",
    fill: "#cececf"
  })), _path5925 || (_path5925 = /*#__PURE__*/React.createElement("path", {
    d: "M31 114v-1h1v1z",
    fill: "#cfcece"
  })), _path5926 || (_path5926 = /*#__PURE__*/React.createElement("path", {
    d: "M33 113h1v1h-1z",
    fill: "#cecfce"
  })), _path5927 || (_path5927 = /*#__PURE__*/React.createElement("path", {
    d: "M34 114v-1h1v1z",
    fill: "#cfcecc"
  })), _path5928 || (_path5928 = /*#__PURE__*/React.createElement("path", {
    d: "M35 113h1v1h-1z",
    fill: "#ced2cf"
  })), _path5929 || (_path5929 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114h-1v-1h1z",
    fill: "#cfd4d9"
  })), _path5930 || (_path5930 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h1v1h-1z",
    fill: "#cdd2d9"
  })), _path5931 || (_path5931 = /*#__PURE__*/React.createElement("path", {
    d: "M41 113h1v1h-1z",
    fill: "#c6cad5"
  })), _path5932 || (_path5932 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114v-1h1v1z",
    fill: "#c0c6d5"
  })), _path5933 || (_path5933 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114h-1v-1h1z",
    fill: "#b6bbcc"
  })), _path5934 || (_path5934 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114h-1v-1h1z",
    fill: "#aeb6c7"
  })), _path5935 || (_path5935 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113v1h-1v-1z",
    fill: "#c2c6cf"
  })), _path5936 || (_path5936 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114v-1h1v1z",
    fill: "#cecfd2"
  })), _path5937 || (_path5937 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113v1h-1v-1z",
    fill: "#cecfd0"
  })), _path5938 || (_path5938 = /*#__PURE__*/React.createElement("path", {
    d: "M58 114h-1v-1h1z",
    fill: "#c8c9ca"
  })), _path5939 || (_path5939 = /*#__PURE__*/React.createElement("path", {
    d: "M63 113v1h-1v-1z",
    fill: "#c8c9c8"
  })), _path5940 || (_path5940 = /*#__PURE__*/React.createElement("path", {
    d: "M63 114v-1h1v1z",
    fill: "#c9cac9"
  })), _path5941 || (_path5941 = /*#__PURE__*/React.createElement("path", {
    d: "M65 114v-1h1v1z",
    fill: "#c9cac7"
  })), _path5942 || (_path5942 = /*#__PURE__*/React.createElement("path", {
    d: "M69 114h-1v-1h1z",
    fill: "#c2c5c2"
  })), _path5943 || (_path5943 = /*#__PURE__*/React.createElement("path", {
    d: "M71 113v1h-1v-1z",
    fill: "#c4c5c5"
  })), _path5944 || (_path5944 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114h-1v-1h1z",
    fill: "#d2d4d2"
  })), _path5945 || (_path5945 = /*#__PURE__*/React.createElement("path", {
    d: "M75 114h-1v-1h1z",
    fill: "#dadada"
  })), _path5946 || (_path5946 = /*#__PURE__*/React.createElement("path", {
    d: "M77 114v-1h1v1z",
    fill: "#e1e1e1",
    fillOpacity: 0.2
  })), _path5947 || (_path5947 = /*#__PURE__*/React.createElement("path", {
    d: "M19 115h-1v-1h1z",
    fill: "#957652",
    fillOpacity: 0.463
  })), _path5948 || (_path5948 = /*#__PURE__*/React.createElement("path", {
    d: "M19 115v-1h1v1z",
    fill: "#c2a26f"
  })), _path5949 || (_path5949 = /*#__PURE__*/React.createElement("path", {
    d: "M21 114v1h-1v-1z",
    fill: "#acb6bc"
  })), _path5950 || (_path5950 = /*#__PURE__*/React.createElement("path", {
    d: "M21 114h1v1h-1z",
    fill: "#99bcdf"
  })), _path5951 || (_path5951 = /*#__PURE__*/React.createElement("path", {
    d: "M22 115v-1h1v1z",
    fill: "#92bcde"
  })), _path5952 || (_path5952 = /*#__PURE__*/React.createElement("path", {
    d: "M24 114v1h-1v-1z",
    fill: "#87bbdf"
  })), _path5953 || (_path5953 = /*#__PURE__*/React.createElement("path", {
    d: "M24 114h1v1h-1z",
    fill: "#87b7de"
  })), _path5954 || (_path5954 = /*#__PURE__*/React.createElement("path", {
    d: "M26 114v1h-1v-1z",
    fill: "#9bbad6"
  })), _path5955 || (_path5955 = /*#__PURE__*/React.createElement("path", {
    d: "M27 115h-1v-1h1z",
    fill: "#afaca4"
  })), _path5956 || (_path5956 = /*#__PURE__*/React.createElement("path", {
    d: "M28 114v1h-1v-1z",
    fill: "#d3b998"
  })), _path5957 || (_path5957 = /*#__PURE__*/React.createElement("path", {
    d: "M29 114v1h-1v-1z",
    fill: "#d0c1a8"
  })), _path5958 || (_path5958 = /*#__PURE__*/React.createElement("path", {
    d: "M30 115h-1v-1h1z",
    fill: "#ccccc7"
  })), _path5959 || (_path5959 = /*#__PURE__*/React.createElement("path", {
    d: "M31 114v1h-1v-1z",
    fill: "#c7cfd5"
  })), _path5960 || (_path5960 = /*#__PURE__*/React.createElement("path", {
    d: "M31 114h1v1h-1z",
    fill: "#c4cddd"
  })), _path5961 || (_path5961 = /*#__PURE__*/React.createElement("path", {
    d: "M33 115h-1v-1h1z",
    fill: "#c7d0e2"
  })), _path5962 || (_path5962 = /*#__PURE__*/React.createElement("path", {
    d: "M34 114v1h-1v-1z",
    fill: "#bfcedd"
  })), _path5963 || (_path5963 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115h-1v-1h1z",
    fill: "#b8cbdf"
  })), _path5964 || (_path5964 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115v-1h1v1z",
    fill: "#b5cce1"
  })), _path5965 || (_path5965 = /*#__PURE__*/React.createElement("path", {
    d: "M37 114v1h-1v-1z",
    fill: "#aec8dc"
  })), _path5966 || (_path5966 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115h-1v-1h1z",
    fill: "#a1b8d6"
  })), _path5967 || (_path5967 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115v-1h1v1z",
    fill: "#7384ad"
  })), _path5968 || (_path5968 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114v1h-1v-1z",
    fill: "#5f77a3"
  })), _path5969 || (_path5969 = /*#__PURE__*/React.createElement("path", {
    d: "M41 115h-1v-1h1z",
    fill: "#506a95"
  })), _path5970 || (_path5970 = /*#__PURE__*/React.createElement("path", {
    d: "M41 114h1v1h-1z",
    fill: "#5f75a4"
  })), _path5971 || (_path5971 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114h1v1h-1z",
    fill: "#4d6796"
  })), _path5972 || (_path5972 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114v1h-1v-1z",
    fill: "#506a97"
  })), _path5973 || (_path5973 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114v1h-1v-1z",
    fill: "#385582"
  })), _path5974 || (_path5974 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115v-1h1v1z",
    fill: "#a8b6c5"
  })), _path5975 || (_path5975 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114h1v1h-1z",
    fill: "#d4d5d6"
  })), _path5976 || (_path5976 = /*#__PURE__*/React.createElement("path", {
    d: "M57 115v-1h1v1z",
    fill: "#cccfcd"
  })), _path5977 || (_path5977 = /*#__PURE__*/React.createElement("path", {
    d: "M76 115v-1h1v1z",
    fill: "#dfe1e0",
    fillOpacity: 0.984
  })), _path5978 || (_path5978 = /*#__PURE__*/React.createElement("path", {
    d: "M77 114h1v1h-1z",
    fill: "#e6e6e6",
    fillOpacity: 0.204
  })), _path5979 || (_path5979 = /*#__PURE__*/React.createElement("path", {
    d: "M19 116h-1v-1h1z",
    fill: "#b09470",
    fillOpacity: 0.443
  })), _path5980 || (_path5980 = /*#__PURE__*/React.createElement("path", {
    d: "M20 115v1h-1v-1z",
    fill: "#c49660"
  })), _path5981 || (_path5981 = /*#__PURE__*/React.createElement("path", {
    d: "M20 116v-1h1v1z",
    fill: "#c0af92"
  })), _path5982 || (_path5982 = /*#__PURE__*/React.createElement("path", {
    d: "M22 115v1h-1v-1z",
    fill: "#a7b3c1"
  })), _path5983 || (_path5983 = /*#__PURE__*/React.createElement("path", {
    d: "M22 116v-1h1v1z",
    fill: "#a3bfd3"
  })), _path5984 || (_path5984 = /*#__PURE__*/React.createElement("path", {
    d: "M24 116h-1v-1h1z",
    fill: "#90bedd"
  })), _path5985 || (_path5985 = /*#__PURE__*/React.createElement("path", {
    d: "M25 116h-1v-1h1z",
    fill: "#8dbadf"
  })), _path5986 || (_path5986 = /*#__PURE__*/React.createElement("path", {
    d: "M25 116v-1h1v1z",
    fill: "#93c2e7"
  })), _path5987 || (_path5987 = /*#__PURE__*/React.createElement("path", {
    d: "M27 115v1h-1v-1z",
    fill: "#9bbfd8"
  })), _path5988 || (_path5988 = /*#__PURE__*/React.createElement("path", {
    d: "M27 116v-1h1v1z",
    fill: "#b1c2ce"
  })), _path5989 || (_path5989 = /*#__PURE__*/React.createElement("path", {
    d: "M29 116h-1v-1h1z",
    fill: "#c3cdd1"
  })), _path5990 || (_path5990 = /*#__PURE__*/React.createElement("path", {
    d: "M30 115v1h-1v-1z",
    fill: "#cacfcf"
  })), _path5991 || (_path5991 = /*#__PURE__*/React.createElement("path", {
    d: "M31 116h-1v-1h1z",
    fill: "#b3c7df"
  })), _path5992 || (_path5992 = /*#__PURE__*/React.createElement("path", {
    d: "M32 115v1h-1v-1z",
    fill: "#7899c6"
  })), _path5993 || (_path5993 = /*#__PURE__*/React.createElement("path", {
    d: "M32 116v-1h1v1z",
    fill: "#516d8a"
  })), _path5994 || (_path5994 = /*#__PURE__*/React.createElement("path", {
    d: "M34 116h-1v-1h1z",
    fill: "#6f95c5"
  })), _path5995 || (_path5995 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115v1h-1v-1z",
    fill: "#699cce"
  })), _path5996 || (_path5996 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116h-1v-1h1z",
    fill: "#6995ca"
  })), _path5997 || (_path5997 = /*#__PURE__*/React.createElement("path", {
    d: "M37 116h-1v-1h1z",
    fill: "#62a5bd"
  })), _path5998 || (_path5998 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115v1h-1v-1z",
    fill: "#5487be"
  })), _path5999 || (_path5999 = /*#__PURE__*/React.createElement("path", {
    d: "M38 116v-1h1v1z",
    fill: "#345492"
  })), _path6000 || (_path6000 = /*#__PURE__*/React.createElement("path", {
    d: "M39 115h1v1h-1z",
    fill: "#7ca8c5"
  })), _path6001 || (_path6001 = /*#__PURE__*/React.createElement("path", {
    d: "M40 115h1v1h-1z",
    fill: "#6995b3"
  })), _path6002 || (_path6002 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v-1h1v1z",
    fill: "#5c81a4"
  })), _path6003 || (_path6003 = /*#__PURE__*/React.createElement("path", {
    d: "M43 115v1h-1v-1z",
    fill: "#739fba"
  })), _path6004 || (_path6004 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116h-1v-1h1z",
    fill: "#8bb5cc"
  })), _path6005 || (_path6005 = /*#__PURE__*/React.createElement("path", {
    d: "M45 116h-1v-1h1z",
    fill: "#5275a3"
  })), _path6006 || (_path6006 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115h1v1h-1z",
    fill: "#a9b4cd"
  })), _path6007 || (_path6007 = /*#__PURE__*/React.createElement("path", {
    d: "M46 115h1v1h-1z",
    fill: "#d5d5d7"
  })), _path6008 || (_path6008 = /*#__PURE__*/React.createElement("path", {
    d: "M77 115v1h-1v-1z",
    fill: "#dee0df",
    fillOpacity: 0.984
  })), _path6009 || (_path6009 = /*#__PURE__*/React.createElement("path", {
    d: "M77 115h1v1h-1z",
    fill: "#e2e2e2",
    fillOpacity: 0.208
  })), _path6010 || (_path6010 = /*#__PURE__*/React.createElement("path", {
    d: "M18 116h1v1h-1z",
    fill: "#a88d71",
    fillOpacity: 0.416
  })), _path6011 || (_path6011 = /*#__PURE__*/React.createElement("path", {
    d: "M19 117v-1h1v1z",
    fill: "#ad865a"
  })), _path6012 || (_path6012 = /*#__PURE__*/React.createElement("path", {
    d: "M20 116h1v1h-1z",
    fill: "#bd996a"
  })), _path6013 || (_path6013 = /*#__PURE__*/React.createElement("path", {
    d: "M21 116h1v1h-1z",
    fill: "#c6a171"
  })), _path6014 || (_path6014 = /*#__PURE__*/React.createElement("path", {
    d: "M23 116v1h-1v-1z",
    fill: "#c0b39f"
  })), _path6015 || (_path6015 = /*#__PURE__*/React.createElement("path", {
    d: "M24 116v1h-1v-1z",
    fill: "#a6c0d0"
  })), _path6016 || (_path6016 = /*#__PURE__*/React.createElement("path", {
    d: "M25 117h-1v-1h1z",
    fill: "#97bcd4"
  })), _path6017 || (_path6017 = /*#__PURE__*/React.createElement("path", {
    d: "M26 116v1h-1v-1z",
    fill: "#97c1e4"
  })), _path6018 || (_path6018 = /*#__PURE__*/React.createElement("path", {
    d: "M26 117v-1h1v1z",
    fill: "#9cc4e3"
  })), _path6019 || (_path6019 = /*#__PURE__*/React.createElement("path", {
    d: "M28 116v1h-1v-1z",
    fill: "#b5d4f3"
  })), _path6020 || (_path6020 = /*#__PURE__*/React.createElement("path", {
    d: "M28 116h1v1h-1z",
    fill: "#c0d9ef"
  })), _path6021 || (_path6021 = /*#__PURE__*/React.createElement("path", {
    d: "M29 117v-1h1v1z",
    fill: "#c8cdd5"
  })), _path6022 || (_path6022 = /*#__PURE__*/React.createElement("path", {
    d: "M31 116v1h-1v-1z",
    fill: "#aec1e6"
  })), _path6023 || (_path6023 = /*#__PURE__*/React.createElement("path", {
    d: "M31 117v-1h1v1z",
    fill: "#678bbe"
  })), _path6024 || (_path6024 = /*#__PURE__*/React.createElement("path", {
    d: "M33 117h-1v-1h1z",
    fill: "#6d5e3e"
  })), _path6025 || (_path6025 = /*#__PURE__*/React.createElement("path", {
    d: "M34 116v1h-1v-1z",
    fill: "#816e52"
  })), _path6026 || (_path6026 = /*#__PURE__*/React.createElement("path", {
    d: "M34 116h1v1h-1z",
    fill: "#7b7465"
  })), _path6027 || (_path6027 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116v1h-1v-1z",
    fill: "#597971"
  })), _path6028 || (_path6028 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116h1v1h-1z",
    fill: "#5babb0"
  })), _path6029 || (_path6029 = /*#__PURE__*/React.createElement("path", {
    d: "M38 117h-1v-1h1z",
    fill: "#5d8ecd"
  })), _path6030 || (_path6030 = /*#__PURE__*/React.createElement("path", {
    d: "M38 116h1v1h-1z",
    fill: "#2e4e8f"
  })), _path6031 || (_path6031 = /*#__PURE__*/React.createElement("path", {
    d: "M39 116h1v1h-1z",
    fill: "#6b90b0"
  })), _path6032 || (_path6032 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v1h-1v-1z",
    fill: "#577ea0"
  })), _path6033 || (_path6033 = /*#__PURE__*/React.createElement("path", {
    d: "M42 117h-1v-1h1z",
    fill: "#6085a6"
  })), _path6034 || (_path6034 = /*#__PURE__*/React.createElement("path", {
    d: "M42 117v-1h1v1z",
    fill: "#4d7799"
  })), _path6035 || (_path6035 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116v1h-1v-1z",
    fill: "#5f88a6"
  })), _path6036 || (_path6036 = /*#__PURE__*/React.createElement("path", {
    d: "M44 117v-1h1v1z",
    fill: "#406492"
  })), _path6037 || (_path6037 = /*#__PURE__*/React.createElement("path", {
    d: "M46 116v1h-1v-1z",
    fill: "#b0b9d5"
  })), _path6038 || (_path6038 = /*#__PURE__*/React.createElement("path", {
    d: "M47 117h-1v-1h1z",
    fill: "#d4d3d6"
  })), _path6039 || (_path6039 = /*#__PURE__*/React.createElement("path", {
    d: "M78 116v1h-1v-1z",
    fill: "#dde2e2",
    fillOpacity: 0.212
  })), _path6040 || (_path6040 = /*#__PURE__*/React.createElement("path", {
    d: "M18 118v-1h1v1z",
    fill: "#aa997f",
    fillOpacity: 0.118
  })), _path6041 || (_path6041 = /*#__PURE__*/React.createElement("path", {
    d: "M19 118v-1h1v1z",
    fill: "#a48868",
    fillOpacity: 0.804
  })), _path6042 || (_path6042 = /*#__PURE__*/React.createElement("path", {
    d: "M20 118v-1h1v1z",
    fill: "#ab8054"
  })), _path6043 || (_path6043 = /*#__PURE__*/React.createElement("path", {
    d: "M22 117v1h-1v-1z",
    fill: "#cc9959"
  })), _path6044 || (_path6044 = /*#__PURE__*/React.createElement("path", {
    d: "M22 118v-1h1v1z",
    fill: "#c4ac85"
  })), _path6045 || (_path6045 = /*#__PURE__*/React.createElement("path", {
    d: "M24 117v1h-1v-1z",
    fill: "#bec0b4"
  })), _path6046 || (_path6046 = /*#__PURE__*/React.createElement("path", {
    d: "M24 117h1v1h-1z",
    fill: "#b5b59b"
  })), _path6047 || (_path6047 = /*#__PURE__*/React.createElement("path", {
    d: "M25 117h1v1h-1z",
    fill: "#acc6dd"
  })), _path6048 || (_path6048 = /*#__PURE__*/React.createElement("path", {
    d: "M26 117h1v1h-1z",
    fill: "#b0cdeb"
  })), _path6049 || (_path6049 = /*#__PURE__*/React.createElement("path", {
    d: "M27 118v-1h1v1z",
    fill: "#b3d3f3"
  })), _path6050 || (_path6050 = /*#__PURE__*/React.createElement("path", {
    d: "M29 118h-1v-1h1z",
    fill: "#bbd6e9"
  })), _path6051 || (_path6051 = /*#__PURE__*/React.createElement("path", {
    d: "M30 117v1h-1v-1z",
    fill: "#c7cbd6"
  })), _path6052 || (_path6052 = /*#__PURE__*/React.createElement("path", {
    d: "M30 118v-1h1v1z",
    fill: "#aec3df"
  })), _path6053 || (_path6053 = /*#__PURE__*/React.createElement("path", {
    d: "M31 117h1v1h-1z",
    fill: "#719acc"
  })), _path6054 || (_path6054 = /*#__PURE__*/React.createElement("path", {
    d: "M32 118v-1h1v1z",
    fill: "#987346"
  })), _path6055 || (_path6055 = /*#__PURE__*/React.createElement("path", {
    d: "M33 117h1v1h-1z",
    fill: "#e68316"
  })), _path6056 || (_path6056 = /*#__PURE__*/React.createElement("path", {
    d: "M35 117v1h-1v-1z",
    fill: "#b37b18"
  })), _path6057 || (_path6057 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118h-1v-1h1z",
    fill: "#5f9359"
  })), _path6058 || (_path6058 = /*#__PURE__*/React.createElement("path", {
    d: "M37 118h-1v-1h1z",
    fill: "#66a7c8"
  })), _path6059 || (_path6059 = /*#__PURE__*/React.createElement("path", {
    d: "M38 117v1h-1v-1z",
    fill: "#5f8bcd"
  })), _path6060 || (_path6060 = /*#__PURE__*/React.createElement("path", {
    d: "M39 117v1h-1v-1z",
    fill: "#406296"
  })), _path6061 || (_path6061 = /*#__PURE__*/React.createElement("path", {
    d: "M39 117h1v1h-1z",
    fill: "#698eaa"
  })), _path6062 || (_path6062 = /*#__PURE__*/React.createElement("path", {
    d: "M41 118h-1v-1h1z",
    fill: "#6590b4"
  })), _path6063 || (_path6063 = /*#__PURE__*/React.createElement("path", {
    d: "M41 117h1v1h-1z",
    fill: "#8bb3cc"
  })), _path6064 || (_path6064 = /*#__PURE__*/React.createElement("path", {
    d: "M43 118h-1v-1h1z",
    fill: "#86b1c7"
  })), _path6065 || (_path6065 = /*#__PURE__*/React.createElement("path", {
    d: "M43 117h1v1h-1z",
    fill: "#62889d"
  })), _path6066 || (_path6066 = /*#__PURE__*/React.createElement("path", {
    d: "M45 117v1h-1v-1z",
    fill: "#5a7ca0"
  })), _path6067 || (_path6067 = /*#__PURE__*/React.createElement("path", {
    d: "M45 118v-1h1v1z",
    fill: "#b6bed7"
  })), _path6068 || (_path6068 = /*#__PURE__*/React.createElement("path", {
    d: "M47 117v1h-1v-1z",
    fill: "#d4d4d4"
  })), _path6069 || (_path6069 = /*#__PURE__*/React.createElement("path", {
    d: "M52 117v1h-1v-1z",
    fill: "#d2d3d3"
  })), _path6070 || (_path6070 = /*#__PURE__*/React.createElement("path", {
    d: "M78 118h-1v-1h1z",
    fill: "#dedede",
    fillOpacity: 0.216
  })), _path6071 || (_path6071 = /*#__PURE__*/React.createElement("path", {
    d: "M20 118v1h-1v-1z",
    fill: "#bfad91",
    fillOpacity: 0.11
  })), _path6072 || (_path6072 = /*#__PURE__*/React.createElement("path", {
    d: "M20 118h1v1h-1z",
    fill: "#917451",
    fillOpacity: 0.761
  })), _path6073 || (_path6073 = /*#__PURE__*/React.createElement("path", {
    d: "M22 118v1h-1v-1z",
    fill: "#c09357"
  })), _path6074 || (_path6074 = /*#__PURE__*/React.createElement("path", {
    d: "M23 119h-1v-1h1z",
    fill: "#cba570"
  })), _path6075 || (_path6075 = /*#__PURE__*/React.createElement("path", {
    d: "M24 119h-1v-1h1z",
    fill: "#c1b196"
  })), _path6076 || (_path6076 = /*#__PURE__*/React.createElement("path", {
    d: "M25 119h-1v-1h1z",
    fill: "#d7b381"
  })), _path6077 || (_path6077 = /*#__PURE__*/React.createElement("path", {
    d: "M25 119v-1h1v1z",
    fill: "#b4bab2"
  })), _path6078 || (_path6078 = /*#__PURE__*/React.createElement("path", {
    d: "M27 118v1h-1v-1z",
    fill: "#a6cbe3"
  })), _path6079 || (_path6079 = /*#__PURE__*/React.createElement("path", {
    d: "M27 119v-1h1v1z",
    fill: "#aad0f2"
  })), _path6080 || (_path6080 = /*#__PURE__*/React.createElement("path", {
    d: "M29 118v1h-1v-1z",
    fill: "#bcd4ec"
  })), _path6081 || (_path6081 = /*#__PURE__*/React.createElement("path", {
    d: "M29 119v-1h1v1z",
    fill: "#c8ced2"
  })), _path6082 || (_path6082 = /*#__PURE__*/React.createElement("path", {
    d: "M30 118h1v1h-1z",
    fill: "#adc3da"
  })), _path6083 || (_path6083 = /*#__PURE__*/React.createElement("path", {
    d: "M31 119v-1h1v1z",
    fill: "#649ebc"
  })), _path6084 || (_path6084 = /*#__PURE__*/React.createElement("path", {
    d: "M33 119h-1v-1h1z",
    fill: "#627462"
  })), _path6085 || (_path6085 = /*#__PURE__*/React.createElement("path", {
    d: "M34 118v1h-1v-1z",
    fill: "#ae7b39"
  })), _path6086 || (_path6086 = /*#__PURE__*/React.createElement("path", {
    d: "M34 119v-1h1v1z",
    fill: "#707c2a"
  })), _path6087 || (_path6087 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118v1h-1v-1z",
    fill: "#56a482"
  })), _path6088 || (_path6088 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118h1v1h-1z",
    fill: "#72a9de"
  })), _path6089 || (_path6089 = /*#__PURE__*/React.createElement("path", {
    d: "M37 118h1v1h-1z",
    fill: "#5a89cd"
  })), _path6090 || (_path6090 = /*#__PURE__*/React.createElement("path", {
    d: "M38 118h1v1h-1z",
    fill: "#3e6697"
  })), _path6091 || (_path6091 = /*#__PURE__*/React.createElement("path", {
    d: "M39 119v-1h1v1z",
    fill: "#6f9ab6"
  })), _path6092 || (_path6092 = /*#__PURE__*/React.createElement("path", {
    d: "M40 118h1v1h-1z",
    fill: "#4473a1"
  })), _path6093 || (_path6093 = /*#__PURE__*/React.createElement("path", {
    d: "M41 119v-1h1v1z",
    fill: "#4b7aac"
  })), _path6094 || (_path6094 = /*#__PURE__*/React.createElement("path", {
    d: "M43 118v1h-1v-1z",
    fill: "#325e95"
  })), _path6095 || (_path6095 = /*#__PURE__*/React.createElement("path", {
    d: "M43 118h1v1h-1z",
    fill: "#4d76a4"
  })), _path6096 || (_path6096 = /*#__PURE__*/React.createElement("path", {
    d: "M45 119h-1v-1h1z",
    fill: "#2f558d"
  })), _path6097 || (_path6097 = /*#__PURE__*/React.createElement("path", {
    d: "M45 118h1v1h-1z",
    fill: "#bac5d8"
  })), _path6098 || (_path6098 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118v1h-1v-1z",
    fill: "#d4d4d2"
  })), _path6099 || (_path6099 = /*#__PURE__*/React.createElement("path", {
    d: "M76 118h1v1h-1z",
    fill: "#dfe1e0",
    fillOpacity: 0.988
  })), _path6100 || (_path6100 = /*#__PURE__*/React.createElement("path", {
    d: "M77 119v-1h1v1z",
    fill: "#e7e7e7",
    fillOpacity: 0.212
  })), _path6101 || (_path6101 = /*#__PURE__*/React.createElement("path", {
    d: "M21 120h-1v-1h1z",
    fill: "#8c8369",
    fillOpacity: 0.114
  })), _path6102 || (_path6102 = /*#__PURE__*/React.createElement("path", {
    d: "M21 119h1v1h-1z",
    fill: "#b28b69",
    fillOpacity: 0.808
  })), _path6103 || (_path6103 = /*#__PURE__*/React.createElement("path", {
    d: "M23 120h-1v-1h1z",
    fill: "#cc9860"
  })), _path6104 || (_path6104 = /*#__PURE__*/React.createElement("path", {
    d: "M24 119v1h-1v-1z",
    fill: "#b7925c"
  })), _path6105 || (_path6105 = /*#__PURE__*/React.createElement("path", {
    d: "M24 119h1v1h-1z",
    fill: "#d8a369"
  })), _path6106 || (_path6106 = /*#__PURE__*/React.createElement("path", {
    d: "M26 120h-1v-1h1z",
    fill: "#cead78"
  })), _path6107 || (_path6107 = /*#__PURE__*/React.createElement("path", {
    d: "M27 120h-1v-1h1z",
    fill: "#bab599"
  })), _path6108 || (_path6108 = /*#__PURE__*/React.createElement("path", {
    d: "M28 120h-1v-1h1z",
    fill: "#b6c5c2"
  })), _path6109 || (_path6109 = /*#__PURE__*/React.createElement("path", {
    d: "M28 120v-1h1v1z",
    fill: "#c0cfe0"
  })), _path6110 || (_path6110 = /*#__PURE__*/React.createElement("path", {
    d: "M30 120h-1v-1h1z",
    fill: "#c7d1d3"
  })), _path6111 || (_path6111 = /*#__PURE__*/React.createElement("path", {
    d: "M31 119v1h-1v-1z",
    fill: "#afc1d9"
  })), _path6112 || (_path6112 = /*#__PURE__*/React.createElement("path", {
    d: "M32 120h-1v-1h1z",
    fill: "#6aa3b9"
  })), _path6113 || (_path6113 = /*#__PURE__*/React.createElement("path", {
    d: "M33 120h-1v-1h1z",
    fill: "#40a083"
  })), _path6114 || (_path6114 = /*#__PURE__*/React.createElement("path", {
    d: "M34 120h-1v-1h1z",
    fill: "#539a98"
  })), _path6115 || (_path6115 = /*#__PURE__*/React.createElement("path", {
    d: "M34 119h1v1h-1z",
    fill: "#399f6f"
  })), _path6116 || (_path6116 = /*#__PURE__*/React.createElement("path", {
    d: "M36 119v1h-1v-1z",
    fill: "#57a5b1"
  })), _path6117 || (_path6117 = /*#__PURE__*/React.createElement("path", {
    d: "M36 119h1v1h-1z",
    fill: "#79a1e2"
  })), _path6118 || (_path6118 = /*#__PURE__*/React.createElement("path", {
    d: "M38 120h-1v-1h1z",
    fill: "#5787d0"
  })), _path6119 || (_path6119 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120h-1v-1h1z",
    fill: "#3361a6"
  })), _path6120 || (_path6120 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120v-1h1v1z",
    fill: "#477dba"
  })), _path6121 || (_path6121 = /*#__PURE__*/React.createElement("path", {
    d: "M40 120v-1h1v1z",
    fill: "#3a75b5"
  })), _path6122 || (_path6122 = /*#__PURE__*/React.createElement("path", {
    d: "M41 119h1v1h-1z",
    fill: "#367db8"
  })), _path6123 || (_path6123 = /*#__PURE__*/React.createElement("path", {
    d: "M43 120h-1v-1h1z",
    fill: "#4384bb"
  })), _path6124 || (_path6124 = /*#__PURE__*/React.createElement("path", {
    d: "M44 119v1h-1v-1z",
    fill: "#2e63a3"
  })), _path6125 || (_path6125 = /*#__PURE__*/React.createElement("path", {
    d: "M45 119v1h-1v-1z",
    fill: "#33598f"
  })), _path6126 || (_path6126 = /*#__PURE__*/React.createElement("path", {
    d: "M46 119v1h-1v-1z",
    fill: "#bbc5d7"
  })), _path6127 || (_path6127 = /*#__PURE__*/React.createElement("path", {
    d: "M47 120h-1v-1h1z",
    fill: "#d3d3d4"
  })), _path6128 || (_path6128 = /*#__PURE__*/React.createElement("path", {
    d: "M63 119h1v1h-1z",
    fill: "#c2c5c3"
  })), _path6129 || (_path6129 = /*#__PURE__*/React.createElement("path", {
    d: "M70 119v1h-1v-1z",
    fill: "#b0b2b1"
  })), _path6130 || (_path6130 = /*#__PURE__*/React.createElement("path", {
    d: "M73 119v1h-1v-1z",
    fill: "#b1b3b2"
  })), _path6131 || (_path6131 = /*#__PURE__*/React.createElement("path", {
    d: "M76 120h-1v-1h1z",
    fill: "#c6c8c7"
  })), _path6132 || (_path6132 = /*#__PURE__*/React.createElement("path", {
    d: "M77 120h-1v-1h1z",
    fill: "#d8dad9",
    fillOpacity: 0.996
  })), _path6133 || (_path6133 = /*#__PURE__*/React.createElement("path", {
    d: "M78 119v1h-1v-1z",
    fill: "#eee",
    fillOpacity: 0.235
  })), _path6134 || (_path6134 = /*#__PURE__*/React.createElement("path", {
    d: "M22 120v1h-1v-1z",
    fill: "#a29471",
    fillOpacity: 0.141
  })), _path6135 || (_path6135 = /*#__PURE__*/React.createElement("path", {
    d: "M22 121v-1h1v1z",
    fill: "#ad8861",
    fillOpacity: 0.82
  })), _path6136 || (_path6136 = /*#__PURE__*/React.createElement("path", {
    d: "M23 120h1v1h-1z",
    fill: "#c6965f"
  })), _path6137 || (_path6137 = /*#__PURE__*/React.createElement("path", {
    d: "M25 121h-1v-1h1z",
    fill: "#c29254"
  })), _path6138 || (_path6138 = /*#__PURE__*/React.createElement("path", {
    d: "M25 121v-1h1v1z",
    fill: "#dfa857"
  })), _path6139 || (_path6139 = /*#__PURE__*/React.createElement("path", {
    d: "M27 120v1h-1v-1z",
    fill: "#eaac50"
  })), _path6140 || (_path6140 = /*#__PURE__*/React.createElement("path", {
    d: "M27 120h1v1h-1z",
    fill: "#dfb76d"
  })), _path6141 || (_path6141 = /*#__PURE__*/React.createElement("path", {
    d: "M28 120h1v1h-1z",
    fill: "#d9c6a7"
  })), _path6142 || (_path6142 = /*#__PURE__*/React.createElement("path", {
    d: "M31 121h-1v-1h1z",
    fill: "#aec2e1"
  })), _path6143 || (_path6143 = /*#__PURE__*/React.createElement("path", {
    d: "M32 120v1h-1v-1z",
    fill: "#719dd8"
  })), _path6144 || (_path6144 = /*#__PURE__*/React.createElement("path", {
    d: "M32 120h1v1h-1z",
    fill: "#58a898"
  })), _path6145 || (_path6145 = /*#__PURE__*/React.createElement("path", {
    d: "M33 120h1v1h-1z",
    fill: "#15a853"
  })), _path6146 || (_path6146 = /*#__PURE__*/React.createElement("path", {
    d: "M35 120v1h-1v-1z",
    fill: "#1fa66b"
  })), _path6147 || (_path6147 = /*#__PURE__*/React.createElement("path", {
    d: "M36 121h-1v-1h1z",
    fill: "#5da2c3"
  })), _path6148 || (_path6148 = /*#__PURE__*/React.createElement("path", {
    d: "M37 120v1h-1v-1z",
    fill: "#69a0d0"
  })), _path6149 || (_path6149 = /*#__PURE__*/React.createElement("path", {
    d: "M38 121h-1v-1h1z",
    fill: "#508bb5"
  })), _path6150 || (_path6150 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120v1h-1v-1z",
    fill: "#1c5073"
  })), _path6151 || (_path6151 = /*#__PURE__*/React.createElement("path", {
    d: "M40 121h-1v-1h1z",
    fill: "#1a5670"
  })), _path6152 || (_path6152 = /*#__PURE__*/React.createElement("path", {
    d: "M40 120h1v1h-1z",
    fill: "#27727e"
  })), _path6153 || (_path6153 = /*#__PURE__*/React.createElement("path", {
    d: "M41 120h1v1h-1z",
    fill: "#368986"
  })), _path6154 || (_path6154 = /*#__PURE__*/React.createElement("path", {
    d: "M43 121h-1v-1h1z",
    fill: "#2d7b66"
  })), _path6155 || (_path6155 = /*#__PURE__*/React.createElement("path", {
    d: "M43 120h1v1h-1z",
    fill: "#3d8874"
  })), _path6156 || (_path6156 = /*#__PURE__*/React.createElement("path", {
    d: "M44 121v-1h1v1z",
    fill: "#3c8c78"
  })), _path6157 || (_path6157 = /*#__PURE__*/React.createElement("path", {
    d: "M46 120v1h-1v-1z",
    fill: "#bccfce"
  })), _path6158 || (_path6158 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121v-1h1v1z",
    fill: "#d3d2d0"
  })), _path6159 || (_path6159 = /*#__PURE__*/React.createElement("path", {
    d: "M61 120v1h-1v-1z",
    fill: "#a9acaa"
  })), _path6160 || (_path6160 = /*#__PURE__*/React.createElement("path", {
    d: "M65 121h-1v-1h1z",
    fill: "#cfd0d0"
  })), _path6161 || (_path6161 = /*#__PURE__*/React.createElement("path", {
    d: "M65 121v-1h1v1z",
    fill: "#aaabab"
  })), _path6162 || (_path6162 = /*#__PURE__*/React.createElement("path", {
    d: "M68 121h-1v-1h1z",
    fill: "#9a9b9b"
  })), _path6163 || (_path6163 = /*#__PURE__*/React.createElement("path", {
    d: "M72 121h-1v-1h1z",
    fill: "#b9baba"
  })), _path6164 || (_path6164 = /*#__PURE__*/React.createElement("path", {
    d: "M72 120h1v1h-1z",
    fill: "#a5a6a5"
  })), _path6165 || (_path6165 = /*#__PURE__*/React.createElement("path", {
    d: "M74 121h-1v-1h1z",
    fill: "#a1a2a1"
  })), _path6166 || (_path6166 = /*#__PURE__*/React.createElement("path", {
    d: "M75 121h-1v-1h1z",
    fill: "#b0b1b1"
  })), _path6167 || (_path6167 = /*#__PURE__*/React.createElement("path", {
    d: "M75 120h1v1h-1z",
    fill: "#bfc1c0"
  })), _path6168 || (_path6168 = /*#__PURE__*/React.createElement("path", {
    d: "M78 120v1h-1v-1z",
    fill: "#f0f0f0",
    fillOpacity: 0.267
  })), _path6169 || (_path6169 = /*#__PURE__*/React.createElement("path", {
    d: "M23 121v1h-1v-1z",
    fill: "#8c795f",
    fillOpacity: 0.157
  })), _path6170 || (_path6170 = /*#__PURE__*/React.createElement("path", {
    d: "M23 121h1v1h-1z",
    fill: "#aa8762",
    fillOpacity: 0.843
  })), _path6171 || (_path6171 = /*#__PURE__*/React.createElement("path", {
    d: "M24 121h1v1h-1z",
    fill: "#bb8b59"
  })), _path6172 || (_path6172 = /*#__PURE__*/React.createElement("path", {
    d: "M26 121v1h-1v-1z",
    fill: "#ce984f"
  })), _path6173 || (_path6173 = /*#__PURE__*/React.createElement("path", {
    d: "M27 122h-1v-1h1z",
    fill: "#e9ab4a"
  })), _path6174 || (_path6174 = /*#__PURE__*/React.createElement("path", {
    d: "M28 122h-1v-1h1z",
    fill: "#efb356"
  })), _path6175 || (_path6175 = /*#__PURE__*/React.createElement("path", {
    d: "M28 121h1v1h-1z",
    fill: "#f3c48b"
  })), _path6176 || (_path6176 = /*#__PURE__*/React.createElement("path", {
    d: "M29 122v-1h1v1z",
    fill: "#d7cfc8"
  })), _path6177 || (_path6177 = /*#__PURE__*/React.createElement("path", {
    d: "M31 121v1h-1v-1z",
    fill: "#a4c6c3"
  })), _path6178 || (_path6178 = /*#__PURE__*/React.createElement("path", {
    d: "M32 122h-1v-1h1z",
    fill: "#4d9e9e"
  })), _path6179 || (_path6179 = /*#__PURE__*/React.createElement("path", {
    d: "M33 122h-1v-1h1z",
    fill: "#46a985"
  })), _path6180 || (_path6180 = /*#__PURE__*/React.createElement("path", {
    d: "M33 121h1v1h-1z",
    fill: "#29b154"
  })), _path6181 || (_path6181 = /*#__PURE__*/React.createElement("path", {
    d: "M34 122v-1h1v1z",
    fill: "#25af5f"
  })), _path6182 || (_path6182 = /*#__PURE__*/React.createElement("path", {
    d: "M36 121v1h-1v-1z",
    fill: "#52b491"
  })), _path6183 || (_path6183 = /*#__PURE__*/React.createElement("path", {
    d: "M37 121v1h-1v-1z",
    fill: "#48ac81"
  })), _path6184 || (_path6184 = /*#__PURE__*/React.createElement("path", {
    d: "M38 122h-1v-1h1z",
    fill: "#3dac6f"
  })), _path6185 || (_path6185 = /*#__PURE__*/React.createElement("path", {
    d: "M38 121h1v1h-1z",
    fill: "#59bc7c"
  })), _path6186 || (_path6186 = /*#__PURE__*/React.createElement("path", {
    d: "M39 121h1v1h-1z",
    fill: "#47b469"
  })), _path6187 || (_path6187 = /*#__PURE__*/React.createElement("path", {
    d: "M41 121v1h-1v-1z",
    fill: "#44b366"
  })), _path6188 || (_path6188 = /*#__PURE__*/React.createElement("path", {
    d: "M41 122v-1h1v1z",
    fill: "#6bcc83"
  })), _path6189 || (_path6189 = /*#__PURE__*/React.createElement("path", {
    d: "M42 122v-1h1v1z",
    fill: "#45b661"
  })), _path6190 || (_path6190 = /*#__PURE__*/React.createElement("path", {
    d: "M43 122v-1h1v1z",
    fill: "#6cd08b"
  })), _path6191 || (_path6191 = /*#__PURE__*/React.createElement("path", {
    d: "M44 122v-1h1v1z",
    fill: "#55b579"
  })), _path6192 || (_path6192 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121v1h-1v-1z",
    fill: "#b8d3c8"
  })), _path6193 || (_path6193 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121h1v1h-1z",
    fill: "#d3d2d2"
  })), _path6194 || (_path6194 = /*#__PURE__*/React.createElement("path", {
    d: "M51 122h-1v-1h1z",
    fill: "#a8aaa9"
  })), _path6195 || (_path6195 = /*#__PURE__*/React.createElement("path", {
    d: "M55 122h-1v-1h1z",
    fill: "#b9bbba"
  })), _path6196 || (_path6196 = /*#__PURE__*/React.createElement("path", {
    d: "M56 121h1v1h-1z",
    fill: "#aeb0af"
  })), _path6197 || (_path6197 = /*#__PURE__*/React.createElement("path", {
    d: "M57 122v-1h1v1z",
    fill: "#939594"
  })), _path6198 || (_path6198 = /*#__PURE__*/React.createElement("path", {
    d: "M60 121h1v1h-1z",
    fill: "#8a8c8b"
  })), _path6199 || (_path6199 = /*#__PURE__*/React.createElement("path", {
    d: "M61 121h1v1h-1z",
    fill: "#919392"
  })), _path6200 || (_path6200 = /*#__PURE__*/React.createElement("path", {
    d: "M62 122v-1h1v1z",
    fill: "#a7a9a8"
  })), _path6201 || (_path6201 = /*#__PURE__*/React.createElement("path", {
    d: "M63 122v-1h1v1z",
    fill: "#afb0af"
  })), _path6202 || (_path6202 = /*#__PURE__*/React.createElement("path", {
    d: "M64 122v-1h1v1z",
    fill: "#ccc"
  })), _path6203 || (_path6203 = /*#__PURE__*/React.createElement("path", {
    d: "M65 121h1v1h-1z",
    fill: "#aeaeae"
  })), _path6204 || (_path6204 = /*#__PURE__*/React.createElement("path", {
    d: "M67 122h-1v-1h1z",
    fill: "#a2a2a2"
  })), _path6205 || (_path6205 = /*#__PURE__*/React.createElement("path", {
    d: "M68 121v1h-1v-1z",
    fill: "#acadad"
  })), _path6206 || (_path6206 = /*#__PURE__*/React.createElement("path", {
    d: "M70 121v1h-1v-1z",
    fill: "#abadac"
  })), _path6207 || (_path6207 = /*#__PURE__*/React.createElement("path", {
    d: "M72 122h-1v-1h1z",
    fill: "#cecece"
  })), _path6208 || (_path6208 = /*#__PURE__*/React.createElement("path", {
    d: "M72 122v-1h1v1z",
    fill: "#cbcbcb"
  })), _path6209 || (_path6209 = /*#__PURE__*/React.createElement("path", {
    d: "M74 121v1h-1v-1z",
    fill: "#cacaca"
  })), _path6210 || (_path6210 = /*#__PURE__*/React.createElement("path", {
    d: "M75 122v-1h1v1z",
    fill: "#c1c3c2",
    fillOpacity: 0.973
  })), _path6211 || (_path6211 = /*#__PURE__*/React.createElement("path", {
    d: "M76 122v-1h1v1z",
    fill: "#dadcdb",
    fillOpacity: 0.867
  })), _path6212 || (_path6212 = /*#__PURE__*/React.createElement("path", {
    d: "M77 121h1v1h-1z",
    fill: "#e6ece6",
    fillOpacity: 0.165
  })), _path6213 || (_path6213 = /*#__PURE__*/React.createElement("path", {
    d: "M23 123v-1h1v1z",
    fill: "#9a826a",
    fillOpacity: 0.169
  })), _path6214 || (_path6214 = /*#__PURE__*/React.createElement("path", {
    d: "M24 122h1v1h-1z",
    fill: "#a4805b",
    fillOpacity: 0.851
  })), _path6215 || (_path6215 = /*#__PURE__*/React.createElement("path", {
    d: "M25 122h1v1h-1z",
    fill: "#b0864c"
  })), _path6216 || (_path6216 = /*#__PURE__*/React.createElement("path", {
    d: "M27 122v1h-1v-1z",
    fill: "#e2a44b"
  })), _path6217 || (_path6217 = /*#__PURE__*/React.createElement("path", {
    d: "M27 122h1v1h-1z",
    fill: "#f3b051"
  })), _path6218 || (_path6218 = /*#__PURE__*/React.createElement("path", {
    d: "M29 123h-1v-1h1z",
    fill: "#ecbd7e"
  })), _path6219 || (_path6219 = /*#__PURE__*/React.createElement("path", {
    d: "M30 122v1h-1v-1z",
    fill: "#d4d3c5"
  })), _path6220 || (_path6220 = /*#__PURE__*/React.createElement("path", {
    d: "M30 123v-1h1v1z",
    fill: "#8fc697"
  })), _path6221 || (_path6221 = /*#__PURE__*/React.createElement("path", {
    d: "M32 122v1h-1v-1z",
    fill: "#3eb465"
  })), _path6222 || (_path6222 = /*#__PURE__*/React.createElement("path", {
    d: "M32 123v-1h1v1z",
    fill: "#4dc277"
  })), _path6223 || (_path6223 = /*#__PURE__*/React.createElement("path", {
    d: "M34 123h-1v-1h1z",
    fill: "#5bc680"
  })), _path6224 || (_path6224 = /*#__PURE__*/React.createElement("path", {
    d: "M35 123h-1v-1h1z",
    fill: "#48b866"
  })), _path6225 || (_path6225 = /*#__PURE__*/React.createElement("path", {
    d: "M35 122h1v1h-1z",
    fill: "#68ce8a"
  })), _path6226 || (_path6226 = /*#__PURE__*/React.createElement("path", {
    d: "M36 122h1v1h-1z",
    fill: "#54b96a"
  })), _path6227 || (_path6227 = /*#__PURE__*/React.createElement("path", {
    d: "M38 122v1h-1v-1z",
    fill: "#43b961"
  })), _path6228 || (_path6228 = /*#__PURE__*/React.createElement("path", {
    d: "M39 122v1h-1v-1z",
    fill: "#53bf75"
  })), _path6229 || (_path6229 = /*#__PURE__*/React.createElement("path", {
    d: "M39 122h1v1h-1z",
    fill: "#3eb264"
  })), _path6230 || (_path6230 = /*#__PURE__*/React.createElement("path", {
    d: "M41 123h-1v-1h1z",
    fill: "#56b872"
  })), _path6231 || (_path6231 = /*#__PURE__*/React.createElement("path", {
    d: "M42 123h-1v-1h1z",
    fill: "#76c58a"
  })), _path6232 || (_path6232 = /*#__PURE__*/React.createElement("path", {
    d: "M42 122h1v1h-1z",
    fill: "#66ba7d"
  })), _path6233 || (_path6233 = /*#__PURE__*/React.createElement("path", {
    d: "M43 122h1v1h-1z",
    fill: "#87ca9a"
  })), _path6234 || (_path6234 = /*#__PURE__*/React.createElement("path", {
    d: "M44 123v-1h1v1z",
    fill: "#87c49c"
  })), _path6235 || (_path6235 = /*#__PURE__*/React.createElement("path", {
    d: "M45 122h1v1h-1z",
    fill: "#bfd5ce"
  })), _path6236 || (_path6236 = /*#__PURE__*/React.createElement("path", {
    d: "M51 122v1h-1v-1z",
    fill: "#b1b3b3"
  })), _path6237 || (_path6237 = /*#__PURE__*/React.createElement("path", {
    d: "M51 123v-1h1v1z",
    fill: "#8d8e8f"
  })), _path6238 || (_path6238 = /*#__PURE__*/React.createElement("path", {
    d: "M53 123h-1v-1h1z",
    fill: "#8c8e8e"
  })), _path6239 || (_path6239 = /*#__PURE__*/React.createElement("path", {
    d: "M54 123h-1v-1h1z",
    fill: "#8f9191"
  })), _path6240 || (_path6240 = /*#__PURE__*/React.createElement("path", {
    d: "M55 122v1h-1v-1z",
    fill: "#bfc0c1"
  })), _path6241 || (_path6241 = /*#__PURE__*/React.createElement("path", {
    d: "M55 122h1v1h-1z",
    fill: "#bbbcbd"
  })), _path6242 || (_path6242 = /*#__PURE__*/React.createElement("path", {
    d: "M57 122v1h-1v-1z",
    fill: "#9a9b9c"
  })), _path6243 || (_path6243 = /*#__PURE__*/React.createElement("path", {
    d: "M57 122h1v1h-1z",
    fill: "#9a9c9b"
  })), _path6244 || (_path6244 = /*#__PURE__*/React.createElement("path", {
    d: "M58 122h1v1h-1z",
    fill: "#a4a6a5"
  })), _path6245 || (_path6245 = /*#__PURE__*/React.createElement("path", {
    d: "M60 122v1h-1v-1z",
    fill: "#acaead"
  })), _path6246 || (_path6246 = /*#__PURE__*/React.createElement("path", {
    d: "M61 122v1h-1v-1z",
    fill: "#adaeae"
  })), _path6247 || (_path6247 = /*#__PURE__*/React.createElement("path", {
    d: "M61 123v-1h1v1z",
    fill: "#bebebe"
  })), _path6248 || (_path6248 = /*#__PURE__*/React.createElement("path", {
    d: "M63 122h1v1h-1z",
    fill: "#c7c7c7"
  })), _path6249 || (_path6249 = /*#__PURE__*/React.createElement("path", {
    d: "M66 123h-1v-1h1z",
    fill: "#b5b5b5"
  })), _path6250 || (_path6250 = /*#__PURE__*/React.createElement("path", {
    d: "M66 123v-1h1v1z",
    fill: "#c3c3c3",
    fillOpacity: 0.965
  })), _path6251 || (_path6251 = /*#__PURE__*/React.createElement("path", {
    d: "M67 122h1v1h-1z",
    fill: "#d0d0d0",
    fillOpacity: 0.918
  })), _path6252 || (_path6252 = /*#__PURE__*/React.createElement("path", {
    d: "M69 122v1h-1v-1z",
    fill: "#ccc",
    fillOpacity: 0.875
  })), _path6253 || (_path6253 = /*#__PURE__*/React.createElement("path", {
    d: "M69 122h1v1h-1z",
    fill: "#caccca",
    fillOpacity: 0.788
  })), _path6254 || (_path6254 = /*#__PURE__*/React.createElement("path", {
    d: "M71 122v1h-1v-1z",
    fill: "#cdcdcd",
    fillOpacity: 0.702
  })), _path6255 || (_path6255 = /*#__PURE__*/React.createElement("path", {
    d: "M71 123v-1h1v1z",
    fill: "#cecece",
    fillOpacity: 0.592
  })), _path6256 || (_path6256 = /*#__PURE__*/React.createElement("path", {
    d: "M73 122v1h-1v-1z",
    fill: "#d2d2d2",
    fillOpacity: 0.467
  })), _path6257 || (_path6257 = /*#__PURE__*/React.createElement("path", {
    d: "M73 123v-1h1v1z",
    fill: "#d1d1d1",
    fillOpacity: 0.349
  })), _path6258 || (_path6258 = /*#__PURE__*/React.createElement("path", {
    d: "M75 123h-1v-1h1z",
    fill: "#d1d1d1",
    fillOpacity: 0.263
  })), _path6259 || (_path6259 = /*#__PURE__*/React.createElement("path", {
    d: "M75 122h1v1h-1z",
    fill: "#d1d7d1",
    fillOpacity: 0.176
  })), _path6260 || (_path6260 = /*#__PURE__*/React.createElement("path", {
    d: "M24 123h1v1h-1z",
    fill: "#8d7c6b",
    fillOpacity: 0.176
  })), _path6261 || (_path6261 = /*#__PURE__*/React.createElement("path", {
    d: "M25 124v-1h1v1z",
    fill: "#8e724c",
    fillOpacity: 0.855
  })), _path6262 || (_path6262 = /*#__PURE__*/React.createElement("path", {
    d: "M27 123v1h-1v-1z",
    fill: "#d39c4e"
  })), _path6263 || (_path6263 = /*#__PURE__*/React.createElement("path", {
    d: "M27 124v-1h1v1z",
    fill: "#f2ae52"
  })), _path6264 || (_path6264 = /*#__PURE__*/React.createElement("path", {
    d: "M28 123h1v1h-1z",
    fill: "#dda869"
  })), _path6265 || (_path6265 = /*#__PURE__*/React.createElement("path", {
    d: "M29 123h1v1h-1z",
    fill: "#d6cfc6"
  })), _path6266 || (_path6266 = /*#__PURE__*/React.createElement("path", {
    d: "M31 124h-1v-1h1z",
    fill: "#97c99a"
  })), _path6267 || (_path6267 = /*#__PURE__*/React.createElement("path", {
    d: "M32 124h-1v-1h1z",
    fill: "#4eae6e"
  })), _path6268 || (_path6268 = /*#__PURE__*/React.createElement("path", {
    d: "M32 123h1v1h-1z",
    fill: "#67bb7f"
  })), _path6269 || (_path6269 = /*#__PURE__*/React.createElement("path", {
    d: "M34 123v1h-1v-1z",
    fill: "#73c58c"
  })), _path6270 || (_path6270 = /*#__PURE__*/React.createElement("path", {
    d: "M34 124v-1h1v1z",
    fill: "#7fc695"
  })), _path6271 || (_path6271 = /*#__PURE__*/React.createElement("path", {
    d: "M35 123h1v1h-1z",
    fill: "#89c79e"
  })), _path6272 || (_path6272 = /*#__PURE__*/React.createElement("path", {
    d: "M36 124v-1h1v1z",
    fill: "#92cb9e"
  })), _path6273 || (_path6273 = /*#__PURE__*/React.createElement("path", {
    d: "M37 124v-1h1v1z",
    fill: "#94d0a1"
  })), _path6274 || (_path6274 = /*#__PURE__*/React.createElement("path", {
    d: "M38 123h1v1h-1z",
    fill: "#97cfa8"
  })), _path6275 || (_path6275 = /*#__PURE__*/React.createElement("path", {
    d: "M39 123h1v1h-1z",
    fill: "#9ed2ae"
  })), _path6276 || (_path6276 = /*#__PURE__*/React.createElement("path", {
    d: "M41 123v1h-1v-1z",
    fill: "#a9d6b6"
  })), _path6277 || (_path6277 = /*#__PURE__*/React.createElement("path", {
    d: "M42 123v1h-1v-1z",
    fill: "#b2d6bd"
  })), _path6278 || (_path6278 = /*#__PURE__*/React.createElement("path", {
    d: "M43 123v1h-1v-1z",
    fill: "#bbdbc8"
  })), _path6279 || (_path6279 = /*#__PURE__*/React.createElement("path", {
    d: "M44 123v1h-1v-1z",
    fill: "#b9d3c0"
  })), _path6280 || (_path6280 = /*#__PURE__*/React.createElement("path", {
    d: "M44 124v-1h1v1z",
    fill: "#abccb8"
  })), _path6281 || (_path6281 = /*#__PURE__*/React.createElement("path", {
    d: "M46 123v1h-1v-1z",
    fill: "#c3cecd"
  })), _path6282 || (_path6282 = /*#__PURE__*/React.createElement("path", {
    d: "M46 123h1v1h-1z",
    fill: "#cdd0ce"
  })), _path6283 || (_path6283 = /*#__PURE__*/React.createElement("path", {
    d: "M50 124h-1v-1h1z",
    fill: "#bec0c0"
  })), _path6284 || (_path6284 = /*#__PURE__*/React.createElement("path", {
    d: "M51 124h-1v-1h1z",
    fill: "#a4a5a7"
  })), _path6285 || (_path6285 = /*#__PURE__*/React.createElement("path", {
    d: "M51 123h1v1h-1z",
    fill: "#b3b4b7"
  })), _path6286 || (_path6286 = /*#__PURE__*/React.createElement("path", {
    d: "M53 124v-1h1v1z",
    fill: "#b3b4b6"
  })), _path6287 || (_path6287 = /*#__PURE__*/React.createElement("path", {
    d: "M56 124v-1h1v1z",
    fill: "#c1c2c3"
  })), _path6288 || (_path6288 = /*#__PURE__*/React.createElement("path", {
    d: "M58 123v1h-1v-1z",
    fill: "#c9cbca",
    fillOpacity: 0.992
  })), _path6289 || (_path6289 = /*#__PURE__*/React.createElement("path", {
    d: "M59 123v1h-1v-1z",
    fill: "#c8cac9",
    fillOpacity: 0.949
  })), _path6290 || (_path6290 = /*#__PURE__*/React.createElement("path", {
    d: "M60 123v1h-1v-1z",
    fill: "#cccecd",
    fillOpacity: 0.894
  })), _path6291 || (_path6291 = /*#__PURE__*/React.createElement("path", {
    d: "M60 123h1v1h-1z",
    fill: "#cfcfcf",
    fillOpacity: 0.816
  })), _path6292 || (_path6292 = /*#__PURE__*/React.createElement("path", {
    d: "M62 124h-1v-1h1z",
    fill: "#cbcbcb",
    fillOpacity: 0.694
  })), _path6293 || (_path6293 = /*#__PURE__*/React.createElement("path", {
    d: "M63 124h-1v-1h1z",
    fill: "#ccc",
    fillOpacity: 0.569
  })), _path6294 || (_path6294 = /*#__PURE__*/React.createElement("path", {
    d: "M63 123h1v1h-1z",
    fill: "#ccc",
    fillOpacity: 0.455
  })), _path6295 || (_path6295 = /*#__PURE__*/React.createElement("path", {
    d: "M65 124h-1v-1h1z",
    fill: "#cacaca",
    fillOpacity: 0.365
  })), _path6296 || (_path6296 = /*#__PURE__*/React.createElement("path", {
    d: "M66 123h1v1h-1z",
    fill: "#d1d1d1",
    fillOpacity: 0.176
  })), _path6297 || (_path6297 = /*#__PURE__*/React.createElement("path", {
    d: "M68 123v1h-1v-1z",
    fill: "#d1d1d1",
    fillOpacity: 0.11
  })), _path6298 || (_path6298 = /*#__PURE__*/React.createElement("path", {
    d: "M69 124v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path6299 || (_path6299 = /*#__PURE__*/React.createElement("path", {
    d: "M25 124h1v1h-1z",
    fill: "#826c51",
    fillOpacity: 0.184
  })), _path6300 || (_path6300 = /*#__PURE__*/React.createElement("path", {
    d: "M26 124h1v1h-1z",
    fill: "#ba8c4e",
    fillOpacity: 0.871
  })), _path6301 || (_path6301 = /*#__PURE__*/React.createElement("path", {
    d: "M28 125h-1v-1h1z",
    fill: "#ecaa53"
  })), _path6302 || (_path6302 = /*#__PURE__*/React.createElement("path", {
    d: "M29 124v1h-1v-1z",
    fill: "#d5a267"
  })), _path6303 || (_path6303 = /*#__PURE__*/React.createElement("path", {
    d: "M30 124v1h-1v-1z",
    fill: "#d1cac6"
  })), _path6304 || (_path6304 = /*#__PURE__*/React.createElement("path", {
    d: "M31 125h-1v-1h1z",
    fill: "#bcd6c0"
  })), _path6305 || (_path6305 = /*#__PURE__*/React.createElement("path", {
    d: "M32 125h-1v-1h1z",
    fill: "#aed7bc"
  })), _path6306 || (_path6306 = /*#__PURE__*/React.createElement("path", {
    d: "M33 125h-1v-1h1z",
    fill: "#b0d6b9"
  })), _path6307 || (_path6307 = /*#__PURE__*/React.createElement("path", {
    d: "M33 125v-1h1v1z",
    fill: "#afd4ba"
  })), _path6308 || (_path6308 = /*#__PURE__*/React.createElement("path", {
    d: "M34 124h1v1h-1z",
    fill: "#b0cfba"
  })), _path6309 || (_path6309 = /*#__PURE__*/React.createElement("path", {
    d: "M35 125v-1h1v1z",
    fill: "#b5d3be"
  })), _path6310 || (_path6310 = /*#__PURE__*/React.createElement("path", {
    d: "M36 124h1v1h-1z",
    fill: "#b3cfbd"
  })), _path6311 || (_path6311 = /*#__PURE__*/React.createElement("path", {
    d: "M38 124v1h-1v-1z",
    fill: "#b8d0c1"
  })), _path6312 || (_path6312 = /*#__PURE__*/React.createElement("path", {
    d: "M38 125v-1h1v1z",
    fill: "#bfd5c8"
  })), _path6313 || (_path6313 = /*#__PURE__*/React.createElement("path", {
    d: "M40 125h-1v-1h1z",
    fill: "#b9cdc2"
  })), _path6314 || (_path6314 = /*#__PURE__*/React.createElement("path", {
    d: "M40 125v-1h1v1z",
    fill: "#c3d7cd"
  })), _path6315 || (_path6315 = /*#__PURE__*/React.createElement("path", {
    d: "M41 124h1v1h-1z",
    fill: "#cbdad2"
  })), _path6316 || (_path6316 = /*#__PURE__*/React.createElement("path", {
    d: "M44 124h1v1h-1z",
    fill: "#c8d4cf"
  })), _path6317 || (_path6317 = /*#__PURE__*/React.createElement("path", {
    d: "M46 124h1v1h-1z",
    fill: "#d2d3d2"
  })), _path6318 || (_path6318 = /*#__PURE__*/React.createElement("path", {
    d: "M50 124v1h-1v-1z",
    fill: "#cbcdcc",
    fillOpacity: 0.957
  })), _path6319 || (_path6319 = /*#__PURE__*/React.createElement("path", {
    d: "M51 125h-1v-1h1z",
    fill: "#c9caca",
    fillOpacity: 0.89
  })), _path6320 || (_path6320 = /*#__PURE__*/React.createElement("path", {
    d: "M52 125h-1v-1h1z",
    fill: "#cccdcd",
    fillOpacity: 0.804
  })), _path6321 || (_path6321 = /*#__PURE__*/React.createElement("path", {
    d: "M52 125v-1h1v1z",
    fill: "#cfd1d1",
    fillOpacity: 0.722
  })), _path6322 || (_path6322 = /*#__PURE__*/React.createElement("path", {
    d: "M53 124h1v1h-1z",
    fill: "#d2d2d2",
    fillOpacity: 0.627
  })), _path6323 || (_path6323 = /*#__PURE__*/React.createElement("path", {
    d: "M54 124h1v1h-1z",
    fill: "#cececf",
    fillOpacity: 0.553
  })), _path6324 || (_path6324 = /*#__PURE__*/React.createElement("path", {
    d: "M56 125h-1v-1h1z",
    fill: "#cecece",
    fillOpacity: 0.435
  })), _path6325 || (_path6325 = /*#__PURE__*/React.createElement("path", {
    d: "M56 125v-1h1v1z",
    fill: "#d7d7d7",
    fillOpacity: 0.325
  })), _path6326 || (_path6326 = /*#__PURE__*/React.createElement("path", {
    d: "M57 125v-1h1v1z",
    fill: "#d1d1d1",
    fillOpacity: 0.22
  })), _path6327 || (_path6327 = /*#__PURE__*/React.createElement("path", {
    d: "M58 125v-1h1v1z",
    fill: "#d4d4d4",
    fillOpacity: 0.141
  })), _path6328 || (_path6328 = /*#__PURE__*/React.createElement("path", {
    d: "M59 124h1v1h-1z",
    fill: "#c9c9c9",
    fillOpacity: 0.075
  })), _path6329 || (_path6329 = /*#__PURE__*/React.createElement("path", {
    d: "M27 125v1h-1v-1z",
    fill: "#a38553",
    fillOpacity: 0.239
  })), _path6330 || (_path6330 = /*#__PURE__*/React.createElement("path", {
    d: "M27 126v-1h1v1z",
    fill: "#ce9a52",
    fillOpacity: 0.925
  })), _path6331 || (_path6331 = /*#__PURE__*/React.createElement("path", {
    d: "M28 125h1v1h-1z",
    fill: "#e8b275"
  })), _path6332 || (_path6332 = /*#__PURE__*/React.createElement("path", {
    d: "M30 126h-1v-1h1z",
    fill: "#d3cbc7"
  })), _path6333 || (_path6333 = /*#__PURE__*/React.createElement("path", {
    d: "M30 125h1v1h-1z",
    fill: "#c7d9d2"
  })), _path6334 || (_path6334 = /*#__PURE__*/React.createElement("path", {
    d: "M31 126v-1h1v1z",
    fill: "#c9dbcf"
  })), _path6335 || (_path6335 = /*#__PURE__*/React.createElement("path", {
    d: "M32 126v-1h1v1z",
    fill: "#ceded2"
  })), _path6336 || (_path6336 = /*#__PURE__*/React.createElement("path", {
    d: "M33 125h1v1h-1z",
    fill: "#c3d4c9"
  })), _path6337 || (_path6337 = /*#__PURE__*/React.createElement("path", {
    d: "M34 125h1v1h-1z",
    fill: "#cedad3"
  })), _path6338 || (_path6338 = /*#__PURE__*/React.createElement("path", {
    d: "M36 126h-1v-1h1z",
    fill: "#d3dcd6"
  })), _path6339 || (_path6339 = /*#__PURE__*/React.createElement("path", {
    d: "M37 125v1h-1v-1z",
    fill: "#d2d9d4"
  })), _path6340 || (_path6340 = /*#__PURE__*/React.createElement("path", {
    d: "M37 126v-1h1v1z",
    fill: "#d1d6d3"
  })), _path6341 || (_path6341 = /*#__PURE__*/React.createElement("path", {
    d: "M39 125v1h-1v-1z",
    fill: "#d0d3d2"
  })), _path6342 || (_path6342 = /*#__PURE__*/React.createElement("path", {
    d: "M39 126v-1h1v1z",
    fill: "#cacecc"
  })), _path6343 || (_path6343 = /*#__PURE__*/React.createElement("path", {
    d: "M40 125h1v1h-1z",
    fill: "#c8ccc9",
    fillOpacity: 0.961
  })), _path6344 || (_path6344 = /*#__PURE__*/React.createElement("path", {
    d: "M41 126v-1h1v1z",
    fill: "#c7cac7",
    fillOpacity: 0.906
  })), _path6345 || (_path6345 = /*#__PURE__*/React.createElement("path", {
    d: "M42 126v-1h1v1z",
    fill: "#cacbca",
    fillOpacity: 0.839
  })), _path6346 || (_path6346 = /*#__PURE__*/React.createElement("path", {
    d: "M43 125h1v1h-1z",
    fill: "#c9cccc",
    fillOpacity: 0.773
  })), _path6347 || (_path6347 = /*#__PURE__*/React.createElement("path", {
    d: "M44 126v-1h1v1z",
    fill: "#cccece",
    fillOpacity: 0.678
  })), _path6348 || (_path6348 = /*#__PURE__*/React.createElement("path", {
    d: "M46 125v1h-1v-1z",
    fill: "#cdcbcb",
    fillOpacity: 0.58
  })), _path6349 || (_path6349 = /*#__PURE__*/React.createElement("path", {
    d: "M46 126v-1h1v1z",
    fill: "#cbcdcd",
    fillOpacity: 0.482
  })), _path6350 || (_path6350 = /*#__PURE__*/React.createElement("path", {
    d: "M47 125h1v1h-1z",
    fill: "#cdd0cd",
    fillOpacity: 0.384
  })), _path6351 || (_path6351 = /*#__PURE__*/React.createElement("path", {
    d: "M49 126v-1h1v1z",
    fill: "#cecece",
    fillOpacity: 0.165
  })), _path6352 || (_path6352 = /*#__PURE__*/React.createElement("path", {
    d: "M27 126h1v1h-1z",
    fill: "#b9915e",
    fillOpacity: 0.329
  })), _path6353 || (_path6353 = /*#__PURE__*/React.createElement("path", {
    d: "M28 126h1v1h-1z",
    fill: "#cfa57a",
    fillOpacity: 0.929
  })), _path6354 || (_path6354 = /*#__PURE__*/React.createElement("path", {
    d: "M30 126v1h-1v-1z",
    fill: "#d2c9c2",
    fillOpacity: 0.976
  })), _path6355 || (_path6355 = /*#__PURE__*/React.createElement("path", {
    d: "M31 126v1h-1v-1z",
    fill: "#c9cec8",
    fillOpacity: 0.941
  })), _path6356 || (_path6356 = /*#__PURE__*/React.createElement("path", {
    d: "M32 127h-1v-1h1z",
    fill: "#c9cbc6",
    fillOpacity: 0.878
  })), _path6357 || (_path6357 = /*#__PURE__*/React.createElement("path", {
    d: "M33 127h-1v-1h1z",
    fill: "#c9cac7",
    fillOpacity: 0.816
  })), _path6358 || (_path6358 = /*#__PURE__*/React.createElement("path", {
    d: "M33 127v-1h1v1z",
    fill: "#c7cac9",
    fillOpacity: 0.761
  })), _path6359 || (_path6359 = /*#__PURE__*/React.createElement("path", {
    d: "M34 126h1v1h-1z",
    fill: "#c8c6c8",
    fillOpacity: 0.71
  })), _path6360 || (_path6360 = /*#__PURE__*/React.createElement("path", {
    d: "M36 126v1h-1v-1z",
    fill: "#c9c8c8",
    fillOpacity: 0.62
  })), _path6361 || (_path6361 = /*#__PURE__*/React.createElement("path", {
    d: "M36 126h1v1h-1z",
    fill: "#c6c6c6",
    fillOpacity: 0.518
  })), _path6362 || (_path6362 = /*#__PURE__*/React.createElement("path", {
    d: "M37 126h1v1h-1z",
    fill: "#c6c3c6",
    fillOpacity: 0.424
  })), _path6363 || (_path6363 = /*#__PURE__*/React.createElement("path", {
    d: "M38 127v-1h1v1z",
    fill: "#c4c4c7",
    fillOpacity: 0.325
  })), _path6364 || (_path6364 = /*#__PURE__*/React.createElement("path", {
    d: "M40 127h-1v-1h1z",
    fill: "#c8c8c8",
    fillOpacity: 0.239
  })), _path6365 || (_path6365 = /*#__PURE__*/React.createElement("path", {
    d: "M41 127h-1v-1h1z",
    fill: "#c4c4c4",
    fillOpacity: 0.153
  })), _path6366 || (_path6366 = /*#__PURE__*/React.createElement("path", {
    d: "M43 127h-1v-1h1z",
    fill: "#e2e2e2",
    fillOpacity: 0.035
  })), _path6367 || (_path6367 = /*#__PURE__*/React.createElement("path", {
    d: "M43 127v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path6368 || (_path6368 = /*#__PURE__*/React.createElement("path", {
    d: "M29 128h-1v-1h1z",
    fill: "#b29e89",
    fillOpacity: 0.196
  })), _path6369 || (_path6369 = /*#__PURE__*/React.createElement("path", {
    d: "M29 127h1v1h-1z",
    fill: "#cbc7bf",
    fillOpacity: 0.251
  })), _path6370 || (_path6370 = /*#__PURE__*/React.createElement("path", {
    d: "M31 128h-1v-1h1z",
    fill: "#c2c2bc",
    fillOpacity: 0.18
  })), _path6371 || (_path6371 = /*#__PURE__*/React.createElement("path", {
    d: "M31 127h1v1h-1z",
    fill: "#c7bcc7",
    fillOpacity: 0.09
  })), _path6372 || (_path6372 = /*#__PURE__*/React.createElement("path", {
    d: "M33 128h-1v-1h1z",
    fill: "#d0b9d0",
    fillOpacity: 0.043
  })), _path6373 || (_path6373 = /*#__PURE__*/React.createElement("path", {
    d: "M33 127h1v1h-1z",
    fill: "#aaa",
    fillOpacity: 0.012
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilkCarton);
export default __webpack_public_path__ + "static/media/milk-carton.f571bf0a10bdd86ae8a60be08b99feeb.svg";
export { ForwardRef as ReactComponent };